webpackJsonp([39,38],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	__webpack_require__(550);
	
	__webpack_require__(551);
	
	var _fetchInject = __webpack_require__(685);
	
	var _fetchInject2 = _interopRequireDefault(_fetchInject);
	
	var _draggable = __webpack_require__(359);
	
	var _draggable2 = _interopRequireDefault(_draggable);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _getUrlParam = __webpack_require__(172);
	
	var _getUrlParam2 = _interopRequireDefault(_getUrlParam);
	
	var _log = __webpack_require__(408);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _dragbox = __webpack_require__(405);
	
	var _dragbox2 = _interopRequireDefault(_dragbox);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _buildFindOptionsFromQueryStringParams = __webpack_require__(404);
	
	var _buildFindOptionsFromQueryStringParams2 = _interopRequireDefault(_buildFindOptionsFromQueryStringParams);
	
	var _insertAgCoordinate = __webpack_require__(399);
	
	var _insertAgCoordinate2 = _interopRequireDefault(_insertAgCoordinate);
	
	var _insertGeomPraticaGenio = __webpack_require__(400);
	
	var _insertGeomPraticaGenio2 = _interopRequireDefault(_insertGeomPraticaGenio);
	
	var _getS3TokenBbox = __webpack_require__(398);
	
	var _getS3TokenBbox2 = _interopRequireDefault(_getS3TokenBbox);
	
	var _getS3Token = __webpack_require__(397);
	
	var _getS3Token2 = _interopRequireDefault(_getS3Token);
	
	var _getAuth = __webpack_require__(369);
	
	var _getAuth2 = _interopRequireDefault(_getAuth);
	
	var _getGeneric = __webpack_require__(384);
	
	var _getGeneric2 = _interopRequireDefault(_getGeneric);
	
	var _config = __webpack_require__(353);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(717);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _tools = __webpack_require__(403);
	
	var _tools2 = _interopRequireDefault(_tools);
	
	var _jquery = __webpack_require__(686);
	
	var _uuid = __webpack_require__(706);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(699);
	__webpack_require__(200);
	__webpack_require__(200);
	
	__webpack_require__(364);
	__webpack_require__(363);
	__webpack_require__(365);
	__webpack_require__(549).polyfill();
	
	window.GV = {
	  init: function init(options) {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var olScripts, projDefs, cesiumScripts, olcsScripts, llScripts, authOptions, auth, s3Token;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(options.application.mapOptions && options.application.mapOptions.type === 'openlayers')) {
	                _context.next = 16;
	                break;
	              }
	
	              console.log('Caricamento libreria OpenLayers');
	              olScripts = ['/geoservices/apps/viewer/dist/openlayers/ol.js', '/geoservices/apps/viewer/dist/openlayers/ol.css', '/geoservices/apps/viewer/dist/proj4js/proj4.js'];
	              projDefs = ['/geoservices/apps/viewer/dist/proj4js/3003.js'];
	
	              if (!options.application.mapOptions.ol3d) {
	                _context.next = 12;
	                break;
	              }
	
	              window.CESIUM_BASE_URL = '/geoservices/apps/viewer/dist/cesium/Build/Cesium';
	              cesiumScripts = ['/geoservices/apps/viewer/dist/cesium/Build/Cesium/Cesium.js'];
	              olcsScripts = ['/geoservices/apps/viewer/dist/olcs/olcesium.js', '/geoservices/apps/viewer/dist/olcs/olcs.css'];
	              _context.next = 10;
	              return (0, _fetchInject2.default)(projDefs, (0, _fetchInject2.default)(olcsScripts, (0, _fetchInject2.default)(olScripts, (0, _fetchInject2.default)(cesiumScripts))));
	
	            case 10:
	              _context.next = 14;
	              break;
	
	            case 12:
	              _context.next = 14;
	              return (0, _fetchInject2.default)(projDefs, (0, _fetchInject2.default)(olScripts));
	
	            case 14:
	              _context.next = 19;
	              break;
	
	            case 16:
	              llScripts = ['/geoservices/apps/viewer/dist/leaflet/leaflet-min.js', '/geoservices/apps/viewer/dist/leaflet/leaflet-min.css'];
	              _context.next = 19;
	              return (0, _fetchInject2.default)(llScripts);
	
	            case 19:
	
	              _this.messageEventListener();
	
	              GV.globals.SESSION.ID = (0, _uuid.v4)();
	
	              if (!options.application.auth) {
	                _context.next = 38;
	                break;
	              }
	
	              authOptions = options.application.auth.options;
	              _context.t0 = options.application.auth.type;
	              _context.next = _context.t0 === 'NAM' ? 26 : _context.t0 === 'S3' ? 31 : 36;
	              break;
	
	            case 26:
	              _context.next = 28;
	              return (0, _getAuth2.default)(options.application.name, authOptions.ruolo);
	
	            case 28:
	              auth = _context.sent;
	
	              if (auth.success) {
	                console.log(auth.data);
	                GV.globals.SESSION.AUTH.RUOLO = auth.data.ruolo;
	                GV.globals.SESSION.AUTH.COD_FISCALE = auth.data.cod_fiscale;
	                GV.globals.SESSION.AUTH.LOGIN = auth.data.login;
	                GV.globals.SESSION.AUTH.NOME = auth.data.nome;
	                GV.globals.SESSION.AUTH.COGNOME = auth.data.cognome;
	                GV.globals.SESSION.AUTH.RUOLI_UTENTE = auth.data.ruoli_utente;
	
	                _this.initConfig(options);
	              } else {
	                (0, _notification2.default)('ACCESSO ALLA APPLICAZIONE NON AUTORIZZATO');
	              }
	              return _context.abrupt('break', 36);
	
	            case 31:
	              _context.next = 33;
	              return (0, _getS3Token2.default)(authOptions.s3Token, authOptions.s3TokenType, authOptions.s3TokenProv);
	
	            case 33:
	              s3Token = _context.sent;
	
	              if (s3Token.success && s3Token.found) _this.initConfig(options);else (0, _notification2.default)('ACCESSO ALLA APPLICAZIONE NON AUTORIZZATO');
	              return _context.abrupt('break', 36);
	
	            case 36:
	              _context.next = 39;
	              break;
	
	            case 38:
	              _this.initConfig(options);
	
	            case 39:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  messageEventListener: function messageEventListener() {
	    window.addEventListener('message', function (event) {
	      var data = event.data;
	      if (!data.type) return;
	    }, false);
	  },
	  initConfig: function initConfig(options) {
	    GV.config = _config2.default;
	    _config2.default.init(options);
	    _vue2.default.component('gv-app', _App2.default);
	    var vm = new _vue2.default({
	      el: '#gv-container',
	      template: '<gv-app></gv-app>'
	    });
	    return vm;
	  },
	  mountLegend: function mountLegend() {
	    (0, _mountComponent2.default)({
	      elId: 'gv-legend',
	      clear: true,
	      containerId: GV.config.containerId,
	      vm: new _vue2.default({
	        template: '<gv-legend ref="gv-legend"></gv-legend>'
	      })
	    });
	  },
	  mount: function mount(options) {
	    (0, _mountComponent2.default)({
	      elId: options.eldId,
	      clear: options.clear,
	      toggleEl: options.toggleEl,
	      containerId: GV.config.containerId,
	      vm: new _vue2.default({
	        template: options.template,
	        data: options.data
	      })
	    });
	  },
	
	  dragbox: _dragbox2.default,
	  globals: _globals2.default,
	  log: _log2.default,
	  eventBus: new _vue2.default(),
	  utils: {
	    getUrlParam: _getUrlParam2.default,
	    buildFindOptionsFromQueryStringParams: _buildFindOptionsFromQueryStringParams2.default,
	    insertAgCoordinate: _insertAgCoordinate2.default,
	    notification: _notification2.default,
	    insertGeomPraticaGenio: _insertGeomPraticaGenio2.default,
	    getS3TokenBbox: _getS3TokenBbox2.default,
	    getS3Token: _getS3Token2.default,
	    getGeneric: _getGeneric2.default
	  },
	  tools: _tools2.default,
	  gvInfoFeatures: []
	};

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  DEFAULT_PROXY: '/geoservices/REST/proxy/proxy?url=',
	
	  USE_SUBDOMAINS: true,
	
	  SESSION: {
	    ID: null,
	    AUTH: {
	      RUOLO: null,
	      COD_FISCALE: null,
	      LOGIN: null,
	      NOME: null,
	      COGNOME: null,
	      RUOLI_UTENTE: null
	    }
	  },
	
	  RL_MAP_CONFIG_SERVICE: '/geoservices/REST/geoportale/map/',
	  RL_LAYER_CONFIG_SERVICE: '/geoservices/REST/config/layer/',
	  RL_QUERY_LAYER_VALUE_LIST_SERVICE: '/geoservices/REST/config/query_layer_valuelist/',
	  RL_QUERY_LAYER_TOPO_VALUE_LIST_SERVICE: '/geoservices/REST/config/query_layer_topo_valuelist/',
	  RL_QUERY_LAYER_SERVICE: '/geoservices/REST/config/query_layer/',
	  RL_QUERY_LAYER_TOPO_SERVICE: '/geoservices/REST/config/query_layer_topo/',
	  RL_DYN_MAP_CONFIG_SERVICE: '/geoservices/REST/config/map/',
	  RL_XSL_INFO_SERVICE: '/geoservices/REST/config/info_xsl?',
	  RL_CATALOG_SERVICE: '/geoservices/REST/geoportale/catalogo/',
	  RL_CANALI_SERVICE: '/geoservices/REST/config/ag_app_canali_tree/',
	  RL_CANALE_CARTE_SERVICE: '/geoservices/REST/config/ag_canale_tree/',
	  RL_DOWNLOAD_CONFIG_SERVICE: '/geoservices/REST/download/map/',
	  RL_DOWNLOAD_INSERT_SERVICE: '/geoservices/REST/download/insert_richiesta/',
	  RL_DOWNLOAD_ESEGUI_RICHIESTA: '/geoservices/REST/download/elabora_richiesta_sincrona/',
	  RL_ENTI_SERVICE: '/geoservices/REST/geoportale/enti/',
	  RL_METADATA_URL: '/geoservices/REST/metadata/scheda_xml/',
	  RL_TRANSFORM_POINT_SERVICE: '/geoservices/REST/coordinate/transform_point/',
	  RL_TRANSFORM_BBOX_SERVICE: '/geoservices/REST/coordinate/transform_bbox/',
	  RL_TRANSFORM_POLY_SERVICE: '/geoservices/REST/coordinate/transform_poly/',
	  RL_ELEVATION: '/geoservices/REST/coordinate/elevation/',
	  RL_AG_APP_LISTA_MAPPE: '/geoservices/REST/config/ag_app_lista_mappe/',
	
	  RL_TERRAIN_PROVIDER_URL: '/geoservices/REST/proxy/geoserverTerrainProvider',
	
	  RL_CATALOG: 'pub',
	
	  HERE_GEOCODE_PROXY: '/geoservices/REST/proxy/here_geocode.v3',
	
	  MAX_BOUNDS: {
	    X_MIN: 43.4,
	    Y_MIN: 7.3,
	    X_MAX: 44.8,
	    Y_MAX: 10.5
	  },
	
	  INFO_WMS_MAX_FEATURES: 10,
	
	  BASE_SCALES: [591657550.5, 295828775.3, 147914387.6, 73957193.82, 36978596.91, 18489298.45, 9244649.227, 4622324.614, 2311162.307, 1155581.153, 577790.5767, 288895.2884, 144447.6442, 72223.82209, 36111.91104, 18055.95552, 9027.977761, 4513.98888, 2256.99444, 1128.49722, 564.24861, 282.124305],
	
	  BASE_LAYERS: {
	    BLANK: {
	      label: 'Sfondo Bianco',
	      icon: '/geoservices/apps/viewer/static/img/legend/bianco.gif'
	    },
	    RL_ORTOFOTO_1986: {
	      label: 'Ortofotocarta Regionale sc. 1:10000 (B/N) - 1986',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_2000: {
	      label: 'Ortofoto IT 2000',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_COSTIERA_2003: {
	      label: 'Ortofoto Costiera 2003',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_2013: {
	      label: 'AGEA: Ortofoto 2013',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_2010: {
	      label: 'AGEA: Ortofoto 2010',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_2007: {
	      label: 'AGEA: Ortofoto 2007',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_2016: {
	      label: 'AGEA: Ortofoto 2016',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_ORTOFOTO_2019: {
	      label: 'AGEA: Ortofoto 2019',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_CARTE_BASE: {
	      label: 'Carte Regionali 2007 -2013',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_CARTE_BASE_NC25: {
	      label: 'Carta Regionale 1:25000 - DBT NC25',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    RL_CARTE_BASE_GS: {
	      label: 'Carte Regionali 2007 -2013',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    MVT_STREETS: {
	      label: 'Stradario',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    TS_STREETS: {
	      label: 'Stradario',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    TS_BASIC: {
	      label: 'Basic',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    TS_DARK_MATTER: {
	      label: 'Dark',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    TS_POSITRON: {
	      label: 'Positron',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    TS_MONOCHROME: {
	      label: 'Monochrome',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    TS_TONER: {
	      label: 'Toner',
	      icon: '/geoservices/apps/viewer/static/img/legend/sfondi_rl.jpg'
	    },
	    OSM: {
	      label: 'OpenStreetMap',
	      icon: '/geoservices/apps/viewer/static/img/legend/openstreetmap.png'
	    },
	    ESRI_IMAGERY: {
	      label: 'ESRI Imagery',
	      icon: '/geoservices/apps/viewer/static/img/legend/esri.gif'
	    },
	    ESRI_GRAY: {
	      label: 'ESRI Gray',
	      icon: '/geoservices/apps/viewer/static/img/legend/esri.gif'
	    },
	    ESRI_DARKGRAY: {
	      label: 'ESRI Dark Gray',
	      icon: '/geoservices/apps/viewer/static/img/legend/esri.gif'
	    },
	    ESRI_STREETS: {
	      label: 'ESRI Streets',
	      icon: '/geoservices/apps/viewer/static/img/legend/esri.gif'
	    },
	    MAPBOX_STREETS: {
	      label: 'Mapbox Streets',
	      icon: '/geoservices/apps/viewer/static/img/legend/mapbox.png'
	    },
	    MAPBOX_MONOCHROME: {
	      label: 'Mapbox Monochrome',
	      icon: '/geoservices/apps/viewer/static/img/legend/mapbox.png'
	    },
	    MAPBOX_VIABILITA: {
	      label: 'Carta della Viabilità',
	      icon: '/geoservices/apps/viewer/static/img/legend/mapbox.png'
	    },
	    MAPBOX_VIABILITA_SATELLITARE: {
	      label: 'Carta satellitare della Viabilità',
	      icon: '/geoservices/apps/viewer/static/img/legend/mapbox.png'
	    },
	    MAPBOX_OUTDOOR: {
	      label: 'Mapbox Outdoor',
	      icon: '/geoservices/apps/viewer/static/img/legend/mapbox.png'
	    },
	    MAPBOX_LIGHT: {
	      label: 'Mapbox Light',
	      icon: '/geoservices/apps/viewer/static/img/legend/mapbox.png'
	    }
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  "use strict";
	
	  var elId = options.elId,
	      vm = options.vm,
	      toggleEl = options.toggleEl;
	
	
	  var el = document.getElementById(elId);
	
	  if (toggleEl && el) {
	    el.style.display = el.style.display === "none" || !el.style.display ? "block" : "none";
	  } else {
	    var _el = (0, _createElement2.default)(options);
	    vm.$mount(_el);
	  }
	
	  return vm;
	};
	
	var _createElement = __webpack_require__(170);
	
	var _createElement2 = _interopRequireDefault(_createElement);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _notification = __webpack_require__(85);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _notification3 = __webpack_require__(79);
	
	var _notification4 = _interopRequireDefault(_notification3);
	
	exports.default = notification;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function notification(message) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
	
	  var title = type === 'info' ? 'Info' : 'Attenzione!';
	
	  if (message && type) {
	    (0, _notification4.default)({
	      title: title,
	      type: type,
	      duration: duration,
	
	      offset: 70,
	      dangerouslyUseHTMLString: true,
	      position: 'bottom-left',
	      message: message
	    });
	  }
	}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(92);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _parseXML = __webpack_require__(177);
	
	var _parseXML2 = _interopRequireDefault(_parseXML);
	
	var _stringFormat = __webpack_require__(409);
	
	var _stringFormat2 = _interopRequireDefault(_stringFormat);
	
	var _getParamString = __webpack_require__(171);
	
	var _getParamString2 = _interopRequireDefault(_getParamString);
	
	var _getFeatureInfo = __webpack_require__(91);
	
	var _getFeatureInfo2 = _interopRequireDefault(_getFeatureInfo);
	
	var _getFeatureInfoXML = __webpack_require__(378);
	
	var _getFeatureInfoXML2 = _interopRequireDefault(_getFeatureInfoXML);
	
	var _getFeatureInfoGeojson = __webpack_require__(375);
	
	var _getFeatureInfoGeojson2 = _interopRequireDefault(_getFeatureInfoGeojson);
	
	var _getFeatureInfoText = __webpack_require__(377);
	
	var _getFeatureInfoText2 = _interopRequireDefault(_getFeatureInfoText);
	
	var _getFeatureInfoHTML = __webpack_require__(376);
	
	var _getFeatureInfoHTML2 = _interopRequireDefault(_getFeatureInfoHTML);
	
	var _getWFSFeature = __webpack_require__(37);
	
	var _getWFSFeature2 = _interopRequireDefault(_getWFSFeature);
	
	var _getFeatureXSLT = __webpack_require__(379);
	
	var _getFeatureXSLT2 = _interopRequireDefault(_getFeatureXSLT);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _LayerFactory = __webpack_require__(161);
	
	var LayerFactory = _interopRequireWildcard(_LayerFactory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _requestCount = 0;
	var _numRequests = 0;
	var _features = [];
	
	
	function _request(event) {
	  GV.log('start info request: ' + new Date());
	
	  _requestCount = 0;
	  _numRequests = 0;
	  _features = [];
	
	  GV.config.maps.forEach(function (mapConfig) {
	    mapConfig.layers.forEach(function (layerConfig) {
	      if (layerConfig.type === 'WMS' && layerConfig.queryable && layerConfig.visible && GV.app.map.layerInRange(layerConfig)) {
	        if (!layerConfig.wmsParams.infoFormat) layerConfig.wmsParams.infoFormat = 'application/json';
	        var infoFormat = layerConfig.wmsParams.infoFormat;
	        queryLayer(layerConfig, infoFormat);
	      }
	    });
	  });
	
	  function queryLayer(layerConfig, infoFormat) {
	    var wmsUrl = getGetFeatureInfoUrl(layerConfig, event);
	    _numRequests++;
	
	    switch (infoFormat) {
	      case 'application/json':
	        (0, _getFeatureInfo2.default)(wmsUrl).then(function (features) {
	          return _handleResponse(features, layerConfig.name);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	        break;
	      case 'application/geojson':
	        (0, _getFeatureInfoGeojson2.default)(wmsUrl, layerConfig.wmsParams.name).then(function (features) {
	          return _handleResponse(features, layerConfig.name);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	        break;
	      case 'text/plain':
	        (0, _getFeatureInfoText2.default)(wmsUrl, layerConfig.wmsParams.name).then(function (data) {
	          return _handleResponse(data, layerConfig.name);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	        break;
	      case 'application/vnd.ogc.gml':
	        (0, _getFeatureInfoXML2.default)(wmsUrl, layerConfig.wmsParams.name, layerConfig.infoOptions).then(function (features) {
	          return _handleResponse(features, layerConfig.name);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	        break;
	      case 'text/html':
	        (0, _getFeatureInfoHTML2.default)(wmsUrl, layerConfig.wmsParams.name).then(function (features) {
	          return _handleResponse(features, layerConfig.name);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	        break;
	      case 'text/xml; subtype=gml/3.2.1':
	        (0, _getFeatureInfoHTML2.default)(wmsUrl, layerConfig.wmsParams.name).then(function (features) {
	          return _handleResponse(features, layerConfig.name);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	        break;
	    }
	  }
	}
	
	function getGetFeatureInfoUrl(layerConfig, event) {
	  if (GV.app.map.type === 'openlayers') {
	    return buildOLWMSOptions(layerConfig, event);
	  } else {
	    var wmsUrl = layerConfig.wmsParams.url.startsWith('/geoservices/REST/proxy/proxy?url=') ? layerConfig.wmsParams.url : _globals2.default.DEFAULT_PROXY + layerConfig.wmsParams.url;
	    var url = layerConfig.infoOptions.infoQueryUrl || wmsUrl;
	
	    var layers = layerConfig.infoOptions.infoQueryLayers || layerConfig.wmsParams.name;
	    var cqlFilter = layerConfig.wmsParams.cql_filter;
	    var infoFormat = layerConfig.wmsParams.infoFormat;
	    if (layerConfig.infoOptions.complexFeature) layerConfig.infoOptions.featureCount = 1;
	
	    return buildWMSOptions(url, layers, event.latlng, infoFormat, layerConfig.infoBuffer, cqlFilter, layerConfig.infoOptions.featureCount);
	  }
	}
	
	function buildOLWMSOptions(layerConfig, event) {
	  var url = layerConfig.infoOptions.infoQueryUrl || layerConfig.wmsParams.url;
	  var queryLayers = layerConfig.infoOptions.infoQueryLayers || layerConfig.wmsParams.name;
	  var infoFormat = layerConfig.wmsParams.infoFormat;
	  var buffer = layerConfig.infoBuffer || 10;
	  var viewProjection = GV.app.map.getView().getProjection();
	  var viewResolution = GV.app.map.getView().getResolution();
	  var source = new ol.source.ImageWMS({
	    url: url,
	    params: { LAYERS: layerConfig.wmsParams.name },
	    ratio: 1,
	    serverType: 'geoserver'
	  });
	  if (layerConfig.infoOptions.complexFeature) layerConfig.infoOptions.featureCount = 1;
	  var infoUrl = source.getFeatureInfoUrl(event.coordinate, viewResolution, viewProjection, {
	    INFO_FORMAT: infoFormat,
	    QUERY_LAYERS: queryLayers,
	    FEATURE_COUNT: layerConfig.infoOptions.featureCount || 100,
	    BUFFER: buffer
	  });
	  infoUrl = _globals2.default.DEFAULT_PROXY + infoUrl;
	  return infoUrl;
	}
	
	function buildWMSOptions(url, layers, latlng, infoFormat, infoBuffer, cqlFilter, featureCount) {
	  var point = GV.app.map.getContainerPoint(latlng);
	  var size = GV.app.map.getSize();
	  var bbox = GV.app.map.getBbox();
	  var buffer = infoBuffer === null || infoBuffer === undefined ? 10 : infoBuffer;
	  var params = {
	    request: 'GetFeatureInfo',
	    service: 'WMS',
	    crs: 'EPSG:3857',
	    styles: '',
	    version: '1.3.0',
	    bbox: bbox,
	    height: size.y,
	    width: size.x,
	    layers: layers,
	    query_layers: layers,
	    FEATURE_COUNT: featureCount || 100,
	    buffer: buffer,
	    info_format: infoFormat,
	    i: parseInt(point.x),
	    j: parseInt(point.y)
	  };
	  if (cqlFilter) {
	    params.cql_filter = cqlFilter;
	  }
	  return url + (0, _getParamString2.default)(params, url, true);
	}
	
	function _handleResponse(features, layerName) {
	  if (!features) return;
	  _requestCount++;
	
	  features.forEach(function (feature) {
	    if (feature.text) {
	      feature.layer = GV.app.map.getLayerByName(feature.layerName);
	      feature.infoOptions = feature.layer.config.infoOptions;
	    } else {
	      feature.layerName = layerName;
	      feature.layer = GV.app.map.getLayerByName(layerName);
	
	      feature.properties = setFeatureProperties(layerName, feature.properties);
	      feature.infoOptions = feature.layer.config.infoOptions;
	      feature.label = feature.infoOptions.complexFeature ? setFeatureLabelComplex(layerName, feature.properties) : setFeatureLabel(layerName, feature.properties);
	    }
	  });
	
	  Array.prototype.push.apply(_features, features);
	  if (_requestCount === _numRequests) {
	    if (_features.length === 0) {
	      GV.log('Nessun elemento trovato');
	      return;
	    }
	    if (_features.length === 1) {
	      var listDiv = document.getElementById('gv-info-wms-list');
	      if (listDiv) {
	        listDiv.parentNode.removeChild(listDiv);
	      }
	      _showFeatureInfo(_features[0]);
	    } else {
	      (0, _mountComponent2.default)({
	        elId: 'gv-info-wms-list',
	        clear: true,
	        vm: new _vue2.default({
	          template: '<gv-info-wms-list :items="items"></gv-info-wms-list>',
	          data: {
	            items: _features
	          }
	        })
	      });
	    }
	
	    GV.log('end info request: ' + new Date());
	  }
	
	  function setFeatureProperties(layerName, properties) {
	    var layerConfig = GV.app.map.getLayerByName(layerName).config;
	    var newProperties = setProperties(properties, layerConfig.cachePostGIS);
	    return newProperties;
	  }
	
	  function setProperties(props, postGis) {
	    var newProps = {};
	    for (var key in props) {
	      if (key !== 'bbox' && props.hasOwnProperty(key)) {
	        if (postGis) {
	          newProps[key.toUpperCase()] = props[key];
	        } else {
	          newProps[key] = props[key];
	        }
	      }
	    }
	    return newProps;
	  }
	
	  function upperProperties(props) {
	    var newProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key)) {
	        newProps[key.toUpperCase()] = props[key];
	      }
	    }
	    return newProps;
	  }
	
	  function setFeatureLabelComplex(layerName, attributes) {
	    var infoLabelAttr, infoIdAttr;
	    infoLabelAttr = getField(layerName, 'infoLabelAttr');
	    infoIdAttr = getField(layerName, 'infoIdAttr');
	    if (infoLabelAttr) {
	      var label = eval('attributes.' + infoLabelAttr);
	      return label;
	    }
	    if (infoIdAttr && attributes[infoIdAttr]) {
	      var _label = eval('attributes.' + infoIdAttr);
	      return _label;
	    }
	  }
	
	  function setFeatureLabel(layerName, attributes) {
	    var infoLabelAttr, infoIdAttr;
	    infoLabelAttr = getField(layerName, 'infoLabelAttr');
	    infoIdAttr = getField(layerName, 'infoIdAttr');
	    if (infoLabelAttr && attributes[infoLabelAttr]) {
	      return attributes[infoLabelAttr];
	    }
	    if (infoIdAttr && attributes[infoIdAttr]) {
	      return attributes[infoIdAttr];
	    }
	    return attributes[getFirstAttribute(attributes)];
	  }
	
	  function getField(layerName, fieldName) {
	    var layerConfig = GV.app.map.getLayerByName(layerName).config;
	    return layerConfig && layerConfig.infoOptions && layerConfig.infoOptions[fieldName] ? layerConfig.infoOptions[fieldName] : null;
	  }
	
	  function getFirstAttribute(attributes) {
	    for (var i in attributes) {
	      if (attributes.hasOwnProperty(i) && typeof i !== 'function') {
	        return i;
	      }
	    }
	    return null;
	  }
	}
	
	function _showFeatureInfo(feature) {
	  var type = getType(feature);
	  switch (type) {
	    case 'text':
	      showText(feature);
	      break;
	    case 'generico':
	      showGenerico(feature);
	      break;
	    case 'xsl':
	      showXml(feature);
	      break;
	    case 'gvi':
	      showGvInfo(feature);
	      break;
	    case 'function':
	      showFunction(feature);
	      break;
	    case 'html':
	      showStaticHtml(feature);
	      break;
	    case 'gml':
	      showRawGml(feature);
	      break;
	    default:
	      showHtml(feature);
	      break;
	  }
	
	  if (!GV.app.map.options.noInfoHiliteFeature) hiliteFeature(feature);
	}
	
	function showFunction(feature) {
	  if (feature.infoOptions.infoFunction) {
	    feature.infoOptions.infoFunction(feature);
	  }
	}
	
	function showGvInfo(feature) {
	  var featureId = feature.id;
	  var layerId = feature.layer.config.id;
	  GV.gvInfoFeatures[featureId] = feature;
	  var panelId = 'gvi-info-' + featureId;
	  var url = '/geoservices/apps/gvi/info/' + layerId + '/?feature_id=' + featureId;
	  if (!feature.infoOptions.infoTarget || feature.infoOptions.infoTarget === 'panel') {
	    showPanel(url, feature.infoOptions, panelId);
	  } else {
	    openPopup(url, feature.infoOptions);
	  }
	}
	
	function showHtml(feature) {
	  var url = (0, _stringFormat2.default)(feature.infoOptions.infoUrl, feature.properties);
	  if (!feature.infoOptions.infoTarget || feature.infoOptions.infoTarget === 'panel') {
	    showPanel(url, feature.infoOptions);
	  } else {
	    openPopup(url, feature.infoOptions);
	  }
	}
	
	function showStaticHtml(feature) {
	  var panelId = 'gvi-info';
	  var html = feature.html;
	  showPanel(null, feature.infoOptions, panelId, html);
	}
	
	function showGenerico(feature) {
	  var title = feature.layer.legend.label;
	  (0, _mountComponent2.default)({
	    elId: 'gv-info-generico',
	    vm: new _vue2.default({
	      template: '<gv-info-generico :properties="properties" :height="height" :width="width" :title="title"></gv-info-generico>',
	      data: {
	        title: title,
	        properties: feature.properties,
	        width: feature.infoOptions.infoWidth || 400,
	        height: feature.infoOptions.infoHeight || 600
	      }
	    })
	  });
	}
	
	function showText(feature) {
	  var infoOptions = feature.infoOptions;
	  var infoUrl = infoOptions.infoUrl;
	  var data = {
	    text: feature.text.replace(/(?:\r\n|\r|\n)/g, '<br>')
	  };
	  (0, _getFeatureXSLT2.default)(infoUrl, data).then(function (resp) {
	    var url = resp.infoUrl;
	    showPanel(url, infoOptions);
	  });
	}
	
	function showXml(data) {
	  var infoOptions = data.infoOptions;
	
	  var xmlDoc = buildGml(data);
	  data.gml = new XMLSerializer().serializeToString(xmlDoc);
	  var infoUrl = infoOptions.infoUrl,
	      infoTarget = infoOptions.infoTarget;
	
	
	  (0, _getFeatureXSLT2.default)(infoUrl, data).then(function (resp) {
	    var url = resp.infoUrl;
	
	    if (!infoTarget || infoTarget === 'panel') {
	      showPanel(url, infoOptions);
	    } else {
	      openPopup(url, infoOptions);
	    }
	  });
	
	  function buildGml(feature) {
	    try {
	      var baseXml = '<?xml version="1.0" encoding="ISO-8859-1"?><msGMLOutput xmlns:gml="http://www.opengis.net/gml" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"></msGMLOutput>';
	      var xmlDoc = (0, _parseXML2.default)(baseXml);
	      var name = /^\d/.test(feature.layerName) ? 'L' + feature.layerName.replace(/\s+/g, '_') : feature.layerName.replace(/\s+/g, '_');
	      var layerName = name + '_layer';
	      var layerNode = xmlDoc.createElement(layerName);
	      var featureName = name + '_feature';
	      var featureNode = xmlDoc.createElement(featureName);
	      var attributes = feature.properties;
	
	      for (var key in attributes) {
	        if (attributes.hasOwnProperty(key) && key !== 'boundedBy') {
	          var text = null;
	          if (attributes[key] === 0 || attributes[key]) {
	            text = xmlDoc.createTextNode(attributes[key]);
	          } else {
	            text = xmlDoc.createTextNode('');
	          }
	          var nodeName = key.match(/^\d/) ? '_' + key : key;
	
	          var attrNode = xmlDoc.createElement(nodeName);
	          attrNode.appendChild(text);
	          featureNode.appendChild(attrNode);
	        }
	      }
	      layerNode.appendChild(featureNode);
	      xmlDoc.documentElement.appendChild(layerNode);
	      return xmlDoc;
	    } catch (exception) {
	      console.error(exception);
	    }
	  }
	
	  function xslTransform(xmlDoc, xslDoc) {
	    try {
	      if (window.XSLTProcessor) {
	        var xsltProcessor = new XSLTProcessor();
	        xsltProcessor.importStylesheet(xslDoc);
	        var transformedDoc = xsltProcessor.transformToDocument(xmlDoc);
	        return new XMLSerializer().serializeToString(transformedDoc);
	      } else {
	        return xmlDoc.transformNode(xslDoc);
	      }
	    } catch (exception) {
	      console.error(exception);
	    }
	  }
	}
	
	function showRawGml(data) {
	  var infoOptions = data.infoOptions;
	  var infoUrl = infoOptions.infoUrl,
	      infoTarget = infoOptions.infoTarget;
	
	
	  (0, _getFeatureXSLT2.default)(infoUrl, data).then(function (resp) {
	    var url = resp.infoUrl;
	
	    if (!infoTarget || infoTarget === 'panel') {
	      showPanel(url, infoOptions);
	    } else {
	      openPopup(url, infoOptions);
	    }
	  });
	}
	
	function getType(feature) {
	  console.log(feature);
	  var infoUrl = feature.infoOptions.infoUrl;
	  if (feature.text) return 'text';
	  if (feature.html) return 'html';
	  if (feature.gml) return 'gml';
	  if (infoUrl === 'gvi') return 'gvi';
	  if (infoUrl === 'function') return 'function';
	  if (infoUrl.substr(infoUrl.length - 12) === 'generico.xsl') return 'generico';
	  if (infoUrl.substr(infoUrl.length - 4) === '.xsl') return 'xsl';
	}
	
	function hiliteFeature(feature) {
	  if (feature.layer.config.flagGeoserver && feature.layer.config.geomType === 'VECTOR') {
	    var layerName = [feature.layerName];
	    var layerConfig = feature.layer.config;
	    var idAttr = layerConfig.infoOptions.infoIdAttr;
	    if (idAttr && layerConfig.cachePostGIS) {
	      idAttr = idAttr.toLowerCase();
	    }
	    var cqlFilter = idAttr + '=\'' + feature.properties[layerConfig.infoOptions.infoIdAttr] + '\'';
	    if (feature.layer.config.wmsParams.cql_filter) {
	      cqlFilter += ' AND ' + feature.layer.config.wmsParams.cql_filter;
	    }
	    (0, _getWFSFeature2.default)(layerConfig.wfsParams, cqlFilter, null).then(function (features) {
	      var findOptions = { noZoom: true };
	      GV.app.map.hiliteFeatures(features, findOptions);
	    });
	  }
	  if (feature.layer.config.infoOptions.complexFeature) {
	    var url = '/geoservices/REST/config/info_hilite_complex_feature/';
	    fetch(url, {
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      body: (0, _stringify2.default)({
	        gml: feature.gml
	      })
	    }).then(function (response) {
	      return response.json();
	    }).then(function (data) {
	      var findOptions = { noZoom: true };
	      var features = [{
	        type: 'Feature',
	        geometry: data
	      }];
	      GV.app.map.hiliteFeatures(features, findOptions);
	    }).catch(function (error) {
	      console.error('Error:', error);
	    });
	  }
	}
	
	function showPanel(url, configOptions, panelId, html) {
	  var id = panelId || 'gv-info-wms-html';
	  (0, _mountComponent2.default)({
	    elId: id,
	    vm: new _vue2.default({
	      template: '<gv-info-wms-html :src="src" :html="html" :height="height" :width="width" :title="title" :id="id"></gv-info-wms-html>',
	      data: {
	        title: 'Risultato Info',
	        src: url,
	        html: html,
	        width: configOptions.infoWidth || 400,
	        height: configOptions.infoHeight || 400,
	        id: id
	      }
	    })
	  });
	}
	
	function openPopup(url, options) {
	  var width = options.infoWidth || 400;
	  var height = options.infoHeight || 500;
	  var target = '';
	  var opts = '';
	  if (options.infoTarget !== 'tab') {
	    target = options.infoTarget;
	    opts = 'status=yes, toolbar=yes, menubar=no, width=' + width + ', height=' + height + ', resizable=yes, scrollbars=yes';
	  }
	
	  var popup = window.open(url, target, opts);
	
	  var timer = setInterval(function () {
	    if (popup.closed) {
	      clearInterval(timer);
	      GV.app.map.clearLayer('InfoWmsHilite');
	    }
	  }, 1000);
	
	  if (!popup) {
	    (0, _notification2.default)('Popup bloccata sul browser<br>Per visualizzare info è necessario abilitare popup', 'info');
	    return;
	  }
	  return popup;
	}
	
	function addHiliteLayer() {
	  if (GV.app.map.type === 'openlayers') {
	    addHiliteLayerOL();
	  } else {
	    addHiliteLayerLL();
	  }
	}
	
	function addHiliteLayerOL() {
	  var color = [255, 204, 0, 0.6];
	  var stroke = new ol.style.Stroke({
	    color: color,
	    width: 6
	  });
	  var styles = {
	    Point: new ol.style.Style({
	      image: new ol.style.Circle({
	        radius: 8,
	        fill: null,
	        stroke: stroke
	      })
	    }),
	    MultiPoint: new ol.style.Style({
	      image: new ol.style.Circle({
	        radius: 8,
	        fill: null,
	        stroke: stroke
	      })
	    }),
	    LineString: new ol.style.Style({
	      stroke: stroke
	    }),
	    MultiLineString: new ol.style.Style({
	      stroke: stroke
	    }),
	    Polygon: new ol.style.Style({
	      stroke: stroke
	    }),
	    MultiPolygon: new ol.style.Style({
	      stroke: stroke
	    }),
	    GeometryCollection: new ol.style.Style({
	      stroke: stroke,
	      image: new ol.style.Circle({
	        radius: 8,
	        fill: null,
	        stroke: stroke
	      })
	    })
	  };
	
	  GV.app.map.loadLayers([{
	    name: 'InfoWmsHilite',
	    type: 'JSON',
	    style: function style(feature) {
	      return styles[feature.getGeometry().getType()];
	    },
	    visible: true,
	    zIndex: 1000
	  }]);
	}
	
	function addHiliteLayerLL() {
	  GV.app.map.loadLayers([{
	    name: 'InfoWmsHilite',
	    type: 'JSON',
	    style: {
	      color: '#ffcc00',
	      fillOpacity: 0,
	      weight: 6,
	      opacity: 0.6
	    },
	    pointToLayer: function pointToLayer(feature, latlng) {
	      return L.circleMarker(latlng, {
	        radius: 8,
	        color: '#ffcc00',
	        fillColor: '#ffcc00',
	        fill: true,
	        fillOpacity: 0.6,
	        weight: 6,
	        opacity: 0.6,
	        alt: ''
	      });
	    },
	    visible: true
	  }]);
	}
	
	function onClick(event) {
	  _request(event);
	}
	
	exports.default = {
	  id: 'info-wms-manager',
	  active: false,
	  firstActivation: true,
	  addHiliteLayer: addHiliteLayer,
	
	  getGetFeatureInfoUrl: getGetFeatureInfoUrl,
	  features: _features,
	
	  activate: function activate() {
	    GV.log('GV.app.infoWmsManager.activate');
	
	    this.active = true;
	
	    if (GV.app.map) {
	      addHiliteLayer(GV.app.map);
	    } else {
	      GV.eventBus.$on('gv-map-mounted', function (map) {
	        addHiliteLayer(map);
	      });
	    }
	
	    GV.app.map.on('click', onClick);
	
	    GV.app.infoWmsManager = this;
	    GV.config.activeControl = this;
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.app.infoWmsManager.deactivate');
	    GV.app.map.off('click', onClick);
	    this.active = false;
	  },
	  showFeatureInfo: _showFeatureInfo
	};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	exports.default = getWFSFeature;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getWFSFeature(wfsParams, cqlFilter, wfsUrl) {
	  if (!wfsUrl && !wfsParams && !wfsParams.url) {
	    console.warning('getWFSFeature: URL non impostata');
	    return;
	  }
	  var url = '' + GV.globals.DEFAULT_PROXY + wfsUrl;
	
	  if (wfsParams) {
	    var baseParams = 'service=WFS&version=2.0.0&request=GetFeature&srsName=EPSG%3A4326&outputFormat=application%2Fjson';
	    var _wfsUrl = wfsParams.url.startsWith('/geoservices/REST/proxy/proxy?url=') ? wfsParams.url : _globals2.default.DEFAULT_PROXY + wfsParams.url;
	    url = '' + _wfsUrl + baseParams + '&typeName=' + wfsParams.typeName + '&cql_filter=' + cqlFilter;
	  }
	  var loading = _loading4.default.service({
	    text: 'Attendere...',
	    background: 'rgba(0, 0, 0, 0.8)'
	  });
	  return _axios2.default.get(url).then(function (response) {
	    loading.close();
	    return response.data.features;
	  }).catch(function (error) {
	    loading.close();
	    console.error(error);
	  });
	}

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCoordTransform;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCoordTransform(srsIn, srsOut, x, y) {
	  var url = '' + _globals2.default.RL_TRANSFORM_POINT_SERVICE + srsIn + '/' + srsOut + '/' + x + ',' + y;
	  return _axios2.default.get(url, {});
	}

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    switchActiveButton: function switchActiveButton() {
	      this.active = !this.active;
	      if (this.active) {
	        if (GV.config.activeControl) {
	          GV.config.activeControl.deactivate();
	        }
	        GV.config.activeControl = this.control;
	        if (GV.config.activeButton && this.name !== GV.config.activeButton.name) {
	          GV.config.activeButton.active = false;
	        }
	        GV.config.activeButton = this;
	        GV.config.activeButton.active = true;
	        this.control.activate();
	      } else {
	        this.control.deactivate();
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (this.options && this.options.active) {
	      this.switchActiveButton();
	    }
	  }
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getGeoJSON;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getGeoJSON(url) {
	  var params = {};
	
	  return _axios2.default.get(url, {
	    params: params
	  });
	}

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    var screenWidth = document.documentElement.clientWidth;
	    var maxScreenWidth = 420;
	    var largeScreen = screenWidth > maxScreenWidth;
	
	    return {
	      screenWidth: screenWidth,
	      maxScreenWidth: maxScreenWidth,
	      largeScreen: largeScreen
	    };
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFeatureInfo;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFeatureInfo(url) {
	  var params = {};
	  return _axios2.default.get(url, {
	    params: params
	  }).then(function (response) {
	    return response.data.features;
	  });
	}

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getConfig;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getConfig(idMap) {
	  if (!idMap || idMap === 'null') {
	    throw new Error('Parametro idMap mancante');
	  }
	
	  var url = idMap.startsWith('D') ? '' + _globals2.default.RL_DYN_MAP_CONFIG_SERVICE + idMap : '' + _globals2.default.RL_MAP_CONFIG_SERVICE + idMap;
	
	  var params = {};
	
	  if (GV.config.application.name) {
	    params.app = GV.config.application.name;
	  } else {
	    params.app = 'gv2';
	  }
	
	  if (GV.config.geoserverUrl) {
	    params.geoserverUrl = GV.config.geoserverUrl;
	  }
	
	  if (GV.config.flagGeoserver) {
	    params.geoserver = 'true';
	  }
	
	  return _axios2.default.get(url, {
	    params: params
	  });
	}

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(73);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	    module.exports = factory();
	  } else {
	    root.X2JS = factory();
	  }
	})(undefined, function () {
	  return function (config) {
	    'use strict';
	
	    var VERSION = '1.2.0';
	
	    config = config || {};
	    initConfigDefaults();
	    initRequiredPolyfills();
	
	    function initConfigDefaults() {
	      if (config.escapeMode === undefined) {
	        config.escapeMode = true;
	      }
	
	      config.attributePrefix = config.attributePrefix || '_';
	      config.arrayAccessForm = config.arrayAccessForm || 'none';
	      config.emptyNodeForm = config.emptyNodeForm || 'text';
	
	      if (config.enableToStringFunc === undefined) {
	        config.enableToStringFunc = true;
	      }
	      config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];
	      if (config.skipEmptyTextNodesForObj === undefined) {
	        config.skipEmptyTextNodesForObj = true;
	      }
	      if (config.stripWhitespaces === undefined) {
	        config.stripWhitespaces = true;
	      }
	      config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];
	
	      if (config.useDoubleQuotes === undefined) {
	        config.useDoubleQuotes = false;
	      }
	
	      config.xmlElementsFilter = config.xmlElementsFilter || [];
	      config.jsonPropertiesFilter = config.jsonPropertiesFilter || [];
	
	      if (config.keepCData === undefined) {
	        config.keepCData = false;
	      }
	    }
	
	    var DOMNodeTypes = {
	      ELEMENT_NODE: 1,
	      TEXT_NODE: 3,
	      CDATA_SECTION_NODE: 4,
	      COMMENT_NODE: 8,
	      DOCUMENT_NODE: 9
	    };
	
	    function initRequiredPolyfills() {}
	
	    function getNodeLocalName(node) {
	      var nodeLocalName = node.localName;
	      if (nodeLocalName == null) nodeLocalName = node.baseName;
	      if (nodeLocalName == null || nodeLocalName == '') nodeLocalName = node.nodeName;
	      return nodeLocalName;
	    }
	
	    function getNodePrefix(node) {
	      return node.prefix;
	    }
	
	    function escapeXmlChars(str) {
	      if (typeof str == 'string') return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');else return str;
	    }
	
	    function unescapeXmlChars(str) {
	      return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, '&');
	    }
	
	    function checkInStdFiltersArrayForm(stdFiltersArrayForm, obj, name, path) {
	      var idx = 0;
	      for (; idx < stdFiltersArrayForm.length; idx++) {
	        var filterPath = stdFiltersArrayForm[idx];
	        if (typeof filterPath === 'string') {
	          if (filterPath == path) break;
	        } else if (filterPath instanceof RegExp) {
	          if (filterPath.test(path)) break;
	        } else if (typeof filterPath === 'function') {
	          if (filterPath(obj, name, path)) break;
	        }
	      }
	      return idx != stdFiltersArrayForm.length;
	    }
	
	    function toArrayAccessForm(obj, childName, path) {
	      switch (config.arrayAccessForm) {
	        case 'property':
	          if (!(obj[childName] instanceof Array)) obj[childName + '_asArray'] = [obj[childName]];else obj[childName + '_asArray'] = obj[childName];
	          break;
	      }
	
	      if (!(obj[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0) {
	        if (checkInStdFiltersArrayForm(config.arrayAccessFormPaths, obj, childName, path)) {
	          obj[childName] = [obj[childName]];
	        }
	      }
	    }
	
	    function fromXmlDateTime(prop) {
	      var bits = prop.split(/[-T:+Z]/g);
	
	      var d = new Date(bits[0], bits[1] - 1, bits[2]);
	      var secondBits = bits[5].split('.');
	      d.setHours(bits[3], bits[4], secondBits[0]);
	      if (secondBits.length > 1) d.setMilliseconds(secondBits[1]);
	
	      if (bits[6] && bits[7]) {
	        var offsetMinutes = bits[6] * 60 + Number(bits[7]);
	        var sign = /\d\d-\d\d:\d\d$/.test(prop) ? '-' : '+';
	
	        offsetMinutes = 0 + (sign == '-' ? -1 * offsetMinutes : offsetMinutes);
	
	        d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());
	      } else if (prop.indexOf('Z', prop.length - 1) !== -1) {
	        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));
	      }
	
	      return d;
	    }
	
	    function checkFromXmlDateTimePaths(value, childName, fullPath) {
	      if (config.datetimeAccessFormPaths.length > 0) {
	        var path = fullPath.split('.#')[0];
	        if (checkInStdFiltersArrayForm(config.datetimeAccessFormPaths, value, childName, path)) {
	          return fromXmlDateTime(value);
	        } else return value;
	      } else return value;
	    }
	
	    function checkXmlElementsFilter(obj, childType, childName, childPath) {
	      if (childType == DOMNodeTypes.ELEMENT_NODE && config.xmlElementsFilter.length > 0) {
	        return checkInStdFiltersArrayForm(config.xmlElementsFilter, obj, childName, childPath);
	      } else return true;
	    }
	
	    function parseDOMChildren(node, path) {
	      if (node.nodeType == DOMNodeTypes.DOCUMENT_NODE) {
	        var result = new Object();
	        var nodeChildren = node.childNodes;
	
	        for (var cidx = 0; cidx < nodeChildren.length; cidx++) {
	          var child = nodeChildren.item(cidx);
	          if (child.nodeType == DOMNodeTypes.ELEMENT_NODE) {
	            var childName = getNodeLocalName(child);
	            result[childName] = parseDOMChildren(child, childName);
	          }
	        }
	        return result;
	      } else if (node.nodeType == DOMNodeTypes.ELEMENT_NODE) {
	        var result = new Object();
	        result.__cnt = 0;
	
	        var nodeChildren = node.childNodes;
	
	        for (var cidx = 0; cidx < nodeChildren.length; cidx++) {
	          var child = nodeChildren.item(cidx);
	          var childName = getNodeLocalName(child);
	
	          if (child.nodeType != DOMNodeTypes.COMMENT_NODE) {
	            var childPath = path + '.' + childName;
	            if (checkXmlElementsFilter(result, child.nodeType, childName, childPath)) {
	              result.__cnt++;
	              if (result[childName] == null) {
	                result[childName] = parseDOMChildren(child, childPath);
	                toArrayAccessForm(result, childName, childPath);
	              } else {
	                if (result[childName] != null) {
	                  if (!(result[childName] instanceof Array)) {
	                    result[childName] = [result[childName]];
	                    toArrayAccessForm(result, childName, childPath);
	                  }
	                }
	                result[childName][result[childName].length] = parseDOMChildren(child, childPath);
	              }
	            }
	          }
	        }
	
	        for (var aidx = 0; aidx < node.attributes.length; aidx++) {
	          var attr = node.attributes.item(aidx);
	          result.__cnt++;
	          result[config.attributePrefix + attr.name] = attr.value;
	        }
	
	        var nodePrefix = getNodePrefix(node);
	        if (nodePrefix != null && nodePrefix != '') {
	          result.__cnt++;
	          result.__prefix = nodePrefix;
	        }
	
	        if (result['#text'] != null) {
	          result.__text = result['#text'];
	          if (result.__text instanceof Array) {
	            result.__text = result.__text.join('\n');
	          }
	
	          if (config.stripWhitespaces) result.__text = result.__text.trim();
	          delete result['#text'];
	          if (config.arrayAccessForm == 'property') delete result['#text_asArray'];
	          result.__text = checkFromXmlDateTimePaths(result.__text, childName, path + '.' + childName);
	        }
	        if (result['#cdata-section'] != null) {
	          result.__cdata = result['#cdata-section'];
	          delete result['#cdata-section'];
	          if (config.arrayAccessForm == 'property') delete result['#cdata-section_asArray'];
	        }
	
	        if (result.__cnt == 0 && config.emptyNodeForm == 'text') {
	          result = '';
	        } else if (result.__cnt == 1 && result.__text != null) {
	          result = result.__text;
	        } else if (result.__cnt == 1 && result.__cdata != null && !config.keepCData) {
	          result = result.__cdata;
	        } else if (result.__cnt > 1 && result.__text != null && config.skipEmptyTextNodesForObj) {
	          if (config.stripWhitespaces && result.__text == '' || result.__text.trim() == '') {
	            delete result.__text;
	          }
	        }
	        delete result.__cnt;
	
	        if (config.enableToStringFunc && (result.__text != null || result.__cdata != null)) {
	          result.toString = function () {
	            return (this.__text != null ? this.__text : '') + (this.__cdata != null ? this.__cdata : '');
	          };
	        }
	
	        return result;
	      } else if (node.nodeType == DOMNodeTypes.TEXT_NODE || node.nodeType == DOMNodeTypes.CDATA_SECTION_NODE) {
	        return node.nodeValue;
	      }
	    }
	
	    function startTag(jsonObj, element, attrList, closed) {
	      var resultStr = '<' + (jsonObj != null && jsonObj.__prefix != null ? jsonObj.__prefix + ':' : '') + element;
	      if (attrList != null) {
	        for (var aidx = 0; aidx < attrList.length; aidx++) {
	          var attrName = attrList[aidx];
	          var attrVal = jsonObj[attrName];
	          if (config.escapeMode) attrVal = escapeXmlChars(attrVal);
	          resultStr += ' ' + attrName.substr(config.attributePrefix.length) + '=';
	          if (config.useDoubleQuotes) resultStr += '"' + attrVal + '"';else resultStr += "'" + attrVal + "'";
	        }
	      }
	      if (!closed) resultStr += '>';else resultStr += '/>';
	      return resultStr;
	    }
	
	    function endTag(jsonObj, elementName) {
	      return '</' + (jsonObj.__prefix != null ? jsonObj.__prefix + ':' : '') + elementName + '>';
	    }
	
	    function endsWith(str, suffix) {
	      return str.indexOf(suffix, str.length - suffix.length) !== -1;
	    }
	
	    function jsonXmlSpecialElem(jsonObj, jsonObjField) {
	      if (config.arrayAccessForm == 'property' && endsWith(jsonObjField.toString(), '_asArray') || jsonObjField.toString().indexOf(config.attributePrefix) == 0 || jsonObjField.toString().indexOf('__') == 0 || jsonObj[jsonObjField] instanceof Function) return true;else return false;
	    }
	
	    function jsonXmlElemCount(jsonObj) {
	      var elementsCnt = 0;
	      if (jsonObj instanceof Object) {
	        for (var it in jsonObj) {
	          if (jsonXmlSpecialElem(jsonObj, it)) continue;
	          elementsCnt++;
	        }
	      }
	      return elementsCnt;
	    }
	
	    function checkJsonObjPropertiesFilter(jsonObj, propertyName, jsonObjPath) {
	      return config.jsonPropertiesFilter.length == 0 || jsonObjPath == '' || checkInStdFiltersArrayForm(config.jsonPropertiesFilter, jsonObj, propertyName, jsonObjPath);
	    }
	
	    function parseJSONAttributes(jsonObj) {
	      var attrList = [];
	      if (jsonObj instanceof Object) {
	        for (var ait in jsonObj) {
	          if (ait.toString().indexOf('__') == -1 && ait.toString().indexOf(config.attributePrefix) == 0) {
	            attrList.push(ait);
	          }
	        }
	      }
	      return attrList;
	    }
	
	    function parseJSONTextAttrs(jsonTxtObj) {
	      var result = '';
	
	      if (jsonTxtObj.__cdata != null) {
	        result += '<![CDATA[' + jsonTxtObj.__cdata + ']]>';
	      }
	
	      if (jsonTxtObj.__text != null) {
	        if (config.escapeMode) result += escapeXmlChars(jsonTxtObj.__text);else result += jsonTxtObj.__text;
	      }
	      return result;
	    }
	
	    function parseJSONTextObject(jsonTxtObj) {
	      var result = '';
	
	      if (jsonTxtObj instanceof Object) {
	        result += parseJSONTextAttrs(jsonTxtObj);
	      } else if (jsonTxtObj != null) {
	        if (config.escapeMode) result += escapeXmlChars(jsonTxtObj);else result += jsonTxtObj;
	      }
	
	      return result;
	    }
	
	    function getJsonPropertyPath(jsonObjPath, jsonPropName) {
	      if (jsonObjPath === '') {
	        return jsonPropName;
	      } else return jsonObjPath + '.' + jsonPropName;
	    }
	
	    function parseJSONArray(jsonArrRoot, jsonArrObj, attrList, jsonObjPath) {
	      var result = '';
	      if (jsonArrRoot.length == 0) {
	        result += startTag(jsonArrRoot, jsonArrObj, attrList, true);
	      } else {
	        for (var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {
	          result += startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);
	          result += parseJSONObject(jsonArrRoot[arIdx], getJsonPropertyPath(jsonObjPath, jsonArrObj));
	          result += endTag(jsonArrRoot[arIdx], jsonArrObj);
	        }
	      }
	      return result;
	    }
	
	    function parseJSONObject(jsonObj, jsonObjPath) {
	      var result = '';
	
	      var elementsCnt = jsonXmlElemCount(jsonObj);
	
	      if (elementsCnt > 0) {
	        for (var it in jsonObj) {
	          if (jsonXmlSpecialElem(jsonObj, it) || jsonObjPath != '' && !checkJsonObjPropertiesFilter(jsonObj, it, getJsonPropertyPath(jsonObjPath, it))) continue;
	
	          var subObj = jsonObj[it];
	
	          var attrList = parseJSONAttributes(subObj);
	
	          if (subObj == null || subObj == undefined) {
	            result += startTag(subObj, it, attrList, true);
	          } else if (subObj instanceof Object) {
	            if (subObj instanceof Array) {
	              result += parseJSONArray(subObj, it, attrList, jsonObjPath);
	            } else if (subObj instanceof Date) {
	              result += startTag(subObj, it, attrList, false);
	              result += subObj.toISOString();
	              result += endTag(subObj, it);
	            } else {
	              var subObjElementsCnt = jsonXmlElemCount(subObj);
	              if (subObjElementsCnt > 0 || subObj.__text != null || subObj.__cdata != null) {
	                result += startTag(subObj, it, attrList, false);
	                result += parseJSONObject(subObj, getJsonPropertyPath(jsonObjPath, it));
	                result += endTag(subObj, it);
	              } else {
	                result += startTag(subObj, it, attrList, true);
	              }
	            }
	          } else {
	            result += startTag(subObj, it, attrList, false);
	            result += parseJSONTextObject(subObj);
	            result += endTag(subObj, it);
	          }
	        }
	      }
	      result += parseJSONTextObject(jsonObj);
	
	      return result;
	    }
	
	    this.parseXmlString = function (xmlDocStr) {
	      var isIEParser = window.ActiveXObject || 'ActiveXObject' in window;
	      if (xmlDocStr === undefined) {
	        return null;
	      }
	      var xmlDoc;
	      if (window.DOMParser) {
	        var parser = new window.DOMParser();
	        var parsererrorNS = null;
	
	        if (!isIEParser) {
	          try {
	            parsererrorNS = parser.parseFromString('INVALID', 'text/xml').getElementsByTagName('parsererror')[0].namespaceURI;
	          } catch (err) {
	            parsererrorNS = null;
	          }
	        }
	        try {
	          xmlDoc = parser.parseFromString(xmlDocStr, 'text/xml');
	          if (parsererrorNS != null && xmlDoc.getElementsByTagNameNS(parsererrorNS, 'parsererror').length > 0) {
	            xmlDoc = null;
	          }
	        } catch (err) {
	          xmlDoc = null;
	        }
	      } else {
	        if (xmlDocStr.indexOf('<?') == 0) {
	          xmlDocStr = xmlDocStr.substr(xmlDocStr.indexOf('?>') + 2);
	        }
	        xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
	        xmlDoc.async = 'false';
	        xmlDoc.loadXML(xmlDocStr);
	      }
	      return xmlDoc;
	    };
	
	    this.asArray = function (prop) {
	      if (prop === undefined || prop == null) return [];else if (prop instanceof Array) return prop;else return [prop];
	    };
	
	    this.toXmlDateTime = function (dt) {
	      if (dt instanceof Date) return dt.toISOString();else if (typeof dt === 'number') return new Date(dt).toISOString();else return null;
	    };
	
	    this.asDateTime = function (prop) {
	      if (typeof prop == 'string') {
	        return fromXmlDateTime(prop);
	      } else return prop;
	    };
	
	    this.xml2json = function (xmlDoc) {
	      return parseDOMChildren(xmlDoc);
	    };
	
	    this.xml_str2json = function (xmlDocStr) {
	      var xmlDoc = this.parseXmlString(xmlDocStr);
	      if (xmlDoc != null) return this.xml2json(xmlDoc);else return null;
	    };
	
	    this.json2xml_str = function (jsonObj) {
	      return parseJSONObject(jsonObj, '');
	    };
	
	    this.json2xml = function (jsonObj) {
	      var xmlDocStr = this.json2xml_str(jsonObj);
	      return this.parseXmlString(xmlDocStr);
	    };
	
	    this.getVersion = function () {
	      return VERSION;
	    };
	  };
	});

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(627)
	
	/* script */
	__vue_exports__ = __webpack_require__(298)
	
	/* template */
	var __vue_template__ = __webpack_require__(876)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(587)
	
	/* script */
	__vue_exports__ = __webpack_require__(325)
	
	/* template */
	var __vue_template__ = __webpack_require__(842)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-33e858c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-coordinate-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(24, function (require) {
	      resolve(__webpack_require__(725));
	    });
	  });
	});
	
	var Control = {
	  id: 'coordinate',
	  active: false,
	  latlng: null,
	  activate: function activate() {
	    GV.log('GV.controls.coordinate.activate');
	    this.active = true;
	    this.openPanel();
	    GV.eventBus.$emit('gv-control-coordinate-activate', this);
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.controls.coordinate.deactivate');
	    GV.eventBus.$emit('gv-control-coordinate-deactivate', this);
	    this.active = false;
	    this.closePanel();
	  },
	  openPanel: function openPanel() {
	    (0, _mountComponent2.default)({
	      elId: 'gv-coordinate-panel',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-coordinate-panel></gv-coordinate-panel>'
	      })
	    });
	  },
	  closePanel: function closePanel() {
	    document.getElementById('gv-coordinate-panel').style.display = 'none';
	  }
	};
	
	exports.default = Control;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = undefined;
	
	var _keys = __webpack_require__(57);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(32);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(46);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _getZoomFromScaleDenom = __webpack_require__(173);
	
	var _getZoomFromScaleDenom2 = _interopRequireDefault(_getZoomFromScaleDenom);
	
	var _getWmsError = __webpack_require__(168);
	
	var _getWmsError2 = _interopRequireDefault(_getWmsError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var esriLink = '<a href="https://www.esri.com/">Esri</a>';
	
	function layerLoadEventMngrTile(layer) {
	  var loading = 0,
	      loaded = 0;
	  layer.getSource().on('tileloadstart', function (event) {
	    ++loading;
	    if (loading === 1) GV.eventBus.$emit('layer-load', layer);
	  });
	  layer.getSource().on('tileloadend', function (event) {
	    ++loaded;
	    if (loading === loaded) {
	      loading = 0;
	      loaded = 0;
	      GV.eventBus.$emit('layer-loaded', layer);
	    }
	  });
	  layer.getSource().on('tileloaderror', function (event) {
	    ++loaded;
	    if (loading === loaded) {
	      loading = 0;
	      loaded = 0;
	      GV.eventBus.$emit('layer-loaded', layer);
	    }
	  });
	}
	
	function layerLoadEventMngrWMS(layer) {
	  layer.getSource().on('imageloadstart', function () {
	    GV.eventBus.$emit('layer-load', layer);
	  });
	  layer.getSource().on('imageloadend', function () {
	    GV.eventBus.$emit('layer-loaded', layer);
	  });
	  layer.getSource().on('imageloaderror', function () {
	    GV.eventBus.$emit('layer-loaded', layer);
	  });
	}
	
	function layerLoadEventMngrVector(layer) {
	  var sourceEventListener = layer.getSource().on('change', function (e) {
	    if (layer.getSource().getState() == 'loading') {
	      GV.eventBus.$emit('layer-load', layer);
	    }
	    if (layer.getSource().getState() == 'ready') {
	      GV.eventBus.$emit('layer-loaded', layer);
	      layer.getSource().un('change', sourceEventListener);
	    }
	  });
	}
	
	var layerFactory = {
	  BLANK: function BLANK() {
	    return null;
	  },
	  OSM: function OSM(layerConfig) {
	    layerConfig.legend = {
	      label: 'OpenStreetMap'
	    };
	    var layer = new ol.layer.Tile({
	      source: new ol.source.OSM()
	    });
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  TILESERVER_GL: function TILESERVER_GL(style) {
	    var layer = new ol.layer.Tile({
	      source: new ol.source.XYZ({
	        url: 'https://tileserver-gl.regione.liguria.it/styles/' + style + '/{z}/{x}/{y}.png'
	      })
	    });
	    return layer;
	  },
	  TS_STREETS: function TS_STREETS(layerConfig) {
	    var layer = this.TILESERVER_GL('streets');
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  TS_BASIC: function TS_BASIC(layerConfig) {
	    var layer = this.TILESERVER_GL('basic-preview');
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  TS_DARK_MATTER: function TS_DARK_MATTER(layerConfig) {
	    var layer = this.TILESERVER_GL('dark-matter');
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  TS_POSITRON: function TS_POSITRON(layerConfig) {
	    var layer = this.TILESERVER_GL('positron');
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  TS_MONOCHROME: function TS_MONOCHROME(layerConfig) {
	    var layer = this.TILESERVER_GL('monochrome');
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  TS_TONER: function TS_TONER(layerConfig) {
	    var layer = this.TILESERVER_GL('toner');
	    layer.config = layerConfig;
	    layer.name = layerConfig.name;
	    return layer;
	  },
	  ESRI_IMAGERY: function ESRI_IMAGERY(layerConfig) {
	    var layer = new ol.layer.Tile({
	      source: new ol.source.XYZ({
	        attributions: 'DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community',
	        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
	      })
	    });
	    layerConfig.name = layerConfig.type;
	    layer.name = layerConfig.type;
	
	    return layer;
	  },
	  ESRI_STREETS: function ESRI_STREETS(layerConfig) {
	    var layer = new ol.layer.Tile({
	      source: new ol.source.XYZ({
	        attributions: '&copy; ' + esriLink + ', \'USGS, NOAA',
	        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}'
	      })
	    });
	    layerConfig.name = layerConfig.type;
	    layer.name = layerConfig.type;
	    return layer;
	  },
	  ESRI_TOPOGRAPHIC: function ESRI_TOPOGRAPHIC(layerConfig) {
	    var layer = new ol.layer.Tile({
	      source: new ol.source.XYZ({
	        attributions: '&copy; ' + esriLink + ',USGS, NOAA',
	        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
	      })
	    });
	    layerConfig.name = layerConfig.type;
	    layer.name = layerConfig.type;
	    return layer;
	  },
	  ESRI_GRAY: function ESRI_GRAY(layerConfig) {
	    var layer = new ol.layer.Tile({
	      source: new ol.source.XYZ({
	        attributions: '&copy; ' + esriLink + ', HERE, DeLorme, MapmyIndia, OpenStreetMap contributors',
	        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
	      })
	    });
	    layerConfig.name = layerConfig.type;
	    layer.name = layerConfig.type;
	    return layer;
	  },
	  ESRI_DARKGRAY: function ESRI_DARKGRAY(layerConfig) {
	    var layer = new ol.layer.Tile({
	      source: new ol.source.XYZ({
	        attributions: '&copy; ' + esriLink + ', HERE, DeLorme, MapmyIndia, OpenStreetMap contributors',
	        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}'
	      })
	    });
	    layerConfig.name = layerConfig.type;
	    layer.name = layerConfig.type;
	    return layer;
	  },
	  RL_CARTE_BASE_NC25: function RL_CARTE_BASE_NC25() {
	    var idMap = 2125;
	    var idLayer = 'L7273';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_CARTE_BASE_NC25',
	      cacheMinZoomLevel: 12,
	      maxScale: 10000,
	      minScale: 200000,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0,
	      attributions: 'Regione Liguria'
	    });
	  },
	  RL_CARTE_BASE: function RL_CARTE_BASE() {
	    return this.WMS({
	      visible: false,
	      name: 'RL_CARTE_BASE',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'CARTE_DI_BASE',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/gwc/service/wms?'
	      },
	      zIndex: 1,
	      attributions: 'Regione Liguria'
	    });
	  },
	  RL_ORTOFOTO_2019: function RL_ORTOFOTO_2019() {
	    var idMap = 2248;
	    var idLayer = 'L8256';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_ORTOFOTO_2019',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/png',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0,
	      attributions: 'Ortofoto 20cm/ ©2019 CONSORZIO TeA - TUTTI I DIRITTI RISERVATI'
	    });
	  },
	  RL_ORTOFOTO_2016: function RL_ORTOFOTO_2016() {
	    var idMap = 1828;
	    var idLayer = 'L5802';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_ORTOFOTO_2016',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/png',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0,
	      attributions: 'Ortofoto 20cm/ ©2016 CONSORZIO TeA - TUTTI I DIRITTI RISERVATI'
	    });
	  },
	  RL_ORTOFOTO_2013: function RL_ORTOFOTO_2013() {
	    var idMap = 1661;
	    var idLayer = 'L4419';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_ORTOFOTO_2013',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0,
	      attributions: 'Immagine di proprietà AGEA'
	    });
	  },
	  RL_ORTOFOTO_2010: function RL_ORTOFOTO_2010() {
	    var idMap = 1505;
	    var idLayer = 'L3861';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_ORTOFOTO_2010',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0,
	      attributions: 'Immagine di proprietà AGEA'
	    });
	  },
	  RL_ORTOFOTO_2007: function RL_ORTOFOTO_2007() {
	    var idMap = 1361;
	    var idLayer = 'L3463';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_ORTOFOTO_2007',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/png',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0,
	      attributions: 'Immagine di proprietà AGEA'
	    });
	  },
	  RL_ORTOFOTO_2000: function RL_ORTOFOTO_2000() {
	    var idMap = 48;
	    var idLayer = 'L48';
	    return this.WMS({
	      idMap: idMap,
	      visible: false,
	      name: 'RL_ORTOFOTO_2000',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: idLayer,
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M' + idMap + '/wms?'
	      },
	      zIndex: 0
	    });
	  },
	  WMS: function WMS(layerConfig) {
	    var name = layerConfig.name,
	        cacheMinZoomLevel = layerConfig.cacheMinZoomLevel,
	        minScale = layerConfig.minScale,
	        maxScale = layerConfig.maxScale,
	        wmsParams = layerConfig.wmsParams,
	        zIndex = layerConfig.zIndex,
	        idMap = layerConfig.idMap,
	        attributions = layerConfig.attributions;
	
	    GV.log('layerFactory - Creazione Layer WMS: ' + name);
	    var layer = null;
	
	    var isCached = cacheMinZoomLevel ? true : false;
	    var opacity = layerConfig.opacity || 1;
	    layerConfig.minZoom = minScale ? (0, _getZoomFromScaleDenom2.default)(minScale) : 8;
	    layerConfig.maxZoom = maxScale ? (0, _getZoomFromScaleDenom2.default)(maxScale) - 1 : 20;
	
	    var params = {
	      transparent: true,
	      format: wmsParams.format,
	      styles: wmsParams.styles || '',
	      client: 'GV2'
	    };
	
	    if (wmsParams.cql_filter) {
	      params.cql_filter = wmsParams.cql_filter;
	    }
	
	    if (wmsParams.sld) {
	      params.sld = wmsParams.sld;
	    }
	
	    var url = wmsParams.url + '?';
	    if (isCached) {
	      if (idMap) {
	        url = url.replace('M' + idMap, 'gwc/service');
	        params.layers = 'M' + idMap + ':' + wmsParams.name;
	      } else {
	        params.layers = wmsParams.name;
	      }
	      var urls = _globals2.default.USE_SUBDOMAINS && url.indexOf('geoservizi.regione.liguria.it') > 0 ? [url.replace('geoservizi', 'geoservizi1'), url.replace('geoservizi', 'geoservizi2')] : null;
	      var cacheVersion = url.indexOf('geoservizi.datasiel.net') > 0 ? layerConfig.cacheVersionTest : layerConfig.cacheVersion;
	      (0, _assign2.default)(params, {
	        SRS: 'EPSG:3857',
	        TILESORIGIN: '-20037508,-20037508',
	        width: 256,
	        height: 256,
	        CACHE_VERSION: cacheVersion
	      });
	      var sourceOptions = {
	        params: params
	      };
	      if (urls) {
	        sourceOptions.urls = urls;
	      } else {
	        sourceOptions.url = url;
	      }
	      if (attributions) {
	        sourceOptions.attributions = attributions;
	      }
	      layer = new ol.layer.Tile({
	        source: new ol.source.TileWMS(sourceOptions)
	      });
	      layerLoadEventMngrTile(layer);
	    } else {
	      (0, _assign2.default)(params, {
	        layers: wmsParams.name,
	        ratio: 1
	      });
	      var _sourceOptions = {
	        url: url,
	        params: params
	      };
	      layer = new ol.layer.Image({
	        url: url,
	        source: new ol.source.ImageWMS(_sourceOptions)
	      });
	      layerLoadEventMngrWMS(layer);
	    }
	
	    layer.setOpacity(opacity);
	    layer.setZIndex(zIndex);
	    layer.type = 'WMS';
	    layer.config = layerConfig;
	    layer.name = name;
	
	    return layer;
	  },
	  JSON: function JSON(layerConfig) {
	    return this.Vector(layerConfig);
	  },
	  Vector: function Vector(layerConfig) {
	    var name = layerConfig.name,
	        data = layerConfig.data,
	        url = layerConfig.url,
	        style = layerConfig.style,
	        cluster = layerConfig.cluster,
	        zIndex = layerConfig.zIndex,
	        onFeatureSelect = layerConfig.onFeatureSelect,
	        onHover = layerConfig.onHover,
	        subType = layerConfig.subType,
	        basePopup = layerConfig.basePopup,
	        legend = layerConfig.legend,
	        filter = layerConfig.filter,
	        tooltip = layerConfig.tooltip;
	
	
	    var format = void 0;
	    switch (subType) {
	      case 'KML':
	        format = new ol.format.KML({});
	        break;
	      case 'GPX':
	        format = new ol.format.GPX({});
	        break;
	      default:
	        format = new ol.format.GeoJSON({});
	        break;
	    }
	
	    var vectorSource = new ol.source.Vector({ format: format, url: url });
	
	    var layer = new ol.layer.Vector({
	      source: vectorSource,
	      style: style
	    });
	
	    if (data) {
	      var source = layer.getSource();
	      source.clear(true);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(data.features), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var feature = _step.value;
	
	          var olFeature = new ol.format.GeoJSON().readFeature(feature, {
	            featureProjection: 'EPSG:3857'
	          });
	          source.addFeature(olFeature);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    if (onFeatureSelect) {
	      GV.app.map.on('click', function (evt) {
	        GV.app.map.forEachFeatureAtPixel(evt.pixel, onFeatureSelect, {
	          layerFilter: function layerFilter(fLayer) {
	            return fLayer === layer;
	          }
	        });
	      });
	    }
	
	    if (onHover) {
	      GV.app.map.on('pointermove', function (evt) {
	        GV.app.map.forEachFeatureAtPixel(evt.pixel, onHover, {
	          layerFilter: function layerFilter(fLayer) {
	            return fLayer === layer;
	          }
	        });
	      });
	    }
	
	    if (basePopup) {
	      (function () {
	        var overlay = new ol.Overlay({
	          element: document.getElementById('ol-popup'),
	          autoPan: true,
	          autoPanAnimation: {
	            duration: 250
	          }
	        });
	        GV.app.map.addOverlay(overlay);
	
	        GV.app.map.on('pointermove', function (evt) {
	          var hit = GV.app.map.map.hasFeatureAtPixel(GV.app.map.getEventPixel(evt.originalEvent));
	          document.getElementById('gv-map').style.cursor = hit ? 'pointer' : '';
	        });
	        GV.app.map.on('click', function (evt) {
	          var pixel = evt.pixel;
	          GV.app.map.forEachFeatureAtPixel(pixel, function (feature) {
	            var properties = feature.getProperties();
	            var closer = document.getElementById('ol-popup-closer');
	            closer.onclick = function () {
	              overlay.setPosition(undefined);
	              closer.blur();
	              return false;
	            };
	            var content = document.getElementById('ol-popup-content');
	            content.innerHTML = '<p><b>LIVELLO</b> ' + legend.label + '</p><br>';
	            (0, _keys2.default)(properties).forEach(function (key) {
	              var value = properties[key];
	              if (typeof value === 'string' || value instanceof String || typeof value === 'number') {
	                content.innerHTML += '<b>' + key + ':</b> ' + value + ' <br>';
	              }
	            });
	            overlay.setPosition(evt.coordinate);
	          });
	        });
	      })();
	    }
	
	    layerLoadEventMngrVector(layer);
	
	    if (cluster) {}
	
	    if (zIndex) layer.setZIndex(zIndex);
	
	    layer.set('altitudeMode', 'clampToGround');
	
	    layer.name = name;
	    return layer;
	  },
	  MVT: function MVT(layerConfig, map) {
	    console.log(map);
	    console.log(layerConfig);
	    olms(map, layerConfig.url).then(function (map) {
	      var layers = map.getLayers();
	      layers.getArray().forEach(function (layer) {
	        if (layer.get('mapbox-source')) {
	          console.log('TileServerGL', layer);
	          layer.config = layerConfig;
	          layer.name = layerConfig.name;
	        }
	      });
	    });
	  },
	  MVT_STREETS: function MVT_STREETS(layerConfig, map) {
	    console.log('MVT');
	    var style = 'streets';
	    var url = 'https://tileserver-gl.regione.liguria.it/styles/' + style + '/style.json';
	    this.MVT(url, map.map);
	    return null;
	  }
	};
	
	function create(layerConfig, map) {
	  if (layerFactory[layerConfig.type]) {
	    var layer = layerFactory[layerConfig.type](layerConfig, map);
	
	    layer.legend = layerConfig.legend;
	    layer.config = layerConfig;
	    return layer;
	  } else {
	    throw new Error('Layer di tipo ' + layerConfig.type + ' non gestito');
	  }
	}
	
	exports.create = create;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCatalog;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCatalog() {
	  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var url = _globals2.default.RL_CATALOG_SERVICE;
	  if (params.idMap) {
	    url += params.idMap;
	  }
	  params.cat = GV.globals.RL_CATALOG;
	  return _axios2.default.get(url, { params: params }).then(function (response) {
	    return response.data.data;
	  });
	}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCoordTransformBbox;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCoordTransformBbox(srsIn, srsOut, bbox) {
	  var url = '' + _globals2.default.RL_TRANSFORM_BBOX_SERVICE + srsIn + '/' + srsOut + '/' + bbox;
	  return _axios2.default.get(url, {});
	}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (idMap) {
	  var url = _globals2.default.RL_DOWNLOAD_CONFIG_SERVICE + idMap;
	
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWmsError;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var X2JS = __webpack_require__(116);
	
	function parse(xml) {
	  return new X2JS().xml_str2json(xml);
	}
	
	function getWmsError(url) {
	  var params = {};
	  var url2 = GV.globals.DEFAULT_PROXY + url;
	  return _axios2.default.get(url2).then(function (response) {
	    var xml = response.data;
	    var error = parse(xml);
	    return error;
	  });
	}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (findOptions) {
	    var expressions = [];
	    var field = findOptions.fields;
	    findOptions.values.split(',').forEach(function (value) {
	        expressions.push(field + '=\'' + value + '\'');
	    });
	    var cqlFilter = encodeURIComponent(expressions.join(' OR '));
	    return cqlFilter;
	};

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  var elType = options.elType || 'div';
	  var containerId = options.containerId || 'gv-container';
	  var elId = options.elId;
	  var clear = options.clear;
	
	  if (clear && document.getElementById(elId)) {
	    document.getElementById(elId).remove();
	  }
	
	  var el = document.createElement(elType);
	  el.id = elId;
	  if (document.getElementById(containerId)) {
	    document.getElementById(containerId).appendChild(el);
	  } else {
	    console.log('Elemento ' + containerId + ' non trovato faccio mount su body');
	    document.body.appendChild(el);
	  }
	
	  return el;
	};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getParamString;
	function getParamString(obj, existingUrl, uppercase) {
	  var params = [];
	  for (var i in obj) {
	    params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	  }
	  return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
	}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUrlParam;
	function getUrlParam(paramName) {
	  var results = new RegExp("[\\?&]" + paramName + "=([^&#]*)", "i").exec(window.location.href);
	  if (results && results[1] === "null") results = null;
	  return results ? decodeURIComponent(results[1]) : null;
	}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getZoomFromScaleDenom;
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getZoomFromScaleDenom(scaleDenom) {
	  var zoom = _globals2.default.BASE_SCALES.findIndex(function (scale) {
	    return scaleDenom > scale;
	  });
	  return zoom < 0 ? 20 : zoom;
	}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBrowserIE;
	function isBrowserIE() {
	  return navigator.userAgent.indexOf('MSIE ') > 0 || navigator.userAgent.indexOf('Trident') > 0 || navigator.userAgent.indexOf('Edge') > 0;
	}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTouch;
	function isTouch() {
	  return window.matchMedia('(pointer: coarse)').matches;
	}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (options) {
	  'use strict';
	
	  var componentId = options.componentId,
	      props = options.props,
	      data = options.data,
	      toggleEl = options.toggleEl;
	
	
	  (0, _mountComponent2.default)({
	    componentId: componentId,
	    containerId: GV.config.containerId,
	    toggleEl: toggleEl,
	    vm: new Vue({
	      template: '<' + componentId + ' ' + props + '></' + componentId + '>',
	      data: data
	    })
	  });
	};
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseXML;
	
	var _isBrowserIE = __webpack_require__(174);
	
	var _isBrowserIE2 = _interopRequireDefault(_isBrowserIE);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseXML(data) {
	  try {
	    var xml = null;
	    if ((0, _isBrowserIE2.default)()) {
	      var xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
	      xmlDoc.async = 'false';
	      xmlDoc.loadXML(data);
	      xml = xmlDoc;
	    } else {
	      var parser = new DOMParser();
	      xml = parser.parseFromString(data, 'text/xml');
	    }
	    return xml;
	  } catch (exception) {
	    console.error(exception);
	  }
	}

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(684);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(199)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!./../../../../../node_modules/vue-style-loader/index.js!./../../../../../node_modules/css-loader/index.js?sourceMap!./mapskin.css", function() {
				var newContent = require("!!./../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!./../../../../../node_modules/vue-style-loader/index.js!./../../../../../node_modules/css-loader/index.js?sourceMap!./mapskin.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(614)
	__webpack_require__(615)
	
	/* script */
	__vue_exports__ = __webpack_require__(259)
	
	/* template */
	var __vue_template__ = __webpack_require__(866)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-51bf92fc"
	
	module.exports = __vue_exports__


/***/ }),
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(413);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(57);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _isTouch = __webpack_require__(175);
	
	var _isTouch2 = _interopRequireDefault(_isTouch);
	
	var _getProtocol = __webpack_require__(406);
	
	var _getProtocol2 = _interopRequireDefault(_getProtocol);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Map = __webpack_require__(764);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Legend = __webpack_require__(761);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Header = __webpack_require__(748);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Title = __webpack_require__(149);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-map', _Map2.default);
	
	_vue2.default.component('gv-legend', _Legend2.default);
	
	_vue2.default.component('gv-header', _Header2.default);
	
	_vue2.default.component('gv-title', _Title2.default);
	
	_vue2.default.component('gv-iframe-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(33, function (require) {
	      resolve(__webpack_require__(750));
	    });
	  });
	});
	_vue2.default.component('gv-info-wms-list', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(29, function (require) {
	      resolve(__webpack_require__(754));
	    });
	  });
	});
	_vue2.default.component('gv-info-wms-html', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(30, function (require) {
	      resolve(__webpack_require__(753));
	    });
	  });
	});
	_vue2.default.component('gv-info-generico', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(31, function (require) {
	      resolve(__webpack_require__(752));
	    });
	  });
	});
	
	exports.default = {
	  name: 'gv-app',
	  data: function data() {
	    return {
	      showHeader: GV.config.application.layout.header,
	      showLegend: GV.config.application.layout.legend,
	      showToolbar: GV.config.application.layout.toolbar
	    };
	  },
	  created: function created() {
	    GV.log('gv-app: created');
	    GV.app = this;
	    GV.app.tools = [];
	  },
	  mounted: function mounted() {
	    GV.log('gv-app: mounted');
	
	    this.addTools(GV.config.application.layout.tools);
	
	    GV.eventBus.$emit('gv-app-mounted', this);
	  },
	
	  methods: {
	    addTools: function addTools() {
	      var _this = this;
	
	      if (GV.config.application.layout.tools) {
	        var tools = GV.config.application.layout.tools;
	        tools.forEach(function (item) {
	          var position = item.position || 'topleft';
	          item.options = item.options || {};
	          _this.addTool(item, position);
	        });
	      }
	    },
	    addTool: function addTool(item, position) {
	      var found = false;
	      GV.tools.forEach(function (tool) {
	        if (item.name === tool.name) {
	          found = true;
	          var itemId = item.name;
	          GV.log('gv-app: addTool -> ' + itemId);
	          if (item.active) item.options.active = true;
	          var props = item.options.props ? item.options.props.map(function (prop) {
	            return (0, _keys2.default)(prop)[0] + '=' + (0, _values2.default)(prop)[0];
	          }).join(' ') : '';
	          var containerId = 'gv-tool-' + position;
	          (0, _mountComponent2.default)({
	            containerId: containerId,
	            elId: itemId,
	            vm: new _vue2.default({
	              template: '<' + itemId + ' ' + props + '></' + itemId + '>'
	            }),
	            toggleEl: false
	          });
	        }
	      });
	      if (!found) {
	        console.error('Strumento ' + item.name + ' non trovato');
	      }
	    }
	  }
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _getAtlanteGeochimicoConfig = __webpack_require__(368);
	
	var _getAtlanteGeochimicoConfig2 = _interopRequireDefault(_getAtlanteGeochimicoConfig);
	
	var _InfoWmsManager = __webpack_require__(31);
	
	var _InfoWmsManager2 = _interopRequireDefault(_InfoWmsManager);
	
	var _getFeatureInfo = __webpack_require__(91);
	
	var _getFeatureInfo2 = _interopRequireDefault(_getFeatureInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	_vue2.default.component('gv-atlante-geochimico-scheda-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(37, function (require) {
	      resolve(__webpack_require__(719));
	    });
	  });
	});
	
	exports.default = {
	  data: function data() {
	    return {
	      livelli: [],
	      livello: null,
	      downloadConfig: null,
	      metaData: null,
	      layerConfig: null,
	      show: true,
	      showLegend: false,
	      legendUrl: null,
	      baseMapConfigId: 2037
	    };
	  },
	
	  methods: {
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-panel-collapse gv-color-scheme el-icon-arrow-up' : 'gv-panel-collapse gv-color-scheme el-icon-arrow-down';
	    },
	
	    hidePanel: function hidePanel() {
	      if (this.show) {
	        document.getElementById('ag-wrapper').style.display = 'none';
	      } else {
	        document.getElementById('ag-wrapper').style.display = 'block';
	      }
	      this.show = !this.show;
	    },
	    onChange: function onChange(value) {
	      var layerConfig = this.livelli.filter(function (livello) {
	        return livello.id == value;
	      });
	      this.layerConfig = layerConfig[0];
	      this.loadLayer(layerConfig[0]);
	      this.legendUrl = '/geoservices/REST/atlante_geochimico/legenda/?id=' + this.layerConfig.id;
	      this.showLegend = true;
	      this.cleanUpDownload();
	    },
	    cleanUpDownload: function cleanUpDownload() {
	      var dlPanel = document.getElementById('gv-map-download');
	      if (dlPanel) {
	        dlPanel.parentNode.removeChild(dlPanel);
	      }
	      var layerMacrobacini = GV.app.map.getLayerByName('SelezioneMacrobacino');
	      if (layerMacrobacini) {
	        GV.app.map.removeLayer(layerMacrobacini);
	      }
	
	      if (GV.config.activeControl) GV.config.activeControl.activate();
	    },
	    loadLayer: function loadLayer(layerConfig) {
	      layerConfig.visible = true;
	      layerConfig.legend.popUpFlag = false;
	      layerConfig.multiClasse = false;
	      var idMap = layerConfig.idMap;
	      GV.config.removeMap(idMap);
	      GV.config.removeMap(this.baseMapConfigId);
	      GV.config.addMapConfig({
	        id: idMap,
	        name: 'Atlante Geochimico',
	        flagGeoserver: true,
	        flagDownload: true,
	        downloadConfig: this.downloadConfig,
	        metaData: this.metaData,
	        layers: [layerConfig]
	      });
	      GV.config.addRlMap(this.baseMapConfigId.toString(), true, false);
	    },
	    subscribeMapEvent: function subscribeMapEvent(event) {
	      var _this = this;
	
	      GV.app.map.on('click', function (event) {
	        var wmsUrl = _this.getWmsUrl(event);
	        console.log(wmsUrl);
	        if (_this.layerConfig && _this.layerConfig.visible) {
	          (0, _getFeatureInfo2.default)(wmsUrl).then(function (features) {
	            _this.showInfo(features);
	          });
	        }
	      });
	    },
	    showInfo: function showInfo(features) {
	      var data = {
	        pcdf: features[0].properties.GRAY_INDEX,
	        pest: features[1].properties.GRAY_INDEX,
	        plower: features[2].properties.GRAY_INDEX,
	        pupper: features[3].properties.GRAY_INDEX,
	        Q1: features[4].properties.GRAY_INDEX,
	        Q2: features[5].properties.GRAY_INDEX,
	        Q3: features[6].properties.GRAY_INDEX,
	        QCD: features[7].properties.GRAY_INDEX,
	        cifre: this.layerConfig.infoOptions.cifreSignificative,
	        unitaMisura: this.layerConfig.infoOptions.unitaMisura,
	        titolo: this.layerConfig.title
	      };
	
	      (0, _mountComponent2.default)({
	        elId: 'gv-atlante-geochimico-scheda-panel',
	        clear: true,
	        vm: new _vue2.default({
	          template: '<gv-atlante-geochimico-scheda-panel :pcdf="pcdf" :pest="pest" :plower="plower" :pupper="pupper" :Q1="Q1" :Q2="Q2" :Q3="Q3" :QCD="QCD" :cifre="cifre" :unitaMisura="unitaMisura" :titolo="titolo"></gv-atlante-geochimico-scheda-panel>',
	          data: data
	        })
	      });
	    },
	    getWmsUrl: function getWmsUrl(event) {
	      if (!this.layerConfig) {
	        return;
	      }
	      var infoFormat = 'application/json';
	      this.layerConfig.wmsParams.infoFormat = 'application/json';
	      this.layerConfig.infoBuffer = 0;
	      return _InfoWmsManager2.default.getGetFeatureInfoUrl(this.layerConfig, event);
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    (0, _getAtlanteGeochimicoConfig2.default)().then(function (data) {
	      _this2.livelli = data.layers.sort(function (a, b) {
	        return a.title.localeCompare(b.title);
	      });
	      _this2.livelli.forEach(function (livello) {
	        livello.title = livello.title.replace('2', '₂').replace('3', '₃').replace('5', '₅');
	      });
	      _this2.downloadConfig = data.downloadConfig;
	      _this2.metaData = data.metaData;
	    });
	    GV.config.addRlMap(this.baseMapConfigId.toString(), true, false);
	    this.subscribeMapEvent(event);
	  }
	};

/***/ }),
/* 251 */,
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	exports.default = {
	  name: 'gv-base-layer-switcher',
	  data: function data() {
	    return {
	      baseLayers: GV.config.baseLayers,
	      activeBaseLayer: GV.config.activeBaseLayer
	    };
	  },
	
	  methods: {
	    onChange: function onChange(value) {
	      GV.eventBus.$emit('change-base-layer', {
	        layer: value
	      });
	    }
	  },
	  mounted: function mounted() {
	    GV.baseLayerSwitcher = this;
	  }
	};

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkbox = __webpack_require__(140);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _checkbox3 = __webpack_require__(52);
	
	var _checkbox4 = _interopRequireDefault(_checkbox3);
	
	var _dialog = __webpack_require__(681);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _dialog3 = __webpack_require__(536);
	
	var _dialog4 = _interopRequireDefault(_dialog3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_dialog4.default, _checkbox4.default);
	
	exports.default = {
	  name: 'gv-conferma-dettaglio',
	  props: ['link', 'label', 'idMap'],
	  data: function data() {
	    return {
	      dialogVisible: true,
	      submitDisabled: true
	    };
	  },
	
	  methods: {
	    cancel: function cancel() {
	      this.dialogVisible = false;
	    },
	    submit: function submit() {
	      GV.config.addRlMap(this.idMap, false, true);
	      this.dialogVisible = false;
	    },
	    toggleSubmit: function toggleSubmit() {
	      this.submitDisabled = !this.submitDisabled;
	    }
	  }
	};

/***/ }),
/* 257 */,
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuebar = __webpack_require__(150);
	
	var _vuebar2 = _interopRequireDefault(_vuebar);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _CulturaInfoGallery = __webpack_require__(204);
	
	var _CulturaInfoGallery2 = _interopRequireDefault(_CulturaInfoGallery);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuebar2.default);
	
	_vue2.default.component('gv-cultura-info-gallery', _CulturaInfoGallery2.default);
	
	_locale2.default.use(_it2.default);
	
	exports.default = {
	  name: 'gv-cultura-info',
	  props: {
	    properties: Object
	  },
	  data: function data() {
	    return {
	      show: false,
	      title: 'SCHEDA LUOGO'
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    showGallery: function showGallery() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-cultura-info-gallery',
	        clear: true,
	        vm: new _vue2.default({
	          template: '<gv-cultura-info-gallery :gallery="gallery" ></gv-cultura-info-gallery>',
	          data: {
	            gallery: this.properties.GALLERY
	          }
	        })
	      });
	    },
	
	    closePanel: function closePanel() {
	      var div = document.getElementById('gv-cultura-info');
	      if (!div) return;
	      div.parentNode.removeChild(div);
	      GV.eventBus.$emit('cultura-close-panel', {
	        flagRicerca: this.flagRicerca
	      });
	    },
	    handleLink: function handleLink(index, link_documentazione) {
	      window.open(link_documentazione);
	    }
	  }
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _carouselItem = __webpack_require__(678);
	
	var _carouselItem2 = _interopRequireDefault(_carouselItem);
	
	var _carouselItem3 = __webpack_require__(532);
	
	var _carouselItem4 = _interopRequireDefault(_carouselItem3);
	
	var _carousel = __webpack_require__(679);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _carousel3 = __webpack_require__(533);
	
	var _carousel4 = _interopRequireDefault(_carousel3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component(_carousel4.default.name, _carousel4.default);
	_vue2.default.component(_carouselItem4.default.name, _carouselItem4.default);
	
	_locale2.default.use(_it2.default);
	
	exports.default = {
	  name: 'gv-cultura-info-gallery',
	  props: {
	    gallery: Array
	  },
	  data: function data() {
	
	    return {
	      show: false,
	
	      title: 'Gallery Immagini',
	
	      autoplay: false,
	      interval: 4000
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.resizePanel();
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    resizePanel: function resizePanel() {
	      var carousel = document.getElementsByClassName('el-carousel')[0];
	      var width = carousel.offsetWidth;
	      carousel.setAttribute('style', 'height:' + width / 2.7 + 'px !important; min-height:300px !important');
	    },
	    closePanel: function closePanel() {
	      var div = document.getElementById('gv-cultura-info-gallery');
	      if (!div) return;
	      div.parentNode.removeChild(div);
	      GV.eventBus.$emit('cultura-close-panel', {
	        flagRicerca: this.flagRicerca
	      });
	    },
	    handleLink: function handleLink(index, link_documentazione) {
	      window.open(link_documentazione);
	    }
	  }
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _tableColumn = __webpack_require__(54);
	
	var _tableColumn2 = _interopRequireDefault(_tableColumn);
	
	var _tableColumn3 = __webpack_require__(53);
	
	var _tableColumn4 = _interopRequireDefault(_tableColumn3);
	
	var _table = __webpack_require__(43);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _table3 = __webpack_require__(41);
	
	var _table4 = _interopRequireDefault(_table3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _LegendMaps = __webpack_require__(146);
	
	var _LegendMaps2 = _interopRequireDefault(_LegendMaps);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _loadComponent = __webpack_require__(176);
	
	var _loadComponent2 = _interopRequireDefault(_loadComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-cultura-legend-maps', _LegendMaps2.default);
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	_vue2.default.use(_button4.default);
	_vue2.default.use(_table4.default);
	_vue2.default.use(_tableColumn4.default);
	
	_vue2.default.component('gv-cultura-ricerca', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(16, function (require) {
	      resolve(__webpack_require__(728));
	    });
	  });
	});
	
	exports.default = {
	  name: 'gv-cultura-legend',
	  data: function data() {
	    var options = GV.config.getToolOptions('gv-cultura-legend');
	
	    var visible = !GV.globals.CULTURA_CONFIG.embed && !GV.globals.CULTURA_CONFIG.flagItinerario;
	    return {
	      options: options,
	      maps: GV.config.maps,
	      show: true,
	      visible: visible,
	      tema: 0,
	      title: 'LEGENDA'
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              GV.log('gv-cultura-legend: mounted');
	              GV.legend = _this;
	              GV.config.addMapConfig(_this.options.maps[0]);
	              _this.show = false;
	              _this.hideLegend();
	              (0, _mountComponent2.default)({
	                elId: 'gv-cultura-ricerca',
	                containerId: GV.config.containerId,
	                toggleEl: true,
	                vm: new _vue2.default({
	                  template: '<gv-cultura-ricerca></gv-cultura-ricerca>'
	                })
	              });
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    hideLegend: function hideLegend(event) {
	      if (this.show) {
	        document.getElementById('gv-cultura-legend-wrapper').style.display = 'block';
	        document.getElementById('gv-cultura-legend').style.width = '260px';
	      } else {
	        var wrap = document.getElementById('gv-cultura-legend-wrapper');
	        if (wrap) wrap.style.display = 'none';
	        var legend = document.getElementById('gv-cultura-legend');
	        if (legend) legend.style.width = '100px';
	      }
	      this.show = !this.show;
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-cultura-legend-collapse gv-color-scheme el-icon-arrow-down' : 'gv-cultura-legend-collapse gv-color-scheme el-icon-arrow-up';
	    }
	  }
	};

/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(92);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _upload = __webpack_require__(198);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _upload3 = __webpack_require__(195);
	
	var _upload4 = _interopRequireDefault(_upload3);
	
	var _formItem = __webpack_require__(42);
	
	var _formItem2 = _interopRequireDefault(_formItem);
	
	var _formItem3 = __webpack_require__(39);
	
	var _formItem4 = _interopRequireDefault(_formItem3);
	
	var _form = __webpack_require__(35);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(33);
	
	var _form4 = _interopRequireDefault(_form3);
	
	var _input = __webpack_require__(29);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _input3 = __webpack_require__(20);
	
	var _input4 = _interopRequireDefault(_input3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	_vue2.default.use(_input4.default);
	_vue2.default.use(_form4.default);
	_vue2.default.use(_formItem4.default);
	_vue2.default.use(_upload4.default);
	
	_locale2.default.use(_it2.default);
	
	_vue2.default.use(_loading4.default);
	
	function onFeatureSelect(feature) {
	  var div = document.getElementById('gv-difesa-suolo-foto-info');
	  if (div) div.remove();
	  GV.mount({
	    elId: 'gv-difesa-suolo-foto-info',
	    toggleEl: true,
	    template: '<gv-difesa-suolo-foto-info :feature="feature" ></gv-difesa-suolo-foto-info>',
	    data: {
	      feature: feature
	    }
	  });
	}
	
	exports.default = {
	  name: 'gv-difesa-suolo-foto',
	  data: function data() {
	    var base_url = 'https://geoservizi.regione.liguria.it/geoserver/M2493/wms?';
	
	    var base_layer = {
	      idMap: 'DIFESA_SUOLO_FOTO',
	      type: 'WMS',
	      visible: true,
	      flagGeoserver: true,
	      multiClasse: true,
	      queryable: true,
	      opacity: 1,
	      minScale: 0,
	      maxScale: 0,
	      geomType: 'VECTOR',
	      wmsParams: {
	        url: base_url,
	        name: 'L9643',
	        format: 'image/png8'
	      },
	      wfsParams: {
	        url: base_url,
	        typeName: 'L9643'
	      },
	      infoOptions: {
	        infoUrl: 'function',
	        infoTarget: null,
	        infoWidth: 0,
	        infoHeight: 0,
	        infoIdAttr: 'id',
	        infoLabelAttr: null
	      }
	    };
	
	    var layer_val = window.structuredClone(base_layer);
	    layer_val.id = 'val';
	    layer_val.name = 'val';
	    layer_val.wmsParams.styles = 'circle_green';
	    layer_val.wmsParams.cql_filter = 'login = \'' + GV.globals.SESSION.AUTH.LOGIN + '\' AND session <> \'' + GV.globals.SESSION.ID + '\' AND validato = true';
	    layer_val.legend = {
	      icon: base_url + 'LAYER=L9643&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&style=circle_green',
	      label: 'Storico - Validate'
	    };
	    layer_val.infoOptions.infoFunction = onFeatureSelect;
	
	    var layer_no_val = window.structuredClone(base_layer);
	    layer_no_val.id = 'no_val';
	    layer_no_val.name = 'no_val';
	    layer_no_val.wmsParams.styles = 'circle_red';
	    layer_no_val.wmsParams.cql_filter = 'login = \'' + GV.globals.SESSION.AUTH.LOGIN + '\' AND session <> \'' + GV.globals.SESSION.ID + '\' AND validato = false';
	    layer_no_val.legend = {
	      icon: base_url + 'LAYER=L9643&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&style=circle_red',
	      label: 'Storico - Non Validate'
	    };
	    layer_no_val.infoOptions.infoFunction = onFeatureSelect;
	
	    var layer_val_s = window.structuredClone(base_layer);
	    layer_val_s.id = 'val_s';
	    layer_val_s.name = 'val_s';
	    layer_val_s.wmsParams.styles = 'triangle_blue';
	    layer_val_s.wmsParams.cql_filter = 'login = \'' + GV.globals.SESSION.AUTH.LOGIN + '\' AND session = \'' + GV.globals.SESSION.ID + '\' AND validato = true';
	    layer_val_s.legend = {
	      icon: base_url + 'LAYER=L9643&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&style=triangle_blue',
	      label: 'Sessione attiva - Validate'
	    };
	    layer_val_s.infoOptions.infoFunction = onFeatureSelect;
	
	    var layer_no_val_s = window.structuredClone(base_layer);
	    layer_no_val_s.id = 'no_val_s';
	    layer_no_val_s.name = 'no_val_s';
	    layer_no_val_s.wmsParams.styles = 'triangle_yellow';
	    layer_no_val_s.wmsParams.cql_filter = 'login = \'' + GV.globals.SESSION.AUTH.LOGIN + '\' AND session = \'' + GV.globals.SESSION.ID + '\' AND validato = false';
	    layer_no_val_s.legend = {
	      icon: base_url + 'LAYER=L9643&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&style=triangle_yellow',
	      label: 'Sessione attiva - Non Validate'
	    };
	    layer_no_val_s.infoOptions.infoFunction = onFeatureSelect;
	
	    var url = '/geoservices/REST/difesa_suolo_foto/upload_foto/?sessione=' + GV.globals.SESSION.ID + '&login=' + GV.globals.SESSION.AUTH.LOGIN + '&operatore=' + GV.globals.SESSION.AUTH.NOME + ' ' + GV.globals.SESSION.AUTH.COGNOME;
	
	    return {
	      dsfForm: {
	        fileList: [],
	        inputStyle: 'width: 350px;'
	      },
	
	      show: true,
	      session: GV.globals.SESSION.ID,
	      url: url,
	      layer_val: layer_val,
	      layer_no_val: layer_no_val,
	      layer_val2: {
	        id: 'val',
	        name: 'val',
	        idMap: 'DIFESA_SUOLO_FOTO',
	        type: 'WMS',
	        visible: true,
	        flagGeoserver: true,
	        multiClasse: true,
	        queryable: true,
	        opacity: 1,
	        minScale: 0,
	        maxScale: 0,
	        geomType: 'VECTOR',
	        wmsParams: {
	          url: base_url,
	          name: 'L9643',
	          format: 'image/png8',
	          styles: 'circle_green',
	          cql_filter: 'session <> \'' + GV.globals.SESSION.ID + '\' AND validato = true' },
	        wfsParams: {
	          url: base_url,
	          typeName: 'L9643'
	        },
	        legend: {
	          icon: base_url + 'LAYER=L9643&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&style=circle_green',
	          label: 'Validate' },
	        infoOptions: {
	          infoUrl: 'function',
	          infoFunction: onFeatureSelect,
	          infoTarget: null,
	          infoWidth: 0,
	          infoHeight: 0,
	          infoIdAttr: 'id',
	          infoLabelAttr: null
	        }
	      },
	      layer_val_s: layer_val_s,
	      layer_no_val_s: layer_no_val_s
	    };
	  },
	  mounted: function mounted() {
	    this.addMapConfig();
	    this.addLayers();
	    GV.globals.DIFESA_SUOLO_FOTO = this;
	  },
	
	  methods: {
	    openLogPanel: function openLogPanel() {
	      GV.mount({
	        elId: 'gv-difesa-suolo-foto-log',
	        toggleEl: true,
	        template: '<gv-difesa-suolo-foto-log></gv-difesa-suolo-foto-log>'
	      });
	    },
	    addLayers: function addLayers() {
	      GV.config.addLayerToMap(this.layer_no_val, 'DIFESA_SUOLO_FOTO');
	      GV.config.addLayerToMap(this.layer_val, 'DIFESA_SUOLO_FOTO');
	      GV.config.addLayerToMap(this.layer_no_val_s, 'DIFESA_SUOLO_FOTO');
	      GV.config.addLayerToMap(this.layer_val_s, 'DIFESA_SUOLO_FOTO');
	    },
	    addMapConfig: function addMapConfig() {
	      GV.config.addMapConfig({
	        id: 'DIFESA_SUOLO_FOTO',
	        name: 'Difesa Suolo Foto',
	        flagGeoserver: true,
	        layers: []
	      });
	    },
	    submitFoto: function submitFoto() {
	      this.$refs.dsfUpload.COGNOME = GV.globals.SESSION.AUTH.COGNOME;
	      this.$refs.dsfUpload.submit();
	    },
	    validateAll: function validateAll() {
	      var loading = _loading4.default.service({
	        fullscreen: true,
	        text: 'Salvataggio in corso...',
	        spinner: 'el-icon-loading',
	        background: 'rgba(0, 0, 0, 0.7)'
	      });
	      var url = '/geoservices/REST/difesa_suolo_foto/validate_all/';
	      fetch(url, {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json'
	        },
	        body: (0, _stringify2.default)({
	          session: GV.globals.SESSION.ID
	        })
	      }).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        loading.close();
	        (0, _notification2.default)('Dati salvati');
	        GV.globals.DIFESA_SUOLO_FOTO.refreshMap();
	      }).catch(function (error) {
	        loading.close();
	        (0, _notification2.default)('Errore nel salvataggio: ' + error);
	        console.error('Error:', error);
	      });
	    },
	    clear: function clear() {
	      this.$refs.dsfUpload.clearFiles();
	    },
	    onUploadSuccess: function onUploadSuccess(response, file, fileList) {
	      var _this = this;
	
	      if (!response.success) {
	        var msg = 'Errore durante il caricamento del file ' + file.name + ' - ' + response.message;
	        (0, _notification2.default)(msg, 'error');
	      } else {}
	      setTimeout(function () {
	        _this.refreshMap();
	        _this.clear();
	      }, 1000);
	    },
	    refreshMap: function refreshMap() {
	      this.reloadLayer('no_val', this.layer_no_val);
	      this.reloadLayer('val', this.layer_val);
	      this.reloadLayer('no_val_s', this.layer_no_val_s);
	      this.reloadLayer('val_s', this.layer_val_s);
	    },
	    reloadLayer: function reloadLayer(layerName, layerConfig) {
	      GV.config.removeLayer(layerName);
	      GV.config.addLayerToMap(layerConfig, 'DIFESA_SUOLO_FOTO');
	    },
	    handleExceed: function handleExceed(files, fileList) {
	      (0, _notification2.default)('Numero massimo di file superato', 'warning');
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-panel-collapse gv-color-scheme el-icon-arrow-up' : 'gv-panel-collapse gv-color-scheme el-icon-arrow-down';
	    },
	
	    hidePanel: function hidePanel() {
	      if (this.show) {
	        document.getElementById('gv-difesa-suolo-foto-wrapper').style.display = 'none';
	      } else {
	        document.getElementById('gv-difesa-suolo-foto-wrapper').style.display = 'block';
	      }
	      this.show = !this.show;
	    }
	  }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(92);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuebar = __webpack_require__(150);
	
	var _vuebar2 = _interopRequireDefault(_vuebar);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _CulturaInfoGallery = __webpack_require__(204);
	
	var _CulturaInfoGallery2 = _interopRequireDefault(_CulturaInfoGallery);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _getCoordTransform = __webpack_require__(45);
	
	var _getCoordTransform2 = _interopRequireDefault(_getCoordTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuebar2.default);
	
	_vue2.default.component('gv-difesa-suolo-foto-info-gallery', _CulturaInfoGallery2.default);
	
	_locale2.default.use(_it2.default);
	
	_vue2.default.use(_loading4.default);
	
	exports.default = {
	  name: 'gv-difesa-suolo-foto-info',
	  props: {
	    feature: Object
	  },
	  data: function data() {
	    return {
	      show: false,
	      properties: this.feature.properties,
	      title: 'SCHEDA FOTO',
	      session: GV.globals.SESSION.ID,
	      changed: true,
	      pointHandler: new L.Draw.Marker(GV.app.map.map, {
	        icon: L.icon({
	          iconUrl: '/geoservices/apps/viewer/dist/static/img/marker-icon.png',
	          iconSize: [12, 20],
	          iconAnchor: [6, 20]
	        })
	      }),
	      layer: null,
	      lon: null,
	      lat: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.log(_this.lon, _this.lat);
	              GV.eventBus.$on('gv-control-measure-activate', function (ev) {
	                GV.app.map.on('draw:created', function (e) {
	                  _this.drawCreated(e);
	                });
	              });
	              GV.eventBus.$on('gv-control-measure-deactivate', function (ev) {
	                _this.clear();
	                GV.app.map.off('draw:created');
	              });
	              GV.app.map.on('draw:created', function (e) {
	                _this.drawCreated(e);
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    toggleValidate: function toggleValidate() {},
	
	    closePanel: function closePanel() {
	      var div = document.getElementById('gv-difesa-suolo-foto-info');
	      if (!div) return;
	      div.parentNode.removeChild(div);
	      GV.app.map.clearLayer('InfoWmsHilite');
	      this.clear();
	    },
	    handleLink: function handleLink(index, link_documentazione) {
	      window.open(link_documentazione);
	    },
	    measurePoint: function measurePoint() {
	      this.clear();
	      this.pointHandler.enable();
	    },
	    clear: function clear() {
	      this.pointHandler.disable();
	      this.lon = null;
	      this.lat = null;
	
	      if (this.layer) {
	        GV.app.map.removeLayer(this.layer);
	      }
	    },
	    handleMarker: function handleMarker(latlng) {
	      var _this2 = this;
	
	      (0, _getCoordTransform2.default)('4326', '25832', latlng.lng, latlng.lat).then(function (response) {
	        if (response.data.points) {
	          var coords = response.data.points[0].split(',');
	          _this2.lon = parseInt(coords[0]);
	          _this2.lat = parseInt(coords[1]);
	        }
	      });
	    },
	    drawCreated: function drawCreated(e) {
	      this.layer = e.layer;
	      this.layer.addTo(GV.app.map);
	      this.handleMarker(this.layer.editing._marker._latlng);
	    },
	    submit: function submit() {
	      var r = confirm('Sei sicuro?');
	      if (r == true) {
	        this.saveData();
	      }
	      return;
	    },
	    saveData: function saveData() {
	      var _this3 = this;
	
	      console.log(this.lon, this.lat);
	
	      var loading = _loading4.default.service({
	        fullscreen: true,
	        text: 'Salvataggio in corso...',
	        spinner: 'el-icon-loading',
	        background: 'rgba(0, 0, 0, 0.7)'
	      });
	      var url = '/geoservices/REST/difesa_suolo_foto/update_foto/';
	      fetch(url, {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json'
	        },
	        body: (0, _stringify2.default)({
	          id: this.properties.id,
	          validato: this.properties.validato,
	          direzione: parseInt(this.properties.direzione),
	          lon: this.lon,
	          lat: this.lat
	        })
	      }).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        loading.close();
	        _this3.clear();
	        _this3.toggleValidate();
	        _this3.closePanel();
	        (0, _notification2.default)('Dati salvati');
	        GV.globals.DIFESA_SUOLO_FOTO.refreshMap();
	      }).catch(function (error) {
	        loading.close();
	        (0, _notification2.default)('Errore nel salvataggio: ' + error);
	        console.error('Error:', error);
	      });
	    },
	    deletePhoto: function deletePhoto() {
	      var r = confirm('Sei sicuro?');
	      if (r == true) {
	        this.deleteData();
	      }
	      return;
	    },
	    deleteData: function deleteData() {
	      var _this4 = this;
	
	      var loading = _loading4.default.service({
	        fullscreen: true,
	        text: 'Cancellazione in corso...',
	        spinner: 'el-icon-loading',
	        background: 'rgba(0, 0, 0, 0.7)'
	      });
	      var url = '/geoservices/REST/difesa_suolo_foto/delete_foto/' + this.properties.id;
	      fetch(url).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        loading.close();
	        _this4.toggleValidate();
	        (0, _notification2.default)('Dati salvati');
	        GV.globals.DIFESA_SUOLO_FOTO.refreshMap();
	      }).catch(function (error) {
	        loading.close();
	        (0, _notification2.default)('Errore nel salvataggio: ' + error);
	        console.error('Error:', error);
	      });
	    }
	  }
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _table = __webpack_require__(43);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _table3 = __webpack_require__(41);
	
	var _table4 = _interopRequireDefault(_table3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default, _table4.default);
	
	_locale2.default.use(_it2.default);
	
	_vue2.default.use(_loading4.default);
	
	exports.default = {
	  name: 'gv-difesa-suolo-foto-log',
	  data: function data() {
	    return {
	      login: GV.globals.SESSION.AUTH.LOGIN,
	      session: GV.globals.SESSION.ID,
	      sessions: null,
	      logs: null,
	      sel_session: null,
	      sel_logs: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var url = '/geoservices/REST/difesa_suolo_foto/read_log/' + this.login;
	    fetch(url).then(function (response) {
	      return response.json();
	    }).then(function (data) {
	      _this.logs = data.data.logs;
	      _this.sessions = data.data.sessions;
	      _this.sel_session = _this.session;
	      _this.sel_logs = _this.filterLogs(_this.sel_session);
	    }).catch(function (error) {
	      (0, _notification2.default)('Errore lettura log: ' + error);
	      console.error('Error:', error);
	    });
	  },
	
	  methods: {
	    closePanel: function closePanel() {
	      var div = document.getElementById('gv-difesa-suolo-foto-log');
	      if (!div) return;
	      div.parentNode.removeChild(div);
	    },
	    onChange: function onChange() {
	      console.log('onChange', this.sel_session);
	      this.sel_logs = this.filterLogs(this.sel_session);
	    },
	    filterLogs: function filterLogs(session) {
	      return this.logs.filter(function (log) {
	        return log.session == session;
	      });
	    }
	  }
	};

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('image-viewer', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(32, function (require) {
	      resolve(__webpack_require__(751));
	    });
	  });
	});
	
	_vue2.default.component('gv-fototeca-carrello-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(2, function (require) {
	      resolve(__webpack_require__(205));
	    });
	  });
	});
	
	exports.default = {
	  name: 'gv-fototeca-immagine',
	  props: ['volo', 'foto'],
	
	  data: function data() {
	    var baseUrl = 'https://srvcarto.regione.liguria.it/dtuff/Img/voli/';
	    var imgUrl = '' + baseUrl + this.volo + '/' + this.foto + '.jpg';
	    return {
	      title: 'Fotogramma: ' + this.foto,
	      imgUrl: imgUrl,
	      logo: '/geoservices/apps/imageviewer2/fototeca/logo.gif'
	    };
	  },
	
	  methods: {
	    addToBasket: function addToBasket() {
	      var _this = this;
	
	      var voli = GV.globals.FOTOTECA_CARRELLO.filter(function (volo) {
	        return volo.id === GV.globals.FOTOTECA_SEL_VOLO.id;
	      });
	      if (voli.length === 0) {
	        GV.globals.FOTOTECA_CARRELLO.push({
	          id: GV.globals.FOTOTECA_SEL_VOLO.id,
	          label: GV.globals.FOTOTECA_SEL_VOLO.nome,
	          dir: GV.globals.FOTOTECA_SEL_VOLO.volo.toLowerCase(),
	          children: [{
	            label: this.foto,
	            file: this.foto + '.jpg'
	          }]
	        });
	      } else {
	        var volo = voli[0];
	        var fotoPresente = false;
	        volo.children.forEach(function (foto) {
	          if (foto.label === _this.foto) fotoPresente = true;
	        });
	        if (!fotoPresente) {
	          volo.children.push({
	            label: this.foto,
	            file: this.foto + '.jpg'
	          });
	        }
	      }
	      this.showCart();
	    },
	    showCart: function showCart() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-fototeca-carrello-panel',
	        containerId: GV.config.containerId,
	        toggleEl: false,
	        vm: new _vue2.default({
	          template: '<gv-fototeca-carrello-panel></gv-fototeca-carrello-panel>'
	        })
	      });
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _getFototecaVoli = __webpack_require__(380);
	
	var _getFototecaVoli2 = _interopRequireDefault(_getFototecaVoli);
	
	var _getCoordTransformBbox = __webpack_require__(163);
	
	var _getCoordTransformBbox2 = _interopRequireDefault(_getCoordTransformBbox);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _FototecaImmagine = __webpack_require__(737);
	
	var _FototecaImmagine2 = _interopRequireDefault(_FototecaImmagine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	_vue2.default.component('gv-fototeca-immagine', _FototecaImmagine2.default);
	_vue2.default.component('gv-fototeca-scheda-volo-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(3, function (require) {
	      resolve(__webpack_require__(206));
	    });
	  });
	});
	
	exports.default = {
	  data: function data() {
	    return {
	      voli: [],
	      volo: [],
	      loading: false,
	      marker: null,
	      bbox: null,
	      baseWfsUrl: GV.globals.DEFAULT_PROXY + 'https://geoservizi.regione.liguria.it/geoserver/wfs?service=WFS&version=2.0.0&request=GetFeature&srsName=EPSG%3A4326&outputFormat=application%2Fjson&',
	      strisciata: null,
	      foto: null
	    };
	  },
	
	  methods: {
	    onChange: function onChange(value) {
	      GV.globals.FOTOTECA_SEL_VOLO = this.voli.filter(function (volo) {
	        return volo.id === value;
	      })[0];
	      var workSpace = 'M' + GV.globals.FOTOTECA_SEL_VOLO.id;
	      var layer = 'L' + GV.globals.FOTOTECA_SEL_VOLO.codLivStrisciata;
	      var cqlFilter = "presenza_fotogrammi='SI'";
	      var wfsUrl = this.baseWfsUrl + 'typeName=' + workSpace + ':' + layer + '&cql_filter=' + cqlFilter;
	      this.loadLayerStrisciata(wfsUrl);
	      this.showSchedaVolo();
	    },
	    showSchedaVolo: function showSchedaVolo() {
	      var el = document.getElementById('gv-fototeca-scheda-volo-panel');
	      if (el) el.remove();
	      (0, _mountComponent2.default)({
	        elId: 'gv-fototeca-scheda-volo-panel',
	        containerId: GV.config.containerId,
	        toggleEl: false,
	        vm: new _vue2.default({
	          template: '<gv-fototeca-scheda-volo-panel></gv-fototeca-scheda-volo-panel>'
	        })
	      });
	    },
	    hiliteStrisciata: function hiliteStrisciata(layer) {
	      var layerStrisciate = GV.app.map.getLayerByName('strisciate');
	      layerStrisciate.eachLayer(function (l) {
	        l.setStyle({
	          color: '#ff0000'
	        });
	      });
	      layer.setStyle({
	        color: '#ffff00'
	      });
	    },
	    loadLayerStrisciata: function loadLayerStrisciata(url) {
	      var _this = this;
	
	      var layerConfig = {
	        type: 'JSON',
	        dataType: 'json',
	        name: 'strisciate',
	        visible: true,
	        geomSubType: 'POLYGON',
	        url: url,
	        idMap: 'fototeca',
	        style: {
	          color: '#ff0000',
	          fillOpacity: 0.0,
	          weight: 2,
	          opacity: 1
	        },
	        zoomToLayerExtent: true,
	        onEachFeature: function onEachFeature(feature, layer) {
	          layer.on('click', function (ev) {
	            _this.strisciata = ev.target.feature.properties.id_strisciata;
	            _this.hiliteStrisciata(layer);
	            _this.loadLayerFoto();
	          });
	          layer.on('mouseover', function (ev) {
	            if (_this.strisciata === ev.target.feature.properties.id_strisciata) return;
	            layer.setStyle({
	              color: '#ff9900'
	            });
	          });
	          layer.on('mouseout', function (ev) {
	            if (_this.strisciata === ev.target.feature.properties.id_strisciata) return;
	            layer.setStyle({
	              color: '#ff0000'
	            });
	          });
	        }
	      };
	      var idMap = layerConfig.idMap;
	      GV.config.removeMap(idMap);
	      GV.config.addMapConfig({
	        id: idMap,
	        name: 'Fototeca',
	        flagGeoserver: true,
	        layers: [layerConfig]
	      });
	    },
	    hiliteFoto: function hiliteFoto(layer) {
	      var layerFoto = GV.app.map.getLayerByName('foto');
	      layerFoto.eachLayer(function (l) {
	        l.setStyle({
	          color: '#ff0000'
	        });
	      });
	      layer.setStyle({
	        color: '#ffff00'
	      });
	    },
	    loadLayerFoto: function loadLayerFoto() {
	      var _this2 = this;
	
	      GV.config.removeLayer('foto');
	      var workSpace = 'M' + GV.globals.FOTOTECA_SEL_VOLO.id;
	      var layer = 'L' + GV.globals.FOTOTECA_SEL_VOLO.codLivFoto;
	      var cqlFilter = 'id_strisciata=\'' + this.strisciata + '\'';
	      var url = this.baseWfsUrl + 'typeName=' + workSpace + ':' + layer + '&cql_filter=' + cqlFilter;
	      var layerConfig = {
	        type: 'JSON',
	        name: 'foto',
	        visible: true,
	        geomSubType: 'POINT',
	        url: url,
	        idMap: 'fototeca',
	        pointToLayer: function pointToLayer(feature, latlng) {
	          var style = {
	            color: '#ff0000',
	            fillColor: '#ff0000',
	            fill: true,
	            weight: 3,
	            radius: 2
	          };
	          return L.circleMarker(latlng, style);
	        },
	        zoomToLayerExtent: true,
	        onEachFeature: function onEachFeature(feature, layer) {
	          layer.on('click', function (ev) {
	            _this2.foto = ev.target.feature.properties.foto;
	            _this2.hiliteFoto(layer);
	            GV.app.map.setView([layer._latlng.lat, layer._latlng.lng], 15);
	            if (ev.target.feature.properties.immagine === 'obliterato') {
	              GV.utils.notification('Fotogramma consultabile presso lo Sportello Cartografico <br>Codice Fotogramma: <b>' + _this2.foto + '</b>', 'info');
	            } else {
	              _this2.showFoto();
	            }
	          });
	          layer.on('mouseover', function (ev) {
	            if (_this2.foto === ev.target.feature.properties.foto) return;
	            layer.setStyle({
	              color: '#ff9900'
	            });
	          });
	          layer.on('mouseout', function (ev) {
	            if (_this2.foto === ev.target.feature.properties.foto) return;
	            layer.setStyle({
	              color: '#ff0000'
	            });
	          });
	        }
	      };
	      var idMap = layerConfig.idMap;
	      GV.config.addLayerToMap(layerConfig, 'fototeca');
	    },
	    showFoto: function showFoto() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-fototeca-immagine',
	        clear: true,
	        vm: new _vue2.default({
	          template: '<gv-fototeca-immagine :volo="volo" :foto="foto" ></gv-fototeca-immagine>',
	          data: {
	            volo: GV.globals.FOTOTECA_SEL_VOLO.volo.toLowerCase(),
	            foto: this.foto
	          }
	        })
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    (0, _getFototecaVoli2.default)(this.bbox).then(function (resp) {
	      _this3.voli = resp;
	      console.log(resp);
	    });
	    GV.eventBus.$on('gv-fototeca-reload-voli', function (event) {
	      var bbox = event.bbox;
	      var srsIn = event.bboxSRS;
	      var srsOut = '3003';
	      if (bbox) {
	        (0, _getCoordTransformBbox2.default)(srsIn, srsOut, bbox).then(function (response) {
	          if (response.data.data) {
	            _this3.bbox = response.data.data[0][0] + ',' + response.data.data[1][0];
	            (0, _getFototecaVoli2.default)(_this3.bbox).then(function (resp) {
	              _this3.voli = resp;
	            });
	          }
	        });
	      } else {
	        _this3.bbox = bbox;
	        (0, _getFototecaVoli2.default)(_this3.bbox).then(function (resp) {
	          _this3.voli = resp;
	        });
	      }
	    });
	  }
	};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkbox = __webpack_require__(140);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _checkbox3 = __webpack_require__(52);
	
	var _checkbox4 = _interopRequireDefault(_checkbox3);
	
	var _notification = __webpack_require__(85);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _notification3 = __webpack_require__(79);
	
	var _notification4 = _interopRequireDefault(_notification3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _getGasComboConfig = __webpack_require__(382);
	
	var _getGasComboConfig2 = _interopRequireDefault(_getGasComboConfig);
	
	var _getGasStrutture = __webpack_require__(383);
	
	var _getGasStrutture2 = _interopRequireDefault(_getGasStrutture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default, _option4.default, _button4.default, _notification4.default);
	_vue2.default.use(_checkbox4.default);
	
	exports.default = {
	  data: function data() {
	    return {
	      name: 'gv-gas',
	      title: 'FILTRI',
	      aree: null,
	      area: null,
	      province: [{ codice: null, descrizione: 'TUTTE LE PROVINCE' }, { codice: '010', descrizione: 'GENOVA' }, { codice: '008', descrizione: 'IMPERIA' }, { codice: '011', descrizione: 'LA SPEZIA' }, { codice: '009', descrizione: 'SAVONA' }],
	      provincia: null,
	      moduli: [],
	      modulo: null,
	      listaAsl: [],
	      asl: 0,
	      soloPostiDisponibili: false,
	      features: null,
	      options: GV.config.getToolOptions('gv-gas')
	    };
	  },
	
	  methods: {
	    onChangeArea: function onChangeArea(value) {
	      this.moduli = this.aree.filter(function (area) {
	        return area.codice === value;
	      })[0].moduli;
	    },
	    onChangeProvincia: function onChangeProvincia(value) {
	      this.asl = 0;
	    },
	    onChangeASL: function onChangeASL(value) {
	      this.provincia = null;
	    },
	    elenco: function elenco() {
	      window.open('http://www.alisa.liguria.it/index.php?option=com_docman&view=docman&Itemid=382');
	    },
	    submit: function submit() {
	      if (this.area) {
	        this.showFeatures();
	      } else {
	        (0, _notification4.default)({
	          title: 'Attenzione',
	          type: 'info',
	          duration: 5000,
	          offset: 70,
	          dangerouslyUseHTMLString: true,
	          position: 'bottom-left',
	          message: 'Il parametro "Area" è obbligatorio'
	        });
	      }
	    },
	    showFeatures: function showFeatures() {
	      var _this = this;
	
	      var filteredFeatures = this.features.filter(function (feature) {
	        var filterArea = _this.area ? feature.properties.idarea === _this.area.toString() : true;
	        var filterProv = _this.provincia ? feature.properties.codProvincia === _this.provincia : true;
	        var filterPosti = _this.soloPostiDisponibili ? feature.properties.disponibilita === 'S' : true;
	        var filterAsl = _this.asl ? feature.properties.ASL == _this.asl : true;
	        var filterModuli = false;
	        if (_this.modulo) {
	          if (feature.properties.idModuli) {
	            var moduli = feature.properties.idModuli.split(',');
	            moduli.forEach(function (modulo) {
	              if (modulo == _this.modulo) filterModuli = true;
	            });
	          }
	        } else {
	          filterModuli = true;
	        }
	        return filterArea && filterProv && filterPosti && filterModuli && filterAsl;
	      });
	      this.loadLayer(filteredFeatures);
	    },
	    loadLayer: function loadLayer(filteredFeatures) {
	      var layer = GV.app.map.getLayerByName('Strutture');
	      if (layer) {
	        GV.app.map.removeLayer(layer);
	      }
	
	      if (filteredFeatures.length === 0) {
	        (0, _notification4.default)({
	          title: 'Attenzione',
	          type: 'info',
	          duration: 5000,
	          offset: 70,
	          dangerouslyUseHTMLString: true,
	          position: 'bottom-left',
	          message: 'Nessuna struttura soddisfa i parametri<br>di ricerca'
	        });
	        return;
	      }
	
	      var customPopup = function customPopup(layer) {
	        var properties = layer.feature.properties;
	        var indirizzo = '';
	        if (properties['cVia']) indirizzo += ' ' + properties['cVia'];
	        if (properties['via']) indirizzo += ' ' + properties['via'];
	        if (properties['nCivico']) indirizzo += ' ' + properties['nCivico'];
	        indirizzo += ', ';
	        if (properties['cap']) indirizzo += properties['cap'] + ' ';
	        if (properties['desComune']) indirizzo += properties['desComune'] + ' ';
	        if (properties['telefono']) indirizzo += '<br/>Tel: ' + properties['telefono'] + ' ';
	
	        var urlScheda = GV.globals.GAS_SCHEDA + 'gasweb/gestione/scheda?ID=' + properties['idul'];
	        var popUp = '\n              <p><b>' + properties['denominazione'] + '</b></p> \n              <p>' + indirizzo + '<br/><br/>\n              Moduli: ' + properties['moduli'] + '<br/>\n              <a href="' + urlScheda + '" target="_blank">Scheda dettaglio</a>\n        ';
	        return popUp;
	      };
	
	      GV.app.map.loadLayers([{
	        name: 'Strutture',
	        type: 'JSON',
	        geomSubType: 'POINT',
	        classes: [{
	          name: 'CLASSE_BASE',
	          style: {
	            iconUrl: '/geoservices/apps/viewer/static/img/gas/strutture.png',
	            iconSize: [22, 27],
	            iconAnchor: [11, 27],
	            popupAnchor: [0, -27]
	          }
	        }],
	        visible: true,
	        data: filteredFeatures,
	        customPopup: customPopup,
	        cluster: {
	          options: {
	            iconCreateFunction: function iconCreateFunction(cluster) {
	              return L.divIcon({
	                html: cluster.getChildCount(),
	                className: 'cluster',
	                iconSize: L.point(28, 28)
	              });
	            },
	            showCoverageOnHover: false,
	            maxClusterRadius: 80
	          }
	        }
	      }]);
	      GV.app.map.fitBounds(GV.app.map.getLayerByName('Strutture').getBounds());
	      if (GV.app.map.getZoom() > 18) GV.app.map.setZoom(18);
	    }
	  },
	  mounted: function mounted() {
	    (0, _notification4.default)({
	      title: 'Attenzione',
	      type: 'info',
	      duration: 10000,
	      offset: 70,
	      dangerouslyUseHTMLString: true,
	      position: 'bottom-left',
	      message: 'Sulla mappa potrebbero non comparire <br>tutte le strutture.<br>Per ottenere un elenco di tutte le <br>strutture selezionare il bottone <br><b>"Elenco Strutture"</b>'
	    });
	  },
	  created: function created() {
	    var _this2 = this;
	
	    var urlCombo = '/geoservices/REST/gas/combo?ENV=' + this.options.env;
	    (0, _getGasComboConfig2.default)(urlCombo).then(function (data) {
	      _this2.aree = data.aree.sort(function (a, b) {
	        return a.descrizione > b.descrizione ? 1 : b.descrizione > a.descrizione ? -1 : 0;
	      });
	
	      _this2.aree.forEach(function (area) {
	        area.moduli.unshift({
	          codiceArea: 0,
	          codice: 0,
	          descrizione: 'TUTTI'
	        });
	      });
	      _this2.listaAsl = data.asl;
	      _this2.listaAsl = _this2.listaAsl.sort(function (a, b) {
	        if (a.descrizione < b.descrizione) {
	          return -1;
	        }
	        if (a.descrizione > b.descrizione) {
	          return 1;
	        }
	        return 0;
	      });
	      _this2.listaAsl.unshift({
	        codice: 0,
	        descrizione: 'TUTTE LE ASL'
	      });
	    });
	    var urlStrutture = '/geoservices/REST/gas/strutture?ENV=' + this.options.env;
	    (0, _getGasStrutture2.default)(urlStrutture).then(function (features) {
	      _this2.features = features;
	    });
	  }
	};

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _getHereGeocode = __webpack_require__(387);
	
	var _getHereGeocode2 = _interopRequireDefault(_getHereGeocode);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	exports.default = {
	  data: function data() {
	    return {
	      results: [],
	      address: [],
	      loading: false,
	      marker: null
	    };
	  },
	
	  methods: {
	    remoteMethod: function remoteMethod(query) {
	      var _this = this;
	
	      if (query.length < 4) {
	        this.results = [];
	        return;
	      }
	      this.loading = true;
	      var timeOutTime = 1000;
	      setTimeout(function () {
	        (0, _getHereGeocode2.default)(query).then(function (results) {
	          _this.loading = false;
	          if (results && results.length > 0) {
	            _this.results = results.map(function (result) {
	              return {
	                label: result.formatted_address,
	                value: result.place_id,
	                location: result.geometry.location
	              };
	            });
	          } else {
	            _this.results = [];
	          }
	        }).catch(function (error) {
	          _this.loading = false;
	          console.error(error);
	        });
	      }, timeOutTime);
	    },
	    onChange: function onChange(value) {
	      var result = this.results.find(function (item) {
	        return item.value === value;
	      });
	      if (result) {
	        this.marker = GV.app.map.addMarker(result);
	      } else {
	        if (this.marker) {
	          GV.app.map.removeLayer(this.marker);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 281 */,
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _getPeliasGeocode = __webpack_require__(388);
	
	var _getPeliasGeocode2 = _interopRequireDefault(_getPeliasGeocode);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	exports.default = {
	  data: function data() {
	    return {
	      results: [],
	      address: [],
	      loading: false,
	      marker: null
	    };
	  },
	
	  methods: {
	    remoteMethod: function remoteMethod(query) {
	      var _this = this;
	
	      if (query.length < 4) {
	        this.results = [];
	        return;
	      }
	      this.loading = true;
	      var timeOutTime = 500;
	      setTimeout(function () {
	        (0, _getPeliasGeocode2.default)(query).then(function (results) {
	          _this.loading = false;
	          console.log(results);
	          var features = results ? results.features : null;
	          if (features && features.length > 0) {
	            _this.results = features.map(function (feature) {
	              return {
	                label: feature.properties.label,
	                value: feature.properties.id,
	                location: {
	                  lat: feature.geometry.coordinates[1],
	                  lng: feature.geometry.coordinates[0]
	                }
	              };
	            });
	          } else {
	            _this.results = [];
	          }
	        }).catch(function (error) {
	          _this.loading = false;
	          console.error(error);
	        });
	      }, timeOutTime);
	    },
	    onChange: function onChange(value) {
	      var result = this.results.find(function (item) {
	        return item.value === value;
	      });
	      if (result) {
	        result.type = 'circle';
	        this.marker = GV.app.map.addMarker(result);
	      } else {
	        if (this.marker) {
	          GV.app.map.removeLayer(this.marker);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'gv-header',
	  computed: {
	    style: function style() {
	      return 'height:' + GV.config.application.layout.header.height;
	    }
	  },
	  mounted: function mounted() {
	    this.$el.innerHTML = GV.config.application.layout.header.html;
	  }
	};

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'gv-inner-html',
	  props: ['html'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _BaseLayerSwitcher = __webpack_require__(720);
	
	var _BaseLayerSwitcher2 = _interopRequireDefault(_BaseLayerSwitcher);
	
	var _LegendMaps = __webpack_require__(146);
	
	var _LegendMaps2 = _interopRequireDefault(_LegendMaps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-base-layer-switcher', _BaseLayerSwitcher2.default);
	
	_vue2.default.component('gv-legend-maps', _LegendMaps2.default);
	
	_vue2.default.component('gv-map-catalog-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(1/* duplicate */, function (require) {
	      resolve(__webpack_require__(147));
	    });
	  });
	});
	
	_vue2.default.use(_button4.default);
	
	exports.default = {
	  name: 'gv-legend',
	  data: function data() {
	    return {
	      options: GV.config.application.layout.legend.options,
	      maps: GV.config.maps,
	      show: true
	    };
	  },
	  mounted: function mounted() {
	    GV.log('gv-legend: mounted');
	    GV.legend = this;
	    if (this.options.showAddMap) {
	      var showMapCatalogPanel = GV.config.idMap || GV.config.agAppMap ? false : true;
	      if (this.options.showMapCatalogPanelOnStart) showMapCatalogPanel = true;
	      if (this.options.dontShowMapCatalogPanelOnStart) showMapCatalogPanel = false;
	      GV.config.loadCatalog({
	        showMapCatalogPanel: showMapCatalogPanel,
	        filterDownloadCatalog: this.options.filterDownloadCatalog
	      });
	    }
	    if (this.options.collapsed || window.matchMedia('(max-width: 500px)').matches) {
	      this.show = false;
	    }
	    this.hideLegend();
	  },
	
	  methods: {
	    hideLegend: function hideLegend(event) {
	      if (this.show) {
	        document.getElementById('gv-legend-title').style.display = 'block';
	        document.getElementById('gv-legend-title-collapsed').style.display = 'none';
	        document.getElementById('gv-legend-wrapper').style.display = 'block';
	        document.getElementById('gv-legend').style.width = '260px';
	      } else {
	        document.getElementById('gv-legend-title').style.display = 'none';
	        document.getElementById('gv-legend-title-collapsed').style.display = 'block';
	        document.getElementById('gv-legend-wrapper').style.display = 'none';
	        document.getElementById('gv-legend').style.width = '26px';
	      }
	      this.show = !this.show;
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-legend-collapse gv-color-scheme el-icon-arrow-down' : 'gv-legend-collapse gv-color-scheme el-icon-arrow-up';
	    },
	
	    addMap: function addMap() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-map-catalog-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-map-catalog-panel></gv-map-catalog-panel>'
	        })
	      });
	    },
	    downloadMaps: function downloadMaps() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-download-totale-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-download-totale-panel></gv-download-totale-panel>'
	        })
	      });
	    }
	  }
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _col = __webpack_require__(67);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _col3 = __webpack_require__(65);
	
	var _col4 = _interopRequireDefault(_col3);
	
	var _row = __webpack_require__(36);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _row3 = __webpack_require__(34);
	
	var _row4 = _interopRequireDefault(_row3);
	
	var _slider = __webpack_require__(197);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _slider3 = __webpack_require__(194);
	
	var _slider4 = _interopRequireDefault(_slider3);
	
	var _popover = __webpack_require__(141);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _popover3 = __webpack_require__(133);
	
	var _popover4 = _interopRequireDefault(_popover3);
	
	var _tableColumn = __webpack_require__(54);
	
	var _tableColumn2 = _interopRequireDefault(_tableColumn);
	
	var _tableColumn3 = __webpack_require__(53);
	
	var _tableColumn4 = _interopRequireDefault(_tableColumn3);
	
	var _table = __webpack_require__(43);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _table3 = __webpack_require__(41);
	
	var _table4 = _interopRequireDefault(_table3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-multi-legend-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(26, function (require) {
	      resolve(__webpack_require__(773));
	    });
	  });
	});
	_vue2.default.component('gv-layers-transparency', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(27, function (require) {
	      resolve(__webpack_require__(760));
	    });
	  });
	});
	_vue2.default.component('gv-layer-search-legend', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(6, function (require) {
	      resolve(__webpack_require__(758));
	    });
	  });
	});
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	_vue2.default.use(_button4.default);
	_vue2.default.use(_table4.default);
	_vue2.default.use(_tableColumn4.default);
	_vue2.default.use(_popover4.default);
	_vue2.default.use(_slider4.default);
	_vue2.default.use(_row4.default);
	_vue2.default.use(_col4.default);
	
	exports.default = {
	  name: 'gv-legend-layers',
	  props: ['map', 'options'],
	  data: function data() {
	    var layerVisibilityCheck = this.options.hideLayerVisibilityCheck ? false : true;
	
	    return {
	      layerVisibilityCheck: layerVisibilityCheck
	    };
	  },
	  mounted: function mounted() {
	    GV.log('gv-legend-layers: mounted');
	  },
	
	  methods: {
	    iconUrl: function iconUrl(layer) {
	      return layer.legend.icon;
	    },
	    getClass: function getClass(layer) {
	      return layer.inRange ? 'gv-list-legend-layer-item' : 'gv-list-legend-layer-item gv-list-legend-layer-disabled-item';
	    },
	    layerClassName: function layerClassName(_ref) {
	      var row = _ref.row,
	          rowIndex = _ref.rowIndex;
	
	      return row.inRange ? 'gv-list-legend-layer-item' : 'gv-list-legend-layer-item gv-list-legend-layer-disabled-item';
	    },
	    setLayerVisible: function setLayerVisible(layer) {
	      GV.eventBus.$emit('set-layer-visible', {
	        layer: layer,
	        checked: layer.visible
	      });
	      this.setLayerTransparency(layer);
	    },
	    setLayerTransparency: function setLayerTransparency(layer) {
	      var opacity = layer['opacityBase100'] / 100;
	      GV.eventBus.$emit('set-layer-transparency', {
	        layerName: layer.name,
	        opacity: opacity
	      });
	    },
	    layerSearch: function layerSearch(layer) {
	      (0, _mountComponent2.default)({
	        elId: 'gv-layer-search-legend',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-layer-search-legend layerId=' + layer.id + '></gv-layer-search-legend>'
	        })
	      });
	    },
	    showLegendPanel: function showLegendPanel(layer) {
	      if (layer.inRange && (layer.multiClasse || layer.flagRemote || layer.legend.popUpFlag)) {
	        var url = null,
	            width,
	            height;
	        if (layer.legend.popUpUrl && layer.legend.popUpFlag) {
	          url = '' + GV.globals.DEFAULT_PROXY + layer.legend.popUpUrl;
	          width = window.matchMedia('(max-width: 450px)').matches ? 300 : layer.legend.popUpWidth || 600;
	          height = window.matchMedia('(max-height: 620px)').matches ? 400 : layer.legend.popUpHeight || 600;
	        } else if (layer.multiClasse) {
	          if (layer.flagGeoserver || layer.flagRemote) {
	            var wmsUrl = layer.wmsParams.url.replace('/geoservices/REST/proxy/proxy?url=', '');
	            url = '' + GV.globals.DEFAULT_PROXY + wmsUrl + 'LAYER=' + layer.name + '&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&';
	            if (layer.wmsParams.styles) {
	              url += 'STYLES=' + layer.wmsParams.styles + '&';
	            }
	            width = window.matchMedia('(max-width: 450px)').matches ? 300 : 400;
	            height = 350;
	          }
	        } else if (layer.flagRemote) {
	          url = '' + GV.globals.DEFAULT_PROXY + layer.wmsParams.url + '&LAYER=' + layer.name + '&SERVICE=WMS&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/jpeg';
	          if (layer.wmsParams.styles) {
	            url += 'STYLES=' + layer.wmsParams.styles + '&';
	          }
	          width = window.matchMedia('(max-width: 450px)').matches ? 300 : 500;
	          height = 350;
	        }
	        (0, _mountComponent2.default)({
	          elId: 'gv-multi-legend-panel',
	          containerId: GV.config.containerId,
	          vm: new _vue2.default({
	            template: '<gv-multi-legend-panel visible="true" :src="src" :height="height" :width="width" :title="title"></gv-multi-legend-panel>',
	            data: {
	              title: 'LEGENDA',
	              src: url,
	
	              width: width,
	              height: height
	            }
	          })
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _LegendLayers = __webpack_require__(762);
	
	var _LegendLayers2 = _interopRequireDefault(_LegendLayers);
	
	var _vuebar = __webpack_require__(150);
	
	var _vuebar2 = _interopRequireDefault(_vuebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-legend-layers', _LegendLayers2.default);
	
	_vue2.default.component('gv-map-info-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	      resolve(__webpack_require__(106));
	    });
	  });
	});
	_vue2.default.component('gv-map-catalog-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      resolve(__webpack_require__(147));
	    });
	  });
	});
	_vue2.default.component('gv-map-download', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(10, function (require) {
	      resolve(__webpack_require__(732));
	    });
	  });
	});
	
	_vue2.default.use(_vuebar2.default);
	
	_vue2.default.use(_button4.default);
	
	exports.default = {
	  name: 'gv-legend-maps',
	  props: ['options'],
	  data: function data() {
	    return {
	      maps: GV.config.maps
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    GV.log('gv-legend-maps: mounted');
	    if (this.options.showDownloadPanelOnLoad && GV.config.idMap) {
	      GV.eventBus.$on('gv-config-init', function (config) {
	        _this.openDownloadPanel(GV.config.idMap, _this.options.downloadFormat);
	      });
	    }
	  },
	
	  methods: {
	    showMapLayers: function showMapLayers(map) {
	      return map.showLayersInLegend;
	    },
	    toggleLayers: function toggleLayers(map) {
	      map.showLayersInLegend = !map.showLayersInLegend;
	    },
	    getToggleLayersClass: function getToggleLayersClass(map) {
	      return map.showLayersInLegend ? 'gv-inverted-color-scheme gv-legend-map-tools-button el-icon-arrow-up' : 'gv-inverted-color-scheme gv-legend-map-tools-button el-icon-arrow-down';
	    },
	    isDownloadable: function isDownloadable(map) {
	      if (this.options.noDownloadButton) return false;
	      if (GV.globals.RL_CATALOG === 'pub' && map.flagDownload) return true;
	      if (GV.globals.RL_CATALOG === 'int' && (map.flagDownloadExtranet || map.flagDownload)) return true;
	      return false;
	    },
	    checkInfoMap: function checkInfoMap(map) {
	      return this.options.showInfoMap && GV.config.getMapConfig(map.id).metaData;
	    },
	    checkDeleteMap: function checkDeleteMap(map) {
	      return !this.options.hideDeleteButton;
	    },
	
	    showMapInfoPanel: function showMapInfoPanel(map) {
	      var metaData = GV.config.getMapConfig(map.id).metaData;
	      var downloadable = this.isDownloadable(map);
	      (0, _mountComponent2.default)({
	        elId: 'gv-map-info-panel',
	        containerId: GV.config.containerId,
	        clear: true,
	        vm: new _vue2.default({
	          template: '<gv-map-info-panel visible="true" :metaData="metaData" addToMapButton="true" downloadable="' + downloadable + '"></gv-map-info-panel>',
	          data: { metaData: metaData }
	        })
	      });
	    },
	    remove: function remove(map) {
	      GV.config.removeMap(map.id);
	    },
	    download: function download(map) {
	      this.openDownloadPanel(map.id);
	    },
	    openDownloadPanel: function openDownloadPanel(idMap, inputFormat) {
	
	      if (document.getElementById('gv-map-download')) {
	        var element = document.getElementById('gv-map-download');
	        element.parentNode.removeChild(element);
	      }
	      var closeWindow = this.options.downloadPanelCloseMode === 'closeWindow';
	      var template = '<gv-map-download idMap="' + idMap + '" closeWindow="' + closeWindow + '" ';
	      if (inputFormat) template += 'inputFormat="' + inputFormat + '"';
	      template += '></gv-map-download>';
	      (0, _mountComponent2.default)({
	        elId: 'gv-map-download',
	        containerId: GV.config.containerId,
	        toggleEl: false,
	        vm: new _vue2.default({
	          template: template
	        })
	      });
	    },
	
	    layerTransparency: function layerTransparency(map) {
	      (0, _mountComponent2.default)({
	        elId: 'gv-layers-transparency',
	        containerId: GV.config.containerId,
	        toggleEl: false,
	        vm: new _vue2.default({
	          template: '<gv-layers-transparency idMap="' + map.id + '"></gv-layers-transparency>'
	        })
	      });
	    }
	  }
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _assign = __webpack_require__(46);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _row = __webpack_require__(36);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _row3 = __webpack_require__(34);
	
	var _row4 = _interopRequireDefault(_row3);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _locale = __webpack_require__(11);
	
	var _getConfig = __webpack_require__(108);
	
	var _getConfig2 = _interopRequireDefault(_getConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	_vue2.default.use(_row4.default);
	_vue2.default.use(_button4.default);
	exports.default = {
	  data: function data() {
	    var gruppi = [{ id: 1, label: 'Mammiferi', classi: '2757' }, { id: 2, label: 'Uccelli', classi: '2756' }, { id: 3, label: 'Rettili', classi: '2761' }, { id: 4, label: 'Anfibi', classi: '2758' }, { id: 5, label: 'Pesci (Agnati, Osteitti e Petromizonti)', classi: '3102, 2759, 2791,3133' }, { id: 6, label: 'Insetti', classi: '2745' }, { id: 7, label: 'Crostacei', classi: '2836' }, { id: 8, label: 'Aracnida, Chilopodi e Diplodi', classi: '2755, 2752, 2748' }, { id: 9, label: 'Bivalvi e Gastropodi', classi: '2754, 2747' }];
	
	    var styles = this.getStyles();
	
	    var layerName = 'L9631';
	    return {
	      idAncillaryMap: 'D849',
	      mapConfig: null,
	      styles: styles,
	      gruppi: gruppi,
	      gruppo: null,
	      specie: null,
	      listaSpecie: [],
	      show: true,
	      buttonDisabled: true,
	      legendUrl: null,
	      layer: null,
	      layers: [],
	      showLayerMngr: true,
	      ancillaryMap: null,
	      layerConfig: {
	        id: null,
	        idMap: 'LIBIOSS_SPECIE',
	        name: layerName,
	        type: 'WMS',
	        visible: true,
	        flagGeoserver: true,
	        multiClasse: true,
	        queryable: true,
	        opacity: 1,
	        minScale: 0,
	        maxScale: 0,
	        wmsParams: {
	          name: layerName,
	          format: 'image/png8',
	          url: 'https://geoservizi.regione.liguria.it/geoserver/M2490/wms?'
	        },
	        wfsParams: {
	          url: 'https://geoservizi.regione.liguria.it/geoserver/M2490/wfs?',
	          typeName: layerName
	        },
	        legend: {
	          icon: 'https://geoservizi.regione.liguria.it/geoserver/M2490/wms?LAYER=L9631&RULE=R0&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LEGEND_OPTIONS=forceLabels:off',
	          label: 'TEST STAZIONI SPECIE',
	          popUpFlag: 0,
	          popUpUrl: null,
	          popUpWidth: 0,
	          popUpHeight: 0
	        },
	        infoOptions: {
	          infoUrl: 'http://srvcarto.regione.liguria.it/info/repertoriocartografico/siraLibiossStazioni_Specie.xsl',
	          infoTarget: null,
	          infoWidth: 0,
	          infoHeight: 0,
	          infoIdAttr: 'id',
	          infoLabelAttr: null
	        }
	      }
	    };
	  },
	
	  watch: {},
	  methods: {
	    getStyles: function getStyles() {
	      var shapes = ['circle', 'square', 'triangle', 'star'];
	      var colors = ['red', 'yellow', 'green', 'blue', 'purple'];
	      var styles = [];
	      shapes.forEach(function (shape) {
	        colors.forEach(function (color) {
	          var style = {
	            id: shape + '_' + color,
	            used: false
	          };
	          styles.push(style);
	        });
	      });
	      return styles;
	    },
	    onChangeGruppo: function onChangeGruppo(value) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var gruppo, response, data;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                gruppo = _this.gruppi.find(function (g) {
	                  return g.id === value;
	                });
	                _context.next = 3;
	                return fetch('/geoservices/REST/libioss/ppf_gruppo_specie/' + gruppo.classi);
	
	              case 3:
	                response = _context.sent;
	                _context.next = 6;
	                return response.json();
	
	              case 6:
	                data = _context.sent;
	
	                _this.listaSpecie = data.lista_specie.map(function (s) {
	                  s.disabled = false;
	                  return s;
	                });
	                _this.specie = null;
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    onChangeSpecie: function onChangeSpecie(value) {
	      this.addLayer(value);
	    },
	    addLayer: function addLayer(cod_specie) {
	      var specie = this.listaSpecie.find(function (s) {
	        return s.id === cod_specie;
	      });
	      if (this.layers.length >= 20) {
	        (0, _notification2.default)('Massimo 20 specie', 'warning');
	        return;
	      }
	      var style = this.getLayerStyle();
	      this.loadLayer(specie, style);
	      this.layers.push({
	        id: specie.id,
	        label: specie.label,
	        style: style
	      });
	      specie.disabled = true;
	    },
	    loadLayer: function loadLayer(specie, style) {
	      var layerConfig = (0, _assign2.default)({}, this.layerConfig);
	      layerConfig.wmsParams = (0, _assign2.default)({}, this.layerConfig.wmsParams);
	      layerConfig.legend = (0, _assign2.default)({}, this.layerConfig.legend);
	      layerConfig.name = 'S' + specie.id;
	      layerConfig.title = specie.label;
	      layerConfig.legend.label = specie.label;
	      layerConfig.legend.icon = 'http://geoservizi.regione.liguria.it/geoserver/M2490/wms?LAYER=L9631&REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LEGEND_OPTIONS=forceLabels:off&style=' + style;
	      layerConfig.wmsParams.cql_filter = 'cod_specie=' + specie.id;
	      layerConfig.wmsParams.styles = style;
	
	      GV.config.addLayerToMap(layerConfig, 'LIBIOSS_SPECIE');
	    },
	    getLayerStyle: function getLayerStyle() {
	      var style = this.styles.find(function (s) {
	        return !s.used;
	      });
	      style.used = true;
	      return style.id;
	    },
	    removeLayer: function removeLayer() {
	      if (!this.layer) {
	        (0, _notification2.default)('Nessuna livello selezionato', 'warning');
	        return;
	      }
	
	      GV.config.removeLayer('S' + this.layer);
	
	      var mapConfig = GV.config.getMapConfig('LIBIOSS_SPECIE');
	      if (!mapConfig) this.addMapConfig();
	
	      this.enableSpecie();
	
	      this.makeStyleAvailable();
	
	      this.resetComboSpecie();
	
	      this.removeLayerFromLayers();
	
	      this.layer = null;
	    },
	    resetComboSpecie: function resetComboSpecie() {
	      var _this2 = this;
	
	      var layer = this.layers.find(function (l) {
	        return l.id === _this2.layer;
	      });
	      var specie = this.listaSpecie.find(function (s) {
	        return s.id === layer.id;
	      });
	      if (specie && specie.id === this.specie) {
	        this.specie = null;
	      }
	    },
	    enableSpecie: function enableSpecie() {
	      var _this3 = this;
	
	      var layer = this.layers.find(function (l) {
	        return l.id === _this3.layer;
	      });
	      var specie = this.listaSpecie.find(function (s) {
	        return s.id === layer.id;
	      });
	
	      if (specie) specie.disabled = false;
	    },
	    makeStyleAvailable: function makeStyleAvailable() {
	      var _this4 = this;
	
	      var layer = this.layers.find(function (l) {
	        return l.id === _this4.layer;
	      });
	      var style = this.styles.find(function (s) {
	        return s.id === layer.style;
	      });
	      style.used = false;
	    },
	    removeLayerFromLayers: function removeLayerFromLayers() {
	      var _this5 = this;
	
	      this.layers.filter(function (layer, index, arr) {
	        if (layer.id === _this5.layer) {
	          arr.splice(index, 1);
	          return true;
	        }
	        return false;
	      });
	    },
	    addMapConfig: function addMapConfig() {
	      GV.config.addMapConfig({
	        id: 'LIBIOSS_SPECIE',
	        name: 'Libioss - Distribuzione specie animali',
	        flagGeoserver: true,
	        layers: [],
	        ancillaryMaps: [this.ancillaryMap]
	      });
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-panel-collapse gv-color-scheme el-icon-arrow-up' : 'gv-panel-collapse gv-color-scheme el-icon-arrow-down';
	    },
	
	    hidePanel: function hidePanel() {
	      if (this.show) {
	        document.getElementById('libioss-wrapper').style.display = 'none';
	      } else {
	        document.getElementById('libioss-wrapper').style.display = 'block';
	      }
	      this.show = !this.show;
	    },
	    layerMngr: function layerMngr() {
	      this.showLayerMngr = !this.showLayerMngr;
	    },
	    download: function download() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var lista_specie, loading, response, data;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                lista_specie = _this6.layers.map(function (s) {
	                  return s.id;
	                }).join(',');
	
	                if (!(lista_specie.length === 0)) {
	                  _context2.next = 6;
	                  break;
	                }
	
	                (0, _notification2.default)('Nessuna specie selezionata', 'warning');
	                return _context2.abrupt('return');
	
	              case 6:
	                loading = _loading4.default.service({
	                  text: 'Preparazione dati...',
	                  background: 'rgba(0, 0, 0, 0.8)'
	                });
	                _context2.next = 9;
	                return fetch('/geoservices/REST/libioss/ppf_download/' + lista_specie);
	
	              case 9:
	                response = _context2.sent;
	                _context2.next = 12;
	                return response.json();
	
	              case 12:
	                data = _context2.sent;
	
	                loading.close();
	                _this6.downloadURI(data.url);
	
	              case 15:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this6);
	      }))();
	    },
	    downloadURI: function downloadURI(url) {
	      var link = document.createElement('a');
	      link.setAttribute('target', '_blank');
	      document.body.appendChild(link);
	      link.href = url;
	      link.click();
	    }
	  },
	  computed: {
	    showSpecie: function showSpecie() {
	      return true;
	    }
	  },
	  mounted: function mounted() {
	    var _this7 = this;
	
	    (0, _getConfig2.default)(this.idAncillaryMap).then(function (data) {
	      _this7.ancillaryMap = data.data.data;
	      _this7.addMapConfig();
	    });
	  }
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Map = __webpack_require__(361);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _Map3 = __webpack_require__(362);
	
	var _Map4 = _interopRequireDefault(_Map3);
	
	var _InfoWmsManager = __webpack_require__(31);
	
	var _InfoWmsManager2 = _interopRequireDefault(_InfoWmsManager);
	
	var _Coordinate = __webpack_require__(160);
	
	var _Coordinate2 = _interopRequireDefault(_Coordinate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var llEvents = ['dblclick', 'mousedown', 'mouseup', 'mouseover', 'mouseout', 'mousemove', 'contextmenu', 'focus', 'blur', 'preclick', 'load', 'unload', 'viewreset', 'movestart', 'move', 'moveend', 'dragstart', 'drag', 'dragend', 'zoomstart', 'zoomend', 'zoomanim', 'zoomlevelschange', 'resize', 'autopanstart', 'layeradd', 'layerremove', 'baselayerchange', 'overlayadd', 'overlayremove', 'locationfound', 'locationerror', 'popupopen', 'popupclose'];
	
	var olEvents = ['click', 'dblclick', 'singleclick', 'change:layerGroup', 'change:size', 'change:target', 'change:view', 'error', 'moveend', 'movestart', 'pointerdrag', 'pointermove', 'postcompose', 'postrender', 'precompose', 'propertychange', 'rendercomplete'];
	exports.default = {
	  name: 'gv-map',
	  data: function data() {
	    return {
	      map: null,
	      type: null
	    };
	  },
	  mounted: function mounted() {
	    this.type = GV.config.application.mapOptions && GV.config.application.mapOptions.type || 'leaflet';
	
	    this.setMapSize();
	
	    if (this.type === 'leaflet') {
	      GV.app.map = _Map2.default.initialize(GV.config.application.mapOptions);
	    } else {
	      GV.app.map = _Map4.default.initialize(GV.config.application.mapOptions);
	    }
	    this.map = GV.app.map;
	
	    this.registerMapEvents();
	
	    this.subscribeConfigEvents();
	
	    if (GV.config.application.mapOptions && GV.config.application.mapOptions.click) {
	      switch (GV.config.application.mapOptions.click) {
	        case 'info':
	          _InfoWmsManager2.default.activate();
	          break;
	        case 'coordinate':
	          _Coordinate2.default.activate();
	          break;
	      }
	    }
	
	    GV.log('gv-map: mounted');
	    GV.eventBus.$emit('gv-map-mounted', GV.app.map);
	  },
	
	  methods: {
	    setMapSize: function setMapSize() {
	      var mapDiv = document.getElementById('gv-map');
	      if (GV.config.application.mapOptions && GV.config.application.mapOptions.width) {
	        mapDiv.style.width = GV.config.application.mapOptions.width + 'px';
	      }
	      if (GV.config.application.mapOptions && GV.config.application.mapOptions.height) {
	        mapDiv.style.height = GV.config.application.mapOptions.height + 'px';
	      }
	    },
	    registerMapEvents: function registerMapEvents() {
	      var _this = this;
	
	      var events = this.type === 'leaflet' ? llEvents : olEvents;
	      events.forEach(function (eventName) {
	        var exposedName = 'map-' + eventName;
	        GV.app.map.on(eventName, function (ev) {
	          ev.mapType = _this.mapType;
	          GV.eventBus.$emit(exposedName, ev);
	        });
	      });
	    },
	    subscribeConfigEvents: function subscribeConfigEvents() {
	      GV.eventBus.$on('config-add-map', function (ev) {
	        var mapConfig = ev.config;
	
	        GV.app.map.loadLayers(mapConfig.layers);
	
	        if (mapConfig.extent_3857) {
	          GV.app.map.setExtent(mapConfig.extent_3857);
	        }
	      });
	
	      GV.eventBus.$on('config-add-layer', function (ev) {
	        var layerConfig = ev.config;
	
	        GV.app.map.loadLayers([layerConfig]);
	
	        if (layerConfig.extent_3857) {
	          GV.app.map.setExtent(layerConfig.extent_3857);
	        }
	      });
	
	      GV.eventBus.$on('config-remove-layer', function (ev) {
	        var idLayer = ev.config;
	        var layer = GV.app.map.getLayerByName(idLayer);
	        if (layer) GV.app.map.removeLayer(layer);
	      });
	
	      GV.eventBus.$on('config-remove-map', function (ev) {
	        var mapConfig = ev.config;
	
	        mapConfig.layers.forEach(function (layerConfig) {
	          var layer = GV.app.map.getLayerByName(layerConfig.name);
	          if (layer) {
	            GV.app.map.removeLayer(layer);
	          }
	        });
	      });
	    }
	  }
	};

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _datePicker = __webpack_require__(680);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _datePicker3 = __webpack_require__(535);
	
	var _datePicker4 = _interopRequireDefault(_datePicker3);
	
	var _row = __webpack_require__(36);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _row3 = __webpack_require__(34);
	
	var _row4 = _interopRequireDefault(_row3);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	_vue2.default.use(_row4.default);
	_vue2.default.use(_datePicker4.default);
	exports.default = {
	  data: function data() {
	    return {
	      idMap: null,
	      mapConfig: null,
	      baseLayerGG: null,
	      baseLayerAA: null,
	      tipi: [],
	      indicatoriGiorno: [],
	      indicatoriAnno: [],
	      anni: [],
	      tipo: null,
	      indicatore: null,
	      data: null,
	      giorno: null,
	      show: true,
	      buttonDisabled: true,
	      showLegend: false,
	      legendUrl: null,
	      datePickerOptions: {
	        disabledDate: this.checkDate
	      }
	    };
	  },
	
	  watch: {
	    giorno: function giorno() {
	      this.data = this.giorno;
	    },
	    data: function data() {
	      if (!this.data) this.showLegend = false;
	      console.log(this.data);
	      if (this.data && this.indicatore) this.loadLayer();
	    }
	  },
	  methods: {
	    checkDate: function checkDate(date) {
	      var today = new Date();
	      var startYear = today.getFullYear() - 4;
	      var startDate = new Date(startYear + '-01-01');
	      return date > today || date < startDate;
	    },
	    onChangeTipo: function onChangeTipo(value) {
	      console.log(value);
	      this.tipo = value;
	      this.indicatore = null;
	      this.data = null;
	      this.giorno = null;
	      this.showLegend = false;
	    },
	    onChangeIndicatore: function onChangeIndicatore(value) {
	      console.log(value);
	      this.indicatore = value;
	      if (this.data) this.loadLayer();
	    },
	    loadLayer: function loadLayer() {
	      GV.config.removeMap(this.idMap);
	      this.mapConfig.layers = [];
	      this.mapConfig.layers = [this.getLayer()];
	      GV.config.addMapConfig(this.mapConfig);
	      this.legendUrl = '/geoservices/REST/rqa/legenda/' + this.indicatore;
	      this.showLegend = true;
	    },
	    getLayer: function getLayer() {
	      var _this = this;
	
	      var layer = this.tipo === 'G' ? this.baseLayerGG : this.baseLayerAA;
	      if (this.tipo === 'G') {
	        layer.wmsParams.styles = 'RQA_' + this.indicatore;
	        layer.wmsParams.cql_filter = 'cod_indicatore=\'' + this.indicatore + '\' AND giorno=\'' + this.data + '\'';
	        var indicatore = this.indicatoriGiorno.find(function (ind) {
	          return ind.id === _this.indicatore;
	        }).nome;
	        layer.legend.label = indicatore + ' (' + this.data + ')';
	      } else {
	        layer.wmsParams.styles = 'RQA_' + this.indicatore;
	        layer.wmsParams.cql_filter = 'cod_indicatore=\'' + this.indicatore + '\' AND anno=' + this.data;
	        var _indicatore = this.indicatoriAnno.find(function (ind) {
	          return ind.id === _this.indicatore;
	        }).nome;
	        layer.legend.label = _indicatore + ' (' + this.data + ')';
	      }
	      return layer;
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-panel-collapse gv-color-scheme el-icon-arrow-up' : 'gv-panel-collapse gv-color-scheme el-icon-arrow-down';
	    },
	
	    hidePanel: function hidePanel() {
	      if (this.show) {
	        document.getElementById('rqa-wrapper').style.display = 'none';
	      } else {
	        document.getElementById('rqa-wrapper').style.display = 'block';
	      }
	      this.show = !this.show;
	    },
	    setData: function setData(data) {
	      this.tipi = data.tipi;
	      this.indicatoriGiorno = data.indicatoriGiorno;
	      this.indicatoriAnno = data.indicatoriAnno;
	      this.anni = data.anni;
	      this.mapConfig = data.mapConfig;
	      this.idMap = data.mapConfig.id;
	      this.baseLayerGG = data.mapConfig.layers.filter(function (layer) {
	        return layer.id === data.idLayerGG;
	      })[0];
	      this.baseLayerAA = data.mapConfig.layers.filter(function (layer) {
	        return layer.id === data.idLayerAA;
	      })[0];
	    },
	    download: function download() {
	      this.downloadURI('https://srvcarto.regione.liguria.it/dtuff/download_statico/2219/rqa-dati.zip');
	    },
	    downloadURI: function downloadURI(url) {
	      var link = document.createElement('a');
	      link.setAttribute('target', '_blank');
	      document.body.appendChild(link);
	      link.href = url;
	      link.click();
	    }
	  },
	  computed: {
	    showIndicatoriGiorno: function showIndicatoriGiorno() {
	      return this.tipo == 'G';
	    },
	    showIndicatoriAnno: function showIndicatoriAnno() {
	      return this.tipo == 'A';
	    }
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _axios2.default.get('/geoservices/REST/rqa/app-config/').then(function (response) {
	      return response.data.data;
	    }).then(function (data) {
	      _this2.setData(data);
	    });
	  }
	};

/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _TestScreenWidth = __webpack_require__(62);
	
	var _TestScreenWidth2 = _interopRequireDefault(_TestScreenWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	exports.default = {
	  data: function data() {
	
	    var options = [{
	      value: 8,
	      label: '1:2.300.000'
	    }, {
	      value: 9,
	      label: '1:1.150.000'
	    }, {
	      value: 10,
	      label: '1:580.000'
	    }, {
	      value: 11,
	      label: '1:290.000'
	    }, {
	      value: 12,
	      label: '1:144.000'
	    }, {
	      value: 13,
	      label: '1:72.000'
	    }, {
	      value: 14,
	      label: '1:36.000'
	    }, {
	      value: 15,
	      label: '1:18.000'
	    }, {
	      value: 16,
	      label: '1:9.000'
	    }, {
	      value: 17,
	      label: '1:4.500'
	    }, {
	      value: 18,
	      label: '1:2.200'
	    }, {
	      value: 19,
	      label: '1:1.100'
	    }, {
	      value: 20,
	      label: '1:560'
	    }];
	
	    return {
	      options: options,
	      value: 9
	    };
	  },
	
	  mixins: [_TestScreenWidth2.default],
	  methods: {
	    onChange: function onChange(value) {
	      GV.app.map.setZoom(value);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    GV.eventBus.$on('map-zoom', function (zoom) {
	      _this.value = Math.round(zoom);
	    });
	  }
	};

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _table = __webpack_require__(43);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _table3 = __webpack_require__(41);
	
	var _table4 = _interopRequireDefault(_table3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_table4.default);
	
	_locale2.default.use(_it2.default);
	
	exports.default = {
	  name: 'gv-scuoladigitale-info-conn',
	  props: {
	    properties: Object
	  },
	  data: function data() {
	    return {
	      nome: null,
	      indirizzo: null,
	      sito: null,
	      show: false
	    };
	  },
	  mounted: function mounted() {
	    console.log(this.properties);
	  },
	  beforeCreate: function beforeCreate() {
	    var div = document.getElementById('gv-scuoladigitale-info-conn');
	    if (!div) return;
	    div.parentNode.removeChild(div);
	  },
	
	  computed: {
	    tipoSede: function tipoSede() {
	      return this.properties.TIPO_SEDE === '1' ? 'Sede distaccata o succursale' : 'Sede Amministrativa';
	    },
	    tipoConn: function tipoConn() {
	      var tipoConn = void 0;
	      switch (this.properties.TIPO_CONNES) {
	        case '1':
	          tipoConn = 'FTTH';
	          break;
	        case '2':
	          tipoConn = 'FTTC';
	          break;
	        case '3':
	          tipoConn = 'ADSL';
	          break;
	        case '4':
	          tipoConn = 'FWA';
	          break;
	        case '5':
	          tipoConn = 'RTG / Senza copertura';
	          break;
	      }
	      return tipoConn;
	    },
	    tipoConnURL: function tipoConnURL() {
	      var tipoConn = void 0;
	      switch (this.properties.TIPO_CONNES) {
	        case '1':
	          tipoConn = 'FTTH';
	          break;
	        case '2':
	          tipoConn = 'FTTC';
	          break;
	        case '3':
	          tipoConn = 'ADSL';
	          break;
	        case '4':
	          tipoConn = 'FWA';
	          break;
	        case '5':
	          tipoConn = 'RTG';
	          break;
	      }
	      return 'https://srvcarto.regione.liguria.it/dtuff/img/Istituti_scolastici_connettivita/' + tipoConn + '.pdf';
	    }
	  },
	  methods: {
	    closePanel: function closePanel() {
	      var div = document.getElementById('gv-scuoladigitale-info-conn');
	      if (!div) return;
	      div.parentNode.removeChild(div);
	    },
	    hidePanel: function hidePanel(event) {
	      if (this.show) {
	        document.getElementById('gv-scuoladigitale-info-conn-body').style.display = 'block';
	        document.getElementById('gv-scuoladigitale-info-conn').style.width = '800px';
	      } else {
	        document.getElementById('gv-scuoladigitale-info-conn-body').style.display = 'none';
	        document.getElementById('gv-scuoladigitale-info-conn').style.width = '200px';
	      }
	      this.show = !this.show;
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.show ? 'gv-scuoladigitale-info-conn-collapse gv-color-scheme el-icon-arrow-down' : 'gv-scuoladigitale-info-conn-collapse gv-color-scheme el-icon-arrow-up';
	    },
	    handleLink: function handleLink(index, link_documentazione) {
	      window.open(link_documentazione);
	    }
	  }
	};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _tableColumn = __webpack_require__(54);
	
	var _tableColumn2 = _interopRequireDefault(_tableColumn);
	
	var _tableColumn3 = __webpack_require__(53);
	
	var _tableColumn4 = _interopRequireDefault(_tableColumn3);
	
	var _table = __webpack_require__(43);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _table3 = __webpack_require__(41);
	
	var _table4 = _interopRequireDefault(_table3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _LegendMaps = __webpack_require__(146);
	
	var _LegendMaps2 = _interopRequireDefault(_LegendMaps);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _loadComponent = __webpack_require__(176);
	
	var _loadComponent2 = _interopRequireDefault(_loadComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-legend-maps', _LegendMaps2.default);
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	_vue2.default.use(_button4.default);
	_vue2.default.use(_table4.default);
	_vue2.default.use(_tableColumn4.default);
	
	_vue2.default.component('gv-scuoladigitale-ricerca', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(15, function (require) {
	      resolve(__webpack_require__(781));
	    });
	  });
	});
	_vue2.default.component('gv-scuoladigitale-ricerca-conn', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(14, function (require) {
	      resolve(__webpack_require__(782));
	    });
	  });
	});
	
	exports.default = {
	  name: 'gv-scuoladigitale-legend',
	  data: function data() {
	    var options = GV.config.getToolOptions('gv-scuoladigitale-legend');
	
	    return {
	      options: options,
	      maps: GV.config.maps,
	      show: true,
	      tema: 0,
	      title: 'LEGENDA ICONE'
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var mapConfig;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              GV.log('gv-scuoladigitale-legend: mounted');
	              GV.legend = _this;
	
	              if (!(_this.options.version === 3)) {
	                _context.next = 7;
	                break;
	              }
	
	              _context.next = 5;
	              return GV.config.addRlMap('2223', true, false);
	
	            case 5:
	              mapConfig = _context.sent;
	
	              (0, _mountComponent2.default)({
	                elId: 'gv-scuoladigitale-ricerca',
	                containerId: GV.config.containerId,
	                toggleEl: true,
	                vm: new _vue2.default({
	                  template: '<gv-scuoladigitale-ricerca-conn></gv-scuoladigitale-ricerca-conn>'
	                })
	              });
	
	            case 7:
	              GV.config.addMapConfig(_this.options.maps[0]);
	              _this.show = false;
	              if (_this.options.version === 2) {
	                _this.hideLegend();
	                (0, _mountComponent2.default)({
	                  elId: 'gv-scuoladigitale-ricerca',
	                  containerId: GV.config.containerId,
	                  toggleEl: true,
	                  vm: new _vue2.default({
	                    template: '<gv-scuoladigitale-ricerca></gv-scuoladigitale-ricerca>'
	                  })
	                });
	              }
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	
	  methods: {
	    showSearch: function showSearch() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-scuoladigitale-ricerca',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-scuoladigitale-ricerca></gv-scuoladigitale-ricerca>'
	        })
	      });
	    },
	
	    hideLegend: function hideLegend(event) {
	      if (this.show) {
	        document.getElementById('gv-scuoladigitale-legend-wrapper').style.display = 'block';
	        document.getElementById('gv-scuoladigitale-legend').style.width = '260px';
	      } else {
	        document.getElementById('gv-scuoladigitale-legend-wrapper').style.display = 'none';
	        document.getElementById('gv-scuoladigitale-legend').style.width = '160px';
	      }
	      this.show = !this.show;
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      console.log('legend', this.show);
	      return this.show ? 'gv-scuoladigitale-legend-collapse gv-color-scheme el-icon-arrow-down' : 'gv-scuoladigitale-legend-collapse gv-color-scheme el-icon-arrow-up';
	    }
	  }
	};

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	exports.default = {
	  data: function data() {
	    return {
	      results: [],
	      address: [],
	      recordsCache: {},
	      layers: null,
	      cachedLayers: [],
	      propertyName: null,
	      loading: false,
	      marker: null,
	      placeHolder: 'Ricerca...'
	    };
	  },
	
	  mounted: function mounted() {
	    this.layers = GV.config.getToolOptions('gv-search').layers;
	    this.propertyName = GV.config.getToolOptions('gv-search').propertyName;
	    this.additionalLabel = GV.config.getToolOptions('gv-search').additionalLabel;
	    this.placeHolder = GV.config.getToolOptions('gv-search').placeHolder || 'Ricerca...';
	  },
	  methods: {
	    search: function search(query) {
	      this.results = [];
	      if (query.length < 3) {
	        return;
	      }
	      this.results = this.filterData(query);
	    },
	    filterData: function filterData(text) {
	      var _this = this;
	
	      var results = [];
	      text = text.replace(/[*+?^${}()|[\]\\]/g, '');
	      if (text === '') {
	        return [];
	      }
	      this.layers.forEach(function (sLayer) {
	        GV.app.map.eachLayer(function (layer) {
	          if (layer.name === sLayer) {
	            if (layer instanceof L.LayerGroup) {
	              layer.eachLayer(function (m) {
	                var loc = m.getLatLng();
	                loc.layer = m;
	                if (m.feature) {
	                  var key = m.feature.properties[_this.propertyName];
	                  if (new RegExp(text, 'i').test(key)) {
	                    var addLabel = _this.additionalLabel ? m.feature.properties[_this.additionalLabel] : null;
	                    var label = _this.additionalLabel ? key + ' (' + addLabel + ')' : key;
	                    results.push({
	                      label: label,
	                      value: label,
	                      location: loc
	                    });
	                  }
	                }
	              });
	            }
	          }
	        });
	      });
	      return results;
	    },
	    onChange: function onChange(value) {
	      var marker = this.results.find(function (item) {
	        return item.value === value;
	      });
	      if (marker) {
	        marker.type = 'circle';
	        marker.zoomLevel = 16;
	        this.marker = GV.app.map.addMarker(marker);
	      } else {
	        if (this.marker) {
	          GV.app.map.removeLayer(this.marker);
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(32);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _option = __webpack_require__(14);
	
	var _option2 = _interopRequireDefault(_option);
	
	var _option3 = __webpack_require__(12);
	
	var _option4 = _interopRequireDefault(_option3);
	
	var _select = __webpack_require__(15);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _select3 = __webpack_require__(13);
	
	var _select4 = _interopRequireDefault(_select3);
	
	var _formItem = __webpack_require__(42);
	
	var _formItem2 = _interopRequireDefault(_formItem);
	
	var _formItem3 = __webpack_require__(39);
	
	var _formItem4 = _interopRequireDefault(_formItem3);
	
	var _form = __webpack_require__(35);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _form3 = __webpack_require__(33);
	
	var _form4 = _interopRequireDefault(_form3);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _getGeoJSON = __webpack_require__(56);
	
	var _getGeoJSON2 = _interopRequireDefault(_getGeoJSON);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _it = __webpack_require__(17);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _locale = __webpack_require__(11);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	_vue2.default.use(_form4.default);
	_vue2.default.use(_formItem4.default);
	_vue2.default.use(_select4.default);
	_vue2.default.use(_option4.default);
	
	_locale2.default.use(_it2.default);
	
	var VueCookie = __webpack_require__(68);
	_vue2.default.use(VueCookie);
	
	exports.default = {
	  name: 'gv-map-selezione-fogli',
	  props: {
	    idMap: String,
	    selFogli: String,
	    field: String
	  },
	  data: function data() {
	    return {
	      title: 'SELEZIONE FOGLI',
	      fogli: [],
	      config: {},
	      storageKey: 'selFogli',
	      style: null,
	      hlStyle: null
	    };
	  },
	
	  computed: {},
	  watch: {
	    fogli: function fogli(fogliSel) {
	      this.syncFogli(fogliSel);
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    GV.eventBus.$on('gv-config-init', function () {
	      _this.config = GV.config.getMapConfig(_this.idMap).downloadConfig;
	      _this.setFeatureStyle();
	      _this.addLayerSquadri();
	      _this.show = true;
	    });
	  },
	
	  methods: {
	    setFeatureStyle: function setFeatureStyle() {
	      var style = void 0;
	      if (GV.app.map.type === 'openlayers') {
	        style = new ol.style.Style({
	          stroke: new ol.style.Stroke({
	            color: [255, 204, 0, 1],
	            width: 1
	          }),
	          fill: new ol.style.Fill({
	            color: [255, 204, 0, 0.1]
	          })
	        });
	      } else {
	        style = {
	          color: '#ffcc00',
	          fillOpacity: 0,
	          weight: 1,
	          opacity: 1
	        };
	      }
	      this.style = style;
	
	      if (GV.app.map.type === 'openlayers') {
	        style = new ol.style.Style({
	          stroke: new ol.style.Stroke({
	            color: [255, 204, 0, 1],
	            width: 3
	          }),
	          fill: new ol.style.Fill({
	            color: [255, 204, 0, 0.6]
	          })
	        });
	      } else {
	        style = {
	          color: '#ffcc00',
	          fillOpacity: 0.6,
	          weight: 2,
	          opacity: 1
	        };
	      }
	      this.hlStyle = style;
	    },
	    syncFogli: function syncFogli(fogliSel) {
	      var _this2 = this;
	
	      var layerFogli = GV.app.map.getLayerByName('SelezioneSquadri');
	      if (!layerFogli) {
	        return;
	      }
	      var style = this.hlStyle;
	      if (GV.app.map.type === 'openlayers') {
	        var features = layerFogli.getSource().getFeatures();
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(features), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var feature = _step.value;
	
	            feature.setStyle(false);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(fogliSel), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var foglio = _step2.value;
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(features), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _feature = _step3.value;
	
	                var codice = _feature.get('COD_SQUADRO') || _feature.get('cod_squadro');
	                if (codice == foglio) {
	                  _feature.setStyle(style);
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      } else {
	        layerFogli.eachLayer(function (layer) {
	          layer.setStyle(_this2.style);
	        });
	        layerFogli.eachLayer(function (layer) {
	          fogliSel.forEach(function (foglio) {
	            var codice = layer.feature.properties.COD_SQUADRO || layer.feature.properties.cod_squadro;
	            if (codice === foglio) {
	              layer.setStyle(_this2.hlStyle);
	            }
	          });
	        });
	      }
	    },
	    addLayerSquadri: function addLayerSquadri() {
	      var _this3 = this;
	
	      var baseUrl = _globals2.default.DEFAULT_PROXY + 'https://geoservizi.regione.liguria.it/geoserver/wfs?service=WFS&version=2.0.0&request=GetFeature&srsName=EPSG:4326&outputFormat=application%2Fjson&typeName=';
	      var url = '' + baseUrl + this.config.livelloSquadri;
	      (0, _getGeoJSON2.default)(url).then(function (response) {
	        _this3.loadDataSquadri(response.data);
	      });
	    },
	    loadDataSquadri: function loadDataSquadri(data) {
	      var _this4 = this;
	
	      if (GV.app.map.getLayerByName('SelezioneSquadri')) {
	        GV.app.map.removeLayer(GV.app.map.getLayerByName('SelezioneSquadri'));
	      }
	
	      var filteredFeatures = data.features.filter(function (feature) {
	        var filter = _this4.config.fogli.filter(function (foglio) {
	          var codice = feature.properties.COD_SQUADRO || feature.properties.cod_squadro;
	          return foglio.codice === codice;
	        });
	        return filter.length > 0;
	      });
	      data.features = filteredFeatures;
	
	      this.layerFogli = data;
	
	      this.loadLayer();
	    },
	    submit: function submit() {
	      this.postMessage('conferma');
	    },
	    cancel: function cancel() {
	      this.postMessage('annulla');
	    },
	    postMessage: function postMessage(button) {
	      var message = {
	        fogliSelezionati: this.fogli.join(','),
	        field: parseInt(this.field),
	        button: button
	      };
	
	      window.parent.postMessage(message, '*');
	    },
	    loadLayer: function loadLayer() {
	      var _this5 = this;
	
	      GV.app.map.loadLayers([{
	        name: 'SelezioneSquadri',
	        type: 'JSON',
	        style: this.style,
	        visible: true,
	        data: this.layerFogli,
	        zIndex: 100,
	        onFeatureSelect: function onFeatureSelect(feature, layer) {
	          var codice = feature.get ? feature.get('COD_SQUADRO') || feature.get('cod_squadro') : feature.properties.COD_SQUADRO || feature.properties.cod_squadro;
	          if (_this5.fogli.indexOf(codice) > -1) {
	            _this5.fogli = _this5.fogli.filter(function (item) {
	              return item !== codice;
	            });
	          } else {
	            _this5.fogli.push(codice);
	          }
	        }
	      }]);
	      GV.config.activeControl.deactivate();
	
	      if (this.selFogli) {
	        this.fogli = this.selFogli.split(',');
	      }
	
	      (0, _notification2.default)('Selezionare un foglio sulla mappa o dalla lista', 'info');
	    },
	
	    collapse: function collapse(event) {
	      if (this.show) {
	        document.getElementById('gv-map-selezione-fogli-body').style.display = 'none';
	      } else {
	        document.getElementById('gv-map-selezione-fogli-body').style.display = 'block';
	      }
	      this.show = !this.show;
	    }
	  }
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'gv-title',
	  props: ['divId', 'title', 'fullTitle', 'hide', 'noClose', 'collapsible', 'width', 'collapsedWidth'],
	  data: function data() {
	    return {
	      collapsed: false
	    };
	  },
	
	  methods: {
	    closePanel: function closePanel() {
	      var div = document.getElementById(this.divId);
	      if (!div) return;
	      this.hide ? div.style.display = 'none' : div.parentNode.removeChild(div);
	      GV.eventBus.$emit('title-close-panel', {
	        divId: this.divId
	      });
	    },
	    collapse: function collapse() {
	      if (this.collapsed) {
	        document.getElementById(this.collapsible).style.display = 'block';
	
	        this.$el.style.width = null;
	      } else {
	        document.getElementById(this.collapsible).style.display = 'none';
	        if (this.collapsedWidth) {
	          this.$el.style.width = this.collapsedWidth;
	        }
	      }
	      this.collapsed = !this.collapsed;
	    },
	    toggleCollapseClass: function toggleCollapseClass() {
	      return this.collapsed ? 'gv-title-collapse gv-color-scheme el-icon-arrow-down' : 'gv-title-collapse gv-color-scheme el-icon-arrow-up';
	    }
	  },
	  mounted: function mounted() {
	    this.$el.id = this.divId + '-title';
	  }
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-map-catalog-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(1/* duplicate */, function (require) {
	      resolve(__webpack_require__(147));
	    });
	  });
	});
	
	var name = 'gv-add-map-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-add-map gv-button fa fa-plus-square-o',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-map-catalog-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-map-catalog-panel></gv-map-catalog-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var name = 'gv-back-button';
	
	exports.default = {
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      name: name,
	      active: false,
	      options: options,
	      action: options.action,
	      url: options.url,
	      confirm: options.confirm,
	      cssClass: 'gv-back gv-button fa fa-arrow-left',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      if (this.confirm) {
	        var r = confirm('Sei sicuro?');
	        if (r == true) {
	          this.back();
	        }
	      } else {
	        this.back();
	      }
	    },
	    back: function back() {
	      if (this.action === 'close') {
	        window.close();
	      } else {
	        if (this.url) {
	          window.location = this.url;
	        } else {
	          history.back();
	        }
	      }
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _CduSelezionaParticelle = __webpack_require__(354);
	
	var _CduSelezionaParticelle2 = _interopRequireDefault(_CduSelezionaParticelle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-cdu-seleziona-particelle-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: _CduSelezionaParticelle2.default,
	      options: options,
	      cssClass: 'gv-button fa fa-file',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-cem-elaborazioni', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(25, function (require) {
	      resolve(__webpack_require__(722));
	    });
	  });
	});
	
	var name = 'gv-cem-elaborazioni-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-cem-elaborazioni gv-button fa fa-magnet',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-cem-elaborazioni',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-cem-elaborazioni></gv-cem-elaborazioni>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {
	    (0, _mountComponent2.default)({
	      elId: 'gv-cem-elaborazioni',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-cem-elaborazioni></gv-cem-elaborazioni>'
	      })
	    });
	  }
	};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _Coordinate = __webpack_require__(160);
	
	var _Coordinate2 = _interopRequireDefault(_Coordinate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-coordinate-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: _Coordinate2.default,
	      options: options,
	      cssClass: 'gv-button fa fa-hand-point-down',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-download-totale-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(23, function (require) {
	      resolve(__webpack_require__(734));
	    });
	  });
	});
	
	var name = 'gv-download-totale-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-download-totale-button gv-button el-icon-download',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-download-totale-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-download-totale-panel></gv-download-totale-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _Draw = __webpack_require__(355);
	
	var _Draw2 = _interopRequireDefault(_Draw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-draw-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: _Draw2.default,
	      options: options,
	      title: 'Acquisizione Geometrie',
	      cssClass: 'gv-button fas fa-edit',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-fototeca-carrello-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(2/* duplicate */, function (require) {
	      resolve(__webpack_require__(205));
	    });
	  });
	});
	
	var name = 'gv-fototeca-carrello-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-button fa fa-shopping-cart',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-fototeca-carrello-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-fototeca-carrello-panel></gv-fototeca-carrello-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-fototeca-scheda-volo-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(3/* duplicate */, function (require) {
	      resolve(__webpack_require__(206));
	    });
	  });
	});
	
	var name = 'gv-fototeca-scheda-volo-button';
	
	exports.default = {
	  name: name,
	
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-button fa fa-info-circle',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      if (!GV.globals.FOTOTECA_SEL_VOLO) return;
	      (0, _mountComponent2.default)({
	        elId: 'gv-fototeca-scheda-volo-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-fototeca-scheda-volo-panel></gv-fototeca-scheda-volo-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _FototecaSelezioneTerritoriale = __webpack_require__(356);
	
	var _FototecaSelezioneTerritoriale2 = _interopRequireDefault(_FototecaSelezioneTerritoriale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-fototeca-selezione-territoriale-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: _FototecaSelezioneTerritoriale2.default,
	      options: options,
	      cssClass: 'gv-button fa fa-edit',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    GV.eventBus.$on('gv-fototeca-selezione-territoriale-switch', function (event) {
	      _this.switchActiveButton();
	    });
	  }
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-button-genio-conferma-load-shape';
	
	
	_vue2.default.component('gv-genio-conferma-load-shape', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(35, function (require) {
	      resolve(__webpack_require__(741));
	    });
	  });
	});
	
	exports.default = {
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      name: name,
	      active: false,
	      options: options,
	      action: options.action,
	      url: options.url,
	      confirm: options.confirm,
	      cssClass: 'gv-back gv-button fa fa-save',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-genio-conferma-load-shape',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-genio-conferma-load-shape></gv-genio-conferma-load-shape>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-genio-localizza', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(12, function (require) {
	      resolve(__webpack_require__(742));
	    });
	  });
	});
	
	var name = 'gv-genio-localizza-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-genio-localizza-button gv-button ms ms-select-hand',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-genio-localizza',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-genio-localizza></gv-genio-localizza>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-genio-pratiche-collegate-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(20, function (require) {
	      resolve(__webpack_require__(743));
	    });
	  });
	});
	
	var name = 'gv-genio-pratiche-collegate-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-button fa fa-link',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-genio-pratiche-collegate-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-genio-pratiche-collegate-panel></gv-genio-pratiche-collegate-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _GenioSelezionaParticelle = __webpack_require__(357);
	
	var _GenioSelezionaParticelle2 = _interopRequireDefault(_GenioSelezionaParticelle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-genio-seleziona-particelle-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: _GenioSelezionaParticelle2.default,
	      options: options,
	      cssClass: 'gv-button fa fa-hand-point-down',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-geocoder-btn-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(34, function (require) {
	      resolve(__webpack_require__(746));
	    });
	  });
	});
	
	var name = 'gv-geocoder-btn-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-button fa fa-search',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-geocoder-btn-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-geocoder-btn-panel></gv-geocoder-btn-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-help-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-button fa fa-question',
	
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      var url = this.options.URL;
	      console.log('onClick', url);
	      if (!url) return;
	      if (url) window.open(url, '_blank');
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-help3D-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(9, function (require) {
	      resolve(__webpack_require__(749));
	    });
	  });
	});
	
	var name = 'gv-help3D-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-help3D-button gv-button fa fa-question',
	      cssActiveClass: 'gv-button'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-help3D-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-help3D-panel></gv-help3D-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {
	    if (this.options.showOnStart) {
	      (0, _mountComponent2.default)({
	        elId: 'gv-help3D-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-help3D-panel></gv-help3D-panel>'
	        })
	      });
	    }
	  }
	};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _InfoWmsManager = __webpack_require__(31);
	
	var _InfoWmsManager2 = _interopRequireDefault(_InfoWmsManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-info-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: _InfoWmsManager2.default,
	      options: options,
	      cssClass: 'gv-button fa fa-info',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {
	    this.active = this.options.active;
	  }
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-insert-point-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(28, function (require) {
	      resolve(__webpack_require__(756));
	    });
	  });
	});
	
	var name = 'gv-insert-point-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      cssClass: 'gv-button fa fa-edit',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-insert-point-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-insert-point-panel></gv-insert-point-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-layer-search', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(7, function (require) {
	      resolve(__webpack_require__(757));
	    });
	  });
	});
	
	var name = 'gv-layer-search-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-layer-search-button gv-button fa fa-search',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-layer-search',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-layer-search></gv-layer-search>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	_vue2.default.component('gv-layer-search-topo', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(5, function (require) {
	      resolve(__webpack_require__(759));
	    });
	  });
	});
	
	var name = 'gv-layer-search-topo-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-layer-search-topo-button gv-button fa fa-search',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-layer-search-topo',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-layer-search-topo></gv-layer-search-topo>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwitchActiveButton = __webpack_require__(55);
	
	var _SwitchActiveButton2 = _interopRequireDefault(_SwitchActiveButton);
	
	var _Measure = __webpack_require__(358);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var name = 'gv-measure-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      control: null,
	      options: options,
	      title: 'Misurazioni',
	      cssClass: 'gv-button fg-measure',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	  mixins: [_SwitchActiveButton2.default],
	  methods: {
	    onClick: function onClick() {
	      this.switchActiveButton();
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {
	    console.log('MOUNTED', GV.app.map.type);
	    this.control = _Measure2.default;
	  }
	};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-print-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(13, function (require) {
	      resolve(__webpack_require__(774));
	    });
	  });
	});
	
	var name = 'gv-print-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-print-button gv-button fa fa-print',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-print-panel',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-print-panel></gv-print-panel>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-ricerca-particella', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(8, function (require) {
	      resolve(__webpack_require__(775));
	    });
	  });
	});
	
	var name = 'gv-ricerca-particella-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-ricerca-particella-button gv-button fa fa-building',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-ricerca-particella',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-ricerca-particella></gv-ricerca-particella>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _button = __webpack_require__(9);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _button3 = __webpack_require__(8);
	
	var _button4 = _interopRequireDefault(_button3);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_button4.default);
	
	_vue2.default.component('gv-ricerca-catastale', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(4, function (require) {
	      resolve(__webpack_require__(777));
	    });
	  });
	});
	
	var name = 'gv-ricerca-catastale-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	
	    return {
	      active: false,
	      options: options,
	      cssClass: 'gv-ricerca-catastale-button gv-button fa fa-building',
	      cssActiveClass: 'gv-button-selected'
	    };
	  },
	
	
	  methods: {
	    onClick: function onClick() {
	      (0, _mountComponent2.default)({
	        elId: 'gv-ricerca-catastale',
	        containerId: GV.config.containerId,
	        toggleEl: true,
	        vm: new _vue2.default({
	          template: '<gv-ricerca-catastale></gv-ricerca-catastale>'
	        })
	      });
	    },
	    setClass: function setClass() {
	      return this.active ? this.cssClass + ' ' + this.cssActiveClass : this.cssClass;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var name = 'gv-switch3D-button';
	
	exports.default = {
	  name: name,
	  data: function data() {
	    var options = GV.config.getToolOptions(name);
	    return {
	      name: name,
	      active: false,
	      options: options,
	      enable3d: null,
	      label: null
	    };
	  },
	
	  methods: {
	    onClick: function onClick() {
	      this.enable3d = !this.enable3d;
	      this.setLabel();
	      GV.app.map.ol3d.setEnabled(this.enable3d);
	      GV.app.map.ol3dEnabled = this.enable3d;
	    },
	    setLabel: function setLabel() {
	      if (this.enable3d) {
	        this.label = '2D';
	      } else {
	        this.label = '3D';
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.enable3d = GV.config.application.mapOptions.enable3d;
	    this.setLabel();
	  }
	};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	"use strict";
	
	(function () {
	    var OGCHelper = {};
	    var loadXML = Cesium.loadXML === undefined ? Cesium.Resource.fetchXML : Cesium.loadXML;
	    var loadArrayBuffer = Cesium.loadArrayBuffer === undefined ? Cesium.Resource.fetchArrayBuffer : Cesium.loadArrayBuffer;
	    var loadImage = Cesium.loadImage === undefined ? Cesium.Resource.fetchImage : Cesium.loadImage;
	    var intersectionRectangle = function intersectionRectangle(rectangle0, rectangle1) {
	        var west = Math.max(rectangle0.west, rectangle1.west);
	        var east = Math.min(rectangle0.east, rectangle1.east);
	        var south = Math.max(rectangle0.south, rectangle1.south);
	        var north = Math.min(rectangle0.north, rectangle1.north);
	        var resultat;
	        if (east <= west || south >= north) {
	            resultat = undefined;
	        } else {
	            resultat = new Cesium.Rectangle(west, south, east, north);
	        }
	        return resultat;
	    };
	
	    OGCHelper.CRS = [{
	        name: "CRS:84",
	        ellipsoid: Cesium.Ellipsoid.WGS84,
	        firstAxeIsLatitude: false,
	        tilingScheme: Cesium.GeographicTilingScheme,
	        supportedCRS: "urn:ogc:def:crs:OGC:2:84"
	    }, {
	        name: "EPSG:4326",
	        ellipsoid: Cesium.Ellipsoid.WGS84,
	        firstAxeIsLatitude: true,
	        tilingScheme: Cesium.GeographicTilingScheme,
	        SupportedCRS: "urn:ogc:def:crs:EPSG::4326"
	    }, {
	        name: "EPSG:3857",
	        ellipsoid: Cesium.Ellipsoid.WGS84,
	        firstAxeIsLatitude: false,
	        tilingScheme: Cesium.WebMercatorTilingScheme,
	        SupportedCRS: "urn:ogc:def:crs:EPSG::3857"
	    }, {
	        name: "OSGEO:41001",
	        ellipsoid: Cesium.Ellipsoid.WGS84,
	        firstAxeIsLatitude: false,
	        tilingScheme: Cesium.WebMercatorTilingScheme,
	        SupportedCRS: "urn:ogc:def:crs:EPSG::3857"
	    }];
	
	    OGCHelper.FormatImage = [{
	        format: "image/png",
	        extension: "png"
	    }, {
	        format: "image/jpeg",
	        extension: "jpg"
	    }, {
	        format: "image/jpeg",
	        extension: "jpeg"
	    }, {
	        format: "image/gif",
	        extension: "gif"
	    }, {
	        format: "image/png; mode=8bit",
	        extension: "png"
	    }];
	
	    OGCHelper.FormatArray = [{
	        format: "image/bil",
	
	        postProcessArray: function postProcessArray(bufferIn, size, highest, lowest, offset) {
	            var resultat;
	            var viewerIn = new DataView(bufferIn);
	            var littleEndianBuffer = new ArrayBuffer(size.height * size.width * 2);
	            var viewerOut = new DataView(littleEndianBuffer);
	            if (littleEndianBuffer.byteLength === bufferIn.byteLength) {
	                var temp,
	                    goodCell = 0,
	                    somme = 0;
	                for (var i = 0; i < littleEndianBuffer.byteLength; i += 2) {
	                    temp = viewerIn.getInt16(i, false) - offset;
	                    if (temp > lowest && temp < highest) {
	                        viewerOut.setInt16(i, temp, true);
	                        somme += temp;
	                        goodCell++;
	                    } else {
	                        var val = goodCell === 0 ? 1 : somme / goodCell;
	                        viewerOut.setInt16(i, val, true);
	                    }
	                }
	                resultat = new Int16Array(littleEndianBuffer);
	            }
	            return resultat;
	        }
	    }];
	
	    OGCHelper.WMSParser = {};
	    OGCHelper.TMSParser = {};
	    OGCHelper.WMTSParser = {};
	
	    OGCHelper.parser = function (description) {
	        var resultat;
	        description = Cesium.defaultValue(description, Cesium.defaultValue.EMPTY_OBJECT);
	        switch (description.service) {
	            case "TMS":
	                resultat = OGCHelper.TMSParser.generate(description);
	                break;
	            case "WMTS":
	                resultat = OGCHelper.WMTSParser.generate(description);
	                break;
	            default:
	                resultat = OGCHelper.WMSParser.generate(description);
	        }
	        return resultat;
	    };
	
	    OGCHelper.WMSParser.generate = function (description) {
	        var resultat;
	        description = Cesium.defaultValue(description, Cesium.defaultValue.EMPTY_OBJECT);
	        if (Cesium.defined(description.url)) {
	            var urlofServer = description.url;
	            var index = urlofServer.lastIndexOf("?");
	            if (index > -1) {
	                urlofServer = urlofServer.substring(0, index);
	            }
	            var urlGetCapabilities = urlofServer + '?SERVICE=WMS&REQUEST=GetCapabilities&tiled=true';
	            if (Cesium.defined(description.proxy)) {
	                urlGetCapabilities = description.proxy.getURL(urlGetCapabilities);
	            }
	            resultat = Cesium.when(loadXML(urlGetCapabilities), function (xml) {
	                return OGCHelper.WMSParser.getMetaDatafromXML(xml, description);
	            });
	        } else if (Cesium.defined(description.xml)) {
	            resultat = OGCHelper.WMSParser.getMetaDatafromXML(description.xml, description);
	        } else {
	            throw new Cesium.DeveloperError('either description.url or description.xml are required.');
	        }
	        return resultat;
	    };
	
	    OGCHelper.WMSParser.getMetaDatafromXML = function (xml, description) {
	        if (!(xml instanceof XMLDocument)) {
	            throw new Cesium.DeveloperError('xml must be a XMLDocument');
	        }
	
	        if (!Cesium.defined(description.layerName)) {
	            throw new Cesium.DeveloperError('description.layerName is required.');
	        }
	        var resultat = {};
	        var layerName = description.layerName;
	        var maxLevel = Cesium.defaultValue(description.maxLevel, 11);
	        var version = undefined;
	        resultat.heightMapWidth = Cesium.defaultValue(description.heightMapWidth, 65);
	        resultat.heightMapHeight = Cesium.defaultValue(description.heightMapHeight, resultat.heightMapWidth);
	        var requestedSize = {
	            width: 65,
	            height: 65
	        };
	        var CRS = undefined;
	        resultat.formatImage = description.formatImage;
	        resultat.formatArray = description.formatArray;
	        resultat.tilingScheme = undefined;
	        var firstAxeIsLatitude = undefined;
	        var isNewVersion = undefined;
	        resultat.ready = false;
	        resultat.levelZeroMaximumGeometricError = undefined;
	        resultat.waterMask = Cesium.defaultValue(description.waterMask, false);
	        if (typeof resultat.waterMask !== "boolean") {
	            resultat.waterMask = false;
	        }
	        resultat.offset = Cesium.defaultValue(description.offset, 0);
	        resultat.highest = Cesium.defaultValue(description.highest, 12000);
	        resultat.lowest = Cesium.defaultValue(description.lowest, -500);
	        var styleName = description.styleName;
	        resultat.hasStyledImage = Cesium.defaultValue(description.hasStyledImage, typeof description.styleName === "string");
	
	        var versionNode = xml.querySelector("[version]");
	        if (versionNode !== null) {
	            version = versionNode.getAttribute("version");
	            isNewVersion = /^1\.[3-9]\./.test(version);
	        }
	
	        var url = xml.querySelector("Request>GetMap OnlineResource").getAttribute("xlink:href");
	        var index = url.indexOf("?");
	        if (index > -1) {
	            url = url.substring(0, index);
	        }
	        if (Cesium.defined(description.proxy)) {
	            url = description.proxy.getURL(url);
	        }
	
	        var nodeFormats = xml.querySelectorAll("Request>GetMap>Format");
	
	        if (!Cesium.defined(resultat.formatImage)) {
	            for (var j = 0; j < nodeFormats.length && !Cesium.defined(resultat.formatArray); j++) {
	                var OGCAvailables = OGCHelper.FormatArray.filter(function (elt) {
	                    return elt.format === nodeFormats[j].textContent;
	                });
	                if (OGCAvailables.length > 0) {
	                    resultat.formatArray = OGCAvailables[0];
	                }
	            }
	        }
	        if (Cesium.defined(resultat.formatArray) && typeof resultat.formatArray.format === "string" && typeof resultat.formatArray.postProcessArray === "function") {
	            resultat.formatArray.terrainDataStructure = {
	                heightScale: 1.0,
	                heightOffset: 0,
	                elementsPerHeight: 1,
	                stride: 1,
	                elementMultiplier: 256.0,
	                isBigEndian: false,
	                lowestEncodedHeight: 0,
	                highestEncodedHeight: 10000
	            };
	        } else {
	            resultat.formatArray = undefined;
	        }
	
	        for (var j = 0; j < nodeFormats.length && !Cesium.defined(resultat.formatImage); j++) {
	            var OGCAvailables = OGCHelper.FormatImage.filter(function (elt) {
	                return elt.format === nodeFormats[j].textContent;
	            });
	            if (OGCAvailables.length > 0) {
	                resultat.formatImage = OGCAvailables[0];
	            }
	        }
	        if (Cesium.defined(resultat.formatImage) && typeof resultat.formatImage.format === "string") {
	            resultat.formatImage.terrainDataStructure = {
	                heightScale: 1.0,
	                heightOffset: 0,
	                elementsPerHeight: 2,
	                stride: 4,
	                elementMultiplier: 256.0,
	                isBigEndian: true,
	                lowestEncodedHeight: 0,
	                highestEncodedHeight: 10000
	            };
	        } else {
	            resultat.formatImage = undefined;
	        }
	        var layerNodes = xml.querySelectorAll("Layer[queryable='1'],Layer[queryable='true']");
	        var layerNode;
	        for (var m = 0; m < layerNodes.length && !Cesium.defined(layerNode); m++) {
	            if (layerNodes[m].querySelector("Name").textContent === layerName) {
	                layerNode = layerNodes[m];
	                var fixedHeight = layerNode.getAttribute("fixedHeight");
	                var fixedWidth = layerNode.getAttribute("fixedWidth");
	                if (Cesium.defined(fixedHeight)) {
	                    fixedHeight = parseInt(fixedHeight);
	                    resultat.heightMapHeight = fixedHeight > 0 && fixedHeight < resultat.heightMapHeight ? fixedHeight : resultat.heightMapHeight;
	                    requestedSize.height = fixedHeight > 0 ? fixedHeight : requestedSize.height;
	                }
	                if (Cesium.defined(fixedWidth)) {
	                    fixedWidth = parseInt(fixedWidth);
	                    resultat.heightMapWidth = fixedWidth > 0 && fixedWidth < resultat.heightMapWidth ? fixedWidth : resultat.heightMapWidth;
	                    requestedSize.width = fixedWidth > 0 ? fixedWidth : requestedSize.width;
	                }
	            }
	        }
	
	        if (Cesium.defined(layerNode) && Cesium.defined(version)) {
	            var found = false;
	            for (var n = 0; n < OGCHelper.CRS.length && !found; n++) {
	                var CRSSelected = OGCHelper.CRS[n];
	                var referentialName = CRSSelected.name;
	                var nodeBBox = layerNode.querySelector("BoundingBox[SRS='" + referentialName + "'],BoundingBox[CRS='" + referentialName + "']");
	
	                if (nodeBBox !== null) {
	                    CRS = referentialName;
	                    firstAxeIsLatitude = CRSSelected.firstAxeIsLatitude;
	                    resultat.tilingScheme = new CRSSelected.tilingScheme({
	                        ellipsoid: CRSSelected.ellipsoid
	                    });
	
	                    var west, east, south, north;
	                    if (firstAxeIsLatitude && isNewVersion) {
	                        west = parseFloat(nodeBBox.getAttribute("miny"));
	                        east = parseFloat(nodeBBox.getAttribute("maxy"));
	                        south = parseFloat(nodeBBox.getAttribute("minx"));
	                        north = parseFloat(nodeBBox.getAttribute("maxx"));
	                    } else {
	                        west = parseFloat(nodeBBox.getAttribute("minx"));
	                        east = parseFloat(nodeBBox.getAttribute("maxx"));
	                        south = parseFloat(nodeBBox.getAttribute("miny"));
	                        north = parseFloat(nodeBBox.getAttribute("maxy"));
	                    }
	                    var rectReference = new Cesium.Rectangle(west, south, east, north);
	                    resultat.getTileDataAvailable = function (x, y, level) {
	                        var retour = false;
	                        var rectangleCalcul = resultat.tilingScheme.tileXYToNativeRectangle(x, y, level);
	                        if (level < maxLevel) {
	                            var scratchRectangle = intersectionRectangle(rectReference, rectangleCalcul);
	                            retour = Cesium.defined(scratchRectangle);
	                        }
	                        return retour;
	                    };
	                    found = true;
	                }
	            }
	
	            if (Cesium.defined(styleName)) {
	                var styleNodes = layerNode.querySelectorAll("Style>Name");
	                var styleFound = false;
	                for (var z = 0; z < styleNodes.length && !styleFound; z++) {
	                    if (styleName === styleNodes[z].textContent) {
	                        styleFound = true;
	                    }
	                }
	                if (!styleFound) {
	                    styleName = undefined;
	                }
	            }
	
	            var tileSets = xml.querySelectorAll("VendorSpecificCapabilities>TileSet");
	            var out = false;
	            for (var q = 0; q < tileSets.length && !out; q++) {
	                var isGoodSRS = tileSets[q].querySelector("BoundingBox[SRS='" + CRS + "'],BoundingBox[CRS='" + CRS + "']") !== null;
	                var isGoodLayer = tileSets[q].querySelector("Layers").textContent === layerName;
	                if (isGoodLayer && isGoodSRS) {
	                    requestedSize.width = parseInt(tileSets[q].querySelector("Width").textContent);
	                    requestedSize.height = parseInt(tileSets[q].querySelector("Height").textContent);
	                    out = true;
	                }
	            }
	
	            resultat.ready = found && (Cesium.defined(resultat.formatImage) || Cesium.defined(resultat.formatArray)) && Cesium.defined(version);
	        }
	
	        if (resultat.ready) {
	            var URLtemplate = url + '?SERVICE=WMS&REQUEST=GetMap&layers=' + layerName + '&version=' + version + '&bbox=';
	            if (isNewVersion && firstAxeIsLatitude) {
	                URLtemplate += '{south},{west},{north},{east}';
	            } else {
	                URLtemplate += '{west},{south},{east},{north}';
	            }
	            URLtemplate += '&crs=' + CRS + '&srs=' + CRS;
	
	            if (resultat.formatImage) {
	                var URLtemplateImage = URLtemplate + '&format=' + resultat.formatImage.format + '&width=' + requestedSize.width + '&height=' + requestedSize.height;
	                if (Cesium.defined(styleName)) {
	                    URLtemplateImage += "&styles=" + styleName + "&style=" + styleName;
	                }
	                resultat.URLtemplateImage = function () {
	                    return URLtemplateImage;
	                };
	                resultat.imageSize = requestedSize;
	            }
	
	            if (resultat.formatArray) {
	                var URLtemplateArray = URLtemplate + '&format=' + resultat.formatArray.format + '&width=' + resultat.heightMapWidth + '&height=' + resultat.heightMapHeight;
	                resultat.URLtemplateArray = function () {
	                    return URLtemplateArray;
	                };
	            }
	        }
	        return resultat;
	    };
	
	    OGCHelper.TMSParser.generate = function (description) {
	        var resultat;
	        description = Cesium.defaultValue(description, Cesium.defaultValue.EMPTY_OBJECT);
	        if (Cesium.defined(description.url)) {
	            resultat = loadXML(description.url).then(function (xml) {
	                return OGCHelper.TMSParser.parseXML(xml, description);
	            });
	        } else if (Cesium.defined(description.xml)) {
	            resultat = OGCHelper.TMSParser.parseXML(description.xml, description);
	        } else {
	            throw new Cesium.DeveloperError('either description.url or description.xml are required.');
	        }
	        return resultat;
	    };
	
	    OGCHelper.TMSParser.parseXML = function (xml, description) {
	        if (!(xml instanceof XMLDocument)) {
	            throw new Cesium.DeveloperError('xml must be a XMLDocument');
	        }
	        var resultat;
	
	        if (xml.querySelector("TileMapService") != null) {
	            if (!Cesium.defined(description.layerName)) {
	                throw new Cesium.DeveloperError('layerName is required.');
	            }
	            var mapServiceNodes = [].slice.apply(xml.querySelectorAll("TileMap[title='" + description.layerName + "']"));
	            var promises = mapServiceNodes.map(function (elt) {
	                var url = elt.getAttribute("href");
	                if (Cesium.defined(description.proxy)) {
	                    url = description.proxy.getURL(url);
	                }
	                return Cesium.when(loadXML(url), function (xml) {
	                    return OGCHelper.TMSParser.getMetaDatafromXML(xml, description);
	                });
	            });
	            var promise = Cesium.when.all(promises).then(function (tabResult) {
	                var retour;
	                for (var i = 0; i < tabResult.length && !Cesium.defined(retour); i++) {
	                    if (Cesium.defined(tabResult[i])) {
	                        retour = tabResult[i];
	                    }
	                }
	                return retour;
	            });
	            resultat = promise.then(function (retour) {
	                return retour;
	            });
	        } else {
	            resultat = OGCHelper.TMSParser.getMetaDatafromXML(xml, description);
	        }
	        return resultat;
	    };
	
	    OGCHelper.TMSParser.getMetaDatafromXML = function (xml, description) {
	        var resultat = {};
	        resultat.ready = false;
	        resultat.heightMapWidth = Cesium.defaultValue(description.heightMapWidth, 65);
	        resultat.heightMapHeight = Cesium.defaultValue(description.heightMapHeight, resultat.heightMapWidth);
	        var maxLevel = Cesium.defaultValue(description.maxLevel, 11);
	        var proxy = description.proxy;
	        resultat.hasStyledImage = Cesium.defaultValue(description.hasStyledImage, typeof description.styleName === "string");
	        resultat.waterMask = Cesium.defaultValue(description.waterMask, false);
	        if (typeof resultat.waterMask != "boolean") {
	            resultat.waterMask = false;
	        }
	        resultat.offset = Cesium.defaultValue(description.offset, 0);
	        resultat.highest = Cesium.defaultValue(description.highest, 12000);
	        resultat.lowest = Cesium.defaultValue(description.lowest, -500);
	
	        var srs = xml.querySelector("SRS").textContent;
	        var goodCRS = OGCHelper.CRS.filter(function (elt) {
	            return elt.name === srs;
	        });
	        if (goodCRS.length > 0) {
	            resultat.tilingScheme = new goodCRS[0].tilingScheme({
	                ellipsoid: goodCRS[0].ellipsoid
	            });
	        }
	
	        var format = xml.querySelector("TileFormat");
	        var goodFormatImage = OGCHelper.FormatImage.filter(function (elt) {
	            return elt.extension == format.getAttribute("extension");
	        });
	        if (goodFormatImage.length > 0) {
	            resultat.formatImage = goodFormatImage[0];
	            resultat.imageSize = {};
	            resultat.imageSize.width = parseInt(format.getAttribute("width"));
	            resultat.imageSize.height = parseInt(format.getAttribute("height"));
	        }
	
	        var tilsetsNode = [].slice.call(xml.querySelectorAll("TileSets>TileSet"));
	        var tileSets = [];
	
	        if (Cesium.defined(resultat.formatImage)) {
	            tileSets = tilsetsNode.map(function (tileSet) {
	                var url = tileSet.getAttribute("href") + "/{x}/{tmsY}." + resultat.formatImage.extension;
	                if (Cesium.defined(proxy)) {
	                    url = proxy.getURL(url);
	                }
	                var level = parseInt(tileSet.getAttribute("order"));
	                return {
	                    url: url,
	                    level: level
	                };
	            });
	            tileSets.sort(function (a, b) {
	                return a.level - b.level;
	            });
	            if (tileSets.length > 0) {
	                resultat.tileSets = tileSets;
	            }
	        }
	
	        if (!Cesium.defined(resultat.tileSets) || !Cesium.defined(resultat.formatImage) || !Cesium.defined(resultat.tilingScheme)) {
	            resultat = undefined;
	        } else {
	            resultat.URLtemplateImage = function (x, y, level) {
	                var retour = "";
	                if (level < tileSets.length) {
	                    retour = tileSets[level].url;
	                }
	                return retour;
	            };
	            var boundingBoxNode = xml.querySelector("BoundingBox");
	            var miny = parseFloat(boundingBoxNode.getAttribute("miny"));
	            var maxy = parseFloat(boundingBoxNode.getAttribute("maxy"));
	            var minx = parseFloat(boundingBoxNode.getAttribute("minx"));
	            var maxx = parseFloat(boundingBoxNode.getAttribute("maxx"));
	            var limites = new Cesium.Rectangle(minx, miny, maxx, maxy);
	            resultat.getTileDataAvailable = function (x, y, level) {
	                var rect = resultat.tilingScheme.tileXYToNativeRectangle(x, y, level);
	                var scratchRectangle = intersectionRectangle(limites, rect);
	                return Cesium.defined(scratchRectangle) && level < maxLevel && level < tileSets.length;
	            };
	            resultat.ready = true;
	        }
	        return resultat;
	    };
	
	    OGCHelper.WMTSParser.generate = function (description) {
	        description = Cesium.defaultValue(description, Cesium.defaultValue.EMPTY_OBJECT);
	        var resultat;
	        if (Cesium.defined(description.url)) {
	            var urlofServer = description.url;
	            var index = urlofServer.lastIndexOf("?");
	            if (index > -1) {
	                urlofServer = urlofServer.substring(0, index);
	            }
	            var urlGetCapabilities = urlofServer + '?REQUEST=GetCapabilities';
	            if (Cesium.defined(description.proxy)) {
	                urlGetCapabilities = description.proxy.getURL(urlGetCapabilities);
	            }
	            resultat = loadXML(urlGetCapabilities).then(function (xml) {
	                return OGCHelper.WMTSParser.getMetaDatafromXML(xml, description);
	            });
	        } else if (Cesium.defined(description.xml)) {
	            resultat = OGCHelper.WMTSParser.getMetaDatafromXML(description.xml, description);
	        } else {
	            throw new Cesium.DeveloperError('either description.url or description.xml are required.');
	        }
	        return resultat;
	    };
	
	    OGCHelper.WMTSParser.getMetaDatafromXML = function (xml, description) {
	        if (!(xml instanceof XMLDocument)) {
	            throw new Cesium.DeveloperError('xml must be a XMLDocument');
	        }
	
	        var resultat = {};
	        var layerName = description.layerName;
	        resultat.ready = false;
	        resultat.heightMapWidth = Cesium.defaultValue(description.heightMapWidth, 65);
	        resultat.heightMapHeight = Cesium.defaultValue(description.heightMapHeight, resultat.heightMapWidth);
	        var maxLevel = Cesium.defaultValue(description.maxLevel, 12);
	        var proxy = description.proxy;
	        var styleName = description.styleName;
	        resultat.hasStyledImage = Cesium.defaultValue(description.hasStyledImage, typeof description.styleName === "string");
	        resultat.waterMask = Cesium.defaultValue(description.waterMask, false);
	        if (typeof resultat.waterMask != "boolean") {
	            resultat.waterMask = false;
	        }
	        resultat.offset = Cesium.defaultValue(description.offset, 0);
	        resultat.highest = Cesium.defaultValue(description.highest, 12000);
	        resultat.lowest = Cesium.defaultValue(description.lowest, -500);
	        var template;
	        var listTileMatrixSetLinkNode = [];
	
	        var urlKVP, urlRESTful;
	        var formatImage;
	
	        var nodesGetOperation = [].slice.call(xml.querySelectorAll('Operation[name="GetTile"] HTTP Get'));
	        var correctEncoding = nodesGetOperation.map(function (elt) {
	            var val = elt.querySelector("Value").textContent;
	            var retour;
	            if ("KVP" === val) {
	                retour = {
	                    node: elt,
	                    type: "KVP"
	                };
	            }
	            if ("RESTful" === val) {
	                retour = {
	                    node: elt,
	                    type: "RESTful"
	                };
	            }
	            return retour;
	        }).filter(function (elt) {
	            return Cesium.defined(elt);
	        });
	
	        for (var i = 0; i < correctEncoding.length; i++) {
	            var node = correctEncoding[i];
	            if (node.type === "RESTful" && !Cesium.defined(urlRESTful)) {
	                urlRESTful = node.node.getAttribute("xlink:href");
	                if (Cesium.defined(proxy)) {
	                    urlRESTful = proxy.getURL(urlRESTful);
	                }
	            }
	            if (node.type === "KVP" && !Cesium.defined(urlKVP)) {
	                urlKVP = node.node.getAttribute("xlink:href");
	                if (Cesium.defined(proxy)) {
	                    urlKVP = proxy.getURL(urlKVP);
	                }
	            }
	        }
	
	        var nodeIdentifiers = xml.querySelectorAll("Contents>Layer>Identifier");
	        var layerNode;
	        for (var i = 0; i < nodeIdentifiers.length && !Cesium.defined(layerNode); i++) {
	            if (layerName === nodeIdentifiers[i].textContent) {
	                layerNode = nodeIdentifiers[i].parentNode;
	            }
	        }
	
	        if (Cesium.defined(layerNode)) {
	            var styleNodes = layerNode.querySelectorAll("Style");
	            var defaultStyle;
	            var selectedStyle;
	
	            for (var i = 0; i < styleNodes.length; i++) {
	                var style = styleNodes[i].querySelector("Identifier").textContent;
	                if (styleNodes[i].getAttribute("isDefault") != null) {
	                    defaultStyle = style;
	                }
	                if (style === styleName) {
	                    selectedStyle = style;
	                }
	            }
	
	            if (!Cesium.defined(styleName) || styleName != selectedStyle) {
	                styleName = Cesium.defaultValue(defaultStyle, "");
	            }
	
	            var nodeFormats = [].slice.call(layerNode.querySelectorAll("Format"));
	            for (var l = 0; l < OGCHelper.FormatImage.length && !Cesium.defined(formatImage); l++) {
	                var validFormats = nodeFormats.filter(function (elt) {
	                    return elt.textContent === OGCHelper.FormatImage[l].format;
	                });
	                if (validFormats.length > 0) {
	                    formatImage = OGCHelper.FormatImage[l];
	                }
	            }
	
	            listTileMatrixSetLinkNode = layerNode.querySelectorAll("TileMatrixSetLink");
	        }
	
	        var nodeMatrixSetIds = [].slice.call(xml.querySelectorAll("TileMatrixSet>Identifier"));
	        for (var a = 0; a < listTileMatrixSetLinkNode.length && !resultat.ready; a++) {
	            var matrixSetLinkNode = listTileMatrixSetLinkNode[a];
	            var tileMatrixSetLinkName = matrixSetLinkNode.querySelector("TileMatrixSet").textContent;
	            var tileMatrixSetNode;
	            var CRSSelected;
	
	            for (var i = 0; i < nodeMatrixSetIds.length && !Cesium.defined(tileMatrixSetNode); i++) {
	                if (nodeMatrixSetIds[i].textContent === tileMatrixSetLinkName) {
	                    tileMatrixSetNode = nodeMatrixSetIds[i].parentNode;
	                }
	            }
	
	            var supportedCRS = tileMatrixSetNode.querySelector("SupportedCRS").textContent;
	            for (var n = 0; n < OGCHelper.CRS.length && !Cesium.defined(CRSSelected); n++) {
	                if (OGCHelper.CRS[n].SupportedCRS === supportedCRS) {
	                    CRSSelected = OGCHelper.CRS[n];
	                }
	            }
	
	            if (Cesium.defined(CRSSelected)) {
	                var tileSets;
	
	                var nodeTileSets = [].slice.call(tileMatrixSetNode.querySelectorAll("TileMatrix"));
	                tileSets = nodeTileSets.map(function (noeud) {
	                    var id = noeud.querySelector("Identifier").textContent;
	                    var maxWidth = parseInt(noeud.querySelector("MatrixWidth").textContent);
	                    var maxHeight = parseInt(noeud.querySelector("MatrixHeight").textContent);
	                    var tileWidth = parseInt(noeud.querySelector("TileWidth").textContent);
	                    var tileHeight = parseInt(noeud.querySelector("TileHeight").textContent);
	                    var scaleDenominator = parseFloat(noeud.querySelector("ScaleDenominator").textContent);
	                    return {
	                        id: id,
	                        maxWidth: maxWidth,
	                        maxHeight: maxHeight,
	                        scaleDenominator: scaleDenominator,
	                        complete: false,
	                        tileWidth: tileWidth,
	                        tileHeight: tileHeight
	                    };
	                });
	
	                tileSets.sort(function (a, b) {
	                    return b.scaleDenominator - a.scaleDenominator;
	                });
	                listTileMatrixLimits = matrixSetLinkNode.querySelectorAll("TileMatrixSetLimits>TileMatrixLimits");
	                for (var t = 0; t < tileSets.length; t++) {
	                    var tile = tileSets[t];
	                    for (var w = 0; w < listTileMatrixLimits.length; w++) {
	                        var nodeLink = listTileMatrixLimits[w];
	                        if (tile.id === nodeLink.querySelector("TileMatrix").textContent) {
	                            tile.minTileRow = parseInt(nodeLink.querySelector("MinTileRow").textContent);
	                            tile.maxTileRow = parseInt(nodeLink.querySelector("MaxTileRow").textContent);
	                            tile.minTileCol = parseInt(nodeLink.querySelector("MinTileCol").textContent);
	                            tile.maxTileCol = parseInt(nodeLink.querySelector("MaxTileCol").textContent);
	                            tile.complete = true;
	                            tileSets[t] = tile;
	                        }
	                    }
	                }
	
	                if (tileSets.length > 0) {
	                    resultat.tilingScheme = new CRSSelected.tilingScheme({
	                        ellipsoid: CRSSelected.ellipsoid,
	                        numberOfLevelZeroTilesX: tileSets[0].maxWidth,
	                        numberOfLevelZeroTilesY: tileSets[0].maxHeight
	                    });
	                    var resourceURL = layerNode.querySelector("ResourceURL[format='" + formatImage.format + "']");
	
	                    if (resourceURL != null) {
	                        template = resourceURL.getAttribute("template").replace("{TileRow}", "{y}").replace("{TileCol}", "{x}").replace("{Style}", styleName).replace("{TileMatrixSet}", tileMatrixSetLinkName).replace("{layer}", layerName).replace("{infoFormatExtension}", formatImage.extension);
	                    } else if (Cesium.defined(urlKVP)) {
	                        template = urlKVP + "service=WMTS&request=GetTile&version=1.0.0&layer=" + layerName + "&style=" + styleName + "&format=" + formatImage.format + "&TileMatrixSet=" + tileMatrixSetLinkName + "&TileMatrix={TileMatrix}&TileRow={y}&TileCol={x}";
	                    }
	
	                    if (Cesium.defined(template)) {
	                        resultat.getTileDataAvailable = function (x, y, level) {
	                            var retour = false;
	                            if (level < maxLevel && level < tileSets.length) {
	                                var tile = tileSets[level];
	                                if (tile.complete) {
	                                    retour = y <= tile.maxTileRow && y >= tile.minTileRow && x <= tile.maxTileCol && x >= tile.minTileCol;
	                                } else {
	                                    retour = x < tile.maxWidth && y < tile.maxHeight;
	                                }
	                            }
	                            return retour;
	                        };
	                        resultat.URLtemplateImage = function (x, y, level) {
	                            var retour = "";
	                            if (resultat.getTileDataAvailable(x, y, level)) {
	                                var tile = tileSets[level];
	                                retour = template.replace("{TileMatrix}", tile.id);
	                            }
	                            return retour;
	                        };
	
	                        var imageSize = {
	                            width: tileSets[0].tileWidth,
	                            height: tileSets[0].tileHeight
	                        };
	                        var checkSize = tileSets.filter(function (elt) {
	                            return elt.tileWidth != imageSize.width || elt.tileHeight != imageSize.height;
	                        });
	                        if (checkSize.length == 0) {
	                            resultat.imageSize = imageSize;
	                        }
	                        resultat.ready = true;
	                    }
	                }
	            }
	        }
	        return resultat;
	    };
	
	    var GeoserverTerrainProvider = function GeoserverTerrainProvider(description) {
	        if (!Cesium.defined(description)) {
	            throw new Cesium.DeveloperError('description is required.');
	        }
	        var errorEvent = new Cesium.Event();
	
	        var credit = description.credit;
	        if (typeof credit === 'string') {
	            credit = new Cesium.Credit(credit);
	        }
	
	        this.ready = false;
	        this._readyPromise = Cesium.when.defer();
	
	        Cesium.defineProperties(this, {
	            errorEvent: {
	                get: function get() {
	                    return errorEvent;
	                }
	            },
	            credit: {
	                get: function get() {
	                    return credit;
	                }
	            },
	            hasVertexNormals: {
	                get: function get() {
	                    return false;
	                }
	            },
	
	            readyPromise: {
	                get: function get() {
	                    return this._readyPromise.promise;
	                }
	            }
	        });
	        var promise = OGCHelper.parser(description);
	        TerrainParser(promise, this);
	    };
	
	    GeoserverTerrainProvider.arrayToHeightmapTerrainData = function (arrayBuffer, limitations, size, formatArray, hasWaterMask, childrenMask) {
	        if (typeof size == "number") {
	            size = {
	                width: size,
	                height: size
	            };
	        }
	        var heightBuffer = formatArray.postProcessArray(arrayBuffer, size, limitations.highest, limitations.lowest, limitations.offset);
	        if (!Cesium.defined(heightBuffer)) {
	            throw new Cesium.DeveloperError("no good size");
	        }
	        var optionsHeihtmapTerrainData = {
	            buffer: heightBuffer,
	            width: size.width,
	            height: size.height,
	            childTileMask: childrenMask,
	            structure: formatArray.terrainDataStructure
	        };
	        if (hasWaterMask) {
	            var waterMask = new Uint8Array(heightBuffer.length);
	            for (var i = 0; i < heightBuffer.length; i++) {
	                if (heightBuffer[i] <= 0) {
	                    waterMask[i] = 255;
	                }
	            }
	            optionsHeihtmapTerrainData.waterMask = waterMask;
	        }
	        return new Cesium.HeightmapTerrainData(optionsHeihtmapTerrainData);
	    };
	
	    GeoserverTerrainProvider.imageToHeightmapTerrainData = function (image, limitations, size, hasWaterMask, childrenMask, hasStyledImage) {
	        if (typeof size == "number") {
	            size = {
	                width: size,
	                height: size
	            };
	        }
	        var dataPixels = Cesium.getImagePixels(image, size.width, size.height);
	        var waterMask = new Uint8Array(dataPixels.length / 4);
	        var buffer = new Int16Array(dataPixels.length / 4);
	        var goodCell = 0,
	            somme = 0;
	        for (var i = 0; i < dataPixels.length; i += 4) {
	            var msb = dataPixels[i];
	            var lsb = dataPixels[i + 1];
	            var isCorrect = dataPixels[i + 2] > 128;
	            var valeur = (msb << 8 | lsb) - limitations.offset - 32768;
	            if (valeur > limitations.lowest && valeur < limitations.highest && (isCorrect || hasStyledImage)) {
	                buffer[i / 4] = valeur;
	                somme += valeur;
	                goodCell++;
	            } else {
	                buffer[i / 4] = goodCell == 0 ? 0 : somme / goodCell;
	            }
	        }
	
	        var optionsHeihtmapTerrainData = {
	            buffer: buffer,
	            width: size.width,
	            height: size.height,
	            childTileMask: childrenMask,
	            structure: {
	                heightScale: 1.0,
	                heightOffset: 0.0,
	                elementsPerHeight: 1,
	                stride: 1,
	                elementMultiplier: 256.0,
	                isBigEndian: false
	            }
	        };
	
	        if (hasWaterMask) {
	            var waterMask = new Uint8Array(buffer.length);
	            for (var i = 0; i < buffer.length; i++) {
	                if (buffer[i] <= 0) {
	                    waterMask[i] = 255;
	                }
	            }
	            optionsHeihtmapTerrainData.waterMask = waterMask;
	        }
	        return new Cesium.HeightmapTerrainData(optionsHeihtmapTerrainData);
	    };
	
	    function TerrainParser(promise, provider) {
	        Cesium.when(promise, function (resultat) {
	            if (Cesium.defined(resultat) && resultat.ready) {
	                resultat.levelZeroMaximumGeometricError = Cesium.TerrainProvider.getEstimatedLevelZeroGeometricErrorForAHeightmap(resultat.tilingScheme.ellipsoid, resultat.heightMapWidth, resultat.tilingScheme.getNumberOfXTilesAtLevel(0));
	                if (Cesium.defined(resultat.URLtemplateImage)) {
	                    resultat.getHeightmapTerrainDataImage = function (x, y, level) {
	                        var retour;
	                        if (!isNaN(x + y + level)) {
	                            var urlArray = templateToURL(resultat.URLtemplateImage(x, y, level), x, y, level, provider);
	                            var limitations = {
	                                highest: resultat.highest,
	                                lowest: resultat.lowest,
	                                offset: resultat.offset
	                            };
	                            var hasChildren = terrainChildrenMask(x, y, level, provider);
	                            var promise = loadImage(urlArray);
	                            if (Cesium.defined(promise)) {
	                                retour = Cesium.when(promise, function (image) {
	                                    return GeoserverTerrainProvider.imageToHeightmapTerrainData(image, limitations, {
	                                        width: resultat.heightMapWidth,
	                                        height: resultat.heightMapHeight
	                                    }, resultat.waterMask, hasChildren, resultat.hasStyledImage);
	                                }).otherwise(function () {
	                                    return new Cesium.HeightmapTerrainData({
	                                        buffer: new Uint16Array(resultat.heightMapWidth * resultat.heightMapHeight),
	                                        width: resultat.heightMapWidth,
	                                        height: resultat.heightMapHeight,
	                                        childTileMask: hasChildren,
	                                        waterMask: new Uint8Array(resultat.heightMapWidth * resultat.heightMapHeight),
	                                        structure: resultat.formatImage.terrainDataStructure
	                                    });
	                                });
	                            }
	                        }
	                        return retour;
	                    };
	                }
	
	                if (Cesium.defined(resultat.URLtemplateArray)) {
	                    resultat.getHeightmapTerrainDataArray = function (x, y, level) {
	                        var retour;
	                        if (!isNaN(x + y + level)) {
	                            var urlArray = templateToURL(resultat.URLtemplateArray(x, y, level), x, y, level, provider);
	                            var limitations = {
	                                highest: resultat.highest,
	                                lowest: resultat.lowest,
	                                offset: resultat.offset
	                            };
	                            var hasChildren = terrainChildrenMask(x, y, level, provider);
	
	                            var promise = loadArrayBuffer(urlArray);
	                            if (Cesium.defined(promise)) {
	                                retour = Cesium.when(promise, function (arrayBuffer) {
	                                    return GeoserverTerrainProvider.arrayToHeightmapTerrainData(arrayBuffer, limitations, {
	                                        width: resultat.heightMapWidth,
	                                        height: resultat.heightMapHeight
	                                    }, resultat.formatArray, resultat.waterMask, hasChildren);
	                                }).otherwise(function () {
	                                    if (Cesium.defined(resultat.getHeightmapTerrainDataImage)) {
	                                        return resultat.getHeightmapTerrainDataImage(x, y, level);
	                                    } else {
	                                        return new Cesium.HeightmapTerrainData({
	                                            buffer: new Uint16Array(resultat.heightMapWidth * resultat.heightMapHeight),
	                                            width: resultat.heightMapWidth,
	                                            height: resultat.heightMapHeight,
	                                            childTileMask: hasChildren,
	                                            waterMask: new Uint8Array(resultat.heightMapWidth * resultat.heightMapHeight),
	                                            structure: resultat.formatImage.terrainDataStructure
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        return retour;
	                    };
	                }
	
	                provider.getLevelMaximumGeometricError = function (level) {
	                    return resultat.levelZeroMaximumGeometricError / (1 << level);
	                };
	
	                provider.requestTileGeometry = function (x, y, level) {
	                    var retour;
	                    if (Cesium.defined(resultat.getHeightmapTerrainDataArray)) {
	                        retour = resultat.getHeightmapTerrainDataArray(x, y, level);
	                    } else if (Cesium.defined(resultat.getHeightmapTerrainDataImage)) {
	                        retour = resultat.getHeightmapTerrainDataImage(x, y, level);
	                    }
	                    return retour;
	                };
	
	                Cesium.defineProperties(provider, {
	                    tilingScheme: {
	                        get: function get() {
	                            return resultat.tilingScheme;
	                        }
	                    },
	                    ready: {
	                        get: function get() {
	                            return resultat.ready;
	                        }
	                    },
	                    hasWaterMask: {
	                        get: function get() {
	                            return resultat.waterMask;
	                        }
	                    },
	                    heightMapHeight: {
	                        get: function get() {
	                            return resultat.heightMapHeight;
	                        }
	                    },
	                    heightMapWidth: {
	                        get: function get() {
	                            return resultat.heightMapWidth;
	                        }
	                    },
	                    getTileDataAvailable: {
	                        get: function get() {
	                            return resultat.getTileDataAvailable;
	                        }
	                    }
	                });
	            }
	            provider._readyPromise.resolve(resultat.ready);
	        });
	    }
	
	    function templateToURL(urlParam, x, y, level, provider) {
	        var rect = provider.tilingScheme.tileXYToNativeRectangle(x, y, level);
	        var xSpacing = (rect.east - rect.west) / (provider.heightMapWidth - 1);
	        var ySpacing = (rect.north - rect.south) / (provider.heightMapHeight - 1);
	        rect.west -= xSpacing * 0.5;
	        rect.east += xSpacing * 0.5;
	        rect.south -= ySpacing * 0.5;
	        rect.north += ySpacing * 0.5;
	
	        var yTiles = provider.tilingScheme.getNumberOfYTilesAtLevel(level);
	        var tmsY = yTiles - y - 1;
	
	        return urlParam.replace("{south}", rect.south).replace("{north}", rect.north).replace("{west}", rect.west).replace("{east}", rect.east).replace("{x}", x).replace("{y}", y).replace("{tmsY}", tmsY);
	    }
	
	    function terrainChildrenMask(x, y, level, provider) {
	        var mask = 0;
	        var childLevel = level + 1;
	        mask |= provider.getTileDataAvailable(2 * x, 2 * y, childLevel) ? 1 : 0;
	        mask |= provider.getTileDataAvailable(2 * x + 1, 2 * y, childLevel) ? 2 : 0;
	        mask |= provider.getTileDataAvailable(2 * x, 2 * y + 1, childLevel) ? 4 : 0;
	        mask |= provider.getTileDataAvailable(2 * x + 1, 2 * y + 1, childLevel) ? 8 : 0;
	        return mask;
	    }
	
	    Cesium.GeoserverTerrainProvider = GeoserverTerrainProvider;
	})();

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _notification = __webpack_require__(85);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _notification3 = __webpack_require__(79);
	
	var _notification4 = _interopRequireDefault(_notification3);
	
	var _assign = __webpack_require__(46);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _getConfig = __webpack_require__(108);
	
	var _getConfig2 = _interopRequireDefault(_getConfig);
	
	var _getCatalog = __webpack_require__(162);
	
	var _getCatalog2 = _interopRequireDefault(_getCatalog);
	
	var _getAgAppListaMappe = __webpack_require__(367);
	
	var _getAgAppListaMappe2 = _interopRequireDefault(_getAgAppListaMappe);
	
	var _getEnti = __webpack_require__(374);
	
	var _getEnti2 = _interopRequireDefault(_getEnti);
	
	var _getCoordTransform = __webpack_require__(45);
	
	var _getCoordTransform2 = _interopRequireDefault(_getCoordTransform);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _getDownloadConfig = __webpack_require__(164);
	
	var _getDownloadConfig2 = _interopRequireDefault(_getDownloadConfig);
	
	var _ConfermaDettaglio = __webpack_require__(724);
	
	var _ConfermaDettaglio2 = _interopRequireDefault(_ConfermaDettaglio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-conferma-dettaglio', _ConfermaDettaglio2.default);
	
	exports.default = {
	  _lastZIndex: 21,
	  debug: false,
	  containerId: 'gv-container',
	  idMap: null,
	  title: null,
	  findOptions: null,
	  filterWmsLayer: null,
	  zoomTo: null,
	  geoserverUrl: null,
	  application: {},
	  baseLayers: [{
	    type: 'ESRI_IMAGERY',
	    visible: true
	  }],
	  activeBaseLayer: 'ESRI_IMAGERY',
	  maps: [],
	  hilitedLayer: [],
	
	  init: function init(options) {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	      var appMappList, idMaps, _idMaps;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (options) {
	                _context.next = 2;
	                break;
	              }
	
	              throw new Error('Opzioni di inizializzazione non impostate!');
	
	            case 2:
	
	              _this.debug = options.debug;
	              _this.idMap = options.idMap;
	              _this.findOptions = options.findOptions;
	              _this.filterWmsLayer = options.filterWmsLayer;
	              _this.zoomTo = options.zoomTo;
	              _this.disableTMS = options.disableTMS;
	              _this.disableCache = options.disableCache;
	              _this.flagGeoserver = options.flagGeoserver;
	              _this.geoserverUrl = options.geoserverUrl;
	              _this.agAppMap = options.agAppMapList;
	
	              if (options.application) {
	                _this.application = options.application;
	              }
	              if (options.containerId) {
	                _this.containerId = options.containerId;
	              }
	
	              _this.application.layout = options.application && options.application.layout ? options.application.layout : {};
	
	              if (options.application) {
	                _this.application.proxy = options.application.proxy || _globals2.default.DEFAULT_PROXY;
	              }
	              if (options.application && options.application.layout && options.application.layout.title) {
	                _this.title = options.application.layout.title;
	              }
	
	              _this.setBaseLayers(options.baseLayers);
	
	              _this.initLoadedMaps = 0;
	              _this.initLoadingMaps = 1;
	
	              if (!options.agAppMapList) {
	                _context.next = 27;
	                break;
	              }
	
	              _context.next = 23;
	              return (0, _getAgAppListaMappe2.default)(options.agAppMapList);
	
	            case 23:
	              appMappList = _context.sent;
	
	              _this.agAppMapList = appMappList;
	              idMaps = appMappList.map(function (map) {
	                return map.id;
	              });
	
	              _this.loadMaps(idMaps);
	
	            case 27:
	
	              if (options.idMap) {
	                _idMaps = options.idMap.toString().split(',');
	
	                _this.loadMaps(_idMaps);
	              }
	
	              if (!options.idMap && !options.agAppMap) {
	                GV.eventBus.$on('gv-app-mounted', function (app) {
	                  options.maps.forEach(function (mapConfig) {
	                    _this.addMapConfig(mapConfig, null);
	                  });
	                  if (_this.application && _this.application.callback) {
	                    _this.application.callback(app);
	                  }
	                });
	              }
	
	              GV.eventBus.$on('map-zoom', function (event) {
	                var layers = _this.getLayersConfig();
	                layers.forEach(function (layerConfig) {
	                  _this.setLayerAttribute(layerConfig.name, 'inRange', GV.app.map.layerInRange(layerConfig));
	
	                  if (GV.app.map.type === 'openlayers') {
	                    var layer = GV.app.map.getLayerByName(layerConfig.name);
	                    var visible = layerConfig.visible && layerConfig.inRange;
	                    layer.setVisible(visible);
	                  }
	                });
	              });
	
	            case 30:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  loadMaps: function loadMaps(idMaps) {
	    var _this2 = this;
	
	    this.initLoadingMaps = idMaps.length;
	
	    idMaps.forEach(function (id) {
	      _this2.addRlMap(id, true, false);
	    });
	    GV.eventBus.$on('gv-config-init', function (app) {
	      if (_this2.application && _this2.application.callback) {
	        _this2.application.callback(app);
	      }
	    });
	  },
	  setBaseLayers: function setBaseLayers(baseLayers) {
	    var _this3 = this;
	
	    this.baseLayers = [];
	    baseLayers.forEach(function (layer) {
	      layer.name = layer.type;
	      layer.label = _globals2.default.BASE_LAYERS[layer.type].label;
	      layer.icon = _globals2.default.BASE_LAYERS[layer.type].icon;
	      _this3.baseLayers.push(layer);
	      if (layer.visible) _this3.activeBaseLayer = layer.name;
	    });
	  },
	  changeBaseLayers: function changeBaseLayers(baseLayers) {
	    var _this4 = this;
	
	    GV.app.map.removeLayer(GV.app.map.activeBaseLayer);
	    this.baseLayers.splice(0);
	    baseLayers.forEach(function (layer) {
	      layer.name = layer.type;
	      layer.label = _globals2.default.BASE_LAYERS[layer.type].label;
	      layer.icon = _globals2.default.BASE_LAYERS[layer.type].icon;
	      _this4.baseLayers.push(layer);
	      if (layer.visible) {
	        _this4.activeBaseLayer = layer.name;
	        if (GV.baseLayerSwitcher) GV.baseLayerSwitcher.activeBaseLayer = layer.name;
	      }
	    });
	
	    GV.app.map.loadBaseLayers();
	  },
	  setLayerconfig: function setLayerconfig(layer, mapConfig) {
	    layer.extent_3857 = mapConfig.extent_3857;
	    var minScaleLabel = layer.minScale ? ' da 1:' + layer.minScale : ' fino';
	    var maxScaleLabel = layer.maxScale ? ' a 1:' + layer.maxScale : '';
	    layer.scaleRangeLabel = 'Visibile' + minScaleLabel + maxScaleLabel;
	
	    layer.minScale = layer.minScale === 0 ? 591657550 : layer.minScale;
	    layer.inRange = GV.app && GV.app.map ? GV.app.map.layerInRange(layer) : true;
	    if (typeof layer.opacity === 'undefined') layer.opacity = 1;
	    layer.opacityBase100 = layer.opacity * 100;
	    layer.zIndex = this._lastZIndex++;
	    this.setLayerType(layer);
	    this.setLayerCache(layer);
	    return layer;
	  },
	  setLayerType: function setLayerType(layer) {
	    if (this.disableTMS && layer.idMap == this.idMap && layer.type === 'TMS') {
	      layer.type = 'WMS';
	    }
	  },
	  setLayerCache: function setLayerCache(layer) {
	    if (this.disableCache && layer.idMap == this.idMap && layer.type === 'WMS') {
	      layer.cacheMinZoomLevel = null;
	    }
	  },
	  addMapConfig: function addMapConfig(mapConfig, baseMapConfig) {
	    var _this5 = this;
	
	    if (mapConfig.ancillaryMaps) {
	      mapConfig.ancillaryMaps.forEach(function (config) {
	        config.extent_3857 = null;
	        _this5.addMapConfig(config, mapConfig);
	      });
	    }
	
	    mapConfig.layers = mapConfig.layers.filter(function (layer) {
	      return !layer.flagBaseVectorLayer;
	    });
	
	    mapConfig.layers.forEach(function (layer) {
	      _this5.setLayerconfig(layer, mapConfig);
	    });
	    mapConfig.layers.reverse();
	
	    if (mapConfig.addLayerConfig && this.getMapConfig(mapConfig.id)) {
	      mapConfig.layers.forEach(function (layer) {
	        _this5.getMapConfig(mapConfig.id).layers.push(layer);
	      });
	    } else {
	      if (this.getMapConfig(mapConfig.id)) {
	        return;
	      }
	
	      if (baseMapConfig && (this.application.layout.legend.options.hideAncillaryMapLegend || baseMapConfig.hideAncillaryMapLegend)) {
	        mapConfig.showLayersInLegend = false;
	      } else {
	        mapConfig.showLayersInLegend = true;
	      }
	
	      this.maps.unshift(mapConfig);
	    }
	
	    GV.eventBus.$emit('config-add-map', {
	      config: mapConfig
	    });
	  },
	  setLayerAttribute: function setLayerAttribute(layerName, attribute, value) {
	    this.maps.forEach(function (map) {
	      var layers = map.layers;
	      layers.forEach(function (layer) {
	        if (layer.name === layerName) {
	          layer[attribute] = value;
	        }
	      });
	    });
	  },
	  removeMap: function removeMap(idMap) {
	    var mapConfig = this.getMapConfig(idMap);
	    if (!mapConfig) return;
	    GV.eventBus.$emit('config-remove-map', {
	      config: mapConfig
	    });
	    var index = this.maps.findIndex(function (map) {
	      return map.id === idMap;
	    });
	    if (index > -1) {
	      this.maps.splice(index, 1);
	    }
	  },
	  removeLayer: function removeLayer(idLayer) {
	    var _this6 = this;
	
	    this.maps.forEach(function (map) {
	      var layerIndex = -1;
	      map.layers.forEach(function (layer, index) {
	        if (layer.name === idLayer) {
	          layerIndex = index;
	        }
	      });
	      if (layerIndex > -1) {
	        map.layers.splice(layerIndex, 1);
	      }
	      if (map.layers.length === 0) {
	        _this6.removeMap(map.id);
	      }
	    });
	    GV.eventBus.$emit('config-remove-layer', {
	      config: idLayer
	    });
	  },
	  addLayerToMap: function addLayerToMap(layerConfig, idMap) {
	    var _this7 = this;
	
	    var layer = (0, _assign2.default)({}, layerConfig);
	    this.maps.forEach(function (map) {
	      if (map.id === idMap) {
	        var mapConfig = _this7.getMapConfig(idMap);
	        if (!_this7.isLayerInMapConfig(layer, mapConfig)) {
	          _this7.setLayerconfig(layer, mapConfig);
	          map.layers.unshift(layer);
	        }
	      }
	    });
	    GV.eventBus.$emit('config-add-layer', {
	      config: layer
	    });
	  },
	  isLayerInMapConfig: function isLayerInMapConfig(layerConfig, mapConfig) {
	    var layers = mapConfig.layers.filter(function (layer) {
	      return layer.name === layerConfig.name;
	    });
	    return layers.length > 0;
	  },
	  setFlagVisible: function setFlagVisible(mapConfig) {
	    if (this.agAppMap) {
	      var map = this.agAppMapList.filter(function (el) {
	        return el.id === mapConfig.id.toString();
	      });
	      if (map && map[0] && !map[0].visible) {
	        mapConfig.layers.forEach(function (layer) {
	          layer.visible = false;
	        });
	      }
	    }
	  },
	  addRlMap: function addRlMap(idMap, setBaseLayer, skipConferma) {
	    var _this8 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	      var response, mapConfig, label;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!_this8.getMapConfig(idMap)) {
	                _context2.next = 2;
	                break;
	              }
	
	              return _context2.abrupt('return', _this8.getMapConfig(idMap));
	
	            case 2:
	              _context2.prev = 2;
	              _context2.next = 5;
	              return (0, _getConfig2.default)(idMap);
	
	            case 5:
	              response = _context2.sent;
	
	              if (response.data.success) {
	                _context2.next = 8;
	                break;
	              }
	
	              throw new Error('Errore Caricamento Mappa: ' + response.data.message);
	
	            case 8:
	              if (response.data.data) {
	                _context2.next = 10;
	                break;
	              }
	
	              throw new Error('Errore Caricamento Mappa: configurazione non trovata');
	
	            case 10:
	
	              _globals2.default.SYS_MANUTENZIONE_DOWNLOAD = response.data.sistema && response.data.sistema.manutenzioneDownload;
	
	              mapConfig = response.data.data;
	
	              if (mapConfig.fileDettaglio && !skipConferma) {
	                label = 'Avvertenze';
	
	                (0, _mountComponent2.default)({
	                  elId: 'gv-conferma-dettaglio',
	                  containerId: _this8.containerId,
	                  vm: new _vue2.default({
	                    template: '<gv-conferma-dettaglio idMap="' + idMap + '" label="' + label + '" link="' + mapConfig.fileDettaglio + '"></gv-conferma-dettaglio>'
	                  })
	                });
	              } else {
	                _this8.loadConfig(mapConfig, setBaseLayer);
	              }
	              return _context2.abrupt('return', mapConfig);
	
	            case 16:
	              _context2.prev = 16;
	              _context2.t0 = _context2['catch'](2);
	
	              console.error(_context2.t0);
	              _notification4.default.error({
	                title: 'Attenzione',
	                type: 'error',
	                duration: 5000,
	                offset: 70,
	                position: 'bottom-left',
	                message: _context2.t0.message
	              });
	
	            case 20:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this8, [[2, 16]]);
	    }))();
	  },
	  setWmsFilter: function setWmsFilter(mapConfig) {
	    GV.config.filterWmsLayer.layers.forEach(function (layerName) {
	      mapConfig.layers.forEach(function (layer) {
	        if (layerName.replace('L', '') == layer.id) {
	          layer.wmsParams.cql_filter = GV.config.filterWmsLayer.cqlFilter;
	        }
	      });
	    });
	  },
	  loadConfig: function loadConfig(mapConfig, setBaseLayer) {
	    if (GV.config.filterWmsLayer) this.setWmsFilter(mapConfig);
	
	    this.setFlagVisible(mapConfig);
	
	    this.addMapConfig(mapConfig, null);
	
	    if (GV.app && GV.app.map && mapConfig.type && mapConfig.type == 'R' && setBaseLayer && this.getBaseLayerConfig('BLANK')) {
	      GV.app.map.changeBaseLayer('BLANK');
	      if (GV.baseLayerSwitcher) GV.baseLayerSwitcher.activeBaseLayer = 'BLANK';
	    }
	
	    if (mapConfig.baseLayers && mapConfig.baseLayers.length > 0) {
	      this.changeBaseLayers(mapConfig.baseLayers);
	    }
	
	    if (mapConfig.activeBaseLayer) {
	      GV.app.map.changeBaseLayer(mapConfig.activeBaseLayer);
	      if (GV.baseLayerSwitcher) GV.baseLayerSwitcher.activeBaseLayer = mapConfig.activeBaseLayer;
	    }
	
	    if (GV.config.findOptions) {
	      GV.app.map.find(GV.config.findOptions);
	    }
	
	    if (GV.config.zoomTo) {
	      this.zoomToCoord(GV.config.zoomTo);
	    }
	
	    this.initLoadedMaps = this.initLoadedMaps + 1;
	    if (this.initLoadingMaps === this.initLoadedMaps) {
	      GV.eventBus.$emit('gv-config-init', GV.app);
	    }
	  },
	  zoomToCoord: function zoomToCoord(zoomConfig) {
	    var _this9 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	      var x, y, loading, response, lon, lat;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (zoomConfig.coord) {
	                _context3.next = 3;
	                break;
	              }
	
	              console.error('Parametro COORD non impostato');
	              return _context3.abrupt('return');
	
	            case 3:
	              if (!zoomConfig.epsg) {
	                zoomConfig.epsg = 3003;
	              }
	              if (!zoomConfig.zoom) {
	                zoomConfig.zoom = 16;
	              }
	              x = zoomConfig.coord.split(',')[0];
	              y = zoomConfig.coord.split(',')[1];
	
	              if (!(zoomConfig.epsg !== 4326 && zoomConfig.epsg !== 4258)) {
	                _context3.next = 16;
	                break;
	              }
	
	              loading = _loading4.default.service({
	                text: 'Ricerca...',
	                background: 'rgba(0, 0, 0, 0.8)'
	              });
	              _context3.next = 11;
	              return (0, _getCoordTransform2.default)(zoomConfig.epsg, '4326', x, y);
	
	            case 11:
	              response = _context3.sent;
	
	              if (response.data.points) {
	                lon = response.data.points[0].split(',')[0];
	                lat = response.data.points[0].split(',')[1];
	
	                GV.app.map.addMarker({
	                  location: [lat, lon],
	                  zoomLevel: zoomConfig.zoom
	                });
	              }
	              loading.close();
	              _context3.next = 17;
	              break;
	
	            case 16:
	              GV.app.map.addMarker({
	                location: [y, x],
	                zoomLevel: zoomConfig.zoom
	              });
	
	            case 17:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this9);
	    }))();
	  },
	  loadCatalog: function loadCatalog(params) {
	    var _this10 = this;
	
	    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	      var catalog, enti;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.next = 2;
	              return (0, _getCatalog2.default)(params);
	
	            case 2:
	              catalog = _context4.sent;
	
	              if (catalog) {
	                _context4.next = 6;
	                break;
	              }
	
	              console.error('loadCatalog: Non sono riuscito a caricare il catalogo.');
	              return _context4.abrupt('return');
	
	            case 6:
	
	              _this10.catalog = _this10.catalogFull = catalog.children;
	
	              _context4.next = 9;
	              return (0, _getEnti2.default)();
	
	            case 9:
	              enti = _context4.sent;
	
	              _this10.enti = enti;
	
	              if (params.showMapCatalogPanel) {
	                (0, _mountComponent2.default)({
	                  elId: 'gv-map-catalog-panel',
	                  toggleEl: false,
	                  vm: new _vue2.default({
	                    template: '<gv-map-catalog-panel></gv-map-catalog-panel>'
	                  })
	                });
	              }
	
	            case 12:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, _this10);
	    }))();
	  },
	  getLayersConfig: function getLayersConfig(filter) {
	    var layers = [];
	    this.maps.forEach(function (map) {
	      if (filter) {
	        var filtered = map.layers.filter(filter);
	        filtered.forEach(function (layer) {
	          layers.push(layer);
	        });
	      } else {
	        map.layers.forEach(function (layer) {
	          layers.push(layer);
	        });
	      }
	    });
	    return layers;
	  },
	  getLayersNameByMapId: function getLayersNameByMapId(idMap) {
	    if (!idMap) {
	      console.error('Parametro "idMap" non definito');
	      return null;
	    }
	    var layers = [];
	    this.maps.forEach(function (map) {
	      if (map.id.toString() === idMap) {
	        map.layers.forEach(function (layer) {
	          if (layer.idMap.toString() === idMap) layers.push(layer.name);
	        });
	      }
	    });
	    return layers;
	  },
	  getLayerConfig: function getLayerConfig(layerName) {
	    var foundLayer = null;
	    this.maps.forEach(function (map) {
	      map.layers.forEach(function (layer) {
	        if (layer.name === layerName) {
	          foundLayer = layer;
	        }
	      });
	    });
	    return foundLayer;
	  },
	  getBaseLayerConfig: function getBaseLayerConfig(layerName) {
	    var foundLayer = this.baseLayers.find(function (layer) {
	      return layer.name === layerName;
	    });
	    return foundLayer;
	  },
	  getMapConfig: function getMapConfig(idMap) {
	    return this.maps.find(function (map) {
	      return map.id == idMap;
	    });
	  },
	  getToolOptions: function getToolOptions(toolName) {
	    var options = null;
	    if (!this.application.layout || !this.application.layout.tools) {
	      return null;
	    }
	    this.application.layout.tools.forEach(function (item) {
	      if (item.name === toolName && item.options) {
	        options = item.options;
	      }
	    });
	    return options;
	  },
	  getButtonOptions: function getButtonOptions(buttonName) {
	    var options = null;
	    if (!this.application.layout || !this.application.layout.toolbar) {
	      return null;
	    }
	    this.application.layout.toolbar.items.forEach(function (item) {
	      if (item.name === buttonName && item.options) {
	        options = item.options;
	      }
	    });
	    return options;
	  },
	  getActiveBaseLayer: function getActiveBaseLayer() {
	    var activeLayer = null;
	    this.baseLayers.forEach(function (layer) {
	      if (layer.visible) {
	        activeLayer = layer;
	      }
	    });
	    return activeLayer;
	  },
	  setActiveBaseLayer: function setActiveBaseLayer(layerName) {
	    this.baseLayers.forEach(function (layer) {
	      layer.visible = layer.name === layerName;
	    });
	  }
	};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-cdu-seleziona-particelle-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(17, function (require) {
	      resolve(__webpack_require__(721));
	    });
	  });
	});
	
	var Control = {
	  id: 'cdu-seleziona-particelle',
	  active: false,
	  latlng: null,
	  activate: function activate() {
	    GV.log('GV.controls.cdu-seleziona-particelle.activate');
	    this.openPanel();
	    GV.eventBus.$emit("gv-control-cdu-seleziona-particelle-activate", this);
	    this.active = true;
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.controls.cdu-seleziona-particelle.deactivate');
	    GV.eventBus.$emit("gv-control-cdu-seleziona-particelle-deactivate", this);
	    this.active = false;
	    this.closePanel();
	  },
	  openPanel: function openPanel() {
	    (0, _mountComponent2.default)({
	      elId: 'gv-cdu-seleziona-particelle-panel',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-cdu-seleziona-particelle-panel></gv-cdu-seleziona-particelle-panel>'
	      })
	    });
	  },
	  closePanel: function closePanel() {
	    document.getElementById('gv-cdu-seleziona-particelle-panel').style.display = 'none';
	  }
	};
	
	exports.default = Control;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Control = {
	  id: 'draw',
	  active: false,
	  latlng: null,
	  activate: function activate() {
	    GV.log('GV.controls.draw.activate');
	    GV.eventBus.$emit('gv-control-draw-activate', this);
	    this.active = true;
	    this.openPanel();
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.controls.draw.deactivate');
	    GV.eventBus.$emit('gv-control-draw-deactivate', this);
	    this.active = false;
	    this.closePanel();
	  },
	  openPanel: function openPanel() {
	    if (GV.app.map.type === 'openlayers') {
	      _vue2.default.component('gv-draw-panel', function () {
	        return new _promise2.default(function (resolve) {
	          __webpack_require__.e/* nsure */(36, function (require) {
	            resolve(__webpack_require__(736));
	          });
	        });
	      });
	    } else {
	      _vue2.default.component('gv-draw-panel', function () {
	        return new _promise2.default(function (resolve) {
	          __webpack_require__.e/* nsure */(22, function (require) {
	            resolve(__webpack_require__(735));
	          });
	        });
	      });
	    }
	    (0, _mountComponent2.default)({
	      elId: 'gv-draw-panel',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-draw-panel></gv-draw-panel>'
	      })
	    });
	  },
	  closePanel: function closePanel() {
	    document.getElementById('gv-draw-panel').style.display = 'none';
	  }
	};
	
	exports.default = Control;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-fototeca-selezione-territoriale-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(21, function (require) {
	      resolve(__webpack_require__(738));
	    });
	  });
	});
	
	var Control = {
	  id: 'fototeca-selezione-territoriale',
	  active: false,
	  latlng: null,
	  activate: function activate() {
	    GV.log('GV.controls.fototeca-selezione-territoriale.activate');
	    this.openPanel();
	    GV.eventBus.$emit("gv-control-fototeca-selezione-territoriale-activate", this);
	    this.active = true;
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.controls.fototeca-selezione-territoriale.deactivate');
	    GV.eventBus.$emit("gv-control-fototeca-selezione-territoriale-deactivate", this);
	    this.active = false;
	    this.closePanel();
	  },
	  openPanel: function openPanel() {
	    (0, _mountComponent2.default)({
	      elId: 'gv-fototeca-selezione-territoriale-panel',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-fototeca-selezione-territoriale-panel></gv-fototeca-selezione-territoriale-panel>'
	      })
	    });
	  },
	  closePanel: function closePanel() {
	    document.getElementById('gv-fototeca-selezione-territoriale-panel').style.display = 'none';
	  }
	};
	
	exports.default = Control;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('gv-genio-seleziona-particelle-panel', function () {
	  return new _promise2.default(function (resolve) {
	    __webpack_require__.e/* nsure */(19, function (require) {
	      resolve(__webpack_require__(744));
	    });
	  });
	});
	
	var Control = {
	  id: 'genio-seleziona-particelle',
	  active: false,
	  latlng: null,
	  activate: function activate() {
	    GV.log('GV.controls.genio-seleziona-particelle.activate');
	    this.openPanel();
	    GV.eventBus.$emit("gv-control-genio-seleziona-particelle-activate", this);
	    this.active = true;
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.controls.genio-seleziona-particelle.deactivate');
	    GV.eventBus.$emit("gv-control-genio-seleziona-particelle-deactivate", this);
	    this.active = false;
	    this.closePanel();
	  },
	  openPanel: function openPanel() {
	    (0, _mountComponent2.default)({
	      elId: 'gv-genio-seleziona-particelle-panel',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-genio-seleziona-particelle-panel></gv-genio-seleziona-particelle-panel>'
	      })
	    });
	  },
	  closePanel: function closePanel() {
	    document.getElementById('gv-genio-seleziona-particelle-panel').style.display = 'none';
	  }
	};
	
	exports.default = Control;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(10);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mountComponent = __webpack_require__(7);
	
	var _mountComponent2 = _interopRequireDefault(_mountComponent);
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Control = {
	  id: 'coordinate',
	  active: false,
	  latlng: null,
	  activate: function activate() {
	    GV.log('GV.controls.measure.activate');
	    GV.eventBus.$emit('gv-control-measure-activate', this);
	    this.active = true;
	    this.openPanel();
	  },
	  deactivate: function deactivate() {
	    GV.log('GV.controls.measure.deactivate');
	    GV.eventBus.$emit('gv-control-measure-deactivate', this);
	    this.active = false;
	    this.closePanel();
	  },
	  openPanel: function openPanel() {
	    if (GV.app.map.type === 'openlayers') {
	      _vue2.default.component('gv-measure-panel', function () {
	        return new _promise2.default(function (resolve) {
	          __webpack_require__.e/* nsure */(11, function (require) {
	            resolve(__webpack_require__(772));
	          });
	        });
	      });
	    } else {
	      _vue2.default.component('gv-measure-panel', function () {
	        return new _promise2.default(function (resolve) {
	          __webpack_require__.e/* nsure */(18, function (require) {
	            resolve(__webpack_require__(771));
	          });
	        });
	      });
	    }
	
	    (0, _mountComponent2.default)({
	      elId: 'gv-measure-panel',
	      containerId: GV.config.containerId,
	      toggleEl: true,
	      vm: new _vue2.default({
	        template: '<gv-measure-panel></gv-measure-panel>'
	      })
	    });
	  },
	  closePanel: function closePanel() {
	    document.getElementById('gv-measure-panel').style.display = 'none';
	  }
	};
	
	exports.default = Control;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('draggable', {
	  inserted: function inserted(el, binding, vnode) {
	    var id = el.id.replace('-title', '');
	    el.className += ' draggable';
	    el.setAttribute('draggable', 'true');
	    el.setAttribute('ondragstart', 'GV.dragbox.start(event)');
	    el.setAttribute('ondragend', 'GV.dragbox.end(event,\'' + id + '\')');
	  }
	});

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = undefined;
	
	var _keys = __webpack_require__(57);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(46);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _interpolateString = __webpack_require__(407);
	
	var _interpolateString2 = _interopRequireDefault(_interpolateString);
	
	var _getParamString = __webpack_require__(171);
	
	var _getParamString2 = _interopRequireDefault(_getParamString);
	
	var _getZoomFromScaleDenom = __webpack_require__(173);
	
	var _getZoomFromScaleDenom2 = _interopRequireDefault(_getZoomFromScaleDenom);
	
	var _getGeoJSON = __webpack_require__(56);
	
	var _getGeoJSON2 = _interopRequireDefault(_getGeoJSON);
	
	var _getWmsError = __webpack_require__(168);
	
	var _getWmsError2 = _interopRequireDefault(_getWmsError);
	
	var _togeojson = __webpack_require__(208);
	
	var _togeojson2 = _interopRequireDefault(_togeojson);
	
	var _parseXML = __webpack_require__(177);
	
	var _parseXML2 = _interopRequireDefault(_parseXML);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var esriLink = '<a href="https://www.esri.com/">Esri</a>';
	
	function buildGeoJson(data, esParams) {
	  'use strict';
	
	  var geoJson = void 0;
	  if (esParams) {
	    var geomField = esParams.geomField || 'location';
	    var features = data.hits.hits;
	    geoJson = {
	      type: 'FeatureCollection',
	      totalFeatures: data.hits.total,
	      features: [],
	      crs: {
	        type: 'name',
	        properties: {
	          name: 'urn:ogc:def:crs:EPSG::4326'
	        }
	      }
	    };
	    features.forEach(function (feature) {
	      var coords = feature._source[geomField];
	      geoJson.features.push({
	        type: 'Feature',
	        id: feature._id,
	        geometry: {
	          type: 'Point',
	          coordinates: coords
	        },
	        geometry_name: 'GEOMETRY',
	        properties: feature._source
	      });
	    });
	  } else {
	    geoJson = typeof data === 'string' ? JSON.parse(data) : data;
	  }
	  return geoJson;
	}
	
	var layerFactory = {
	  BLANK: function BLANK(layerConfig) {
	    layerConfig.legend = {
	      label: 'Sfondo Bianco'
	    };
	    return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	      opacity: 0.0,
	      maxZoom: 20
	    });
	  },
	  OSM: function OSM(layerConfig) {
	    layerConfig.legend = {
	      label: 'OpenStreetMap'
	    };
	    return L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	      attribution: 'Map data © <a href="https://www.openstreetmap.org/copyright" target="blank">OpenStreetMap</a> contributors',
	      maxZoom: 21
	    });
	  },
	  TILESERVER_GL: function TILESERVER_GL(style) {
	    return L.tileLayer('https://tileserver-gl.regione.liguria.it/styles/' + style + '/{z}/{x}/{y}.png', {
	      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      minZoom: 0,
	      maxZoom: 20,
	      subdomains: ['1', '2']
	    });
	  },
	  TS_STREETS: function TS_STREETS() {
	    return this.TILESERVER_GL('streets');
	  },
	  TS_BASIC: function TS_BASIC() {
	    return this.TILESERVER_GL('basic-preview');
	  },
	  TS_DARK_MATTER: function TS_DARK_MATTER() {
	    return this.TILESERVER_GL('dark-matter');
	  },
	  TS_POSITRON: function TS_POSITRON() {
	    return this.TILESERVER_GL('positron');
	  },
	  TS_MONOCHROME: function TS_MONOCHROME() {
	    return this.TILESERVER_GL('monochrome');
	  },
	  TS_TONER: function TS_TONER() {
	    return this.TILESERVER_GL('toner');
	  },
	  ESRI_IMAGERY: function ESRI_IMAGERY(layerConfig) {
	    layerConfig.legend = {
	      label: 'ESRI Imagery'
	    };
	    layerConfig.name = layerConfig.type;
	    var attr = 'DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community';
	    return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
	      attribution: '&copy; ' + esriLink + ', ' + attr,
	      maxZoom: 20 });
	  },
	  ESRI_STREETS: function ESRI_STREETS(layerConfig) {
	    layerConfig.legend = {
	      label: 'ESRI Streets'
	    };
	    layerConfig.name = layerConfig.type;
	    var attr = 'USGS, NOAA';
	    return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
	      attribution: '&copy; ' + esriLink + ', ' + attr,
	      maxZoom: 20 });
	  },
	  ESRI_TOPOGRAPHIC: function ESRI_TOPOGRAPHIC(layerConfig) {
	    layerConfig.legend = {
	      label: 'ESRI Topographic'
	    };
	    layerConfig.name = layerConfig.type;
	    var attr = 'USGS, NOAA';
	    return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
	      attribution: '&copy; ' + esriLink + ', ' + attr,
	      maxZoom: 20 });
	  },
	  ESRI_GRAY: function ESRI_GRAY(layerConfig) {
	    layerConfig.legend = {
	      label: 'ESRI Gray'
	    };
	    layerConfig.name = layerConfig.type;
	    var attr = 'HERE, DeLorme, MapmyIndia, OpenStreetMap contributors';
	    return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
	      attribution: '&copy; ' + esriLink + ', ' + attr,
	      maxZoom: 16 });
	  },
	  ESRI_DARKGRAY: function ESRI_DARKGRAY(layerConfig) {
	    layerConfig.legend = {
	      label: 'ESRI Dark Gray'
	    };
	    layerConfig.name = layerConfig.type;
	    var attr = 'HERE, DeLorme, MapmyIndia, OpenStreetMap contributors';
	    return L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
	      attribution: '&copy; ' + esriLink + ', ' + attr,
	      maxZoom: 16 });
	  },
	  MAPBOX: function MAPBOX(layerConfig) {
	    var USERNAME = layerConfig.mapboxConfig.userName;
	    var ACCESS_TOKEN = layerConfig.mapboxConfig.accessToken;
	    var STYLE = layerConfig.mapboxConfig.style;
	    return L.tileLayer('https://api.mapbox.com/styles/v1/' + USERNAME + '/' + STYLE + '/tiles/256/{z}/{x}/{y}?access_token=' + ACCESS_TOKEN, {
	      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      maxZoom: 20
	    });
	  },
	  MAPBOX_VIABILITA: function MAPBOX_VIABILITA(layerConfig) {
	    var USERNAME = 'liguriadigitale';
	    var ACCESS_TOKEN = 'pk.eyJ1IjoibGlndXJpYWRpZ2l0YWxlIiwiYSI6ImNqbzQzajk0bDEwa3EzcWt1ZThqazFqcGIifQ.dUhSMka7mXTD2inJGmlBMw';
	    var STYLE = 'cjo442ih3407m2slfdwc1hib5';
	    var LEGEND_LABEL = 'Carta della Viabilità';
	
	    layerConfig.legend = {
	      label: LEGEND_LABEL
	    };
	    return L.tileLayer('https://api.mapbox.com/styles/v1/' + USERNAME + '/' + STYLE + '/tiles/256/{z}/{x}/{y}?access_token=' + ACCESS_TOKEN, {
	      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      maxZoom: 20
	    });
	  },
	  MAPBOX_MONOCHROME: function MAPBOX_MONOCHROME(layerConfig) {
	    var USERNAME = 'liguriadigitale';
	    var ACCESS_TOKEN = 'pk.eyJ1IjoibGlndXJpYWRpZ2l0YWxlIiwiYSI6ImNqbzQzajk0bDEwa3EzcWt1ZThqazFqcGIifQ.dUhSMka7mXTD2inJGmlBMw';
	    var STYLE = 'ckgj8eqz80t8q19theln5gwrk';
	
	    var LEGEND_LABEL = 'Mapbox Monochrome';
	
	    layerConfig.legend = {
	      label: LEGEND_LABEL
	    };
	    return L.tileLayer('https://api.mapbox.com/styles/v1/' + USERNAME + '/' + STYLE + '/tiles/256/{z}/{x}/{y}?access_token=' + ACCESS_TOKEN, {
	      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      maxZoom: 20
	    });
	  },
	  MAPBOX_STREETS: function MAPBOX_STREETS(layerConfig) {
	    var USERNAME = 'liguriadigitale';
	    var ACCESS_TOKEN = 'pk.eyJ1IjoibGlndXJpYWRpZ2l0YWxlIiwiYSI6ImNqbzQzajk0bDEwa3EzcWt1ZThqazFqcGIifQ.dUhSMka7mXTD2inJGmlBMw';
	    var STYLE = 'ckgj8f25p0o6y19jxk0ykap41';
	
	    var LEGEND_LABEL = 'Mapbox Streets';
	
	    layerConfig.legend = {
	      label: LEGEND_LABEL
	    };
	    return L.tileLayer('https://api.mapbox.com/styles/v1/' + USERNAME + '/' + STYLE + '/tiles/256/{z}/{x}/{y}?access_token=' + ACCESS_TOKEN, {
	      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      maxZoom: 20
	    });
	  },
	  MAPBOX_VIABILITA_SATELLITARE: function MAPBOX_VIABILITA_SATELLITARE(layerConfig) {
	    var USERNAME = 'liguriadigitale';
	    var ACCESS_TOKEN = 'pk.eyJ1IjoibGlndXJpYWRpZ2l0YWxlIiwiYSI6ImNqbzQzajk0bDEwa3EzcWt1ZThqazFqcGIifQ.dUhSMka7mXTD2inJGmlBMw';
	    var STYLE = 'cjo43w54x00di2spieg5itsgf';
	    var LEGEND_LABEL = 'Carta ibrida';
	
	    layerConfig.legend = {
	      label: LEGEND_LABEL
	    };
	    return L.tileLayer('https://api.mapbox.com/styles/v1/' + USERNAME + '/' + STYLE + '/tiles/256/{z}/{x}/{y}?access_token=' + ACCESS_TOKEN, {
	      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      maxZoom: 20
	    });
	  },
	  STAMEN_TERRAIN: function STAMEN_TERRAIN(layerConfig) {
	    layerConfig.legend = {
	      label: 'Stamen Terrain'
	    };
	    return L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.{ext}', {
	      attribution: 'Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      minZoom: 0,
	      maxZoom: 20,
	      ext: 'png'
	    });
	  },
	  STAMEN_TONER_LIGHT: function STAMEN_TONER_LIGHT(layerConfig) {
	    layerConfig.legend = {
	      label: 'Stamen Toner Light'
	    };
	    return L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.{ext}', {
	      attribution: 'Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	      subdomains: 'abcd',
	      minZoom: 0,
	      maxZoom: 20,
	      ext: 'png'
	    });
	  },
	  RL_CARTE_BASE_NC25: function RL_CARTE_BASE_NC25() {
	    return this.WMS({
	      visible: false,
	      name: 'L7273',
	      cacheMinZoomLevel: 12,
	      maxScale: 10000,
	      minScale: 200000,
	      wmsParams: {
	        name: 'L7273',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M2125/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Regione Liguria'
	    });
	  },
	  RL_CARTE_BASE: function RL_CARTE_BASE() {
	    return this.WMS({
	      visible: false,
	      name: 'CARTE_DI_BASE',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'CARTE_DI_BASE',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Regione Liguria'
	    });
	  },
	  RL_ORTOFOTO_2019: function RL_ORTOFOTO_2019() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'L8256',
	        format: 'image/png',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M2248/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Ortofoto 20cm/ ©2019 CONSORZIO TeA - TUTTI I DIRITTI RISERVATI'
	    });
	  },
	  RL_ORTOFOTO_2016: function RL_ORTOFOTO_2016() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'L5802',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Ortofoto 20cm/ ©2016 CONSORZIO TeA - TUTTI I DIRITTI RISERVATI'
	    });
	  },
	  RL_ORTOFOTO_2013: function RL_ORTOFOTO_2013() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'L4419',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M1661/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Immagine di proprietà AGEA'
	    });
	  },
	  RL_ORTOFOTO_2010: function RL_ORTOFOTO_2010() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'L3861',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M1505/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Immagine di proprietà AGEA'
	    });
	  },
	  RL_ORTOFOTO_2007: function RL_ORTOFOTO_2007() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'L3463',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M1361/wms?'
	      },
	      zIndex: 1,
	      attribution: 'Immagine di proprietà AGEA'
	    });
	  },
	  RL_ORTOFOTO_2000: function RL_ORTOFOTO_2000() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 8,
	      wmsParams: {
	        name: 'L48',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M48/wms?'
	      },
	      zIndex: 1
	    });
	  },
	  RL_ORTOFOTO_1986: function RL_ORTOFOTO_1986() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	
	      wmsParams: {
	        name: 'L1070',
	        format: 'image/jpeg',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M11/wms?'
	      },
	      zIndex: 1
	    });
	  },
	  RL_ORTOFOTO_COSTIERA_2003: function RL_ORTOFOTO_COSTIERA_2003() {
	    return this.WMS({
	      visible: false,
	      name: 'ORTOFOTO',
	      cacheMinZoomLevel: 7,
	      wmsParams: {
	        name: 'L8279',
	        format: 'image/png',
	        url: 'https://geoservizi.regione.liguria.it/geoserver/M2264/wms?'
	      },
	      zIndex: 1
	    });
	  },
	  TMS: function TMS(layerConfig) {
	    var url = layerConfig.tmsParams.url.replace('/tms/', '/tiles/');
	    var name = layerConfig.tmsParams.name;
	    var attribution = layerConfig.attribution;
	    var tmsUrl = url + '/1.0.0/' + name + '/{z}/{x}/{y}.png';
	    var maxLevel = layerConfig.maxScale ? (0, _getZoomFromScaleDenom2.default)(layerConfig.maxScale) - 1 : 20;
	
	    var layer = L.tileLayer(tmsUrl, {
	      minZoom: 1,
	      maxZoom: maxLevel,
	      attribution: attribution
	    });
	    layer.setZIndex(layerConfig.zIndex);
	    layer.name = name.replace('/webmercator', '');
	    return layer;
	  },
	  WMS: function WMS(layerConfig) {
	    var name = layerConfig.name,
	        cacheMinZoomLevel = layerConfig.cacheMinZoomLevel,
	        minScale = layerConfig.minScale,
	        maxScale = layerConfig.maxScale,
	        wmsParams = layerConfig.wmsParams,
	        flagGeoserver = layerConfig.flagGeoserver,
	        zIndex = layerConfig.zIndex;
	
	    GV.log('layerFactory - Creazione Layer WMS: ' + name);
	    var layer = null;
	
	    var isCached = cacheMinZoomLevel ? true : false;
	    var format = wmsParams.format;
	    var opacity = layerConfig.opacity || 1;
	    layerConfig.minZoom = minScale ? (0, _getZoomFromScaleDenom2.default)(minScale) : 8;
	    layerConfig.maxZoom = maxScale ? (0, _getZoomFromScaleDenom2.default)(maxScale) - 1 : 20;
	
	    var options = {
	      subdomains: ['1', '2'],
	      transparent: true,
	      layers: wmsParams.name,
	      format: format,
	      styles: wmsParams.styles || '',
	      opacity: opacity,
	      minZoom: layerConfig.minZoom,
	      maxZoom: layerConfig.maxZoom,
	      bounds: L.latLngBounds(L.latLng(_globals2.default.MAX_BOUNDS.X_MIN, _globals2.default.MAX_BOUNDS.Y_MIN), L.latLng(_globals2.default.MAX_BOUNDS.X_MAX, _globals2.default.MAX_BOUNDS.Y_MAX)),
	      client: 'GV2'
	    };
	    if (wmsParams.cql_filter) {
	      options.cql_filter = wmsParams.cql_filter;
	    }
	    if (wmsParams.sld) {
	      options.sld = wmsParams.sld;
	    }
	
	    var url = wmsParams.url;
	    if (isCached) {
	      if (_globals2.default.USE_SUBDOMAINS && url.indexOf('geoservizi.regione.liguria.it') > 0) {
	        url = url.replace('geoservizi', 'geoservizi{s}');
	      }
	      var cacheVersion = url.indexOf('geoservizi.datasiel.net') > 0 ? layerConfig.cacheVersionTest : layerConfig.cacheVersion;
	      (0, _assign2.default)(options, {
	        tiled: true,
	        TILESORIGIN: '-20037508,-20037508',
	        tileSize: 256,
	        CACHE_VERSION: cacheVersion
	      });
	      layer = L.tileLayer.wms(url, options);
	      layer.on('tileerror', function (err) {
	        (0, _getWmsError2.default)(err.tile.currentSrc).then(function (response) {
	          console.error('ERRORE WMS');
	          if (response && response.ServiceExceptionReport) console.log(response.ServiceExceptionReport.ServiceException);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	      });
	    } else {
	      (0, _assign2.default)(options, {
	        tiled: false,
	        pane: 'tilePane'
	      });
	      layer = L.nonTiledLayer.wms(url, options);
	      layer.on('error', function (err) {
	        (0, _getWmsError2.default)(err.target.url).then(function (response) {
	          console.error('ERRORE WMS');
	          console.log(response.ServiceExceptionReport.ServiceException);
	        }).catch(function (error) {
	          return console.error(error);
	        });
	      });
	    }
	
	    layer.setZIndex(zIndex);
	    layer.type = 'WMS';
	    layer.name = name;
	    return layer;
	  },
	  JSON: function JSON(layerConfig) {
	    var data = layerConfig.data,
	        url = layerConfig.url,
	        name = layerConfig.name,
	        wfsParams = layerConfig.wfsParams,
	        esParams = layerConfig.esParams,
	        classes = layerConfig.classes,
	        style = layerConfig.style,
	        pointToLayer = layerConfig.pointToLayer,
	        tooltip = layerConfig.tooltip,
	        popup = layerConfig.popup,
	        basePopup = layerConfig.basePopup,
	        customPopup = layerConfig.customPopup,
	        cluster = layerConfig.cluster,
	        subType = layerConfig.subType,
	        legend = layerConfig.legend,
	        onEachFeature = layerConfig.onEachFeature,
	        onFeatureSelect = layerConfig.onFeatureSelect,
	        filter = layerConfig.filter,
	        autoZoom = layerConfig.autoZoom;
	
	    var clusterLayer = null;
	    var options = {};
	
	    if (classes && classes.length > 0) {
	      if (layerConfig.geomSubType === 'POINT') {
	        options.pointToLayer = function (feature, latlng) {
	          var style;
	          classes.forEach(function (cls) {
	            if (cls.filter && cls.filter.key && cls.filter.value) {
	              if (feature.properties[cls.filter.key] === cls.filter.value) {
	                style = cls.style;
	              }
	            } else {
	              style = cls.style;
	            }
	          });
	          if (style.iconUrl) {
	            var icon;
	            switch (style.iconUrl) {
	              case 'default':
	                icon = L.icon({
	                  iconUrl: '/geoservices/apps/viewer/dist/static/img/marker-icon.png',
	                  iconSize: [25, 41],
	                  iconAnchor: [12, 41],
	                  popupAnchor: [0, -41]
	                });
	                break;
	              case 'default-small':
	                icon = L.icon({
	                  iconUrl: '/geoservices/apps/viewer/dist/static/img/marker-icon.png',
	                  iconSize: [12, 20],
	                  iconAnchor: [6, 10],
	                  popupAnchor: [0, -20]
	                });
	                break;
	              default:
	                icon = L.icon({
	                  iconUrl: style.iconUrl,
	                  iconSize: style.iconSize,
	                  iconAnchor: style.iconAnchor,
	                  popupAnchor: style.popupAnchor
	                });
	            }
	            var alt = tooltip ? (0, _interpolateString2.default)(tooltip, feature.properties) : '';
	            return L.marker(latlng, {
	              icon: icon,
	              alt: alt
	            });
	          } else if (style.svgIconHtml) {
	            var svgIcon = L.divIcon({
	              html: style.svgIconHtml,
	              className: style.className,
	              iconSize: style.iconSize,
	              iconAnchor: style.iconAnchor
	            });
	            var _alt = tooltip ? (0, _interpolateString2.default)(tooltip, feature.properties) : '';
	            return L.marker(latlng, {
	              icon: svgIcon,
	              alt: _alt
	            });
	          } else {
	            return L.circleMarker(latlng, style);
	          }
	        };
	      } else {
	        options.style = function (feature) {
	          var style;
	          classes.forEach(function (cls) {
	            if (cls.filter && cls.filter.key && cls.filter.value) {
	              if (feature.properties[cls.filter.key] === cls.filter.value) {
	                style = cls.style;
	              }
	            } else {
	              style = cls.style;
	            }
	          });
	          return style;
	        };
	      }
	      options.filter = function (feature) {
	        var visible = false;
	        classes.forEach(function (cls) {
	          if (!cls.filter) {
	            visible = true;
	          } else {
	            if (cls.filter.key && cls.filter.value) {
	              if (feature.properties[cls.filter.key] === cls.filter.value) {
	                visible = true;
	              }
	            }
	          }
	        });
	        return visible;
	      };
	    }
	
	    if (style) {
	      options.style = style;
	    }
	
	    if (pointToLayer) {
	      options.pointToLayer = pointToLayer;
	    }
	    if (filter) {
	      options.filter = filter;
	    }
	
	    function simplePopup(layer) {
	      var props = [];
	      (0, _keys2.default)(layer.feature.properties).forEach(function (key) {
	        if (key === 'stroke' || key === 'stroke-opacity' || key === 'stroke-width' || key === 'fill' || key === 'fill-opacity') {
	          return;
	        }
	        var value = layer.feature.properties[key];
	        if (typeof value === 'string' || value instanceof String || typeof value === 'number') {
	          props.push({
	            key: key,
	            value: value
	          });
	        }
	      });
	      var popUp = '<div><b>' + legend.label + '</b><br><br></div>';
	      popUp += '<div>';
	      props.forEach(function (prop) {
	        popUp += prop.key + ':' + prop.value + '<br>';
	      });
	      popUp += '</div>';
	      return popUp;
	    }
	
	    if (tooltip || popup || basePopup || customPopup) {
	      options.onEachFeature = function (feature, layer) {
	        if (tooltip) {
	          layer.options.title = (0, _interpolateString2.default)(tooltip, feature.properties);
	        }
	        if (popup) {
	          layer.bindPopup((0, _interpolateString2.default)(popup, feature.properties));
	        }
	        if (basePopup) {
	          layer.bindPopup(simplePopup);
	        }
	        if (customPopup) {
	          layer.bindPopup(customPopup);
	        }
	      };
	    }
	
	    if (onEachFeature) {
	      options.onEachFeature = onEachFeature;
	    }
	
	    var layer = L.geoJson(null, options);
	    layer.name = name;
	    layer.geoJson = null;
	
	    if (onFeatureSelect) {
	      layer.on('click', function (e) {
	        onFeatureSelect(e.layer.feature, e.layer);
	      });
	    }
	
	    var parameters;
	
	    if (wfsParams && wfsParams.typeName && wfsParams.url) {
	      parameters = {
	        service: 'WFS',
	        version: '2.0.0',
	        request: 'GetFeature',
	        srsName: 'EPSG:4326',
	        outputFormat: 'text/javascript',
	        format_options: 'callback: getJson',
	        typeName: wfsParams.typeName
	      };
	      url = wfsParams.url + (0, _getParamString2.default)(parameters);
	    }
	
	    if (esParams) {
	      parameters = {};
	      if (esParams.field) {
	        parameters.q = esParams.field + ':';
	        if (esParams.query) {
	          parameters.q += esParams.query;
	        } else {
	          parameters.q += '*';
	        }
	      } else {
	        if (esParams.query) {
	          parameters.q = esParams.query;
	        }
	      }
	      parameters.pretty = 'true';
	      parameters.size = 100000;
	
	
	      url = GV.config.application.proxy + esParams.url + (0, _getParamString2.default)(parameters);
	    }
	
	    if (cluster) {
	      var clusterOptions = {
	        showCoverageOnHover: false
	      };
	      if (cluster.options) {
	        (0, _assign2.default)(clusterOptions, cluster.options);
	      }
	      clusterLayer = L.markerClusterGroup(clusterOptions);
	      clusterLayer.name = name;
	    }
	
	    if (url) {
	      (0, _getGeoJSON2.default)(url).then(function (response) {
	        var geoJson = void 0;
	        if (!response.data || response.data === 'null') {
	          console.error('NESSUN DATO', layer);
	          return;
	        }
	        if (subType === 'KML') {
	          var xml = (0, _parseXML2.default)(response.data);
	          geoJson = _togeojson2.default.kml(xml);
	        } else if (subType === 'GPX') {
	          var _xml = (0, _parseXML2.default)(response.data);
	          geoJson = _togeojson2.default.gpx(_xml);
	        } else {
	          geoJson = buildGeoJson(response.data, esParams);
	        }
	        layer.geoJson = geoJson;
	        layer.addData(geoJson);
	        if (cluster) {
	          clusterLayer.geoJson = layer.geoJson;
	          clusterLayer.addLayer(layer);
	        }
	        layer.fire('ready');
	        GV.eventBus.$emit('layer-loaded-json', layer);
	        if (autoZoom) {
	          GV.app.map.fitBounds(layer.getBounds(), {
	            maxZoom: 17
	          });
	        }
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	
	    if (data) {
	      layer.geoJson = data;
	      layer.addData(data);
	      if (cluster) {
	        clusterLayer.geoJson = layer.geoJson;
	        clusterLayer.addLayer(layer);
	      }
	      layer.fire('ready');
	      GV.eventBus.$emit('layer-loaded-json', layer);
	      if (autoZoom) {
	        GV.app.map.fitBounds(layer.getBounds(), {
	          maxZoom: 17
	        });
	      }
	    }
	
	    return cluster ? clusterLayer : layer;
	  }
	};
	
	function create(layerConfig) {
	  if (layerFactory[layerConfig.type]) {
	    var layer = layerFactory[layerConfig.type](layerConfig);
	    layer.legend = layerConfig.legend;
	    layer.config = layerConfig;
	    return layer;
	  } else {
	    throw new Error('Layer di tipo ' + layerConfig.type + ' non gestito');
	  }
	}
	
	exports.create = create;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _assign = __webpack_require__(46);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _LayerFactory = __webpack_require__(360);
	
	var LayerFactory = _interopRequireWildcard(_LayerFactory);
	
	var _getWFSFeature = __webpack_require__(37);
	
	var _getWFSFeature2 = _interopRequireDefault(_getWFSFeature);
	
	var _buildCqlFilter = __webpack_require__(169);
	
	var _buildCqlFilter2 = _interopRequireDefault(_buildCqlFilter);
	
	var _InfoWmsManager = __webpack_require__(31);
	
	var _InfoWmsManager2 = _interopRequireDefault(_InfoWmsManager);
	
	var _getCoordTransform = __webpack_require__(45);
	
	var _getCoordTransform2 = _interopRequireDefault(_getCoordTransform);
	
	var _getCoordTransformBbox = __webpack_require__(163);
	
	var _getCoordTransformBbox2 = _interopRequireDefault(_getCoordTransformBbox);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var llMap = {
	  type: 'leaflet',
	  layers: [],
	  baseLayers: [],
	  initialExtent: [],
	  map: null,
	  zoom: null,
	  buttons: [],
	  mapOptions: {
	    type: 'leaflet',
	    zoomControl: false,
	    minZoom: 7,
	    maxZoom: 20
	  },
	  initialize: function initialize() {
	    (0, _assign2.default)(this.mapOptions, GV.config.application.mapOptions);
	
	    this.map = L.map('gv-map', this.mapOptions);
	    this.type = 'leaflet';
	    this.options = this.map.options;
	
	    this.setInitialExtent();
	
	    this.zoom = this.map._zoom;
	
	    this.setRestrictedExtent();
	
	    this.setLoading();
	
	    this.loadBaseLayers();
	
	    this.loadControls();
	
	    this.eventMngr();
	
	    if (this.options.static) {
	      this.map.dragging.disable();
	      this.map.touchZoom.disable();
	      this.map.doubleClickZoom.disable();
	      this.map.scrollWheelZoom.disable();
	      this.map.boxZoom.disable();
	      this.map.keyboard.disable();
	      if (this.map.tap) this.map.tap.disable();
	    }
	
	    return this;
	  },
	  on: function on(event, fn) {
	    this.map.on(event, fn);
	  },
	  off: function off(event) {
	    this.map.off(event);
	  },
	  fitBounds: function fitBounds(bounds, opts) {
	    this.map.fitBounds(bounds, opts);
	  },
	  panTo: function panTo(coords) {
	    this.map.panTo(coords);
	  },
	  setView: function setView(center, zoom, opt) {
	    var coords = Array.isArray(center) ? { lat: center[0], lng: center[1] } : center;
	    this.map.setView(coords, zoom, opt);
	  },
	  setMinZoom: function setMinZoom(bounds) {
	    this.map.setMinZoom(bounds);
	  },
	  setMaxBounds: function setMaxBounds(bounds) {
	    this.map.setMaxBounds(bounds);
	  },
	  getBounds: function getBounds() {
	    return this.map.getBounds();
	  },
	  getSize: function getSize() {
	    return this.map.getSize();
	  },
	  getCenter: function getCenter() {
	    return this.map.getCenter();
	  },
	  getZoom: function getZoom() {
	    return this.map.getZoom();
	  },
	  getBoundsZoom: function getBoundsZoom(bounds, inside, padding) {
	    return this.map.getBoundsZoom(bounds, inside, padding);
	  },
	  setZoom: function setZoom(zoom, opt) {
	    this.map.setZoom(zoom, opt);
	  },
	  removeLayer: function removeLayer(layer) {
	    this.map.removeLayer(layer);
	  },
	  addLayer: function addLayer(layer) {
	    this.map.addLayer(layer);
	  },
	  flyTo: function flyTo(center, zoom, opt) {
	    this.map.flyTo(center, zoom, opt);
	  },
	  latLngToContainerPoint: function latLngToContainerPoint(latlng) {
	    return this.map.latLngToContainerPoint(latlng);
	  },
	  addControl: function addControl(control) {
	    this.map.addControl(control);
	  },
	  eachLayer: function eachLayer(fn, context) {
	    this.map.eachLayer(fn, context);
	  },
	  addHandler: function addHandler(handler, fn) {
	    this.map.addHandler(handler, fn);
	  },
	  eventMngr: function eventMngr() {
	    var _this = this;
	
	    this.on('zoom', function () {
	      GV.eventBus.$emit('map-zoom', _this.map._zoom);
	    });
	    GV.eventBus.$on('set-layer-visible', function (event) {
	      _this.setLayerVisible(event.layer, event.checked);
	      _this.setHiliteLayerVisible(event);
	    });
	    GV.eventBus.$on('set-layer-transparency', function (event) {
	      var layer = _this.getLayerByName(event.layerName);
	      if (layer && layer.setOpacity) layer.setOpacity(event.opacity);
	    });
	    GV.eventBus.$on('change-base-layer', function (event) {
	      _this.changeBaseLayer(event.layer);
	    });
	  },
	  setHiliteLayerVisible: function setHiliteLayerVisible(event) {
	    var _this2 = this;
	
	    if (!GV.config.hilitedLayer) {
	      return;
	    }
	    GV.config.hilitedLayer.forEach(function (hl) {
	      if (hl === event.layer.name) {
	        var layer = _this2.getLayerByName('InfoWmsHilite');
	        layer.eachLayer(function (m) {
	          var opacity = event.checked ? 0.6 : 0.0;
	          m.setStyle({
	            opacity: opacity
	          });
	        });
	      }
	    });
	  },
	  projToGeoBounds: function projToGeoBounds(extent) {
	    var extArray = extent.split(',');
	    var swPoint = L.point(extArray[0], extArray[1]);
	    var nePoint = L.point(extArray[2], extArray[3]);
	    var swLatLng = L.Projection.SphericalMercator.unproject(swPoint);
	    var neLatLng = L.Projection.SphericalMercator.unproject(nePoint);
	    return L.latLngBounds(swLatLng, neLatLng);
	  },
	  setExtent: function setExtent(extent) {
	    this.initialExtent = this.projToGeoBounds(extent);
	    this.fitBounds(this.initialExtent);
	  },
	  setInitialExtent: function setInitialExtent() {
	    GV.log('setInitialExtent');
	    if (this.mapOptions.center && this.mapOptions.zoom) {
	      this.setView(this.mapOptions.center, this.mapOptions.zoom);
	    } else {
	      var extent = this.mapOptions.initialExtent || '830036,5402959,1123018,5597635';
	      this.setExtent(extent);
	    }
	  },
	  setRestrictedExtent: function setRestrictedExtent(extent, zoom) {
	    var restrictedExtent = extent || this.mapOptions.restrictedExtent;
	    if (restrictedExtent) {
	      this.restrictedExtent = this.projToGeoBounds(restrictedExtent);
	      this.setMaxBounds(this.restrictedExtent);
	      if (zoom) {
	        GV.app.map.map.options.minZoom = zoom;
	      }
	      if (extent === this.mapOptions.initialExtent) {
	        this.setMinZoom(this.zoom);
	      }
	
	      GV.log('setRestrictedExtent', this.restrictedExtent);
	    }
	  },
	  getExtent: function getExtent() {
	    var swPoint = this.getBounds().getSouthWest();
	    var nePoint = this.getBounds().getNorthEast();
	    var swPrj = L.Projection.SphericalMercator.project(swPoint);
	    var nePrj = L.Projection.SphericalMercator.project(nePoint);
	    return L.bounds(swPrj, nePrj);
	  },
	  getExtentAsString: function getExtentAsString(bounds) {
	    var swPoint = bounds ? bounds.getSouthWest() : this.getBounds().getSouthWest();
	    var nePoint = bounds ? bounds.getNorthEast() : this.getBounds().getNorthEast();
	    var swPrj = L.Projection.SphericalMercator.project(swPoint);
	    var nePrj = L.Projection.SphericalMercator.project(nePoint);
	    return swPrj.x + ',' + swPrj.y + ',' + nePrj.x + ',' + nePrj.y;
	  },
	  setLayerVisible: function setLayerVisible(layerConfig, visible) {
	    'use strict';
	
	    if (visible) {
	      layerConfig.visible = true;
	      this.loadLayers([layerConfig]);
	    } else {
	      var layer = this.getLayerByName(layerConfig.name);
	      if (layer) {
	        this.removeLayer(layer);
	      }
	    }
	  },
	  layerInRange: function layerInRange(layerConfig) {
	    'use strict';
	
	    if (!layerConfig.minScale && !layerConfig.minScale) {
	      return true;
	    }
	    return this.getScale() < layerConfig.minScale && this.getScale() > layerConfig.maxScale;
	  },
	  loadControls: function loadControls() {
	    'use strict';
	
	    var _this3 = this;
	
	    if (this.mapOptions.controls) {
	      var cntrl;
	      this.controls = {};
	      this.mapOptions.controls.forEach(function (control) {
	        switch (control.name) {
	          case 'scale':
	            cntrl = L.control.scale({
	              imperial: false
	            }).addTo(_this3.map);
	            _this3.controls[control] = cntrl;
	            break;
	        }
	      });
	    }
	  },
	  loadBaseLayers: function loadBaseLayers() {
	    var _this4 = this;
	
	    this.baseLayers = [];
	    GV.config.baseLayers.forEach(function (layerConfig) {
	      var layer = LayerFactory.create(layerConfig);
	      _this4.baseLayers[layer.config.type] = layer;
	      if (layer && layerConfig.visible) {
	        layer.on('loading', function () {
	          _this4.loading(true, layer);
	        });
	        layer.on('load', function () {
	          _this4.loading(false, layer);
	        });
	        layer.addTo(_this4.map);
	        _this4.activeBaseLayer = layer;
	        GV.config.activeBaseLayer = layer.config.name;
	      }
	    });
	  },
	  loadLayers: function loadLayers(layers) {
	    var _this5 = this;
	
	    layers.forEach(function (layerConfig) {
	      if (!_this5.getLayerByName(layerConfig.name)) {
	        var layer = LayerFactory.create(layerConfig);
	        if (layer && layerConfig.visible) {
	          layer.on('loading', function () {
	            _this5.loading(true, layer);
	          });
	          layer.on('load', function () {
	            _this5.loading(false, layer);
	          });
	          layer.addTo(_this5.map);
	          layer.on('ready', function () {
	            if (layerConfig.zoomToLayerExtent) {
	              (function () {
	                var bounds = new L.latLngBounds();
	                layer.eachLayer(function (_layer) {
	                  if (_layer.getBounds) {
	                    bounds.extend(_layer.getBounds());
	                  } else {
	                    bounds.extend(new L.latLngBounds(_layer._latlng, _layer._latlng));
	                  }
	                });
	                if (bounds) _this5.fitBounds(bounds);
	              })();
	            }
	          });
	        }
	      }
	    });
	  },
	  filterLayer: function filterLayer(layerName, filters) {
	    var layer = this.getLayerByName(layerName);
	    if (!layer) return;
	    if (filters) {
	      layer.eachLayer(function (marker) {
	        var opacity = 0;
	        filters.forEach(function (filter) {
	          if (marker.feature.properties[filter.key] === filter.value) {
	            opacity = layer.config.opacity || 1;
	          }
	        });
	        marker.setOpacity(opacity);
	      });
	    } else {
	      layer.eachLayer(function (marker) {
	        var opacity = layer.config.opacity || 1;
	        marker.setOpacity(opacity);
	      });
	    }
	  },
	  getLayerByName: function getLayerByName(layerName) {
	    var foundLayer = null;
	    this.eachLayer(function (layer) {
	      if (layer.config && layer.config.name && layer.config.name === layerName) {
	        foundLayer = layer;
	      }
	    });
	    return foundLayer;
	  },
	  changeBaseLayer: function changeBaseLayer(layerName) {
	    var activeLayerName = GV.config.getActiveBaseLayer().name;
	    if (activeLayerName !== layerName) {
	      this.baseLayers[layerName].addTo(this.map);
	      this.activeBaseLayer = this.baseLayers[layerName];
	      this.removeLayer(this.baseLayers[activeLayerName]);
	      GV.config.setActiveBaseLayer(layerName);
	    }
	  },
	  getScale: function getScale() {
	    var scaleDenom = 591657550 / Math.pow(2, this.map._zoom);
	    return scaleDenom;
	  },
	  setLoading: function setLoading() {
	    var _this6 = this;
	
	    this._spinning = 0;
	    this.on('layerremove', function (e) {
	      if (e.layer.loading) {
	        _this6.loading(false);
	      }
	      if (typeof e.layer.on !== 'function') {
	        return;
	      }
	      e.layer.off('load');
	      e.layer.off('loading');
	    });
	  },
	  loading: function loading(state, layer) {
	    if (state) {
	      if (this._spinning === 0) {
	        GV.log('start load: ' + layer.config.name);
	        this.map._container.style.cursor = 'progress';
	      }
	      this._spinning++;
	    } else {
	      this._spinning--;
	      GV.log('end load: ' + layer.config.name);
	      if (this._spinning <= 0) {
	        GV.log('FINE CARICAMENTO LAYER');
	        this.map._container.style.cursor = 'default';
	        GV.eventBus.$emit('map-full-loaded', this.map);
	      }
	    }
	  },
	  addMarker: function addMarker(markerConfig) {
	    var _this7 = this;
	
	    if (markerConfig.epsg && markerConfig.epsg != '4326') {
	      (0, _getCoordTransform2.default)(markerConfig.epsg, '4326', markerConfig.location[1], markerConfig.location[0]).then(function (response) {
	        if (response.data.points) {
	          var lon = response.data.points[0].split(',')[0];
	          var lat = response.data.points[0].split(',')[1];
	          markerConfig.location = [lat, lon];
	          return _this7.addMarkerToMap(markerConfig);
	        }
	      });
	    } else {
	      return this.addMarkerToMap(markerConfig);
	    }
	  },
	  addMarkerToMap: function addMarkerToMap(markerConfig) {
	    var icon = L.icon({
	      iconUrl: '/geoservices/apps/viewer/dist/static/img/marker-icon.png',
	      iconSize: [25, 41],
	      iconAnchor: [12, 41],
	      popupAnchor: [0, -41]
	    });
	    var opts = {
	      opacity: 0.8,
	      icon: icon,
	      title: markerConfig.label
	    };
	    var marker = markerConfig.type === 'circle' ? L.circleMarker(markerConfig.location, opts).addTo(this.map) : L.marker(markerConfig.location, opts).addTo(this.map);
	    this.flyTo(markerConfig.location, markerConfig.zoomLevel || 14);
	    return marker;
	  },
	  find: function find(findOptions) {
	    var _this8 = this;
	
	    console.log(GV.config.maps);
	
	    if (findOptions.bbox) {
	      this.zoomToBound(findOptions.bbox, findOptions.epsg, findOptions.maxZoom);
	      return;
	    }
	    if ((!findOptions.values || findOptions.values === 'null') && !findOptions.cqlFilter) {
	      console.error('Parametri FIND non completi: manca CQL_FILTER o VALUES');
	      return;
	    }
	    var cqlFilter = findOptions.cqlFilter || (0, _buildCqlFilter2.default)(findOptions);
	    var layers = findOptions.layers || GV.config.getLayersNameByMapId(findOptions.map);
	
	    var typeNames = layers.join(',');
	    var layerConfig = GV.config.getLayerConfig(layers[0]);
	    var wfsParams = layerConfig.wfsParams;
	    wfsParams.typeName = typeNames;
	
	    var loading = _loading4.default.service({
	      text: 'Ricerca...',
	      background: 'rgba(0, 0, 0, 0.8)'
	    });
	
	    (0, _getWFSFeature2.default)(wfsParams, cqlFilter).then(function (features) {
	      _this8.hiliteFeatures(features, findOptions, layers, loading);
	    }).catch(function (error) {
	      console.error(error);
	      loading.close();
	    });
	  },
	  zoomTo: function zoomTo(lat, lon, zoom) {
	    this.setView(new L.LatLng(lat, lon), zoom);
	  },
	  zoomToBound: function zoomToBound(strBounds, epsg, maxZoom) {
	    var _this9 = this;
	
	    if (epsg != '4326') {
	      var srsIn = epsg;
	      var srsOut = '4326';
	      (0, _getCoordTransformBbox2.default)(srsIn, srsOut, strBounds).then(function (response) {
	        if (response.data.data) {
	          var sw = response.data.data[0][0].split(',').reverse();
	          var ne = response.data.data[1][0].split(',').reverse();
	          _this9.fitBounds([sw, ne]);
	        }
	      });
	    } else {
	      var coord = strBounds.split(',');
	      var sw = [coord[0], coord[1]];
	      var ne = [coord[2], coord[3]];
	      this.fitBounds([sw, ne]);
	    }
	  },
	  getContainerPoint: function getContainerPoint(latlng) {
	    var point = this.latLngToContainerPoint(latlng);
	    return point;
	  },
	  getBbox: function getBbox() {
	    var bounds = GV.app.map.getBounds();
	    var sw = GV.app.map.options.crs.project(bounds.getSouthWest());
	    var ne = GV.app.map.options.crs.project(bounds.getNorthEast());
	    return sw.x + ',' + sw.y + ',' + ne.x + ',' + ne.y;
	  },
	  clearLayer: function clearLayer() {
	    var layer = this.getLayerByName('InfoWmsHilite');
	    layer.clearLayers();
	  },
	  hiliteFeatures: function hiliteFeatures(features, findOptions, layers, loading) {
	    _InfoWmsManager2.default.addHiliteLayer();
	    var layer = this.getLayerByName('InfoWmsHilite');
	    if (features && features.length > 0) {
	      layer.clearLayers();
	      layer.addData(features);
	      if (!findOptions) {
	        this.fitBounds(layer.getBounds(), {});
	      } else {
	        if (!findOptions.noZoom) {
	          var maxZoom = findOptions && findOptions.maxZoom ? findOptions.maxZoom : 15;
	          this.fitBounds(layer.getBounds(), {
	            maxZoom: maxZoom
	          });
	        }
	      }
	      if (layers) GV.config.hilitedLayer = layers;
	    } else {
	      if (findOptions && findOptions.notFoundAlert) {
	        (0, _notification2.default)('Nessun Elemento Trovato');
	      }
	      console.warn('Nessun Elemento Trovato');
	    }
	    if (loading) loading.close();
	  }
	};
	
	exports.default = llMap;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loading = __webpack_require__(24);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _base = __webpack_require__(5);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _loading3 = __webpack_require__(23);
	
	var _loading4 = _interopRequireDefault(_loading3);
	
	var _getIterator2 = __webpack_require__(32);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(46);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _LayerFactory = __webpack_require__(161);
	
	var LayerFactory = _interopRequireWildcard(_LayerFactory);
	
	var _getWFSFeature = __webpack_require__(37);
	
	var _getWFSFeature2 = _interopRequireDefault(_getWFSFeature);
	
	var _buildCqlFilter = __webpack_require__(169);
	
	var _buildCqlFilter2 = _interopRequireDefault(_buildCqlFilter);
	
	var _InfoWmsManager = __webpack_require__(31);
	
	var _InfoWmsManager2 = _interopRequireDefault(_InfoWmsManager);
	
	var _getCoordTransform = __webpack_require__(45);
	
	var _getCoordTransform2 = _interopRequireDefault(_getCoordTransform);
	
	var _createElement = __webpack_require__(170);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _notification = __webpack_require__(16);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var olMap = {
	  type: 'openlayers',
	  layers: [],
	  baseLayers: [],
	  initialExtent: [],
	  map: null,
	  zoom: null,
	  loading: 0,
	  loaded: 0,
	  buttons: [],
	  ol3dEnabled: false,
	  options: {
	    type: 'openlayers',
	    zoomControl: false,
	    minZoom: 7,
	    maxZoom: 20
	  },
	  initialize: function initialize() {
	    (0, _assign2.default)(this.options, GV.config.application.mapOptions);
	
	    var viewOptions = {};
	    if (this.options.restrictedExtent) {
	      viewOptions.extent = this.extentToArray(this.options.restrictedExtent);
	    }
	
	    this.map = new ol.Map({
	      target: 'gv-map',
	      layers: [],
	      controls: [new ol.control.Attribution()],
	      view: new ol.View(viewOptions)
	    });
	
	    this.createPopupDiv();
	    this.setInitialExtent();
	    this.zoom = this.getView().getZoom();
	    this.setLoading();
	    this.loadBaseLayer();
	    this.eventMngr();
	
	    if (this.options.ol3d) {
	      GV.globals.USE_SUBDOMAINS = false;
	      this.loadCesium();
	    }
	
	    return this;
	  },
	  loadCesium: function loadCesium() {
	    __webpack_require__(352);
	
	    var ol3d = new olcs.OLCesium({ map: this.map });
	    this.scene = ol3d.getCesiumScene();
	    var terrainProvider = new Cesium.GeoserverTerrainProvider({
	      url: GV.globals.RL_TERRAIN_PROVIDER_URL,
	      layerName: 'DTM_dbtopo_5m_wgs84'
	    });
	    this.scene.terrainProvider = terrainProvider;
	
	    if (this.options.enable3d) {
	      ol3d.setEnabled(true);
	      this.ol3dEnabled = true;
	    }
	    this.ol3d = ol3d;
	  },
	  switch3d: function switch3d() {
	    console.log('SWITCH 3D');
	    this.ol3dEnabled = !this.ol3dEnabled;
	    this.ol3d.setEnabled(this.ol3dEnabled);
	  },
	  setLoading: function setLoading() {
	    var _this = this;
	
	    GV.eventBus.$on('layer-load', function (event) {
	      ++_this.loading;
	    });
	    GV.eventBus.$on('layer-loaded', function (event) {
	      ++_this.loaded;
	      if (_this.loading === _this.loaded) {
	        _this.loading = 0;
	        _this.loaded = 0;
	        GV.log('FINE CARICAMENTO MAPPA');
	        GV.eventBus.$emit('map-full-loaded', _this.map);
	      }
	    });
	  },
	  eventMngr: function eventMngr() {
	    var _this2 = this;
	
	    this.map.on('moveend', function (e) {
	      var newZoom = _this2.getView().getZoom();
	      if (_this2.zoom != newZoom) {
	        GV.eventBus.$emit('map-zoom', newZoom);
	        _this2.zoom = newZoom;
	      }
	    });
	    this.map.on('rendercomplete', function (e) {});
	    GV.eventBus.$on('set-layer-visible', function (event) {
	      _this2.setLayerVisible(event.layer, event.checked);
	      _this2.setHiliteLayerVisible(event.layer, event.checked);
	    });
	    GV.eventBus.$on('set-layer-transparency', function (event) {
	      _this2.setLayerOpacity(event.layerName, event.opacity);
	    });
	    GV.eventBus.$on('change-base-layer', function (event) {
	      _this2.changeBaseLayer(event.layer);
	    });
	  },
	  addInteraction: function addInteraction(intercation) {
	    this.map.addInteraction(intercation);
	  },
	  removeInteraction: function removeInteraction(interaction) {
	    this.map.removeInteraction(interaction);
	  },
	  getView: function getView() {
	    return this.map.getView();
	  },
	  getOverlays: function getOverlays() {
	    return this.map.getOverlays();
	  },
	  removeOverlay: function removeOverlay(ovl) {
	    this.map.removeOverlay(ovl);
	  },
	  setLayerOpacity: function setLayerOpacity(layerName, opacity) {
	    var layer = this.getLayerByName(layerName);
	    if (layer && layer.setOpacity) layer.setOpacity(opacity);
	  },
	  setExtent: function setExtent(extent) {
	    var ext = this.extentToArray(extent);
	    this.fit(ext);
	  },
	  extentToArray: function extentToArray(extent) {
	    var extFloat = extent.split(',').map(function (ex) {
	      return parseFloat(ex);
	    });
	    return extFloat;
	  },
	  setInitialExtent: function setInitialExtent() {
	    GV.log('setInitialExtent');
	    if (this.options.center && this.options.zoom) {
	      this.setView(this.options.center, this.options.zoom);
	    } else {
	      var extent = this.options.initialExtent || '830036,5402959,1123018,5597635';
	      this.setExtent(extent);
	    }
	  },
	  setView: function setView(center, zoom) {
	    var coords = Array.isArray(center) ? center : [center.lng, center.lat];
	    this.getView().setCenter(ol.proj.fromLonLat(coords));
	    this.getView().setZoom(zoom);
	  },
	  getExtent: function getExtent() {
	    var swPoint = this.getBounds().getSouthWest();
	    var nePoint = this.getBounds().getNorthEast();
	    var swPrj = L.Projection.SphericalMercator.project(swPoint);
	    var nePrj = L.Projection.SphericalMercator.project(nePoint);
	    return L.bounds(swPrj, nePrj);
	  },
	  getExtentAsString: function getExtentAsString() {
	    return this.getView().calculateExtent().join(',');
	  },
	  setLayerVisible: function setLayerVisible(layerConfig, visible) {
	    var layer = this.getLayerByName(layerConfig.name);
	    layer.setVisible(visible);
	    layerConfig.visible = visible;
	  },
	  setHiliteLayerVisible: function setHiliteLayerVisible(layerConfig, visible) {
	    if (!GV.config.hilitedLayer) {
	      return;
	    }
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(GV.config.hilitedLayer), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var hl = _step.value;
	
	        if (hl[0] === layerConfig.name) {
	          var layer = this.getLayerByName('InfoWmsHilite');
	          layer.setVisible(visible);
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  },
	  layerInRange: function layerInRange(layerConfig) {
	    if (!layerConfig.minScale && !layerConfig.minScale) {
	      return true;
	    }
	    return this.getScale() < layerConfig.minScale && this.getScale() > layerConfig.maxScale;
	  },
	  loadBaseLayer: function loadBaseLayer() {
	    var _this3 = this;
	
	    GV.config.baseLayers.forEach(function (layerConfig) {
	      if (layerConfig.visible) {
	        _this3.setBaseLayer(layerConfig);
	      }
	    });
	  },
	  setBaseLayer: function setBaseLayer(layerConfig) {
	    if (layerConfig.name === 'BLANK') {
	      GV.config.activeBaseLayer = 'BLANK';
	      return;
	    }
	    var layer = LayerFactory.create(layerConfig, this);
	    if (layer) {
	      layer.config.baseLayer = true;
	      this.map.getLayers().insertAt(0, layer);
	      this.activeBaseLayer = layer;
	      GV.config.activeBaseLayer = layer.config.name;
	    }
	  },
	  changeBaseLayer: function changeBaseLayer(layerName) {
	    if (GV.config.activeBaseLayer !== layerName) {
	      var layer = this.getLayerByName(GV.config.activeBaseLayer);
	      this.removeLayer(layer);
	      var layerConfig = GV.config.getBaseLayerConfig(layerName);
	      this.setBaseLayer(layerConfig);
	    }
	  },
	  getLayerByName: function getLayerByName(layerName) {
	    var foundLayer = null;
	    this.map.getLayers().forEach(function (layer) {
	      if (layer.name && layer.name === layerName) {
	        foundLayer = layer;
	      }
	    });
	    return foundLayer;
	  },
	  getScale: function getScale() {
	    var scaleDenom = 591657550 / Math.pow(2, this.getView().getZoom());
	    return scaleDenom;
	  },
	  getZoom: function getZoom() {
	    return this.getView().getZoom();
	  },
	  setZoom: function setZoom(zoom) {
	    this.getView().setZoom(zoom);
	  },
	  getCenter: function getCenter() {
	    return ol.proj.transform(this.getView().getCenter(), 'EPSG:3857', 'EPSG:4326').reverse();
	  },
	  removeLayer: function removeLayer(layer) {
	    this.map.removeLayer(layer);
	  },
	  addLayer: function addLayer(layer) {
	    this.map.addLayer(layer);
	  },
	  addOverlay: function addOverlay(overlay) {
	    this.map.addOverlay(overlay);
	  },
	  getTarget: function getTarget() {
	    return this.map.getTarget();
	  },
	  getEventPixel: function getEventPixel(pixel) {
	    return this.map.getEventPixel(pixel);
	  },
	  getSize: function getSize() {
	    return this.map.getSize();
	  },
	  fit: function fit(extent, opt) {
	    var geom = ol.geom.Polygon.fromExtent(extent);
	
	    geom.scale(1.2);
	    this.getView().fit(geom, opt);
	  },
	  createPopupDiv: function createPopupDiv() {
	    (0, _createElement2.default)({ elId: 'ol-popup', containerId: 'body' });
	    (0, _createElement2.default)({ elId: 'ol-popup-closer', containerId: 'ol-popup' });
	    (0, _createElement2.default)({ elId: 'ol-popup-content', containerId: 'ol-popup' });
	  },
	  loadLayers: function loadLayers(layers) {
	    var _this4 = this;
	
	    var switch3d = false;
	    layers.forEach(function (layerConfig) {
	      if (_this4.getLayerByName(layerConfig.name)) {
	        return;
	      }
	      var layer = LayerFactory.create(layerConfig, _this4);
	      if (layer) {
	        if (_this4.ol3dEnabled && layerConfig.type === 'JSON' && layerConfig.name !== 'InfoWmsHilite' && layerConfig.name !== 'RisknatDataset') {
	          switch3d = true;
	          _this4.switch3d();
	        }
	        _this4.addLayer(layer);
	
	        GV.config.setLayerAttribute(layerConfig.name, 'inRange', _this4.layerInRange(layerConfig));
	        var visible = layerConfig.visible && _this4.layerInRange(layerConfig);
	        layer.setVisible(visible);
	
	        if (layerConfig.type === 'JSON') {
	          (function () {
	            var vectorSource = layer.getSource();
	            vectorSource.once('change', function () {
	              if (vectorSource.getState() === 'ready') {
	                if (layerConfig.zoomToLayerExtent && layer.getSource().getFeatures().length > 0) {
	                  _this4.fit(vectorSource.getExtent(), { maxZoom: 15 });
	                  console.log('ready', vectorSource.getFeatures());
	                }
	                if (switch3d) {
	                  _this4.switch3d();
	                }
	              }
	            });
	          })();
	        }
	      }
	    });
	  },
	  clearLayer: function clearLayer(layerName) {
	    var layer = this.getLayerByName(layerName);
	    if (layer) {
	      var source = layer.getSource();
	      source.clear();
	    }
	  },
	  addMarker: function addMarker(markerConfig) {
	    var _this5 = this;
	
	    if (markerConfig.epsg && markerConfig.epsg != '4326') {
	      (0, _getCoordTransform2.default)(markerConfig.epsg, '4326', markerConfig.location[1], markerConfig.location[0]).then(function (response) {
	        if (response.data.points) {
	          var lon = response.data.points[0].split(',')[0];
	          var lat = response.data.points[0].split(',')[1];
	          markerConfig.location = [lat, lon];
	          return _this5.addMarkerToMap(markerConfig);
	        }
	      });
	    } else {
	      return this.addMarkerToMap(markerConfig);
	    }
	  },
	  addMarkerToMap: function addMarkerToMap(markerConfig) {
	    var coords = Array.isArray(markerConfig.location) ? markerConfig.location : [markerConfig.location.lng, markerConfig.location.lat];
	    var feature = new ol.Feature({
	      geometry: new ol.geom.Point(ol.proj.fromLonLat(coords)),
	      name: markerConfig.label
	    });
	
	    feature.setStyle(new ol.style.Style({
	      image: new ol.style.Icon({
	        anchor: [0.5, 1],
	        src: '/geoservices/apps/viewer/dist/static/img/marker-icon.png'
	      })
	    }));
	
	    var vectorLayer = new ol.layer.Vector({
	      source: new ol.source.Vector({
	        features: [feature]
	      }),
	      zIndex: 1000
	    });
	    this.addLayer(vectorLayer);
	
	    this.fit(feature.getGeometry().getExtent(), {
	      maxZoom: markerConfig.zoomLevel || 15
	    });
	    return vectorLayer;
	  },
	  find: function find(findOptions) {
	    var _this6 = this;
	
	    if (findOptions.bbox) {
	      this.zoomToBound(findOptions.bbox, findOptions.epsg, findOptions.maxZoom);
	      return;
	    }
	    if ((!findOptions.values || findOptions.values === 'null') && !findOptions.cqlFilter) {
	      console.error('Parametri FIND non completi: manca CQL_FILTER o VALUES');
	      return;
	    }
	    var cqlFilter = findOptions.cqlFilter || (0, _buildCqlFilter2.default)(findOptions);
	    var layers = findOptions.layers || GV.config.getLayersNameByMapId(findOptions.map);
	
	    var typeNames = layers.join(',');
	    var layerConfig = GV.config.getLayerConfig(layers[0]);
	    var wfsParams = layerConfig.wfsParams;
	    wfsParams.typeName = typeNames;
	
	    var loading = _loading4.default.service({
	      text: 'Ricerca...',
	      background: 'rgba(0, 0, 0, 0.8)'
	    });
	    (0, _getWFSFeature2.default)(wfsParams, cqlFilter).then(function (features) {
	      _this6.hiliteFeatures(features, findOptions, layers, loading);
	    }).catch(function (error) {
	      console.error(error);
	      loading.close();
	    });
	  },
	  zoomTo: function zoomTo(lat, lon, zoom) {
	    this.setView([lon, lat], zoom);
	  },
	  zoomToBound: function zoomToBound(extent, epsg, maxZoom) {
	    if (epsg != '3857') {
	      var ext = this.extentToArray(extent);
	      var prj = new ol.proj.Projection({
	        code: 'EPSG:' + epsg
	      });
	      var trExt = ol.proj.transformExtent(ext, prj, 'EPSG:3857');
	      this.fit(trExt, {
	        maxZoom: maxZoom || 15
	      });
	    } else {
	      this.setExtent(extent);
	    }
	  },
	  on: function on(event, fn) {
	    this.map.on(event, fn);
	  },
	  off: function off(event, fn) {
	    this.map.un(event, fn);
	  },
	  forEachFeatureAtPixel: function forEachFeatureAtPixel(pixel, callback, options) {
	    this.map.forEachFeatureAtPixel(pixel, callback, options);
	  },
	  hiliteFeatures: function hiliteFeatures(features, findOptions, layers, loading) {
	    _InfoWmsManager2.default.addHiliteLayer();
	    var layer = this.getLayerByName('InfoWmsHilite');
	    if (features && features.length > 0) {
	      var source = layer.getSource();
	      source.clear();
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(features), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var feature = _step2.value;
	
	          var olFeature = new ol.format.GeoJSON().readFeature(feature, {
	            featureProjection: 'EPSG:3857'
	          });
	          source.addFeature(olFeature);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      if (findOptions && !findOptions.noZoom) {
	        var maxZoom = findOptions && findOptions.maxZoom ? findOptions.maxZoom : 15;
	        this.fit(layer.getSource().getExtent(), {
	          maxZoom: maxZoom
	        });
	      }
	
	      if (layers) GV.config.hilitedLayer = layers;
	    } else {
	      if (findOptions && findOptions.notFoundAlert) {
	        (0, _notification2.default)('Nessun Elemento Trovato');
	      }
	      console.warn('Nessun Elemento Trovato');
	    }
	    if (loading) loading.close();
	  }
	};
	
	exports.default = olMap;

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, 'find', {
	    value: function value(predicate) {
	      'use strict';
	
	      if (this == null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	
	      for (var i = 0; i !== length; i++) {
	        if (predicate.call(thisArg, this[i], i, list)) {
	          return this[i];
	        }
	      }
	      return undefined;
	    }
	  });
	}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	if (!Array.prototype.findIndex) {
	  Object.defineProperty(Array.prototype, 'findIndex', {
	    value: function value(predicate) {
	      if (this == null) {
	        throw new TypeError('"this" is null or not defined');
	      }
	
	      var o = Object(this);
	
	      var len = o.length >>> 0;
	
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	
	      var thisArg = arguments[1];
	
	      var k = 0;
	
	      while (k < len) {
	        var kValue = o[k];
	        if (predicate.call(thisArg, kValue, k, o)) {
	          return k;
	        }
	
	        k++;
	      }
	
	      return -1;
	    }
	  });
	}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    return this.substr(position || 0, searchString.length) === searchString;
	  };
	}

/***/ }),
/* 366 */,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (applicazione) {
	  var url = '' + _globals2.default.RL_AG_APP_LISTA_MAPPE + applicazione;
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var url = GV.globals.ATLANTE_GEOCHIMICO_CONFIG_URL;
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(app, ruolo, test) {
	    var url, response;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            url = '/geoservices/REST/utils/autorizza_nam/' + app + '/' + ruolo;
	            _context.next = 3;
	            return _axios2.default.get(url);
	
	          case 3:
	            response = _context.sent;
	            return _context.abrupt('return', response.data);
	
	          case 5:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  function getAuth(_x, _x2, _x3) {
	    return _ref.apply(this, arguments);
	  }
	
	  return getAuth;
	}();

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getEnti;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getEnti() {
	  var url = _globals2.default.RL_ENTI_SERVICE;
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFeatureInfo;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addLayerName(data, layerName) {
	  var features = data.features;
	
	  data.features.forEach(function (feature, index) {
	    feature.id = layerName + '.' + index;
	  });
	
	  return features;
	}
	function getFeatureInfo(url, layers) {
	  var params = {};
	  return _axios2.default.get(url, {
	    params: params
	  }).then(function (response) {
	    var data = response.data;
	    var features = addLayerName(data, layers);
	    return features;
	  });
	}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFeatureInfo;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFeatureInfo(url, layerName) {
	  var params = {};
	  return _axios2.default.get(url, {
	    params: params
	  }).then(function (response) {
	    var feature = {
	      layerName: layerName,
	      id: '1',
	      label: '1',
	      html: response.data,
	      properties: null
	    };
	    return [feature];
	  });
	}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFeatureInfo;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFeatureInfo(url, layerName) {
	  var params = {};
	  return _axios2.default.get(url, {
	    params: params
	  }).then(function (response) {
	    var feature = {
	      layerName: layerName,
	      id: "1",
	      label: "1",
	      text: response.data,
	      properties: null
	    };
	    return [feature];
	  });
	}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(57);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = getFeatureInfo;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var X2JS = __webpack_require__(116);
	
	function parseGml(gml, layerName) {
	  var data = new X2JS().xml_str2json(gml);
	  var features = [];
	
	  if (data.FeatureCollection && data.FeatureCollection.featureMember) {
	    if (Array.isArray(data.FeatureCollection.featureMember)) {
	      data.FeatureCollection.featureMember.forEach(function (featureMember, index2) {
	        var feature = featureMember[(0, _keys2.default)(featureMember)[0]];
	        var properties = {};
	        var toAdd = false;
	        (0, _keys2.default)(feature).forEach(function (key, index) {
	          if (key !== '__prefix' && key !== '__text' && key !== 'toString') {
	            properties[key] = feature[key].__text;
	            toAdd = true;
	          }
	        });
	        if (toAdd) {
	          features.push({
	            type: 'Feature',
	            id: layerName + '.' + index2,
	            geometry: null,
	            properties: properties
	          });
	        }
	      });
	    } else {
	      (function () {
	        var featureMember = data.FeatureCollection.featureMember;
	        var feature = featureMember[(0, _keys2.default)(featureMember)[0]];
	        var properties = {};
	        var toAdd = false;
	        var index2 = 0;
	        (0, _keys2.default)(feature).forEach(function (key, index) {
	          if (key !== '__prefix' && key !== '__text' && key !== 'toString') {
	            properties[key] = feature[key].__text;
	            toAdd = true;
	          }
	        });
	        if (toAdd) {
	          features.push({
	            type: 'Feature',
	            id: layerName + '.' + index2,
	            geometry: null,
	            properties: properties
	          });
	        }
	      })();
	    }
	  }
	
	  if (data.msGMLOutput) {
	    (0, _keys2.default)(data.msGMLOutput).forEach(function (key, index) {
	      if (key.indexOf('_layer') >= 0) {
	        (function () {
	          var layerName = key.replace('_layer', '');
	          var layer = data.msGMLOutput[key];
	          (0, _keys2.default)(layer).forEach(function (key2, index2) {
	            var feature = layer[key2];
	            if (Array.isArray(feature)) {
	              feature.forEach(function (value) {
	                var properties = value;
	                features.push({
	                  type: 'Feature',
	                  id: layerName + '.' + index2,
	                  geometry: null,
	                  properties: properties
	                });
	              });
	            } else {
	              (function () {
	                var properties = {};
	                var toAdd = false;
	                (0, _keys2.default)(feature).forEach(function (key, index) {
	                  if (key !== '__prefix' && key !== '__text' && key !== 'toString') {
	                    properties[key] = feature[key];
	                    toAdd = true;
	                  }
	                });
	                if (toAdd) {
	                  features.push({
	                    type: 'Feature',
	                    id: layerName + '.' + index2,
	                    geometry: null,
	                    properties: properties
	                  });
	                }
	              })();
	            }
	          });
	        })();
	      }
	    });
	  }
	
	  return features;
	}
	
	function parseGmlComplex(gml, layers) {
	  var data = new X2JS().xml_str2json(gml);
	
	
	  var features = [{
	    layerName: layers,
	    gml: gml,
	    properties: data
	  }];
	  return features;
	}
	
	function getFeatureInfo(url, layers, infoOptions) {
	  var params = {};
	
	  return _axios2.default.get(url, {
	    params: params
	  }).then(function (response) {
	    var gml = response.data;
	    var features = infoOptions.complexFeature ? parseGmlComplex(response.data, layers) : parseGml(gml, layers);
	    return features;
	  });
	}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFeatureXSLT;
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFeatureXSLT(infoUrl, data) {
	  var idLayer = data.layerName ? data.layerName.replace('L', '') : null;
	  var titolo = data.layer && data.layer.legend ? data.layer.legend.label : null;
	  return _axios2.default.post(_globals2.default.RL_XSL_INFO_SERVICE, {
	    data: {
	      xslUrl: infoUrl,
	      gml: data.gml,
	      idLayer: idLayer,
	      titolo: titolo,
	      featureAttributes: data.properties,
	      text: data.text
	    }
	  }).then(function (response) {
	    return response.data;
	  });
	}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (bbox) {
	  var url = '/geoservices/REST/fototeca/voli/';
	  if (bbox) url += '?bbox=' + bbox;
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 381 */,
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (url) {
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (url) {
	  return _axios2.default.get(url).then(function (response) {
	    return response.data.features;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(22);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(21);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(url) {
	    var response;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return _axios2.default.get(url);
	
	          case 2:
	            response = _context.sent;
	            return _context.abrupt('return', response.data);
	
	          case 4:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function (_x) {
	    return _ref.apply(this, arguments);
	  };
	}();

/***/ }),
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (query) {
	  var params = {
	    mapview: '7.43,43.75;10.00,44.70',
	    searchtext: query.replace('INCROCIO', '@')
	  };
	
	  return _axios2.default.get(_globals2.default.HERE_GEOCODE_PROXY, {
	    params: params
	  }).then(function (response) {
	    return response.data.Response.View[0].Result.map(function (result) {
	      return {
	        relevance: result.Relevance,
	        match_level: result.MatchLevel,
	        match_type: result.MatchType,
	        formatted_address: result.Location.Address.Label,
	        place_id: result.Location.LocationId,
	        geometry: {
	          location: {
	            lat: result.Location.DisplayPosition.Latitude,
	            lng: result.Location.DisplayPosition.Longitude
	          }
	        }
	      };
	    });
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (query) {
	  var params = {
	    text: query
	  };
	
	  return _axios2.default.get('https://srvcarto.regione.liguria.it/geoservices/REST/geocoder/proxy/pelias_geocode/v1/autocomplete/search', {
	    params: params
	  }).then(function (response) {
	    return response.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (token, type, prov) {
	  var url = type && type === 'genio' && prov ? '/geoservices/REST/genioweb/get_token/' + prov + '/' : '/geoservices/REST/sigmater/get_token/';
	  url += token;
	  return _axios2.default.get(url).then(function (response) {
	    return response.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (token) {
	  var url = "/geoservices/REST/sigmater/get_token_bbox/" + token;
	  return _axios2.default.get(url).then(function (response) {
	    return response.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (idSession, coord_x, coord_y, esito, coord_z, coord_2_x, coord_2_y, coord_2_z, epsg) {
	  var url = '/geoservices/REST/config/ag_insert_coordinate?idSession=' + idSession + '&coord_x=' + coord_x + '&coord_y=' + coord_y + '&esito=' + esito;
	  if (coord_z) {
	    url += '&coord_z=' + coord_z;
	  }
	  if (coord_2_x) {
	    url += '&coord_2_x=' + coord_2_x;
	  }
	  if (coord_2_y) {
	    url += '&coord_2_y=' + coord_2_y;
	  }
	  if (coord_2_z) {
	    url += '&coord_2_z=' + coord_2_z;
	  }
	  if (epsg) {
	    url += '&epsg=' + epsg;
	  }
	  _axios2.default.get(url).then(function (response) {
	    GV.globals.flagInsert = true;
	    if (!response.data.success) {
	      alert('Attenzione: - ' + response.data.message);
	    } else {
	      GV.globals.flagInsert = true;
	      if ((0, _isBrowserIE2.default)()) {
	        window.history.back(-1);
	      } else {
	        window.close();
	      }
	    }
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _isBrowserIE = __webpack_require__(174);
	
	var _isBrowserIE2 = _interopRequireDefault(_isBrowserIE);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data) {
	  return _axios2.default.post("/geoservices/REST/genioweb/insert_geom_pratica", {
	    headers: { Accept: "text/xml" },
	    data: data
	  }).then(function (response) {
	    return response.data;
	  });
	};
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _globals = __webpack_require__(6);
	
	var _globals2 = _interopRequireDefault(_globals);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(1);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Geocoder = __webpack_require__(745);
	
	var _Geocoder2 = _interopRequireDefault(_Geocoder);
	
	var _GeocoderPelias = __webpack_require__(747);
	
	var _GeocoderPelias2 = _interopRequireDefault(_GeocoderPelias);
	
	var _GeocoderBtn = __webpack_require__(799);
	
	var _GeocoderBtn2 = _interopRequireDefault(_GeocoderBtn);
	
	var _Search = __webpack_require__(783);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Scalebar = __webpack_require__(778);
	
	var _Scalebar2 = _interopRequireDefault(_Scalebar);
	
	var _InnerHtml = __webpack_require__(755);
	
	var _InnerHtml2 = _interopRequireDefault(_InnerHtml);
	
	var _AddMap = __webpack_require__(785);
	
	var _AddMap2 = _interopRequireDefault(_AddMap);
	
	var _Info = __webpack_require__(802);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _Coordinate = __webpack_require__(789);
	
	var _Coordinate2 = _interopRequireDefault(_Coordinate);
	
	var _Measure = __webpack_require__(806);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	var _Draw = __webpack_require__(791);
	
	var _Draw2 = _interopRequireDefault(_Draw);
	
	var _DownloadTotale = __webpack_require__(790);
	
	var _DownloadTotale2 = _interopRequireDefault(_DownloadTotale);
	
	var _LayerSearch = __webpack_require__(804);
	
	var _LayerSearch2 = _interopRequireDefault(_LayerSearch);
	
	var _LayerSearchTopo = __webpack_require__(805);
	
	var _LayerSearchTopo2 = _interopRequireDefault(_LayerSearchTopo);
	
	var _AtlanteGeochimicoLivelli = __webpack_require__(718);
	
	var _AtlanteGeochimicoLivelli2 = _interopRequireDefault(_AtlanteGeochimicoLivelli);
	
	var _SelezioneFogli = __webpack_require__(784);
	
	var _SelezioneFogli2 = _interopRequireDefault(_SelezioneFogli);
	
	var _Gas = __webpack_require__(740);
	
	var _Gas2 = _interopRequireDefault(_Gas);
	
	var _RicercaParticellaCatastale = __webpack_require__(808);
	
	var _RicercaParticellaCatastale2 = _interopRequireDefault(_RicercaParticellaCatastale);
	
	var _S3RicercaCatastale = __webpack_require__(809);
	
	var _S3RicercaCatastale2 = _interopRequireDefault(_S3RicercaCatastale);
	
	var _Print = __webpack_require__(807);
	
	var _Print2 = _interopRequireDefault(_Print);
	
	var _ScuolaDigitaleLegend = __webpack_require__(780);
	
	var _ScuolaDigitaleLegend2 = _interopRequireDefault(_ScuolaDigitaleLegend);
	
	var _ScuolaDigitaleInfoConn = __webpack_require__(779);
	
	var _ScuolaDigitaleInfoConn2 = _interopRequireDefault(_ScuolaDigitaleInfoConn);
	
	var _GenioLocalizza = __webpack_require__(796);
	
	var _GenioLocalizza2 = _interopRequireDefault(_GenioLocalizza);
	
	var _GenioSelezionaParticelle = __webpack_require__(798);
	
	var _GenioSelezionaParticelle2 = _interopRequireDefault(_GenioSelezionaParticelle);
	
	var _GenioConfermaLoadShape = __webpack_require__(795);
	
	var _GenioConfermaLoadShape2 = _interopRequireDefault(_GenioConfermaLoadShape);
	
	var _CemElaborazioni = __webpack_require__(788);
	
	var _CemElaborazioni2 = _interopRequireDefault(_CemElaborazioni);
	
	var _Back = __webpack_require__(786);
	
	var _Back2 = _interopRequireDefault(_Back);
	
	var _FototecaVoli = __webpack_require__(739);
	
	var _FototecaVoli2 = _interopRequireDefault(_FototecaVoli);
	
	var _FototecaCarrello = __webpack_require__(792);
	
	var _FototecaCarrello2 = _interopRequireDefault(_FototecaCarrello);
	
	var _FototecaSchedaVolo = __webpack_require__(793);
	
	var _FototecaSchedaVolo2 = _interopRequireDefault(_FototecaSchedaVolo);
	
	var _FototecaSelezioneTerritoriale = __webpack_require__(794);
	
	var _FototecaSelezioneTerritoriale2 = _interopRequireDefault(_FototecaSelezioneTerritoriale);
	
	var _GenioPraticheCollegate = __webpack_require__(797);
	
	var _GenioPraticheCollegate2 = _interopRequireDefault(_GenioPraticheCollegate);
	
	var _RqaLivelli = __webpack_require__(776);
	
	var _RqaLivelli2 = _interopRequireDefault(_RqaLivelli);
	
	var _LibiossSpecie = __webpack_require__(763);
	
	var _LibiossSpecie2 = _interopRequireDefault(_LibiossSpecie);
	
	var _DifesaSuoloFoto = __webpack_require__(729);
	
	var _DifesaSuoloFoto2 = _interopRequireDefault(_DifesaSuoloFoto);
	
	var _DifesaSuoloFotoInfo = __webpack_require__(730);
	
	var _DifesaSuoloFotoInfo2 = _interopRequireDefault(_DifesaSuoloFotoInfo);
	
	var _DifesaSuoloFotoLog = __webpack_require__(731);
	
	var _DifesaSuoloFotoLog2 = _interopRequireDefault(_DifesaSuoloFotoLog);
	
	var _Switch3D = __webpack_require__(810);
	
	var _Switch3D2 = _interopRequireDefault(_Switch3D);
	
	var _Help3D = __webpack_require__(801);
	
	var _Help3D2 = _interopRequireDefault(_Help3D);
	
	var _Help = __webpack_require__(800);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	var _InsertPoint = __webpack_require__(803);
	
	var _InsertPoint2 = _interopRequireDefault(_InsertPoint);
	
	var _CulturaLegend = __webpack_require__(727);
	
	var _CulturaLegend2 = _interopRequireDefault(_CulturaLegend);
	
	var _CulturaInfo = __webpack_require__(726);
	
	var _CulturaInfo2 = _interopRequireDefault(_CulturaInfo);
	
	var _CduSelezionaParticelle = __webpack_require__(787);
	
	var _CduSelezionaParticelle2 = _interopRequireDefault(_CduSelezionaParticelle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tools = [];
	
	tools.push({
	  name: 'gv-geocoder'
	});
	
	_vue2.default.component('gv-geocoder-here', _Geocoder2.default);
	
	tools.push({
	  name: 'gv-geocoder-pelias'
	});
	
	_vue2.default.component('gv-geocoder', _GeocoderPelias2.default);
	
	tools.push({ name: 'gv-geocoder-btn-button' });
	
	_vue2.default.component('gv-geocoder-btn-button', _GeocoderBtn2.default);
	
	tools.push({
	  name: 'gv-search'
	});
	
	_vue2.default.component('gv-search', _Search2.default);
	
	tools.push({
	  name: 'gv-scalebar'
	});
	
	_vue2.default.component('gv-scalebar', _Scalebar2.default);
	
	tools.push({
	  name: 'gv-inner-html'
	});
	
	_vue2.default.component('gv-inner-html', _InnerHtml2.default);
	
	tools.push({
	  name: 'gv-add-map-button'
	});
	
	_vue2.default.component('gv-add-map-button', _AddMap2.default);
	
	tools.push({
	  name: 'gv-info-button'
	});
	
	_vue2.default.component('gv-info-button', _Info2.default);
	
	tools.push({
	  name: 'gv-coordinate-button'
	});
	
	_vue2.default.component('gv-coordinate-button', _Coordinate2.default);
	
	tools.push({
	  name: 'gv-measure-button'
	});
	
	_vue2.default.component('gv-measure-button', _Measure2.default);
	
	tools.push({
	  name: 'gv-draw-button'
	});
	
	_vue2.default.component('gv-draw-button', _Draw2.default);
	
	tools.push({
	  name: 'gv-download-totale-button'
	});
	
	_vue2.default.component('gv-download-totale-button', _DownloadTotale2.default);
	
	tools.push({
	  name: 'gv-layer-search-button'
	});
	
	_vue2.default.component('gv-layer-search-button', _LayerSearch2.default);
	
	tools.push({
	  name: 'gv-layer-search-topo-button'
	});
	
	_vue2.default.component('gv-layer-search-topo-button', _LayerSearchTopo2.default);
	
	tools.push({
	  name: 'atlante-geochimico-livelli'
	});
	
	_vue2.default.component('atlante-geochimico-livelli', _AtlanteGeochimicoLivelli2.default);
	
	tools.push({
	  name: 'gv-map-selezione-fogli'
	});
	
	_vue2.default.component('gv-map-selezione-fogli', _SelezioneFogli2.default);
	
	tools.push({
	  name: 'gv-gas'
	});
	
	_vue2.default.component('gv-gas', _Gas2.default);
	
	tools.push({
	  name: 'gv-ricerca-particella-button'
	});
	
	_vue2.default.component('gv-ricerca-particella-button', _RicercaParticellaCatastale2.default);
	
	tools.push({
	  name: 'gv-ricerca-catastale-button'
	});
	
	_vue2.default.component('gv-ricerca-catastale-button', _S3RicercaCatastale2.default);
	
	tools.push({
	  name: 'gv-print-button'
	});
	
	_vue2.default.component('gv-print-button', _Print2.default);
	
	tools.push({
	  name: 'gv-scuoladigitale-legend'
	});
	
	_vue2.default.component('gv-scuoladigitale-legend', _ScuolaDigitaleLegend2.default);
	
	tools.push({
	  name: 'gv-scuoladigitale-info-conn'
	});
	
	_vue2.default.component('gv-scuoladigitale-info-conn', _ScuolaDigitaleInfoConn2.default);
	
	tools.push({
	  name: 'gv-genio-localizza-button'
	});
	
	_vue2.default.component('gv-genio-localizza-button', _GenioLocalizza2.default);
	
	tools.push({
	  name: 'gv-genio-seleziona-particelle-button'
	});
	
	_vue2.default.component('gv-genio-seleziona-particelle-button', _GenioSelezionaParticelle2.default);
	
	tools.push({
	  name: 'gv-button-genio-conferma-load-shape'
	});
	
	_vue2.default.component('gv-button-genio-conferma-load-shape', _GenioConfermaLoadShape2.default);
	
	tools.push({
	  name: 'gv-cem-elaborazioni-button'
	});
	
	_vue2.default.component('gv-cem-elaborazioni-button', _CemElaborazioni2.default);
	
	tools.push({
	  name: 'gv-back-button'
	});
	
	_vue2.default.component('gv-back-button', _Back2.default);
	
	tools.push({
	  name: 'gv-fototeca-voli'
	});
	
	_vue2.default.component('gv-fototeca-voli', _FototecaVoli2.default);
	
	tools.push({ name: 'gv-fototeca-carrello-button' });
	
	_vue2.default.component('gv-fototeca-carrello-button', _FototecaCarrello2.default);
	
	tools.push({ name: 'gv-fototeca-scheda-volo-button' });
	
	_vue2.default.component('gv-fototeca-scheda-volo-button', _FototecaSchedaVolo2.default);
	
	tools.push({ name: 'gv-fototeca-selezione-territoriale-button' });
	
	_vue2.default.component('gv-fototeca-selezione-territoriale-button', _FototecaSelezioneTerritoriale2.default);
	
	tools.push({ name: 'gv-genio-pratiche-collegate-button' });
	
	_vue2.default.component('gv-genio-pratiche-collegate-button', _GenioPraticheCollegate2.default);
	
	tools.push({
	  name: 'rqa-livelli'
	});
	
	_vue2.default.component('rqa-livelli', _RqaLivelli2.default);
	
	tools.push({
	  name: 'libioss-specie'
	});
	
	_vue2.default.component('libioss-specie', _LibiossSpecie2.default);
	
	tools.push({
	  name: 'difesa-suolo-foto'
	});
	
	_vue2.default.component('difesa-suolo-foto', _DifesaSuoloFoto2.default);
	tools.push({
	  name: 'gv-difesa-suolo-foto-info'
	});
	
	_vue2.default.component('gv-difesa-suolo-foto-info', _DifesaSuoloFotoInfo2.default);
	tools.push({
	  name: 'gv-difesa-suolo-foto-log'
	});
	
	_vue2.default.component('gv-difesa-suolo-foto-log', _DifesaSuoloFotoLog2.default);
	
	tools.push({ name: 'gv-switch3D-button' });
	
	_vue2.default.component('gv-switch3D-button', _Switch3D2.default);
	
	tools.push({ name: 'gv-help3D-button' });
	
	_vue2.default.component('gv-help3D-button', _Help3D2.default);
	
	tools.push({ name: 'gv-help-button' });
	
	_vue2.default.component('gv-help-button', _Help2.default);
	
	tools.push({ name: 'gv-insert-point-button' });
	
	_vue2.default.component('gv-insert-point-button', _InsertPoint2.default);
	
	tools.push({
	  name: 'gv-cultura-legend'
	});
	
	_vue2.default.component('gv-cultura-legend', _CulturaLegend2.default);
	tools.push({
	  name: 'gv-cultura-info'
	});
	
	_vue2.default.component('gv-cultura-info', _CulturaInfo2.default);
	
	tools.push({
	  name: 'gv-cdu-seleziona-particelle-button'
	});
	
	_vue2.default.component('gv-cdu-seleziona-particelle-button', _CduSelezionaParticelle2.default);
	
	exports.default = tools;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var map = (0, _getUrlParam2.default)('FIND_MAP') || (0, _getUrlParam2.default)('ID') || (0, _getUrlParam2.default)('id');
	  var layers = (0, _getUrlParam2.default)('FIND_LAYERS') ? (0, _getUrlParam2.default)('FIND_LAYERS').split(',') : null;
	  var fields = (0, _getUrlParam2.default)('FIND_FIELDS');
	  var values = (0, _getUrlParam2.default)('FIND_VALUES');
	  var cqlFilter = (0, _getUrlParam2.default)('FIND_CQL_FILTER');
	  return {
	    map: map,
	    layers: layers,
	    fields: fields,
	    values: values,
	    cqlFilter: cqlFilter
	  };
	};
	
	var _getUrlParam = __webpack_require__(172);
	
	var _getUrlParam2 = _interopRequireDefault(_getUrlParam);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var startpos = null;
	
	window.document.body.setAttribute('ondrop', 'GV.dragbox.drop(event)');
	
	exports.default = {
	  start: function start(ev) {
	    startpos = [ev.screenX, ev.screenY];
	    ev.dataTransfer.setData('text/plain', ev.target.id);
	  },
	  end: function end(ev, elId) {
	    var el = document.getElementById(elId);
	    var style = window.getComputedStyle(el, null);
	    var endpos = [ev.screenX, ev.screenY];
	    el.style.top = Number(style.top.replace('px', '')) + (endpos[1] - startpos[1]) + 'px';
	    el.style.left = Number(style.left.replace('px', '')) + (endpos[0] - startpos[0]) + 'px';
	  },
	  drop: function drop(ev) {
	    if (ev.target.type === 'text') {
	      ev.preventDefault();
	    }
	  }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getProtocol;
	function getProtocol() {
	  'use strict';
	
	  return window.location.href.split(':')[0];
	}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (str, data) {
	  var templateRe = /\{ *([\w_\-]+) *\}/g;
	  return str.replace(templateRe, function (str, key) {
	    var value = data[key];
	
	    if (value === undefined) {
	      throw new Error('No value provided for variable ' + str);
	    } else if (typeof value === 'function') {
	      value = value(data);
	    }
	    return value;
	  });
	};

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	function log(msg) {
	  if (GV.config.debug) {
	    console.log(msg);
	  }
	}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stringFormat;
	
	var tokenRegEx = /\$\{([\w.]+?)\}/g;
	
	function stringFormat(template, context, args) {
	  var replacer = function replacer(str, match) {
	    var replacement;
	
	    var subs = match.split(/\.+/);
	    for (var i = 0; i < subs.length; i++) {
	      if (i == 0) {
	        replacement = context;
	      }
	
	      replacement = replacement[subs[i]];
	    }
	
	    if (typeof replacement == 'function') {
	      replacement = args ? replacement.apply(null, args) : replacement();
	    }
	
	    if (typeof replacement == 'undefined') {
	      return 'undefined';
	    } else {
	      return replacement;
	    }
	  };
	
	  return template.replace(tokenRegEx, replacer);
	}

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */,
/* 558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */,
/* 561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */,
/* 563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */,
/* 566 */,
/* 567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */,
/* 569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */,
/* 573 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */,
/* 584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */,
/* 602 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */,
/* 607 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */,
/* 609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */,
/* 626 */,
/* 627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */,
/* 636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */,
/* 646 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */,
/* 649 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */,
/* 658 */,
/* 659 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */,
/* 674 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */,
/* 676 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */,
/* 683 */,
/* 684 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(677);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(199)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!./../../../node_modules/vue-style-loader/index.js!./../../../node_modules/css-loader/index.js?sourceMap!./base.css", function() {
				var newContent = require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!./../../../node_modules/vue-style-loader/index.js!./../../../node_modules/css-loader/index.js?sourceMap!./base.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(586)
	
	/* script */
	__vue_exports__ = __webpack_require__(249)
	
	/* template */
	var __vue_template__ = __webpack_require__(841)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(571)
	__webpack_require__(570)
	
	/* script */
	__vue_exports__ = __webpack_require__(250)
	
	/* template */
	var __vue_template__ = __webpack_require__(827)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-186c5b53"
	
	module.exports = __vue_exports__


/***/ }),
/* 719 */,
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(644)
	
	/* script */
	__vue_exports__ = __webpack_require__(252)
	
	/* template */
	var __vue_template__ = __webpack_require__(888)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-75b8b42e"
	
	module.exports = __vue_exports__


/***/ }),
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(600)
	
	/* script */
	__vue_exports__ = __webpack_require__(256)
	
	/* template */
	var __vue_template__ = __webpack_require__(853)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 725 */,
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(671)
	__webpack_require__(670)
	
	/* script */
	__vue_exports__ = __webpack_require__(258)
	
	/* template */
	var __vue_template__ = __webpack_require__(908)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c5de5840"
	
	module.exports = __vue_exports__


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(558)
	
	/* script */
	__vue_exports__ = __webpack_require__(260)
	
	/* template */
	var __vue_template__ = __webpack_require__(816)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 728 */,
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(585)
	
	/* script */
	__vue_exports__ = __webpack_require__(262)
	
	/* template */
	var __vue_template__ = __webpack_require__(840)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(660)
	__webpack_require__(659)
	
	/* script */
	__vue_exports__ = __webpack_require__(263)
	
	/* template */
	var __vue_template__ = __webpack_require__(900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9d6c6290"
	
	module.exports = __vue_exports__


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(636)
	
	/* script */
	__vue_exports__ = __webpack_require__(264)
	
	/* template */
	var __vue_template__ = __webpack_require__(882)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(609)
	
	/* script */
	__vue_exports__ = __webpack_require__(271)
	
	/* template */
	var __vue_template__ = __webpack_require__(862)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e584568"
	
	module.exports = __vue_exports__


/***/ }),
/* 738 */,
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(605)
	
	/* script */
	__vue_exports__ = __webpack_require__(274)
	
	/* template */
	var __vue_template__ = __webpack_require__(858)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-49a48e71"
	
	module.exports = __vue_exports__


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(623)
	
	/* script */
	__vue_exports__ = __webpack_require__(275)
	
	/* template */
	var __vue_template__ = __webpack_require__(872)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-575350c1"
	
	module.exports = __vue_exports__


/***/ }),
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(573)
	
	/* script */
	__vue_exports__ = __webpack_require__(280)
	
	/* template */
	var __vue_template__ = __webpack_require__(829)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1bcdfb88"
	
	module.exports = __vue_exports__


/***/ }),
/* 746 */,
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(599)
	
	/* script */
	__vue_exports__ = __webpack_require__(282)
	
	/* template */
	var __vue_template__ = __webpack_require__(852)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-40ca8980"
	
	module.exports = __vue_exports__


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(581)
	
	/* script */
	__vue_exports__ = __webpack_require__(283)
	
	/* template */
	var __vue_template__ = __webpack_require__(836)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2b5510d5"
	
	module.exports = __vue_exports__


/***/ }),
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(594)
	
	/* script */
	__vue_exports__ = __webpack_require__(290)
	
	/* template */
	var __vue_template__ = __webpack_require__(848)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3b64f109"
	
	module.exports = __vue_exports__


/***/ }),
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(661)
	
	/* script */
	__vue_exports__ = __webpack_require__(296)
	
	/* template */
	var __vue_template__ = __webpack_require__(901)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(656)
	
	/* script */
	__vue_exports__ = __webpack_require__(297)
	
	/* template */
	var __vue_template__ = __webpack_require__(898)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(643)
	__webpack_require__(642)
	
	/* script */
	__vue_exports__ = __webpack_require__(299)
	
	/* template */
	var __vue_template__ = __webpack_require__(887)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-757c852c"
	
	module.exports = __vue_exports__


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(674)
	
	/* script */
	__vue_exports__ = __webpack_require__(300)
	
	/* template */
	var __vue_template__ = __webpack_require__(911)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d6e32478"
	
	module.exports = __vue_exports__


/***/ }),
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(647)
	__webpack_require__(646)
	
	/* script */
	__vue_exports__ = __webpack_require__(314)
	
	/* template */
	var __vue_template__ = __webpack_require__(890)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-761d5d3a"
	
	module.exports = __vue_exports__


/***/ }),
/* 777 */,
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(652)
	
	/* script */
	__vue_exports__ = __webpack_require__(316)
	
	/* template */
	var __vue_template__ = __webpack_require__(895)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7f9b7ad1"
	
	module.exports = __vue_exports__


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(663)
	__webpack_require__(662)
	
	/* script */
	__vue_exports__ = __webpack_require__(318)
	
	/* template */
	var __vue_template__ = __webpack_require__(902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a9b27da4"
	
	module.exports = __vue_exports__


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(664)
	
	/* script */
	__vue_exports__ = __webpack_require__(319)
	
	/* template */
	var __vue_template__ = __webpack_require__(903)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(676)
	
	/* script */
	__vue_exports__ = __webpack_require__(323)
	
	/* template */
	var __vue_template__ = __webpack_require__(913)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(640)
	__webpack_require__(639)
	
	/* script */
	__vue_exports__ = __webpack_require__(324)
	
	/* template */
	var __vue_template__ = __webpack_require__(885)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-71b34ef7"
	
	module.exports = __vue_exports__


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(559)
	
	/* script */
	__vue_exports__ = __webpack_require__(326)
	
	/* template */
	var __vue_template__ = __webpack_require__(817)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(574)
	
	/* script */
	__vue_exports__ = __webpack_require__(327)
	
	/* template */
	var __vue_template__ = __webpack_require__(830)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(622)
	
	/* script */
	__vue_exports__ = __webpack_require__(328)
	
	/* template */
	var __vue_template__ = __webpack_require__(871)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(563)
	
	/* script */
	__vue_exports__ = __webpack_require__(329)
	
	/* template */
	var __vue_template__ = __webpack_require__(821)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(672)
	
	/* script */
	__vue_exports__ = __webpack_require__(330)
	
	/* template */
	var __vue_template__ = __webpack_require__(909)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(567)
	
	/* script */
	__vue_exports__ = __webpack_require__(331)
	
	/* template */
	var __vue_template__ = __webpack_require__(824)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(637)
	
	/* script */
	__vue_exports__ = __webpack_require__(332)
	
	/* template */
	var __vue_template__ = __webpack_require__(883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(564)
	
	/* script */
	__vue_exports__ = __webpack_require__(333)
	
	/* template */
	var __vue_template__ = __webpack_require__(822)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(624)
	
	/* script */
	__vue_exports__ = __webpack_require__(334)
	
	/* template */
	var __vue_template__ = __webpack_require__(873)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(575)
	
	/* script */
	__vue_exports__ = __webpack_require__(335)
	
	/* template */
	var __vue_template__ = __webpack_require__(831)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(556)
	
	/* script */
	__vue_exports__ = __webpack_require__(336)
	
	/* template */
	var __vue_template__ = __webpack_require__(814)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(593)
	
	/* script */
	__vue_exports__ = __webpack_require__(337)
	
	/* template */
	var __vue_template__ = __webpack_require__(847)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(582)
	
	/* script */
	__vue_exports__ = __webpack_require__(338)
	
	/* template */
	var __vue_template__ = __webpack_require__(837)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(584)
	
	/* script */
	__vue_exports__ = __webpack_require__(339)
	
	/* template */
	var __vue_template__ = __webpack_require__(839)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(555)
	
	/* script */
	__vue_exports__ = __webpack_require__(340)
	
	/* template */
	var __vue_template__ = __webpack_require__(813)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(638)
	
	/* script */
	__vue_exports__ = __webpack_require__(341)
	
	/* template */
	var __vue_template__ = __webpack_require__(884)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(641)
	
	/* script */
	__vue_exports__ = __webpack_require__(342)
	
	/* template */
	var __vue_template__ = __webpack_require__(886)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(665)
	
	/* script */
	__vue_exports__ = __webpack_require__(343)
	
	/* template */
	var __vue_template__ = __webpack_require__(904)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(569)
	
	/* script */
	__vue_exports__ = __webpack_require__(344)
	
	/* template */
	var __vue_template__ = __webpack_require__(826)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(561)
	
	/* script */
	__vue_exports__ = __webpack_require__(345)
	
	/* template */
	var __vue_template__ = __webpack_require__(819)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(607)
	
	/* script */
	__vue_exports__ = __webpack_require__(346)
	
	/* template */
	var __vue_template__ = __webpack_require__(860)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(589)
	
	/* script */
	__vue_exports__ = __webpack_require__(347)
	
	/* template */
	var __vue_template__ = __webpack_require__(844)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(649)
	
	/* script */
	__vue_exports__ = __webpack_require__(348)
	
	/* template */
	var __vue_template__ = __webpack_require__(892)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(588)
	
	/* script */
	__vue_exports__ = __webpack_require__(349)
	
	/* template */
	var __vue_template__ = __webpack_require__(843)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(634)
	
	/* script */
	__vue_exports__ = __webpack_require__(350)
	
	/* template */
	var __vue_template__ = __webpack_require__(880)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(602)
	
	/* script */
	__vue_exports__ = __webpack_require__(351)
	
	/* template */
	var __vue_template__ = __webpack_require__(855)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 811 */,
/* 812 */,
/* 813 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-geocoder-btn",
	      "title": "Ricerca Indirizzo"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-genio-conferma-load-shape",
	      "title": "Conferma"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 815 */,
/* 816 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return (_vm.visible) ? _vm._c('div', {
	    staticClass: "gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-cultura-legend"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-cultura-legend-title gv-color-scheme",
	    attrs: {
	      "id": "gv-cultura-legend-title"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Nascondi Legenda"
	    },
	    on: {
	      "click": _vm.hideLegend
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-cultura-legend-wrapper",
	    attrs: {
	      "id": "gv-cultura-legend-wrapper"
	    }
	  }, [_vm._c('div', [_vm._c('div', {
	    staticClass: "gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-cultura-legend-body"
	    }
	  }, [_vm._c('gv-cultura-legend-maps', {
	    attrs: {
	      "options": _vm.options
	    }
	  })], 1)])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-add-map",
	      "title": "Aggiungi Mappe"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 818 */,
/* 819 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-layer-search",
	      "title": "Ricerca sui Livelli"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 820 */,
/* 821 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-cem-elaborazioni",
	      "title": "Lista Elaborazioni"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-fototeca-carrello",
	      "title": "Carrello"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 823 */,
/* 824 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-download-totale-button",
	      "title": "Download"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 825 */,
/* 826 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-insert-point",
	      "title": "Localizza Punto"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "atlante-geochimico gv-color-scheme"
	  }, [_vm._c('div', {
	    staticClass: "ag-title gv-color-scheme",
	    attrs: {
	      "id": "ag-title"
	    }
	  }, [_vm._v("\n    Atlante Geochimico\n    "), _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Nascondi Pannello"
	    },
	    on: {
	      "click": _vm.hidePanel
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "ag-wrapper gv-color-scheme",
	    attrs: {
	      "id": "ag-wrapper"
	    }
	  }, [_vm._c('el-select', {
	    attrs: {
	      "placeholder": "Seleziona Elemento",
	      "filterable": "",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.livello),
	      callback: function($$v) {
	        _vm.livello = $$v
	      },
	      expression: "livello"
	    }
	  }, _vm._l((_vm.livelli), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.title
	      }
	    }, [_vm._c('span', {
	      staticStyle: {
	        "font-size": "16px"
	      }
	    }, [_vm._v(_vm._s(item.title))])])
	  })), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showLegend),
	      expression: "showLegend"
	    }],
	    staticClass: "ag-legend"
	  }, [_vm._c('gv-iframe-panel', {
	    staticClass: "gv-iframe-panel",
	    attrs: {
	      "src": _vm.legendUrl,
	      "height": "237",
	      "width": "249"
	    }
	  })], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 828 */,
/* 829 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('el-select', {
	    staticClass: "gv-geocoder",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "remote": "",
	      "size": "mini",
	      "placeholder": "Ricerca Indirizzo...",
	      "remote-method": _vm.remoteMethod,
	      "loading": _vm.loading,
	      "loading-text": "Caricamento... ",
	      "no-match-text": "Nessun indirizzo trovato",
	      "no-data-text": "Nessun indirizzo trovato",
	      "id": "gv-geocoder"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.address),
	      callback: function($$v) {
	        _vm.address = $$v
	      },
	      expression: "address"
	    }
	  }, _vm._l((_vm.results), function(item) {
	    return _vm._c('el-option', {
	      key: item.value,
	      staticClass: "gv-geocoder-options",
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-back",
	      "title": "Ritorno"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-fototeca-selezione-territoriale",
	      "title": "Selezione Territoriale"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    style: (_vm.style),
	    attrs: {
	      "id": "gv-header"
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-genio-pratiche-collegate",
	      "title": "Genio Pratiche Collegate"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 838 */,
/* 839 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-genio-seleziona-particelle",
	      "title": "Seleziona Particelle"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto",
	    attrs: {
	      "id": "gv-difesa-suolo-foto"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-title gv-color-scheme"
	  }, [_vm._v("\n    Difesa Suolo: Caricamento Foto\n    "), _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Nascondi Pannello"
	    },
	    on: {
	      "click": _vm.hidePanel
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-wrapper gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-wrapper"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-body gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-body"
	    }
	  }, [_vm._c('div', {
	    attrs: {
	      "id": "gv-difesa-suolo-foto-div"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-session"
	  }, [_vm._v("SESSIONE: " + _vm._s(_vm.session))]), _vm._v(" "), _vm._c('el-form', {
	    ref: "dsf-form",
	    attrs: {
	      "model": _vm.dsfForm
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-upload"
	  }, [_vm._c('el-form-item', [_vm._c('el-upload', {
	    ref: "dsfUpload",
	    attrs: {
	      "action": _vm.url,
	      "limit": 20,
	      "drag": "",
	      "file-list": _vm.dsfForm.fileList,
	      "auto-upload": false,
	      "on-success": _vm.onUploadSuccess,
	      "on-exceed": _vm.handleExceed,
	      "multiple": "",
	      "list-type": "picture"
	    }
	  }, [_vm._c('i', {
	    staticClass: "el-icon-upload"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "el-upload__text"
	  }, [_vm._v("\n                  Trascina qui i file o seleziona per upload "), _vm._c('br'), _vm._v("\n                  Limite massimo 20 file\n                ")])])], 1)], 1)])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-button"
	  }, [_vm._c('el-button', {
	    staticClass: "gv-map-catalog-button",
	    attrs: {
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.submitFoto
	    }
	  }, [_vm._v("Carica i file")]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-map-catalog-button",
	    attrs: {
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.clear
	    }
	  }, [_vm._v("Pulisci coda")]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-map-catalog-button",
	    attrs: {
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.validateAll
	    }
	  }, [_vm._v("Valida tutto")]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-map-catalog-button-log",
	    attrs: {
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.openLogPanel
	    }
	  }, [_vm._v("Log")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "gv-container"
	    }
	  }, [(_vm.showHeader) ? _vm._c('gv-header') : _vm._e(), _vm._v(" "), _vm._c('gv-map', {
	    ref: "gv-map"
	  }), _vm._v(" "), (_vm.showLegend) ? _vm._c('gv-legend', {
	    ref: "gv-legend"
	  }) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-tool-container"
	  }, [_vm._c('div', {
	    staticClass: "gv-tool-top gv-tool-left",
	    attrs: {
	      "id": "gv-tool-topleft"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-tool-top gv-tool-right",
	    attrs: {
	      "id": "gv-tool-topright"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-tool-bottom gv-tool-left",
	    attrs: {
	      "id": "gv-tool-bottomleft"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-tool-bottom gv-tool-right",
	    attrs: {
	      "id": "gv-tool-bottomright"
	    }
	  })])
	}]}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-panel-title gv-color-scheme"
	  }, [_vm._c('span', {
	    staticClass: "gv-color-scheme",
	    attrs: {
	      "title": _vm.fullTitle
	    }
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.noClose) ? _vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-close",
	      "type": "button",
	      "title": "Chiudi Panello"
	    },
	    on: {
	      "click": _vm.closePanel
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.collapsible) ? _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Mostra/Nascondi Pannello"
	    },
	    on: {
	      "click": _vm.collapse
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-ricerca-particella",
	      "title": "Ricerca Particella Catastale"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-measure",
	      "title": _vm.title
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 845 */,
/* 846 */,
/* 847 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-genio-localizza",
	      "title": "Localizzazione"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.html)
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('el-select', {
	    staticClass: "gv-geocoder",
	    attrs: {
	      "filterable": "",
	      "clearable": "",
	      "remote": "",
	      "size": "mini",
	      "placeholder": "Ricerca Indirizzo...",
	      "remote-method": _vm.remoteMethod,
	      "loading": _vm.loading,
	      "loading-text": "Caricamento... ",
	      "no-match-text": "Nessun indirizzo trovato",
	      "no-data-text": "Nessun indirizzo trovato",
	      "id": "gv-geocoder-pelias"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.address),
	      callback: function($$v) {
	        _vm.address = $$v
	      },
	      expression: "address"
	    }
	  }, _vm._l((_vm.results), function(item) {
	    return _vm._c('el-option', {
	      key: item.value,
	      staticClass: "gv-geocoder-options",
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('el-dialog', {
	    attrs: {
	      "width": "50%",
	      "title": "Avvertenze",
	      "visible": _vm.dialogVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogVisible = $event
	      }
	    }
	  }, [_vm._c('div', [_vm._v("\n    Prima di proseguire è necessario visualizzare le\n    "), _vm._c('a', {
	    attrs: {
	      "href": _vm.link,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(". "), _vm._c('br'), _vm._c('br'), _vm._v("\n    Cliccando su\n    "), _vm._c('span', {
	    staticStyle: {
	      "color": "#00377c"
	    }
	  }, [_vm._c('b', [_vm._v("\"Accetto\"")])]), _vm._v("\n    l’utente dichiara di aver preso visione dell’avviso.\n  ")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('span', [_vm._c('el-checkbox', {
	    on: {
	      "change": _vm.toggleSubmit
	    }
	  }, [_vm._v("Dichiaro di aver preso visione delle Avvertenze")])], 1), _vm._v(" "), _vm._c('span', {
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_vm._c('el-button', {
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._c('span', {
	    staticStyle: {
	      "color": "#00377c",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Annulla")])]), _vm._v(" "), _vm._c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.submitDisabled
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._c('span', {
	    staticStyle: {
	      "color": "#ffffff",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Accetto")])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 854 */,
/* 855 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    staticClass: "gv-button",
	    attrs: {
	      "id": "gv-button-switch3D",
	      "title": "Switch3D"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n")])
	},staticRenderFns: []}

/***/ }),
/* 856 */,
/* 857 */,
/* 858 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('el-select', {
	    staticClass: "gv-fototeca-voli",
	    attrs: {
	      "filterable": "",
	      "remote": "",
	      "size": "mini",
	      "placeholder": "Seleziona un volo...",
	      "id": "gv-fototeca-voli"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.volo),
	      callback: function($$v) {
	        _vm.volo = $$v
	      },
	      expression: "volo"
	    }
	  }, _vm._l((_vm.voli), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      staticClass: "gv-fototeca-voli-options",
	      attrs: {
	        "label": item.nome,
	        "value": item.id
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),
/* 859 */,
/* 860 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-layer-search-topo",
	      "title": "Ricerche sui Livelli"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 861 */,
/* 862 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-fototeca-immagine gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-fototeca-immagine"
	    }
	  }, [_vm._c('gv-title', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    attrs: {
	      "title": _vm.title,
	      "divId": 'gv-fototeca-immagine'
	    }
	  }), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-color-scheme gv-button-fototeca-immagine-carrello",
	    attrs: {
	      "id": "gv-button-fototeca-immagine-carrello",
	      "icon": "el-icon-circle-plus-outline",
	      "title": "Aggiungi al Carrello",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.addToBasket
	    }
	  }, [_vm._v("Aggiungi al Carrello")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-fototeca-immagine-body",
	    attrs: {
	      "id": "gv-fototeca-immagine-body"
	    }
	  }, [_vm._c('image-viewer', {
	    attrs: {
	      "imgUrl": _vm.imgUrl,
	      "logo": _vm.logo,
	      "width": "400",
	      "height": "400"
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-cultura-info-gallery gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-cultura-info-gallery"
	    }
	  }, [_vm._c('div', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    staticClass: "gv-cultura-info-title gv-color-scheme",
	    attrs: {
	      "id": "gv-cultura-info-gallery-title"
	    }
	  }, [_vm._c('strong', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-close",
	      "type": "button",
	      "title": "Chiudi Panello"
	    },
	    on: {
	      "click": _vm.closePanel
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-cultura-info-gallery-body",
	    attrs: {
	      "id": "gv-cultura-info-gallery-body"
	    }
	  }, [_vm._c('el-carousel', {
	    attrs: {
	      "type": "card",
	      "interval": _vm.interval,
	      "autoplay": _vm.autoplay,
	      "indicator-position": "none",
	      "arrow": "never"
	    }
	  }, _vm._l((_vm.gallery), function(item) {
	    return _vm._c('el-carousel-item', {
	      key: item.id
	    }, [_vm._c('div', [_vm._c('div', {
	      staticClass: "item"
	    }, [_vm._c('div', {
	      staticClass: "item__content",
	      attrs: {
	        "title": item.text
	      }
	    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")]), _vm._v(" "), _vm._c('img', {
	      staticStyle: {
	        "width": "100%",
	        "height": "auto"
	      },
	      attrs: {
	        "src": item.imgUrl,
	        "title": item.text,
	        "alt": item.text
	      }
	    })])])])
	  }))], 1)])
	},staticRenderFns: []}

/***/ }),
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-cdu-seleziona-particelle",
	      "title": "Cdu Seleziona Particelle"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-gas gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-gas"
	    }
	  }, [_vm._c('gv-title', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    attrs: {
	      "title": _vm.title,
	      "divId": 'gv-gas',
	      "noClose": true,
	      "collapsible": 'gv-gas-body'
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-gas-body",
	    attrs: {
	      "id": "gv-gas-body"
	    }
	  }, [_vm._c('el-select', {
	    staticClass: "gv-gas-combo",
	    attrs: {
	      "placeholder": "Seleziona Area",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeArea
	    },
	    model: {
	      value: (_vm.area),
	      callback: function($$v) {
	        _vm.area = $$v
	      },
	      expression: "area"
	    }
	  }, _vm._l((_vm.aree), function(item) {
	    return _vm._c('el-option', {
	      key: item.codice,
	      attrs: {
	        "value": item.codice,
	        "label": item.descrizione
	      }
	    })
	  })), _vm._v(" "), _vm._c('el-select', {
	    staticClass: "gv-gas-combo",
	    attrs: {
	      "placeholder": "Seleziona Modulo",
	      "size": "mini"
	    },
	    model: {
	      value: (_vm.modulo),
	      callback: function($$v) {
	        _vm.modulo = $$v
	      },
	      expression: "modulo"
	    }
	  }, _vm._l((_vm.moduli), function(item) {
	    return _vm._c('el-option', {
	      key: item.codice,
	      attrs: {
	        "value": item.codice,
	        "label": item.descrizione
	      }
	    })
	  })), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-gas-checkbox"
	  }, [_vm._c('el-checkbox', {
	    model: {
	      value: (_vm.soloPostiDisponibili),
	      callback: function($$v) {
	        _vm.soloPostiDisponibili = $$v
	      },
	      expression: "soloPostiDisponibili"
	    }
	  }, [_vm._v("Solo strutture con posti disponibili")])], 1), _vm._v(" "), _vm._c('el-select', {
	    staticClass: "gv-gas-combo",
	    attrs: {
	      "placeholder": "Seleziona Provincia",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeProvincia
	    },
	    model: {
	      value: (_vm.provincia),
	      callback: function($$v) {
	        _vm.provincia = $$v
	      },
	      expression: "provincia"
	    }
	  }, _vm._l((_vm.province), function(item) {
	    return _vm._c('el-option', {
	      key: item.codice,
	      attrs: {
	        "value": item.codice,
	        "label": item.descrizione
	      }
	    })
	  })), _vm._v(" "), _vm._c('el-select', {
	    staticClass: "gv-gas-combo",
	    attrs: {
	      "placeholder": "Seleziona ASL",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeASL
	    },
	    model: {
	      value: (_vm.asl),
	      callback: function($$v) {
	        _vm.asl = $$v
	      },
	      expression: "asl"
	    }
	  }, _vm._l((_vm.listaAsl), function(item) {
	    return _vm._c('el-option', {
	      key: item.codice,
	      attrs: {
	        "value": item.codice,
	        "label": item.descrizione
	      }
	    })
	  })), _vm._v(" "), _vm._c('el-button', {
	    attrs: {
	      "id": "gv-gas-submit",
	      "type": "primary",
	      "size": "mini",
	      "icon": "el-icon-search"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Visualizza")]), _vm._v(" "), _vm._c('el-button', {
	    attrs: {
	      "id": "gv-gas-elenco",
	      "type": "primary",
	      "size": "mini",
	      "icon": "el-icon-document"
	    },
	    on: {
	      "click": _vm.elenco
	    }
	  }, [_vm._v("Elenco Strutture")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-fototeca-scheda-volo",
	      "title": "Scheda Volo"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 874 */,
/* 875 */,
/* 876 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    directives: [{
	      name: "bar",
	      rawName: "v-bar"
	    }]
	  }, [_vm._c('div', {
	    attrs: {
	      "id": "gv-legend-maps"
	    }
	  }, _vm._l((_vm.maps), function(map) {
	    return _vm._c('ul', {
	      key: map.id,
	      staticClass: "gv-list-group"
	    }, [_vm._c('div', {
	      staticClass: "gv-list-legend-map-item gv-inverted-color-scheme"
	    }, [_vm._c('li', [_vm._v(_vm._s(map.name))]), _vm._v(" "), _vm._c('div', {
	      staticClass: "gv-legend-map-tools gv-inverted-color-scheme"
	    }, [(!_vm.options.noToggleLayers) ? _vm._c('el-button', {
	      class: _vm.getToggleLayersClass(map),
	      attrs: {
	        "title": "Mostra/Nascondi Livelli in Legenda",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          _vm.toggleLayers(map)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.checkInfoMap(map)) ? _vm._c('el-button', {
	      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
	      attrs: {
	        "id": 'gv-legend-scheda-' + map.id,
	        "title": "Visualizza Scheda",
	        "icon": "el-icon-document",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          _vm.showMapInfoPanel(map)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.options.noDeleteButton) ? _vm._c('el-button', {
	      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
	      attrs: {
	        "id": 'gv-legend-delete-' + map.id,
	        "title": "Elimina Mappa",
	        "icon": "el-icon-delete",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          _vm.remove(map)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.options.showLayersTransparency) ? _vm._c('el-button', {
	      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
	      attrs: {
	        "id": 'gv-legend-transparency-' + map.id,
	        "title": "Trasparenza Livelli",
	        "icon": "el-icon-setting",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          _vm.layerTransparency(map)
	        }
	      }
	    }) : _vm._e(), _vm._v(" "), (_vm.isDownloadable(map)) ? _vm._c('el-button', {
	      staticClass: "gv-inverted-color-scheme gv-legend-map-tools-button",
	      attrs: {
	        "id": 'gv-legend-download-' + map.id,
	        "title": "Download Mappa",
	        "icon": "el-icon-download",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          _vm.download(map)
	        }
	      }
	    }) : _vm._e()], 1)]), _vm._v(" "), _vm._c('gv-legend-layers', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.showMapLayers(map)),
	        expression: "showMapLayers(map)"
	      }],
	      attrs: {
	        "map": map,
	        "options": _vm.options
	      }
	    })], 1)
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-ricerca-catastale",
	      "title": "Ricerche Catastali"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 881 */,
/* 882 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-log",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-log"
	    }
	  }, [_vm._c('div', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    staticClass: "gv-difesa-suolo-foto-log-title gv-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-log-title"
	    }
	  }, [_vm._v("\n    Difesa Suolo: LOG ERRORI\n    "), _vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-close",
	      "type": "button",
	      "title": "Chiudi Panello",
	      "alt": "Chiudi Panello"
	    },
	    on: {
	      "click": _vm.closePanel
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-log-wrapper gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-log-wrapper"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-log-body gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-log-body"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-log-select"
	  }, [_vm._c('b', [_vm._v("SESSIONE")]), _vm._v(" "), _vm._c('el-select', {
	    attrs: {
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.sel_session),
	      callback: function($$v) {
	        _vm.sel_session = $$v
	      },
	      expression: "sel_session"
	    }
	  }, _vm._l((_vm.sessions), function(item) {
	    return _vm._c('el-option', {
	      key: item.session,
	      attrs: {
	        "value": item.session,
	        "label": item.session
	      }
	    }, [_vm._c('span', {
	      staticStyle: {
	        "font-size": "16px"
	      }
	    }, [_vm._v(_vm._s(item.session))])])
	  }))], 1), _vm._v(" "), _vm._c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "empty-text": "Nessun Log",
	      "data": _vm.sel_logs,
	      "size": "mini"
	    }
	  }, [_vm._c('el-table-column', {
	    attrs: {
	      "label": "Nome Foto",
	      "width": "150"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(" " + _vm._s(scope.row.file_name) + " ")]
	      }
	    }])
	  }), _vm._v(" "), _vm._c('el-table-column', {
	    attrs: {
	      "label": "Errore",
	      "width": "200"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v(" " + _vm._s(scope.row.errore) + " ")]
	      }
	    }])
	  })], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-draw",
	      "title": _vm.title
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-help-aib",
	      "title": "Help"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-map-selezione-fogli gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-map-selezione-fogli"
	    }
	  }, [_vm._c('gv-title', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    attrs: {
	      "title": _vm.title,
	      "divId": 'gv-map-selezione-fogli',
	      "noClose": true,
	      "collapsible": 'gv-map-selezione-fogli-body'
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-map-selezione-fogli-body",
	    attrs: {
	      "id": "gv-map-selezione-fogli-body"
	    }
	  }, [_vm._c('el-select', {
	    attrs: {
	      "size": "mini",
	      "multiple": "",
	      "collapse-tags": "",
	      "placeholder": "Seleziona"
	    },
	    model: {
	      value: (_vm.fogli),
	      callback: function($$v) {
	        _vm.fogli = $$v
	      },
	      expression: "fogli"
	    }
	  }, _vm._l((_vm.config.fogli), function(item) {
	    return _vm._c('el-option', {
	      key: item.codice,
	      attrs: {
	        "value": item.codice,
	        "label": item.nome
	      }
	    })
	  })), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-map-selezione-fogli-buttons"
	  }, [_vm._c('el-button', {
	    attrs: {
	      "id": "gv-map-selezione-fogli-submit",
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Conferma")]), _vm._v(" "), _vm._c('el-button', {
	    attrs: {
	      "id": "gv-map-selezione-fogli-cancel",
	      "type": "primary",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("Annulla")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-help3D-button",
	      "title": "Help Navigazione 3D"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "libioss gv-color-scheme"
	  }, [_vm._c('div', {
	    staticClass: "libioss-title gv-color-scheme"
	  }, [_vm._v("\n    Libioss - Distribuzione specie animali\n    "), _vm._v(" "), _vm._c('button', {
	    staticClass: "gv-color-scheme libioss-download-button el-icon-download",
	    attrs: {
	      "id": "libioss-download-button",
	      "title": "Download Dati",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.download
	    }
	  }), _vm._v(" "), _vm._c('button', {
	    staticClass: "gv-color-scheme libioss-download-button el-icon-files",
	    attrs: {
	      "id": "libioss-download-button",
	      "title": "Gestione Livelli",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.layerMngr
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "libioss-wrapper gv-color-scheme",
	    attrs: {
	      "id": "libioss-wrapper"
	    }
	  }, [_vm._c('div', {
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "placeholder": "Seleziona Gruppo",
	      "size": "mini",
	      "filterable": ""
	    },
	    on: {
	      "change": _vm.onChangeGruppo
	    },
	    model: {
	      value: (_vm.gruppo),
	      callback: function($$v) {
	        _vm.gruppo = $$v
	      },
	      expression: "gruppo"
	    }
	  }, _vm._l((_vm.gruppi), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.label
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSpecie),
	      expression: "showSpecie"
	    }],
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Seleziona Specie",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeSpecie
	    },
	    model: {
	      value: (_vm.specie),
	      callback: function($$v) {
	        _vm.specie = $$v
	      },
	      expression: "specie"
	    }
	  }, _vm._l((_vm.listaSpecie), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "disabled": item.disabled,
	        "value": item.id,
	        "label": item.label
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showLayerMngr),
	      expression: "showLayerMngr"
	    }]
	  }, [_vm._c('div', {
	    staticClass: "layer-mngr"
	  }, [_vm._c('div', {
	    staticClass: "combo"
	  }, [_vm._v("GESTIONE LIVELLI")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "placeholder": "Seleziona Livello",
	      "size": "mini"
	    },
	    model: {
	      value: (_vm.layer),
	      callback: function($$v) {
	        _vm.layer = $$v
	      },
	      expression: "layer"
	    }
	  }, _vm._l((_vm.layers), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.label
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "combo"
	  }, [_vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-delete",
	      "type": "button",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.removeLayer
	    }
	  }, [_vm._c('span', {
	    staticStyle: {
	      "color": "#ffffff",
	      "font-weight": "bold"
	    }
	  }, [_vm._v("Rimuovi livello")])])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('el-select', {
	    attrs: {
	      "size": "mini",
	      "placeholder": "Sfondo"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.activeBaseLayer),
	      callback: function($$v) {
	        _vm.activeBaseLayer = $$v
	      },
	      expression: "activeBaseLayer"
	    }
	  }, _vm._l((_vm.baseLayers), function(item) {
	    return _vm._c('el-option', {
	      key: item.name,
	      attrs: {
	        "label": item.label,
	        "value": item.name
	      }
	    }, [_vm._c('span', {
	      staticStyle: {
	        "float": "left"
	      }
	    }, [_vm._c('img', {
	      staticClass: "gv-sfondi-icon",
	      attrs: {
	        "src": item.icon
	      }
	    }), _vm._v(" "), _vm._c('span', {
	      staticClass: "gv-sfondi-label"
	    }, [_vm._v(_vm._s(item.label))])])])
	  }))
	},staticRenderFns: []}

/***/ }),
/* 889 */,
/* 890 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "rqa gv-color-scheme"
	  }, [_vm._c('div', {
	    staticClass: "rqa-title gv-color-scheme"
	  }, [_vm._v("\n    Rete Qualità Aria - Indicatori annuali e giornalieri\n    "), _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Nascondi Pannello"
	    },
	    on: {
	      "click": _vm.hidePanel
	    }
	  }), _vm._v(" "), _vm._c('button', {
	    staticClass: "gv-color-scheme rqa-download-button el-icon-download",
	    attrs: {
	      "id": "rqa-download-button",
	      "title": "Download Dati",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.download
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "rqa-wrapper gv-color-scheme",
	    attrs: {
	      "id": "rqa-wrapper"
	    }
	  }, [_vm._c('div', {
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "placeholder": "Seleziona Annuali/Giornalieri",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeTipo
	    },
	    model: {
	      value: (_vm.tipo),
	      callback: function($$v) {
	        _vm.tipo = $$v
	      },
	      expression: "tipo"
	    }
	  }, _vm._l((_vm.tipi), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.label
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showIndicatoriGiorno),
	      expression: "showIndicatoriGiorno"
	    }],
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Seleziona Inquinante e Indicatore",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeIndicatore
	    },
	    model: {
	      value: (_vm.indicatore),
	      callback: function($$v) {
	        _vm.indicatore = $$v
	      },
	      expression: "indicatore"
	    }
	  }, _vm._l((_vm.indicatoriGiorno), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.nome
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showIndicatoriGiorno),
	      expression: "showIndicatoriGiorno"
	    }],
	    staticClass: "combo"
	  }, [_vm._c('el-date-picker', {
	    attrs: {
	      "size": "mini",
	      "type": "date",
	      "placeholder": "Seleziona Giorno",
	      "picker-options": _vm.datePickerOptions,
	      "value-format": "yyyy-MM-dd"
	    },
	    model: {
	      value: (_vm.giorno),
	      callback: function($$v) {
	        _vm.giorno = $$v
	      },
	      expression: "giorno"
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showIndicatoriAnno),
	      expression: "showIndicatoriAnno"
	    }],
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Seleziona Inquinante e Indicatore",
	      "size": "mini"
	    },
	    on: {
	      "change": _vm.onChangeIndicatore
	    },
	    model: {
	      value: (_vm.indicatore),
	      callback: function($$v) {
	        _vm.indicatore = $$v
	      },
	      expression: "indicatore"
	    }
	  }, _vm._l((_vm.indicatoriAnno), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.nome
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showIndicatoriAnno),
	      expression: "showIndicatoriAnno"
	    }],
	    staticClass: "combo"
	  }, [_vm._c('el-select', {
	    attrs: {
	      "filterable": "",
	      "placeholder": "Seleziona Anno",
	      "size": "mini"
	    },
	    model: {
	      value: (_vm.data),
	      callback: function($$v) {
	        _vm.data = $$v
	      },
	      expression: "data"
	    }
	  }, _vm._l((_vm.anni), function(item) {
	    return _vm._c('el-option', {
	      key: item.id,
	      attrs: {
	        "value": item.id,
	        "label": item.label
	      }
	    })
	  }))], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showLegend),
	      expression: "showLegend"
	    }]
	  }, [_vm._c('gv-iframe-panel', {
	    staticClass: "gv-iframe-panel",
	    attrs: {
	      "src": _vm.legendUrl,
	      "height": "141",
	      "width": "230"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 891 */,
/* 892 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-print-button",
	      "title": "Stampa"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 893 */,
/* 894 */,
/* 895 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return (_vm.largeScreen) ? _vm._c('div', {
	    staticClass: "scalebar",
	    attrs: {
	      "id": "gv-scalebar"
	    }
	  }, [_vm._c('el-select', {
	    attrs: {
	      "size": "mini",
	      "placeholder": ""
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.value),
	      callback: function($$v) {
	        _vm.value = $$v
	      },
	      expression: "value"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _vm._c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 896 */,
/* 897 */,
/* 898 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "gv-legend-layer-table"
	    }
	  }, [_vm._c('el-table', {
	    staticStyle: {
	      "width": "100%",
	      "line-height": "23px",
	      "font-weight": "400"
	    },
	    attrs: {
	      "data": _vm.map.layers,
	      "show-header": false,
	      "size": "mini",
	      "empty-text": " ",
	      "row-class-name": _vm.layerClassName
	    }
	  }, [_vm._c('el-table-column', {
	    attrs: {
	      "align": "center",
	      "width": "30"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._c('img', {
	          attrs: {
	            "alt": scope.row.legend.label,
	            "src": _vm.iconUrl(scope.row),
	            "width": "20"
	          },
	          on: {
	            "click": function($event) {
	              _vm.showLegendPanel(scope.row)
	            }
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), (_vm.layerVisibilityCheck) ? _vm._c('el-table-column', {
	    attrs: {
	      "align": "center",
	      "width": "25"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._c('span', [_vm._c('el-checkbox', {
	          staticClass: "gv-layer-visibility-cb",
	          attrs: {
	            "disabled": !scope.row.inRange
	          },
	          on: {
	            "change": function($event) {
	              _vm.setLayerVisible(scope.row)
	            }
	          },
	          model: {
	            value: (scope.row.visible),
	            callback: function($$v) {
	              _vm.$set(scope.row, "visible", $$v)
	            },
	            expression: "scope.row.visible"
	          }
	        }, [_vm._v("layer-visibility")])], 1)]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), _vm._c('el-table-column', {
	    staticStyle: {
	      "word-break": "normal"
	    },
	    attrs: {
	      "class-name": "gv-inverted-color-scheme-light"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._c('el-popover', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (!scope.row.inRange),
	            expression: "!scope.row.inRange"
	          }],
	          attrs: {
	            "trigger": "hover",
	            "placement": "left-start",
	            "offset": "10",
	            "popper-class": "gv-layer-popover"
	          }
	        }, [_vm._c('p', [_vm._v(_vm._s(scope.row.scaleRangeLabel))]), _vm._v(" "), _vm._c('div', {
	          staticClass: "gv-legend-popover-button"
	        }, [_vm._c('el-button', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (_vm.options.layerPopover && _vm.options.layerPopover.find),
	            expression: "options.layerPopover && options.layerPopover.find"
	          }],
	          staticClass: "gv-color-scheme gv-legend-map-tools-button",
	          attrs: {
	            "title": "Ricerca sul livello",
	            "icon": "el-icon-search",
	            "size": "mini"
	          },
	          on: {
	            "click": function($event) {
	              _vm.layerSearch(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), _vm._c('div', {
	          staticClass: "name-wrapper",
	          attrs: {
	            "slot": "reference"
	          },
	          slot: "reference"
	        }, [_vm._v("\n            " + _vm._s(scope.row.legend.label) + "\n          ")])]), _vm._v(" "), (_vm.options.layerPopover && scope.row.inRange) ? _vm._c('el-popover', {
	          attrs: {
	            "trigger": "hover",
	            "popper-class": "popover-scala",
	            "placement": "left-start",
	            "width": "150",
	            "offset": "15"
	          }
	        }, [_vm._c('div', {
	          staticClass: "gv-legend-transparency-layer-slider"
	        }, [_vm._c('el-slider', {
	          on: {
	            "change": function($event) {
	              _vm.setLayerTransparency(scope.row)
	            }
	          },
	          model: {
	            value: (scope.row.opacityBase100),
	            callback: function($$v) {
	              _vm.$set(scope.row, "opacityBase100", $$v)
	            },
	            expression: "scope.row.opacityBase100"
	          }
	        })], 1), _vm._v(" "), _vm._c('el-row', {
	          staticClass: "row-bg gv-legend-popover-buttons",
	          attrs: {
	            "type": "flex",
	            "justify": "left"
	          }
	        }, [_vm._c('div', {
	          staticClass: "gv-legend-popover-button"
	        }, [_vm._c('el-button', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (_vm.options.layerPopover && _vm.options.layerPopover.find),
	            expression: "options.layerPopover && options.layerPopover.find"
	          }],
	          staticClass: "gv-color-scheme gv-legend-map-tools-button",
	          attrs: {
	            "title": "Ricerca sul livello",
	            "icon": "el-icon-search",
	            "size": "mini"
	          },
	          on: {
	            "click": function($event) {
	              _vm.layerSearch(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), _vm._c('div', {
	          staticClass: "gv-legend-popover-button"
	        }, [_vm._c('el-checkbox', {
	          staticClass: "gv-layer-visibility-cb",
	          on: {
	            "change": function($event) {
	              _vm.setLayerVisible(scope.row)
	            }
	          },
	          model: {
	            value: (scope.row.visible),
	            callback: function($$v) {
	              _vm.$set(scope.row, "visible", $$v)
	            },
	            expression: "scope.row.visible"
	          }
	        }, [_vm._v("layer-visibility")])], 1)]), _vm._v(" "), _vm._c('div', {
	          staticClass: "name-wrapper",
	          attrs: {
	            "slot": "reference"
	          },
	          slot: "reference"
	        }, [_vm._v("\n            " + _vm._s(scope.row.legend.label) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _vm._c('div', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (!_vm.options.layerPopover && scope.row.inRange),
	            expression: "!options.layerPopover && scope.row.inRange"
	          }],
	          staticClass: "name-wrapper",
	          attrs: {
	            "slot": "reference"
	          },
	          slot: "reference"
	        }, [_vm._v("\n          " + _vm._s(scope.row.legend.label) + "\n        ")])]
	      }
	    }])
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 899 */,
/* 900 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-info gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-info"
	    }
	  }, [_vm._c('div', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    staticClass: "gv-difesa-suolo-foto-info-title gv-color-scheme",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-info-title"
	    }
	  }, [_vm._c('strong', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-close",
	      "type": "button",
	      "title": "Chiudi Panello",
	      "alt": "Chiudi Panello"
	    },
	    on: {
	      "click": _vm.closePanel
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "bar",
	      rawName: "v-bar"
	    }]
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-info-body",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-info-body"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-difesa-suolo-foto-info-scheda"
	  }, [_vm._c('div', {
	    staticStyle: {
	      "font-size": "20px",
	      "width": "90%"
	    }
	  }, [_vm._c('strong', [_vm._v("NOME FILE: ")]), _vm._v(" " + _vm._s(_vm.properties.file_name) + "\n        ")]), _vm._v(" "), _vm._c('div', {
	    staticStyle: {
	      "font-size": "20px",
	      "width": "90%"
	    }
	  }, [_vm._c('strong', [_vm._v("DATA: ")]), _vm._v(" " + _vm._s(_vm.properties.datetime) + "\n        ")]), _vm._v(" "), _vm._c('div', {
	    staticStyle: {
	      "font-size": "20px",
	      "width": "90%"
	    }
	  }, [_vm._c('el-checkbox', {
	    on: {
	      "change": _vm.toggleValidate
	    },
	    model: {
	      value: (_vm.properties.validato),
	      callback: function($$v) {
	        _vm.$set(_vm.properties, "validato", $$v)
	      },
	      expression: "properties.validato"
	    }
	  }, [_vm._v("Validato")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "gv-difesa-suolo-foto-label"
	  }, [_vm._v("Direzione")]), _vm._v(" "), _vm._c('el-input', {
	    staticStyle: {
	      "width": "33px"
	    },
	    attrs: {
	      "id": "gv-difesa-suolo-foto-direzione",
	      "size": "mini",
	      "maxlength": "3",
	      "placeholder": "Direzione",
	      "type": "integer"
	    },
	    model: {
	      value: (_vm.properties.direzione),
	      callback: function($$v) {
	        _vm.$set(_vm.properties, "direzione", $$v)
	      },
	      expression: "properties.direzione"
	    }
	  }), _vm._v(" "), _vm._c('span', {
	    staticClass: "gv-difesa-suolo-foto-degree"
	  }, [_vm._v("°")]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-color-scheme fas fa-hand-point-down",
	    attrs: {
	      "id": "gv-measure-point",
	      "title": "Sposta",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.measurePoint
	    }
	  }), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('el-button', {
	    ref: "button",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-info-submit",
	      "title": "Salva",
	      "type": "primary",
	      "size": "mini",
	      "disabled": !_vm.changed
	    },
	    on: {
	      "click": function($event) {
	        _vm.submit()
	      }
	    }
	  }, [_vm._v("\n            Salva\n          ")]), _vm._v(" "), _vm._c('el-button', {
	    ref: "button",
	    attrs: {
	      "id": "gv-difesa-suolo-foto-info-delete",
	      "title": "Cancella Foto",
	      "type": "danger",
	      "size": "mini"
	    },
	    on: {
	      "click": function($event) {
	        _vm.deletePhoto()
	      }
	    }
	  }, [_vm._v("\n            Cancella Foto\n          ")])], 1), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('div', {
	    staticStyle: {
	      "font-size": "20px",
	      "width": "90%"
	    }
	  }, [_vm._c('a', {
	    attrs: {
	      "href": _vm.properties.url,
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "width": "300px",
	      "src": _vm.properties.url
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticStyle: {
	      "font-size": "20px",
	      "width": "90%"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-legend"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-legend-title gv-color-scheme",
	    attrs: {
	      "id": "gv-legend-title"
	    }
	  }, [_vm._c('b', [_vm._v("LEGENDA")]), _vm._v(" "), _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Nascondi Legenda"
	    },
	    on: {
	      "click": _vm.hideLegend
	    }
	  }), _vm._v(" "), _vm._c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.options.showAddMap),
	      expression: "options.showAddMap"
	    }],
	    staticClass: "gv-color-scheme gv-legend-buttons ms ms-layers-add",
	    attrs: {
	      "id": "gv-legend-add-map",
	      "title": "Aggiungi Mappe",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.addMap
	    }
	  }), _vm._v(" "), _vm._c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.options.showDownloadTotale),
	      expression: "options.showDownloadTotale"
	    }],
	    staticClass: "gv-color-scheme gv-legend-buttons el-icon-download",
	    attrs: {
	      "id": "gv-legend-add-map",
	      "title": "Download Mappe",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.downloadMaps
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-legend-title-collapsed gv-color-scheme",
	    attrs: {
	      "id": "gv-legend-title-collapsed"
	    }
	  }, [_vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Mostra Legenda"
	    },
	    on: {
	      "click": _vm.hideLegend
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-legend-wrapper",
	    attrs: {
	      "id": "gv-legend-wrapper"
	    }
	  }, [_vm._c('gv-legend-maps', {
	    attrs: {
	      "maps": _vm.maps,
	      "options": _vm.options
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-legend-footer gv-inverted-color-scheme"
	  }, [(_vm.options.showBaseLayerSwitcher) ? _vm._c('gv-base-layer-switcher', {
	    ref: "gv-base-layer-switcher"
	  }) : _vm._e()], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-scuoladigitale-info-conn gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-scuoladigitale-info-conn"
	    }
	  }, [_vm._c('div', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    staticClass: "gv-scuoladigitale-info-conn-title gv-color-scheme",
	    attrs: {
	      "id": "gv-scuoladigitale-info-conn-title"
	    }
	  }, [_vm._c('b', [_vm._v("Risultato Info")]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-close",
	      "type": "button",
	      "title": "Chiudi Panello"
	    },
	    on: {
	      "click": _vm.closePanel
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-scuoladigitale-info-conn-body",
	    attrs: {
	      "id": "gv-scuoladigitale-info-conn-body"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-scuoladigitale-info-conn-result"
	  }, [_vm._c('div', {
	    staticClass: "gv-scuoladigitale-info-conn-scuola"
	  }, [_vm._c('TABLE', {
	    attrs: {
	      "width": "92%"
	    }
	  }, [_vm._c('TBODY', [_vm._c('TR', [_vm._c('TD', {
	    staticClass: "fogliaL"
	  }, [_vm._v("Istituto")]), _vm._v(" "), _vm._c('TD', {
	    staticClass: "foglia"
	  }, [_vm._v(_vm._s(_vm.properties.ISTITUTO))])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
	    staticClass: "fogliaL"
	  }, [_vm._v("Indirizzo")]), _vm._v(" "), _vm._c('TD', {
	    staticClass: "foglia"
	  }, [_vm._v(_vm._s(_vm.properties.INDIRIZZO) + " - " + _vm._s(_vm.properties.CAP) + " - " + _vm._s(_vm.properties.COMUNE))])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
	    staticClass: "fogliaL"
	  }, [_vm._v("Telefono")]), _vm._v(" "), _vm._c('TD', {
	    staticClass: "foglia"
	  }, [_vm._v(_vm._s(_vm.properties.TELEFONO))])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
	    staticClass: "fogliaL"
	  }, [_vm._v("Sede")]), _vm._v(" "), _vm._c('TD', {
	    staticClass: "foglia"
	  }, [_vm._v("\n                        " + _vm._s(_vm.tipoSede) + "\n                    ")])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
	    staticClass: "fogliaL"
	  }, [_vm._v("Connessione")]), _vm._v(" "), _vm._c('TD', {
	    staticClass: "foglia"
	  }, [_vm._c('A', {
	    attrs: {
	      "href": _vm.tipoConnURL,
	      "target": "_blank"
	    }
	  }, [_vm._c('B', [_vm._v("Connettività " + _vm._s(_vm.tipoConn))])], 1)], 1)], 1)], 1)], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-scuoladigitale-legend"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-scuoladigitale-legend-title gv-color-scheme",
	    attrs: {
	      "id": "gv-scuoladigitale-legend-title"
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _vm._c('button', {
	    class: _vm.toggleCollapseClass(),
	    attrs: {
	      "size": "mini",
	      "title": "Nascondi Legenda"
	    },
	    on: {
	      "click": _vm.hideLegend
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "gv-scuoladigitale-legend-wrapper",
	    attrs: {
	      "id": "gv-scuoladigitale-legend-wrapper"
	    }
	  }, [_vm._c('div', [_vm._c('div', {
	    staticClass: "gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-scuoladigitale-legend-body"
	    }
	  }, [_vm._c('gv-legend-maps', {
	    attrs: {
	      "options": _vm.options
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "title": "Info sui livelli della mappa"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-cultura-info gv-inverted-color-scheme",
	    attrs: {
	      "id": "gv-cultura-info"
	    }
	  }, [_vm._c('div', {
	    directives: [{
	      name: "draggable",
	      rawName: "v-draggable"
	    }],
	    staticClass: "gv-cultura-info-title gv-color-scheme",
	    attrs: {
	      "id": "gv-cultura-info-title"
	    }
	  }, [_vm._c('strong', {
	    staticStyle: {
	      "margin-left": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._c('el-button', {
	    staticClass: "gv-close gv-color-scheme",
	    attrs: {
	      "icon": "el-icon-close",
	      "type": "button",
	      "title": "Chiudi Panello",
	      "alt": "Chiudi Panello"
	    },
	    on: {
	      "click": _vm.closePanel
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    directives: [{
	      name: "bar",
	      rawName: "v-bar"
	    }]
	  }, [_vm._c('div', {
	    staticClass: "gv-cultura-info-body",
	    attrs: {
	      "id": "gv-cultura-info-body"
	    }
	  }, [_vm._c('div', {
	    staticClass: "gv-cultura-info-scheda"
	  }, [_vm._c('div', {
	    staticStyle: {
	      "font-size": "20px",
	      "width": "90%"
	    }
	  }, [_vm._c('strong', [_vm._v(_vm._s(_vm.properties.NOME.toUpperCase()))])]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('div', {
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_vm._v(_vm._s(_vm.properties.INDIRIZZO_FORMAT))]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('div', {
	    staticStyle: {
	      "width": "90%"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.properties.RAGGRUPPAMENTO) + " / "), _vm._c('strong', [_vm._v(_vm._s(_vm.properties.CATNAME))])]), _vm._v(" "), (_vm.properties.DESCRIZIONE_BREVE) ? _vm._c('div', {
	    staticClass: "gv-cultura-info-descrizione"
	  }, [_vm._c('pre', [_vm._c('em', [_vm._v(_vm._s(_vm.properties.DESCRIZIONE_BREVE))])])]) : _vm._e(), _vm._v(" "), (_vm.properties.DESCRIZIONE) ? _vm._c('div', {
	    staticClass: "gv-cultura-info-descrizione"
	  }, [_vm._c('pre', [_vm._v(_vm._s(_vm.properties.DESCRIZIONE))])]) : _vm._e(), _vm._v(" "), (_vm.properties.opere.length > 0) ? _vm._c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.properties.opere), function(item) {
	    return _vm._c('ul', {
	      key: item.id
	    }, [_vm._c('li', [_vm._v(_vm._s(item.nome))])])
	  })], 2) : _vm._e()]), _vm._v(" "), (_vm.properties.GALLERY.length > 0) ? _vm._c('div', {
	    staticClass: "gv-cultura-info-button"
	  }, [_vm._c('el-button', {
	    attrs: {
	      "alt": "Galleria Immagini",
	      "size": "mini",
	      "type": "info"
	    },
	    on: {
	      "click": _vm.showGallery
	    }
	  }, [_vm._v("Galleria Immagini")])], 1) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('strong', [_vm._v("Alcune opere correlate")])])
	}]}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    class: _vm.setClass(),
	    attrs: {
	      "id": "gv-button-coordinate",
	      "title": "Acquisizione Coordinate"
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 910 */,
/* 911 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "gv-map"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 912 */,
/* 913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "gv-search",
	    attrs: {
	      "id": "gv-search"
	    }
	  }, [_vm._c('el-select', {
	    attrs: {
	      "id": "gv-seach-input",
	      "filterable": "",
	      "clearable": "",
	      "remote": "",
	      "size": "mini",
	      "placeholder": _vm.placeHolder,
	      "remote-method": _vm.search,
	      "loading": _vm.loading,
	      "loading-text": "Caricamento... ",
	      "no-match-text": "Nessun elemento trovato",
	      "no-data-text": "Nessun elemento trovato"
	    },
	    on: {
	      "change": _vm.onChange
	    },
	    model: {
	      value: (_vm.address),
	      callback: function($$v) {
	        _vm.address = $$v
	      },
	      expression: "address"
	    }
	  }, _vm._l((_vm.results), function(item) {
	    return _vm._c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }))], 1)
	},staticRenderFns: []}

/***/ }),
/* 914 */,
/* 915 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/GV.js